import QBtn from 'quasar/src/components/btn/QBtn.js';import QDate from 'quasar/src/components/date/QDate.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QInput from 'quasar/src/components/input/QInput.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import QTime from 'quasar/src/components/time/QTime.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import date from 'quasar/src/utils/date.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QField from 'quasar/src/components/field/QField.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QBar from 'quasar/src/components/bar/QBar.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QTable from 'quasar/src/components/table/QTable.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QList from 'quasar/src/components/item/QList.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QTd from 'quasar/src/components/table/QTd.js';import QTh from 'quasar/src/components/table/QTh.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QTr from 'quasar/src/components/table/QTr.js';import Ripple from 'quasar/src/directives/Ripple.js';import extend from 'quasar/src/utils/extend.js';import is from 'quasar/src/utils/is.js';import exportFile from 'quasar/src/utils/export-file.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QFile from 'quasar/src/components/file/QFile.js';import format from 'quasar/src/utils/format.js';import uid from 'quasar/src/utils/uid.js';import QEditor from 'quasar/src/components/editor/QEditor.js';import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QImg from 'quasar/src/components/img/QImg.js';import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import EventBus from 'quasar/src/utils/EventBus.js';;
import { resolveComponent, resolveDirective, openBlock, createBlock, mergeProps, createSlots, withCtx, createVNode, createElementVNode, normalizeClass, createCommentVNode, withDirectives, renderSlot, defineComponent, h, createElementBlock, normalizeStyle, toRaw, Fragment, normalizeProps, guardReactiveProps, renderList, withModifiers, toDisplayString, vShow, createTextVNode, resolveDynamicComponent, pushScopeId, popScopeId, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import Cropper from './assets/cropper/index.js';
import './assets/tinymce/index.js';
import axios from 'axios';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$c = ".q-radio.ellipsis-label,\n.q-checkbox.ellipsis-label,\n.q-toggle.ellipsis-label,\n.q-option-group.ellipsis-label,\n.q-option-group.ellipsis-label > div,\n.q-option-group-input.ellipsis-label .q-option-group,\n.q-option-group-input.ellipsis-label .q-option-group > div {\n    max-width: 100%;\n}\n.q-radio.ellipsis-label .q-radio,\n.q-checkbox.ellipsis-label .q-checkbox,\n.q-toggle.ellipsis-label .q-toggle,\n.q-option-group.ellipsis-label .q-radio,\n.q-option-group.ellipsis-label .q-checkbox,\n.q-option-group.ellipsis-label .q-toggle,\n.q-option-group-input.ellipsis-label .q-option-group .q-radio,\n.q-option-group-input.ellipsis-label .q-option-group .q-checkbox,\n.q-option-group-input.ellipsis-label .q-option-group .q-toggle {\n    max-width: 100%;\n}\n.q-radio.ellipsis-label .q-radio__label,\n.q-checkbox.ellipsis-label .q-checkbox__label,\n.q-toggle.ellipsis-label .q-toggle__label,\n.q-option-group.ellipsis-label .q-radio__label,\n.q-option-group.ellipsis-label .q-checkbox__label,\n.q-option-group.ellipsis-label .q-toggle__label,\n.q-option-group-input.ellipsis-label .q-option-group .q-radio__label,\n.q-option-group-input.ellipsis-label .q-option-group .q-checkbox__label,\n.q-option-group-input.ellipsis-label .q-option-group .q-toggle__label {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {\n    .q-loading.blur {\n        -webkit-transition: none !important;\n        -moz-transition: none !important;\n        -o-transition: none !important;\n        transition: none !important;\n    }\n    .q-loading.blur > .q-loading__backdrop {\n        background-color: #0000001a !important;\n        -webkit-backdrop-filter: blur(3px);\n        backdrop-filter: blur(3px);\n        opacity: unset;\n        -webkit-transition: none !important;\n        -moz-transition: none !important;\n        -o-transition: none !important;\n        transition: none !important;\n    }\n}\n";
styleInject(css_248z$c);

const enfisKey = '_e_';

function isObject(v) {
    return v !== null && typeof v === 'object' && Array.isArray(v) !== true;
}
function prepareApp(app, uiOpts, pluginOpts) {
    app.config.globalProperties.$log = console.log;
    app.config.globalProperties.$e = pluginOpts.$e;
    app.provide(enfisKey, pluginOpts.$e);
    uiOpts.components !== void 0 &&
        Object.values(uiOpts.components).forEach((c) => {
            if (isObject(c) === true && c.name !== void 0) {
                app.component(c.name, c);
            }
        });
    uiOpts.modules !== void 0 &&
        Object.values(uiOpts.modules).forEach((m) => {
            if (isObject(m) === true) {
                m.install(pluginOpts);
                m.__installed = true;
            }
        });
}
function installEnfis (parentApp, opts = {}) {
    const $e = opts.$e;
    $e.config = opts.config || {};
    prepareApp(parentApp, opts, {
        parentApp,
        $e,
        $q: parentApp.config.globalProperties.$q,
    });
}

const SSR$7 = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
var script$e = {
    name: 'QDateTimeInput',
    components: {
        QBtn,
        QDate,
        QIcon,
        QInput,
        QPopupProxy,
        QTime,
    },
    directives: {
        ClosePopup,
    },
    beforeMount() {
        if (!SSR$7) {
            for (let i = 0; i < this.documentEventListeners.length; i++) {
                const documentEventListener = this.documentEventListeners[i];
                document.addEventListener(documentEventListener.name, documentEventListener.action);
            }
        }
    },
    unmounted() {
        if (!SSR$7) {
            for (let i = 0; i < this.documentEventListeners.length; i++) {
                const documentEventListener = this.documentEventListeners[i];
                document.removeEventListener(documentEventListener.name, documentEventListener.action);
            }
        }
    },
    props: {
        type: {
            type: String,
            default: 'date',
            validator: (v) => ['date', 'time', 'date-time'].includes(v),
        },
        includeSeconds: {
            type: Boolean,
            default: true,
        },
        emptyValueToNow: {
            type: Boolean,
            default: false,
        },
        autoClose: {
            type: Boolean,
            default: true,
        },
        pickIcon: {
            type: String,
            default: null,
        },
        dateIcon: {
            type: String,
            default: 'event',
        },
        timeIcon: {
            type: String,
            default: 'access_time',
        },
        modelValue: {},
        name: String,
        for: String,
        label: String,
        stackLabel: Boolean,
        hint: String,
        hideHint: Boolean,
        prefix: String,
        suffix: String,
        labelSlot: Boolean,
        bottomSlots: Boolean,
        hideBottomSpace: Boolean,
        autofocus: Boolean,
        clearable: Boolean,
        clearIcon: String,
        loading: Boolean,
        counter: Boolean,
        debounce: [String, Number],
        dense: Boolean,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        flat: Boolean,
        bordered: Boolean,
        rounded: Boolean,
        landscape: Boolean,
        itemAligned: Boolean,
        color: String,
        bgColor: String,
        labelColor: String,
        textColor: String,
        shadowText: String,
        dark: {
            type: Boolean,
            default: null,
        },
        error: {
            type: Boolean,
            default: null,
        },
        errorMessage: String,
        noErrorIcon: Boolean,
        rules: Array,
        reactiveRules: Boolean,
        lazyRules: {
            type: [Boolean, String],
            validator: (v) => [true, false, 'ondemand'].includes(v),
        },
        mask: String,
        dateMask: String,
        timeMask: String,
        reverseFillMask: Boolean,
        fillMask: [Boolean, String],
        unmaskedValue: Boolean,
        locale: Object,
        calendar: {
            type: String,
            validator: (v) => ['gregorian', 'persian'].includes(v),
            default: 'gregorian',
        },
        firstDayOfWeek: [String, Number],
        format24h: {
            type: Boolean,
            default: null,
        },
        disable: Boolean,
        readonly: Boolean,
        inputClass: [Array, String, Object],
        inputStyle: [Array, String, Object],
        dateTitle: String,
        dateSubtitle: String,
        dateMultiple: {
            type: Boolean,
            default: undefined,
        },
        dateRange: {
            type: Boolean,
            default: undefined,
        },
        dateOptions: [Array, Function],
        dateEvents: [Array, Function],
        dateEventColor: [String, Function],
        dateMinimal: {
            type: Boolean,
            default: undefined,
        },
        dateNoUnset: {
            type: Boolean,
            default: undefined,
        },
        dateTodayBtn: {
            type: Boolean,
            default: undefined,
        },
        dateEmitImmediately: {
            type: Boolean,
            default: undefined,
        },
        dateYearsInMonthView: {
            type: Boolean,
            default: undefined,
        },
        dateDefaultView: {
            type: String,
            default: 'Calendar',
            validator: (v) => ['Calendar', 'Years', 'Months'].includes(v),
        },
        dateDefaultYearMonth: {
            type: String,
            validator: (v) => /^-?[\d]+\/[0-1]\d$/.test(v),
        },
        dateNavigationMinYearMonth: {
            type: String,
            validator: (v) => /^-?[\d]+\/[0-1]\d$/.test(v),
        },
        dateNavigationMaxYearMonth: {
            type: String,
            validator: (v) => /^-?[\d]+\/[0-1]\d$/.test(v),
        },
        timeOptions: Function,
        timeHourOptions: Array,
        timeMinuteOptions: Array,
        timeSecondOptions: Array,
        timeWithSeconds: {
            type: Boolean,
            default: undefined,
        },
        timeNowBtn: {
            type: Boolean,
            default: undefined,
        },
        timeDefaultDate: {
            type: String,
            validator: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v),
        },
        popupProxyProps: Object,
    },
    data() {
        return {
            documentEventListeners: [
                {
                    name: 'mouseup',
                    action: (e) => {
                        if (this.closeNeeded) {
                            this.closeNeeded = false;
                            setTimeout(() => {
                                this.$refs.popupProxy.hide();
                            });
                        }
                    },
                },
                {
                    name: 'touchend',
                    action: (e) => {
                        if (this.closeNeeded) {
                            this.closeNeeded = false;
                            setTimeout(() => {
                                this.$refs.popupProxy.hide();
                            });
                        }
                    },
                },
            ],
            dateView: true,
            lastValue: null,
            closeNeeded: false,
        };
    },
    computed: {
        hasError() {
            return this.$refs.input.hasError;
        },
        nativeEl() {
            return this.$refs.input.nativeEl;
        },
        dateRef() {
            return this.$refs.date;
        },
        timeRef() {
            return this.$refs.time;
        },
        modelValueProp: {
            get() {
                return this.modelValue;
            },
            set(modelValue) {
            },
        },
        inputProps() {
            const props = {
                dark: this.dark,
                error: this.error,
                errorMessage: this.errorMessage,
                noErrorIcon: this.noErrorIcon,
                rules: this.rules,
                reactiveRules: this.reactiveRules,
                lazyRules: this.lazyRules,
                label: this.label,
                stackLabel: this.stackLabel,
                hint: this.hint,
                hideHint: this.hideHint,
                prefix: this.prefix,
                suffix: this.suffix,
                labelColor: this.labelColor,
                color: this.color,
                bgColor: this.bgColor,
                filled: this.filled,
                outlined: this.outlined,
                borderless: this.borderless,
                standout: this.standout,
                square: this.square,
                loading: this.loading,
                labelSlot: this.labelSlot,
                bottomSlots: this.bottomSlots,
                hideBottomSpace: this.hideBottomSpace,
                rounded: this.rounded,
                dense: this.dense,
                itemAligned: this.itemAligned,
                counter: this.counter,
                clearable: this.clearable,
                clearIcon: this.clearIcon,
                disable: this.disable,
                readonly: this.readonly,
                autofocus: this.autofocus,
                for: this.for,
                mask: this.mask,
                reverseFillMask: this.reverseFillMask,
                fillMask: this.fillMask,
                unmaskedValue: this.unmaskedValue,
                name: this.name,
                shadowText: this.shadowText,
                debounce: this.debounce,
                inputClass: this.inputClass,
                inputStyle: this.inputStyle,
            };
            if (this.mask === void 0) {
                const includeSeconds = this.timeWithSeconds === void 0 ? this.includeSeconds : this.timeWithSeconds;
                switch (this.type) {
                    case 'date-time':
                        props.mask = this.mask || '##.##.#### ##:##' + (includeSeconds ? ':##' : '');
                        break;
                    case 'time':
                        props.mask = this.mask || '##:##' + (includeSeconds ? ':##' : '');
                        break;
                    case 'date':
                    default:
                        props.mask = this.mask || '##.##.####';
                        break;
                }
            }
            Object.keys(props).forEach((key) => {
                if (props[key] === undefined) {
                    delete props[key];
                }
            });
            return props;
        },
        dateProps() {
            const props = {
                mask: this.dateMask,
                locale: this.locale,
                calendar: this.calendar,
                landscape: this.landscape,
                color: this.color,
                textColor: this.textColor,
                square: this.square,
                flat: this.flat,
                bordered: this.bordered,
                dark: this.dark,
                multiple: this.dateMultiple,
                range: this.dateRange,
                title: this.dateTitle,
                subtitle: this.dateSubtitle,
                defaultYearMonth: this.dateDefaultYearMonth,
                yearsInMonthView: this.dateYearsInMonthView,
                events: this.dateEvents,
                eventColor: this.dateEventColor,
                emitImmediately: this.dateEmitImmediately,
                options: this.dateOptions,
                navigationMinYearMonth: this.dateNavigationMinYearMonth,
                navigationMaxYearMonth: this.dateNavigationMaxYearMonth,
                noUnset: this.dateNoUnset,
                firstDayOfWeek: this.firstDayOfWeek,
                todayBtn: this.dateTodayBtn,
                minimal: this.dateMinimal,
                defaultView: this.dateDefaultView,
            };
            if (this.dateMask === void 0) {
                const includeSeconds = this.timeWithSeconds === void 0 ? this.includeSeconds : this.timeWithSeconds;
                switch (this.type) {
                    case 'date-time':
                        props.mask = 'DD.MM.YYYY HH:mm' + (includeSeconds ? ':ss' : '');
                        break;
                    case 'time':
                        props.mask = 'HH:mm' + (includeSeconds ? ':ss' : '');
                        break;
                    case 'date':
                    default:
                        props.mask = 'DD.MM.YYYY';
                        break;
                }
            }
            Object.keys(props).forEach((key) => {
                if (props[key] === undefined) {
                    delete props[key];
                }
            });
            return props;
        },
        timeProps() {
            const props = {
                dark: this.dark,
                mask: this.timeMask,
                locale: this.locale,
                calendar: this.calendar,
                landscape: this.landscape,
                color: this.color,
                textColor: this.textColor,
                square: this.square,
                flat: this.flat,
                bordered: this.bordered,
                format24h: this.format24h,
                defaultDate: this.timeDefaultDate,
                options: this.timeOptions,
                hourOptions: this.timeHourOptions,
                minuteOptions: this.timeMinuteOptions,
                secondOptions: this.timeSecondOptions,
                withSeconds: this.timeWithSeconds,
                nowBtn: this.timeNowBtn,
            };
            if (this.timeWithSeconds === void 0) {
                props.withSeconds = this.includeSeconds;
            }
            if (this.timeMask === void 0) {
                switch (this.type) {
                    case 'date-time':
                        props.mask = 'DD.MM.YYYY HH:mm' + (props.withSeconds ? ':ss' : '');
                        break;
                    case 'time':
                        props.mask = 'HH:mm' + (props.withSeconds ? ':ss' : '');
                        break;
                    case 'date':
                    default:
                        props.mask = 'DD.MM.YYYY';
                        break;
                }
            }
            Object.keys(props).forEach((key) => {
                if (props[key] === undefined) {
                    delete props[key];
                }
            });
            return props;
        },
        pickIconProp() {
            return this.pickIcon || (this.type === 'time' ? this.timeIcon : this.dateIcon);
        },
    },
    methods: {
        resetValidation() {
            this.$refs.input.resetValidation();
        },
        validate(value) {
            return this.$refs.input.validate(value);
        },
        focus() {
            this.$refs.input.focus();
        },
        blur() {
            this.$refs.input.blur();
        },
        select() {
            this.$refs.input.select();
        },
        getNativeElement() {
            this.$refs.input.getNativeElement();
        },
        updateEmptyValue() {
            if (this.emptyValueToNow === true && (this.modelValueProp == undefined || this.modelValueProp == null || this.modelValueProp == '')) {
                let format = '';
                switch (this.type) {
                    case 'date':
                        format = 'DD.MM.YYYY';
                        break;
                    case 'time':
                        format = 'HH:mm' + (this.includeSeconds ? ':ss' : '');
                        break;
                    case 'date-time':
                        format = 'DD.MM.YYYY HH:mm' + (this.includeSeconds ? ':ss' : '');
                        break;
                }
                const modelValue = date.formatDate(Date.now(), format);
                this.$emit('update:model-value', modelValue);
            }
        },
        onButtonClick(evt) {
            if (evt == undefined || evt == null) {
                return;
            }
            evt.cancelable !== false && evt.preventDefault();
            evt.stopPropagation();
            const state = {
                rootRef: this.$refs.input.$el,
                targetRef: this.$refs.input.$el.querySelector('.q-field__native.row'),
            };
            if (this.$q.platform.is.mobile !== true) {
                const el = (state.targetRef !== void 0 && state.targetRef) || state.rootRef;
                el.focus();
            } else if (state.rootRef.contains(document.activeElement) === true) {
                document.activeElement.blur();
            }
        },
        onUpdateModelValue(value) {
            if (this.autoClose) {
                let hide = false;
                if (value == null || value == '') {
                    this.lastValue = null;
                    hide = true;
                } else if (this.type === 'date') {
                    hide = true;
                } else if (this.type === 'time') {
                    const fragment = value.slice(-2);
                    this.closeNeeded = this.lastValue != null && this.lastValue !== fragment;
                    this.lastValue = fragment;
                } else if (this.type === 'date-time') {
                    if (this.dateView) {
                        this.lastValue = value.slice(-2);
                        this.dateView = false;
                    } else {
                        const fragment = value.slice(-2);
                        this.closeNeeded = this.lastValue != null && this.lastValue !== fragment;
                        this.lastValue = fragment;
                    }
                }
                if (hide) {
                    setTimeout(() => {
                        this.$refs.popupProxy.hide();
                    });
                }
            }
            this.$emit('update:model-value', value);
        },
        onClear(value) {
            this.$emit('clear', value);
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
        onNavigation(view) {
            this.$emit('navigation', view);
        },
        onRangeStart(from) {
            this.$emit('range-start', from);
        },
        onRangeEnd(range) {
            this.$emit('range-end', range);
        },
    },
    emits: ['update:model-value', 'clear', 'focus', 'blur', 'navigation', 'range-start', 'range-end', 'before-show', 'show', 'before-hide', 'hide'],
    expose: ['hasError', 'nativeEl', 'dateRef', 'timeRef', 'resetValidation', 'validate', 'focus', 'blur', 'select', 'getNativeElement'],
};

function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_date = resolveComponent("q-date");
  const _component_q_time = resolveComponent("q-time");
  const _component_q_popup_proxy = resolveComponent("q-popup-proxy");
  const _component_q_icon = resolveComponent("q-icon");
  const _component_q_input = resolveComponent("q-input");
  const _directive_close_popup = resolveDirective("close-popup");
  return (openBlock(), createBlock(_component_q_input, mergeProps({
    ref: "input",
    modelValue: $options.modelValueProp,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($options.modelValueProp) = $event))
  }, $options.inputProps, {
    class: "q-date-time-input",
    "onUpdate:modelValue": $options.onUpdateModelValue,
    onClear: $options.onClear,
    onFocus: $options.onFocus,
    onBlur: $options.onBlur
  }), createSlots({
    append: withCtx(() => [
      ($props.disable !== true && $props.readonly !== true)
        ? (openBlock(), createBlock(_component_q_icon, {
            key: 0,
            class: "q-field__focusable-action",
            tag: "button",
            name: $options.pickIconProp,
            tabindex: "0",
            type: "button",
            "aria-hidden": null,
            role: null,
            size: "24px",
            onClick: $options.onButtonClick
          }, {
            default: withCtx(() => [
              createVNode(_component_q_popup_proxy, mergeProps({
                ref: "popupProxy",
                "transition-show": "scale",
                "transition-hide": "scale",
                cover: true
              }, $props.popupProxyProps, {
                onBeforeShow: _cache[4] || (_cache[4] = $event => {
                        $options.updateEmptyValue($event);
                        _ctx.$emit('before-show', $event);
                    }),
                onShow: _cache[5] || (_cache[5] = $event => (_ctx.$emit('show', $event))),
                onBeforeHide: _cache[6] || (_cache[6] = $event => (_ctx.$emit('before-hide', $event))),
                onHide: _cache[7] || (_cache[7] = $event => {
                        $data.dateView = true;
                        _ctx.$emit('hide', $event);
                    })
              }), {
                default: withCtx(() => [
                  ($props.type === 'date' || ($props.type !== 'time' && $data.dateView))
                    ? (openBlock(), createBlock(_component_q_date, mergeProps({
                        key: 0,
                        ref: "date",
                        modelValue: $options.modelValueProp,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.modelValueProp) = $event))
                      }, $options.dateProps, {
                        "onUpdate:modelValue": $options.onUpdateModelValue,
                        onNavigation: $options.onNavigation,
                        onRangeStart: $options.onRangeStart,
                        onRangeEnd: $options.onRangeEnd
                      }), {
                        default: withCtx(() => [
                          createElementVNode("div", {
                            class: normalizeClass(["row items-center", { 'justify-end': $props.type !== 'date-time', 'justify-between': $props.type === 'date-time' }])
                          }, [
                            ($props.type === 'date-time')
                              ? (openBlock(), createBlock(_component_q_btn, {
                                  key: 0,
                                  icon: $props.timeIcon,
                                  color: $props.color,
                                  flat: "",
                                  "no-caps": "",
                                  onClick: _cache[0] || (_cache[0] = $event => ($data.dateView = !$data.dateView))
                                }, null, 8 /* PROPS */, ["icon", "color"]))
                              : createCommentVNode("v-if", true),
                            withDirectives(createVNode(_component_q_btn, {
                              label: _ctx.$q.lang.label.close,
                              color: $props.color,
                              flat: "",
                              "no-caps": ""
                            }, null, 8 /* PROPS */, ["label", "color"]), [
                              [_directive_close_popup]
                            ])
                          ], 2 /* CLASS */)
                        ]),
                        _: 1 /* STABLE */
                      }, 16 /* FULL_PROPS */, ["modelValue", "onUpdate:modelValue", "onNavigation", "onRangeStart", "onRangeEnd"]))
                    : createCommentVNode("v-if", true),
                  ($props.type === 'time' || ($props.type !== 'date' && !$data.dateView))
                    ? (openBlock(), createBlock(_component_q_time, mergeProps({
                        key: 1,
                        ref: "time",
                        modelValue: $options.modelValueProp,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($options.modelValueProp) = $event))
                      }, $options.timeProps, { "onUpdate:modelValue": $options.onUpdateModelValue }), {
                        default: withCtx(() => [
                          createElementVNode("div", {
                            class: normalizeClass(["row items-center", { 'justify-end': $props.type !== 'date-time', 'justify-between': $props.type === 'date-time' }])
                          }, [
                            ($props.type === 'date-time')
                              ? (openBlock(), createBlock(_component_q_btn, {
                                  key: 0,
                                  icon: $props.dateIcon,
                                  color: $props.color,
                                  flat: "",
                                  "no-caps": "",
                                  onClick: _cache[2] || (_cache[2] = $event => ($data.dateView = !$data.dateView))
                                }, null, 8 /* PROPS */, ["icon", "color"]))
                              : createCommentVNode("v-if", true),
                            withDirectives(createVNode(_component_q_btn, {
                              label: _ctx.$q.lang.label.close,
                              color: $props.color,
                              flat: "",
                              "no-caps": ""
                            }, null, 8 /* PROPS */, ["label", "color"]), [
                              [_directive_close_popup]
                            ])
                          ], 2 /* CLASS */)
                        ]),
                        _: 1 /* STABLE */
                      }, 16 /* FULL_PROPS */, ["modelValue", "onUpdate:modelValue"]))
                    : createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 16 /* FULL_PROPS */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name", "onClick"]))
        : createCommentVNode("v-if", true),
      renderSlot(_ctx.$slots, "append")
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['default'])
      ? {
          name: "default",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots['prepend'])
      ? {
          name: "prepend",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend")
          ]),
          key: "1"
        }
      : undefined,
    (_ctx.$slots['before'])
      ? {
          name: "before",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "before")
          ]),
          key: "2"
        }
      : undefined,
    (_ctx.$slots['after'])
      ? {
          name: "after",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "after")
          ]),
          key: "3"
        }
      : undefined,
    (_ctx.$slots['label'])
      ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ]),
          key: "4"
        }
      : undefined,
    (_ctx.$slots['error'])
      ? {
          name: "error",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "error")
          ]),
          key: "5"
        }
      : undefined,
    (_ctx.$slots['hint'])
      ? {
          name: "hint",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "hint")
          ]),
          key: "6"
        }
      : undefined,
    (_ctx.$slots['counter'])
      ? {
          name: "counter",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "counter")
          ]),
          key: "7"
        }
      : undefined,
    (_ctx.$slots['loading'])
      ? {
          name: "loading",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "loading")
          ]),
          key: "8"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "onClear", "onFocus", "onBlur"]))
}

script$e.render = render$e;
script$e.__file = "src/components/QDateTimeInput.vue";

var script$d = {
    name: 'QNumberInput',
    components: {
        QInput,
    },
    props: {
        locales: {
            type: [String, Array],
            default: undefined,
        },
        compactDisplay: {
            type: String,
            default: undefined,
            validator: (v) => ['short', 'long'].includes(v),
        },
        currency: {
            type: String,
            default: undefined,
        },
        currencyDisplay: {
            type: String,
            default: undefined,
            validator: (v) => ['symbol', 'narrowSymbol', 'code', 'name'].includes(v),
        },
        currencySign: {
            type: String,
            default: undefined,
            validator: (v) => ['standard', 'accounting'].includes(v),
        },
        notation: {
            type: String,
            default: undefined,
            validator: (v) => ['standard', 'scientific', 'engineering', 'compact'].includes(v),
        },
        numberingSystem: {
            type: String,
            default: undefined,
            validator: (v) =>
                [
                    'arab',
                    'arabext',
                    'bali',
                    'beng',
                    'deva',
                    'fullwide',
                    'gujr',
                    'guru',
                    'hanidec',
                    'khmr',
                    'knda',
                    'laoo',
                    'latn',
                    'limb',
                    'mlym',
                    'mong',
                    'mymr',
                    'orya',
                    'tamldec',
                    'telu',
                    'thai',
                    'tibt',
                ].includes(v),
        },
        signDisplay: {
            type: String,
            default: undefined,
            validator: (v) => ['auto', 'always', 'exceptZero', 'negative', 'never'].includes(v),
        },
        formattingStyle: {
            type: String,
            default: undefined,
            validator: (v) => ['decimal', 'currency', 'percent', 'unit'].includes(v),
        },
        unit: {
            type: String,
            default: undefined,
        },
        unitDisplay: {
            type: String,
            default: undefined,
            validator: (v) => ['long', 'short', 'narrow'].includes(v),
        },
        useGrouping: {
            type: String,
            default: undefined,
            validator: (v) => ['always', 'auto', 'min2', false, true].includes(v),
        },
        roundingMode: {
            type: String,
            default: undefined,
            validator: (v) => ['ceil', 'floor', 'expand', 'trunc', 'halfCeil', 'halfFloor', 'halfExpand', 'halfTrunc', 'halfEven'].includes(v),
        },
        roundingPriority: {
            type: String,
            default: undefined,
            validator: (v) => ['auto', 'morePrecision', 'lessPrecision'].includes(v),
        },
        roundingIncrement: {
            type: Number,
            default: undefined,
            validator: (v) => [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000, 2000, 2500, 5000].includes(v),
        },
        trailingZeroDisplay: {
            type: String,
            default: undefined,
            validator: (v) => ['auto', 'stripIfInteger'].includes(v),
        },
        minimumIntegerDigits: {
            type: Number,
            default: undefined,
            validator: (v) => v >= 1 && v <= 21,
        },
        minimumFractionDigits: {
            type: Number,
            default: undefined,
            validator: (v) => v >= 0 && v <= 20,
        },
        maximumFractionDigits: {
            type: Number,
            default: undefined,
            validator: (v) => v >= 0 && v <= 20,
        },
        minimumSignificantDigits: {
            type: Number,
            default: undefined,
            validator: (v) => v >= 1 && v <= 21,
        },
        maximumSignificantDigits: {
            type: Number,
            default: undefined,
            validator: (v) => v >= 1 && v <= 21,
        },
        modelValue: {},
        name: String,
        for: String,
        label: String,
        stackLabel: Boolean,
        hint: String,
        hideHint: Boolean,
        prefix: String,
        suffix: String,
        labelSlot: Boolean,
        bottomSlots: Boolean,
        hideBottomSpace: Boolean,
        autofocus: Boolean,
        clearable: Boolean,
        clearIcon: String,
        loading: Boolean,
        counter: Boolean,
        debounce: [String, Number],
        dense: Boolean,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        flat: Boolean,
        bordered: Boolean,
        rounded: Boolean,
        landscape: Boolean,
        itemAligned: Boolean,
        color: String,
        bgColor: String,
        labelColor: String,
        textColor: String,
        shadowText: String,
        dark: {
            type: Boolean,
            default: null,
        },
        error: {
            type: Boolean,
            default: null,
        },
        errorMessage: String,
        noErrorIcon: Boolean,
        rules: Array,
        reactiveRules: Boolean,
        lazyRules: {
            type: [Boolean, String],
            validator: (v) => [true, false, 'ondemand'].includes(v),
        },
        disable: Boolean,
        readonly: Boolean,
        inputClass: [Array, String, Object],
        inputStyle: [Array, String, Object],
    },
    data() {
        return {
            hasFocus: false,
        };
    },
    computed: {
        hasError() {
            return this.$refs.input.hasError;
        },
        nativeEl() {
            return this.$refs.input.nativeEl;
        },
        modelValueProp: {
            get() {
                const value = this.hasFocus ? this.unformatValue(this.modelValue) : this.formatValue(this.modelValue);
                if (value != this.modelValue) {
                    this.$emit('update:model-value', value);
                }
                return value;
            },
            set(modelValue) {
                this.$emit('update:model-value', modelValue);
            },
        },
        inputProps() {
            const props = {
                dark: this.dark,
                error: this.error,
                errorMessage: this.errorMessage,
                noErrorIcon: this.noErrorIcon,
                rules: this.rules,
                reactiveRules: this.reactiveRules,
                lazyRules: this.lazyRules,
                label: this.label,
                stackLabel: this.stackLabel,
                hint: this.hint,
                hideHint: this.hideHint,
                prefix: this.prefix,
                suffix: this.suffix,
                labelColor: this.labelColor,
                color: this.color,
                bgColor: this.bgColor,
                filled: this.filled,
                outlined: this.outlined,
                borderless: this.borderless,
                standout: this.standout,
                square: this.square,
                loading: this.loading,
                labelSlot: this.labelSlot,
                bottomSlots: this.bottomSlots,
                hideBottomSpace: this.hideBottomSpace,
                rounded: this.rounded,
                dense: this.dense,
                itemAligned: this.itemAligned,
                counter: this.counter,
                clearable: this.clearable,
                clearIcon: this.clearIcon,
                disable: this.disable,
                readonly: this.readonly,
                autofocus: this.autofocus,
                shadowText: this.shadowText,
                debounce: this.debounce,
                inputClass: this.inputClass,
                inputStyle: this.inputStyle,
            };
            Object.keys(props).forEach((key) => {
                if (props[key] === undefined) {
                    delete props[key];
                }
            });
            return props;
        },
        inputHiddenProps() {
            const props = {
                name: this.name || this.for,
                value: this.unformatValue(this.modelValueProp),
                disabled: this.disable || undefined,
            };
            return props;
        },
    },
    methods: {
        formatValue(value) {
            value = parseFloat(typeof value === 'string' ? value.replace(/[^\d-.,]/g, '').replace(',', '.') : value);
            if (isNaN(value)) {
                value = '';
            } else {
                const options = {
                    compactDisplay: this.compactDisplay,
                    currency: this.currency,
                    currencySign: this.currencySign,
                    notation: this.notation,
                    numberingSystem: this.numberingSystem,
                    signDisplay: this.signDisplay,
                    style: this.formattingStyle,
                    unit: this.unit,
                    unitDisplay: this.unitDisplay,
                    useGrouping: this.useGrouping,
                    roundingMode: this.roundingMode,
                    roundingPriority: this.roundingPriority,
                    roundingIncrement: this.roundingIncrement,
                    trailingZeroDisplay: this.trailingZeroDisplay,
                    minimumIntegerDigits: this.minimumIntegerDigits,
                    minimumFractionDigits: this.minimumFractionDigits,
                    maximumFractionDigits: this.maximumFractionDigits,
                    minimumSignificantDigits: this.minimumSignificantDigits,
                    maximumSignificantDigits: this.maximumSignificantDigits,
                };
                value = Intl.NumberFormat(this.locales, options).format(value);
            }
            return value;
        },
        unformatValue(value) {
            return typeof value === 'string' ? value.replace(/[^\d-.,]/g, '') : value;
        },
        resetValidation() {
            this.$refs.input.resetValidation();
        },
        validate(value) {
            return this.$refs.input.validate(value);
        },
        focus() {
            this.$refs.input.focus();
        },
        blur() {
            this.$refs.input.blur();
        },
        select() {
            this.$refs.input.select();
        },
        getNativeElement() {
            this.$refs.input.getNativeElement();
        },
        onKeyPress(evt) {
            const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',', '-'];
            const keyPressed = evt.key;
            if (!keysAllowed.includes(keyPressed)) {
                evt.preventDefault();
                return;
            }
            let value = this.nativeEl.value;
            const positionStart = this.nativeEl.selectionStart;
            const positionEnd = this.nativeEl.selectionEnd;
            value = value.substring(0, positionStart) + keyPressed + value.substring(positionEnd);
            if (!/^-?\d*([.,]\d*)?$/.test(value)) {
                evt.preventDefault();
            }
        },
        onClear(value) {
            this.$emit('clear', value);
        },
        onFocus(evt) {
            this.hasFocus = true;
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.hasFocus = false;
            this.$emit('blur', evt);
        },
    },
    emits: ['update:model-value', 'clear', 'focus', 'blur'],
    expose: ['hasError', 'nativeEl', 'resetValidation', 'validate', 'focus', 'blur', 'select', 'getNativeElement'],
};

function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_input = resolveComponent("q-input");
  return (openBlock(), createBlock(_component_q_input, mergeProps({
    ref: "input",
    modelValue: $options.modelValueProp,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.modelValueProp) = $event))
  }, $options.inputProps, {
    class: "q-number-input",
    onKeypress: $options.onKeyPress,
    onClear: $options.onClear,
    onFocus: $options.onFocus,
    onBlur: $options.onBlur
  }), createSlots({
    default: withCtx(() => [
      createElementVNode("input", mergeProps({ type: "hidden" }, $options.inputHiddenProps), null, 16 /* FULL_PROPS */),
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['prepend'])
      ? {
          name: "prepend",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots['append'])
      ? {
          name: "append",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "append")
          ]),
          key: "1"
        }
      : undefined,
    (_ctx.$slots['before'])
      ? {
          name: "before",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "before")
          ]),
          key: "2"
        }
      : undefined,
    (_ctx.$slots['after'])
      ? {
          name: "after",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "after")
          ]),
          key: "3"
        }
      : undefined,
    (_ctx.$slots['label'])
      ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ]),
          key: "4"
        }
      : undefined,
    (_ctx.$slots['error'])
      ? {
          name: "error",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "error")
          ]),
          key: "5"
        }
      : undefined,
    (_ctx.$slots['hint'])
      ? {
          name: "hint",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "hint")
          ]),
          key: "6"
        }
      : undefined,
    (_ctx.$slots['counter'])
      ? {
          name: "counter",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "counter")
          ]),
          key: "7"
        }
      : undefined,
    (_ctx.$slots['loading'])
      ? {
          name: "loading",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "loading")
          ]),
          key: "8"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["modelValue", "onKeypress", "onClear", "onFocus", "onBlur"]))
}

script$d.render = render$d;
script$d.__file = "src/components/QNumberInput.vue";

var script$c = {
    name: 'QOptionInput',
    components: {
        QCheckbox,
        QField,
        QRadio,
        QToggle,
    },
    props: {
        label: String,
        hint: String,
        hideHint: Boolean,
        labelColor: String,
        color: String,
        bgColor: String,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        loading: Boolean,
        hideBottomSpace: Boolean,
        rounded: Boolean,
        dense: Boolean,
        itemAligned: Boolean,
        counter: Boolean,
        clearable: Boolean,
        clearIcon: String,
        disable: Boolean,
        readonly: Boolean,
        autofocus: Boolean,
        for: String,
        maxlength: [Number, String],
        dark: {
            type: Boolean,
            default: null,
        },
        modelValue: {
            required: true,
        },
        error: {
            type: Boolean,
            default: null,
        },
        errorMessage: String,
        noErrorIcon: Boolean,
        rules: Array,
        reactiveRules: Boolean,
        lazyRules: {
            type: [Boolean, String],
            validator: (v) => [true, false, 'ondemand'].includes(v),
        },
        name: String,
        type: {
            default: 'radio',
            validator: (v) => ['radio', 'checkbox', 'toggle'].includes(v),
        },
        labelPosition: {
            default: 'right',
            validator: (v) => ['top', 'left', 'right'].includes(v),
        },
        val: {},
        trueValue: { default: true },
        falseValue: { default: false },
        indeterminateValue: { default: null },
        toggleOrder: {
            type: String,
            validator: (v) => v === 'tf' || v === 'ft',
        },
        toggleIndeterminate: Boolean,
        checkedIcon: String,
        uncheckedIcon: String,
        indeterminateIcon: String,
        keepColor: Boolean,
        size: String,
        tabindex: [String, Number],
        ellipsis: {
            type: Boolean,
            default: true,
        },
        htmlTitle: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        hasError() {
            return this.$refs.field.hasError;
        },
        modelValueProp: {
            get() {
                return this.modelValue;
            },
            set(modelValue) {
            },
        },
    },
    methods: {
        resetValidation() {
            this.$refs.field.resetValidation();
        },
        validate(value) {
            return this.$refs.field.validate(value);
        },
        focus() {
            this.$refs.field.focus();
        },
        blur() {
            this.$refs.field.blur();
        },
        onUpdateModelValue(value) {
            this.$emit('update:model-value', value);
        },
        onClear(value) {
            this.$emit('clear', value);
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
    },
    emits: ['update:model-value', 'clear', 'focus', 'blur'],
    expose: ['hasError', 'resetValidation', 'validate', 'focus', 'blur'],
};

function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_radio = resolveComponent("q-radio");
  const _component_q_checkbox = resolveComponent("q-checkbox");
  const _component_q_toggle = resolveComponent("q-toggle");
  const _component_q_field = resolveComponent("q-field");
  return (openBlock(), createBlock(_component_q_field, {
    ref: "field",
    modelValue: $options.modelValueProp,
    "onUpdate:modelValue": [
      _cache[3] || (_cache[3] = $event => (($options.modelValueProp) = $event)),
      $options.onUpdateModelValue
    ],
    label: $props.labelPosition === 'top' ? $props.label : undefined,
    "stack-label": true,
    hint: $props.hint,
    "hide-hint": $props.hideHint,
    "label-color": $props.labelColor,
    color: $props.color,
    "bg-color": $props.bgColor,
    filled: $props.filled,
    outlined: $props.outlined,
    borderless: $props.borderless,
    standout: $props.standout,
    square: $props.square,
    loading: $props.loading,
    "hide-bottom-space": $props.hideBottomSpace,
    rounded: $props.rounded,
    dense: $props.dense,
    "item-aligned": $props.itemAligned,
    counter: $props.counter,
    clearable: $props.clearable,
    "clear-icon": $props.clearIcon,
    disable: $props.disable,
    readonly: $props.readonly,
    autofocus: $props.autofocus,
    for: _ctx.$props.for,
    maxlength: $props.maxlength,
    dark: $props.dark,
    error: $props.error,
    "error-message": $props.errorMessage,
    "no-error-icon": $props.noErrorIcon,
    rules: $props.rules,
    "reactive-rules": $props.reactiveRules,
    "lazy-rules": $props.lazyRules,
    onClear: $options.onClear,
    onFocus: $options.onFocus,
    onBlur: $options.onBlur,
    class: "q-option-input"
  }, createSlots({
    control: withCtx(() => [
      ($props.type === 'radio')
        ? (openBlock(), createBlock(_component_q_radio, {
            key: 0,
            modelValue: $options.modelValueProp,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = $event => (($options.modelValueProp) = $event)),
              $options.onUpdateModelValue
            ],
            label: $props.labelPosition !== 'top' ? $props.label : undefined,
            "left-label": $props.labelPosition === 'left',
            title: $props.htmlTitle && $props.ellipsis ? $props.label : undefined,
            name: $props.name,
            val: $props.val,
            "checked-icon": $props.checkedIcon,
            "unchecked-icon": $props.uncheckedIcon,
            color: $props.color,
            "keep-color": $props.keepColor,
            dark: $props.dark,
            dense: $props.dense,
            size: $props.size,
            disable: $props.disable,
            tabindex: $props.tabindex,
            class: normalizeClass({ 'ellipsis-label': $props.ellipsis, 'full-width': true })
          }, null, 8 /* PROPS */, ["modelValue", "label", "left-label", "title", "name", "val", "checked-icon", "unchecked-icon", "color", "keep-color", "dark", "dense", "size", "disable", "tabindex", "class", "onUpdate:modelValue"]))
        : createCommentVNode("v-if", true),
      ($props.type === 'checkbox')
        ? (openBlock(), createBlock(_component_q_checkbox, {
            key: 1,
            modelValue: $options.modelValueProp,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = $event => (($options.modelValueProp) = $event)),
              $options.onUpdateModelValue
            ],
            label: $props.labelPosition !== 'top' ? $props.label : undefined,
            "left-label": $props.labelPosition === 'left',
            title: $props.htmlTitle && $props.ellipsis ? $props.label : undefined,
            name: $props.name,
            val: $props.val,
            "true-value": $props.trueValue,
            "false-value": $props.falseValue,
            "indeterminate-value": $props.indeterminateValue,
            "toggle-order": $props.toggleOrder,
            "toggle-indeterminate": $props.toggleIndeterminate,
            "checked-icon": $props.checkedIcon,
            "unchecked-icon": $props.uncheckedIcon,
            "indeterminate-icon": $props.indeterminateIcon,
            color: $props.color,
            "keep-color": $props.keepColor,
            dark: $props.dark,
            dense: $props.dense,
            size: $props.size,
            disable: $props.disable || $props.readonly,
            tabindex: $props.tabindex,
            class: normalizeClass({ 'ellipsis-label': $props.ellipsis, 'full-width': true })
          }, null, 8 /* PROPS */, ["modelValue", "label", "left-label", "title", "name", "val", "true-value", "false-value", "indeterminate-value", "toggle-order", "toggle-indeterminate", "checked-icon", "unchecked-icon", "indeterminate-icon", "color", "keep-color", "dark", "dense", "size", "disable", "tabindex", "class", "onUpdate:modelValue"]))
        : createCommentVNode("v-if", true),
      ($props.type === 'toggle')
        ? (openBlock(), createBlock(_component_q_toggle, {
            key: 2,
            modelValue: $options.modelValueProp,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = $event => (($options.modelValueProp) = $event)),
              $options.onUpdateModelValue
            ],
            label: $props.labelPosition !== 'top' ? $props.label : undefined,
            "left-label": $props.labelPosition === 'left',
            title: $props.htmlTitle && $props.ellipsis ? $props.label : undefined,
            name: $props.name,
            val: $props.val,
            "true-value": $props.trueValue,
            "false-value": $props.falseValue,
            "indeterminate-value": $props.indeterminateValue,
            "toggle-order": $props.toggleOrder,
            "toggle-indeterminate": $props.toggleIndeterminate,
            "checked-icon": $props.checkedIcon,
            "unchecked-icon": $props.uncheckedIcon,
            "indeterminate-icon": $props.indeterminateIcon,
            color: $props.color,
            "keep-color": $props.keepColor,
            dark: $props.dark,
            dense: $props.dense,
            size: $props.size,
            disable: $props.disable,
            tabindex: $props.tabindex,
            class: normalizeClass({ 'ellipsis-label': $props.ellipsis, 'full-width': true })
          }, null, 8 /* PROPS */, ["modelValue", "label", "left-label", "title", "name", "val", "true-value", "false-value", "indeterminate-value", "toggle-order", "toggle-indeterminate", "checked-icon", "unchecked-icon", "indeterminate-icon", "color", "keep-color", "dark", "dense", "size", "disable", "tabindex", "class", "onUpdate:modelValue"]))
        : createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['default'])
      ? {
          name: "default",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots['prepend'])
      ? {
          name: "prepend",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend")
          ]),
          key: "1"
        }
      : undefined,
    (_ctx.$slots['append'])
      ? {
          name: "append",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "append")
          ]),
          key: "2"
        }
      : undefined,
    (_ctx.$slots['before'])
      ? {
          name: "before",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "before")
          ]),
          key: "3"
        }
      : undefined,
    (_ctx.$slots['after'])
      ? {
          name: "after",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "after")
          ]),
          key: "4"
        }
      : undefined,
    (_ctx.$slots['label'])
      ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ]),
          key: "5"
        }
      : undefined,
    (_ctx.$slots['error'])
      ? {
          name: "error",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "error")
          ]),
          key: "6"
        }
      : undefined,
    (_ctx.$slots['hint'])
      ? {
          name: "hint",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "hint")
          ]),
          key: "7"
        }
      : undefined,
    (_ctx.$slots['counter'])
      ? {
          name: "counter",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "counter")
          ]),
          key: "8"
        }
      : undefined,
    (_ctx.$slots['loading'])
      ? {
          name: "loading",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "loading")
          ]),
          key: "9"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "label", "hint", "hide-hint", "label-color", "color", "bg-color", "filled", "outlined", "borderless", "standout", "square", "loading", "hide-bottom-space", "rounded", "dense", "item-aligned", "counter", "clearable", "clear-icon", "disable", "readonly", "autofocus", "for", "maxlength", "dark", "error", "error-message", "no-error-icon", "rules", "reactive-rules", "lazy-rules", "onUpdate:modelValue", "onClear", "onFocus", "onBlur"]))
}

var css_248z$b = ".q-option-input.q-field--readonly[data-v-13f4e954] .q-field__native .q-checkbox.disabled {\n  opacity: 1 !important;\n  cursor: default !important; }\n\n.q-option-input.q-field--readonly[data-v-13f4e954] .q-field__native .q-checkbox.disabled * {\n  cursor: default !important; }\n";
styleInject(css_248z$b);

script$c.render = render$c;
script$c.__scopeId = "data-v-13f4e954";
script$c.__file = "src/components/QOptionInput.vue";

var script$b = {
    name: 'QOptionGroupInput',
    components: {
        QField,
        QOptionGroup,
    },
    props: {
        label: String,
        hint: String,
        hideHint: Boolean,
        labelColor: String,
        color: String,
        bgColor: String,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        loading: Boolean,
        hideBottomSpace: Boolean,
        rounded: Boolean,
        dense: Boolean,
        itemAligned: Boolean,
        counter: Boolean,
        clearable: Boolean,
        clearIcon: String,
        disable: Boolean,
        readonly: Boolean,
        autofocus: Boolean,
        for: String,
        maxlength: [Number, String],
        dark: {
            type: Boolean,
            default: null,
        },
        modelValue: {
            required: true,
        },
        error: {
            type: Boolean,
            default: null,
        },
        errorMessage: String,
        noErrorIcon: Boolean,
        rules: Array,
        reactiveRules: Boolean,
        lazyRules: {
            type: [Boolean, String],
            validator: (v) => [true, false, 'ondemand'].includes(v),
        },
        name: String,
        options: {
            type: Array,
            validator: (opts) => opts.every((opt) => 'value' in opt && 'label' in opt),
        },
        type: {
            default: 'radio',
            validator: (v) => ['radio', 'checkbox', 'toggle'].includes(v),
        },
        leftLabel: Boolean,
        inline: Boolean,
        size: String,
        keepColor: Boolean,
    },
    computed: {
        hasError() {
            return this.$refs.field.hasError;
        },
        modelValueProp: {
            get() {
                return this.modelValue;
            },
            set(modelValue) {
            },
        },
    },
    methods: {
        resetValidation() {
            this.$refs.field.resetValidation();
        },
        validate(value) {
            return this.$refs.field.validate(value);
        },
        focus() {
            this.$refs.field.focus();
        },
        blur() {
            this.$refs.field.blur();
        },
        onUpdateModelValue(value) {
            this.$emit('update:model-value', value);
        },
        onClear(value) {
            this.$emit('clear', value);
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
    },
    emits: ['update:model-value', 'clear', 'focus', 'blur'],
    expose: ['hasError', 'resetValidation', 'validate', 'focus', 'blur'],
};

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_option_group = resolveComponent("q-option-group");
  const _component_q_field = resolveComponent("q-field");
  return (openBlock(), createBlock(_component_q_field, {
    ref: "field",
    modelValue: $options.modelValueProp,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = $event => (($options.modelValueProp) = $event)),
      $options.onUpdateModelValue
    ],
    label: $props.label,
    "stack-label": Array.isArray($props.options) && $props.options.length > 0,
    hint: $props.hint,
    "hide-hint": $props.hideHint,
    "label-color": $props.labelColor,
    color: $props.color,
    "bg-color": $props.bgColor,
    filled: $props.filled,
    outlined: $props.outlined,
    borderless: $props.borderless,
    standout: $props.standout,
    square: $props.square,
    loading: $props.loading,
    "hide-bottom-space": $props.hideBottomSpace,
    rounded: $props.rounded,
    dense: $props.dense,
    "item-aligned": $props.itemAligned,
    counter: $props.counter,
    clearable: $props.clearable,
    "clear-icon": $props.clearIcon,
    disable: $props.disable,
    readonly: $props.readonly,
    autofocus: $props.autofocus,
    for: _ctx.$props.for,
    maxlength: $props.maxlength,
    dark: $props.dark,
    error: $props.error,
    "error-message": $props.errorMessage,
    "no-error-icon": $props.noErrorIcon,
    rules: $props.rules,
    "reactive-rules": $props.reactiveRules,
    "lazy-rules": $props.lazyRules,
    onClear: $options.onClear,
    onFocus: $options.onFocus,
    onBlur: $options.onBlur,
    class: "q-option-group-input"
  }, createSlots({
    control: withCtx(() => [
      createVNode(_component_q_option_group, {
        modelValue: $options.modelValueProp,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = $event => (($options.modelValueProp) = $event)),
          $options.onUpdateModelValue
        ],
        name: $props.name,
        options: $props.options,
        type: $props.type,
        "left-label": $props.leftLabel,
        inline: $props.inline,
        size: $props.size,
        dense: $props.dense,
        color: $props.color,
        "keep-color": $props.keepColor,
        dark: $props.dark,
        disable: $props.disable
      }, null, 8 /* PROPS */, ["modelValue", "name", "options", "type", "left-label", "inline", "size", "dense", "color", "keep-color", "dark", "disable", "onUpdate:modelValue"])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['default'])
      ? {
          name: "default",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots['prepend'])
      ? {
          name: "prepend",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend")
          ]),
          key: "1"
        }
      : undefined,
    (_ctx.$slots['append'])
      ? {
          name: "append",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "append")
          ]),
          key: "2"
        }
      : undefined,
    (_ctx.$slots['before'])
      ? {
          name: "before",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "before")
          ]),
          key: "3"
        }
      : undefined,
    (_ctx.$slots['after'])
      ? {
          name: "after",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "after")
          ]),
          key: "4"
        }
      : undefined,
    (_ctx.$slots['label'])
      ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ]),
          key: "5"
        }
      : undefined,
    (_ctx.$slots['error'])
      ? {
          name: "error",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "error")
          ]),
          key: "6"
        }
      : undefined,
    (_ctx.$slots['hint'])
      ? {
          name: "hint",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "hint")
          ]),
          key: "7"
        }
      : undefined,
    (_ctx.$slots['counter'])
      ? {
          name: "counter",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "counter")
          ]),
          key: "8"
        }
      : undefined,
    (_ctx.$slots['loading'])
      ? {
          name: "loading",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "loading")
          ]),
          key: "9"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "label", "stack-label", "hint", "hide-hint", "label-color", "color", "bg-color", "filled", "outlined", "borderless", "standout", "square", "loading", "hide-bottom-space", "rounded", "dense", "item-aligned", "counter", "clearable", "clear-icon", "disable", "readonly", "autofocus", "for", "maxlength", "dark", "error", "error-message", "no-error-icon", "rules", "reactive-rules", "lazy-rules", "onUpdate:modelValue", "onClear", "onFocus", "onBlur"]))
}

script$b.render = render$b;
script$b.__file = "src/components/QOptionGroupInput.vue";

const SSR$6 = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
({
    ...QToolbar.props,
});
const viewport = (props, context) => {
    return props.nodes;
};
var script$a = defineComponent({
    name: 'QOverflowToolbar',
    components: {
        viewport,
        QBar,
        QBtn,
        QCard,
        QCardSection,
        QPopupProxy,
        QResizeObserver,
        QSpace,
        QToolbar,
    },
    directives: {
        ClosePopup,
    },
    created() {
        this.$e.event.on('resize.q-overflow-toolbar', this.update);
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.update();
            }, 100);
        });
    },
    updated() {
    },
    unmounted() {
        this.$e.event.off('resize.q-overflow-toolbar', this.update);
    },
    props: {
        modelValue: {
            type: Boolean,
            default: null,
        },
        inset: Boolean,
        debug: {
            type: Boolean,
            default: false,
        },
        forced: {
            type: Boolean,
            default: false,
        },
        target: {
            default: true,
        },
        breakpoint: {
            type: [String, Number],
            default: 450,
        },
        popupWidth: {
            type: String,
            default: '250px',
        },
        dialogWidth: {
            type: String,
            default: '80vw',
        },
        buttonAlign: {
            type: String,
            default: null,
            validator: (v) => ['center', 'left', 'right', 'space-around', 'space-between', 'unset'].includes(v),
        },
        menuButtonProps: Object,
        popupProxyProps: Object,
        toolbarStyle: [String, Array, Object],
        toolbarClass: [String, Array, Object],
    },
    data() {
        return {
            spaceRequired: false,
            nodeWidths: {},
            hiddenIds: [],
        };
    },
    computed: {
        modelValueProp: {
            get() {
                return this.modelValue;
            },
            set(modelValue) {
                this.$emit('update:model-value', modelValue);
            },
        },
        currentComponent() {
            return this.$refs.toolbarMenu.currentComponent;
        },
        hiddenComponentCount() {
            return this.hiddenIds.length;
        },
        menuButtonPropsComputed() {
            let menuButtonProps = {
                flat: true,
                round: true,
                dense: true,
                icon: 'more_vert',
                class: 'q-ml-sm',
            };
            if (typeof this.menuButtonProps == 'object' && this.menuButtonProps != null) {
                menuButtonProps = {
                    ...menuButtonProps,
                    ...this.menuButtonProps,
                };
            }
            return menuButtonProps;
        },
    },
    methods: {
        useSize(size) {
            const defaults = {
                xs: 18,
                sm: 24,
                md: 32,
                lg: 38,
                xl: 46,
            };
            return size !== void 0 ? (size in defaults ? `${defaults[size]}px` : size) : null;
        },
        getInnerWidth(element) {
            if (SSR$6) {
                return 0;
            }
            const style = window.getComputedStyle(element);
            return element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        },
        getOutterWidth(element) {
            if (SSR$6) {
                return 0;
            }
            const style = window.getComputedStyle(element);
            return element.getBoundingClientRect().width + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        },
        getContent(target) {
            let vNodes = this.$slots.default();
            if (target === 'toolbar') {
                vNodes = vNodes.map((vNode, index) => {
                    if (vNode.type.name == 'QKnob' || vNode.type.name == 'QSpinner') {
                        if (typeof vNode.props === 'object' && vNode.props != null) {
                            const size = this.useSize(vNode.props.size);
                            if (size != null) {
                                if (typeof vNode.props.style != 'object' || vNode.props.style == null) {
                                    vNode.props.style = {};
                                }
                                vNode.props.style['min-width'] = size;
                            }
                        }
                    }
                    return vNode;
                });
            } else if (target === 'popup') {
                let fragment = false;
                const vNodesTemp = [];
                for (let i = 0; i < vNodes.length; i++) {
                    const vNode = vNodes[i];
                    if (typeof vNode.type === 'symbol' && Array.isArray(vNode.children)) {
                        vNodesTemp.push(...vNode.children);
                        fragment = true;
                    } else {
                        vNodesTemp.push(vNode);
                    }
                }
                if (fragment) {
                    vNodes = vNodesTemp;
                }
                vNodes = vNodes
                    .filter((vNode, index) => {
                        let id = null;
                        if (
                            typeof vNode.props == 'object' &&
                            vNode.props != null &&
                            typeof vNode.props['qot-id'] === 'string' &&
                            vNode.props['qot-id'].length > 0
                        ) {
                            id = vNode.props['qot-id'];
                        }
                        const processNode = function (vNode) {
                            if (typeof vNode.type === 'object') {
                                if (typeof vNode.props != 'object' || vNode.props == null) {
                                    vNode.props = {};
                                }
                                if (vNode.type.name == 'QBtn') {
                                    vNode.props['no-wrap'] = true;
                                    if (vNode.props.round === '' || vNode.props.round === true) {
                                        vNode.props.round = false;
                                    }
                                    if (
                                        (typeof vNode.props.label != 'string' || vNode.props.label.length == 0) &&
                                        typeof vNode.props.title == 'string' &&
                                        vNode.props.title.length > 0
                                    ) {
                                        vNode.props.label = vNode.props.title;
                                    }
                                } else if (vNode.type.name == 'QBtnGroup') {
                                    vNode.props.outline = false;
                                    vNode.props.rounded = false;
                                    const children = vNode.children.default();
                                    if (Array.isArray(children)) {
                                        let existTitle = false;
                                        for (let i = 0; i < children.length; i++) {
                                            const button = children[i];
                                            if (
                                                typeof button.props === 'object' &&
                                                button.props !== null &&
                                                typeof button.props.title === 'string' &&
                                                button.props.title.length > 0
                                            ) {
                                                existTitle = true;
                                                break;
                                            }
                                        }
                                        if (existTitle) {
                                            children.map((button) => processNode(button));
                                            vNode.children.default = function () {
                                                return children;
                                            };
                                        }
                                    }
                                } else if (vNode.type.name == 'QCheckbox' || vNode.type.name == 'QToggle') {
                                    vNode.props['left-label'] = false;
                                    if (
                                        (typeof vNode.props.label != 'string' || vNode.props.label.length == 0) &&
                                        typeof vNode.props.title == 'string' &&
                                        vNode.props.title.length > 0
                                    ) {
                                        vNode.props.label = vNode.props.title;
                                    }
                                } else if (vNode.type.name == 'QSeparator') {
                                    vNode.props.vertical = false;
                                    vNode.props.spaced = '10px';
                                } else if (vNode.type === 'Symbol(Fragment)') {
                                    const children = vNode.children.default();
                                    if (Array.isArray(children)) {
                                        children.map((child) => processNode(child));
                                    }
                                }
                                if (typeof vNode.props['qot-props'] === 'object') {
                                    Object.assign(vNode.props, vNode.props['qot-props']);
                                    delete vNode.props['qot-props'];
                                }
                                if (Array.isArray(vNode.dirs)) {
                                    for (let i = 0; i < vNode.dirs.length; i++) {
                                        const dir = vNode.dirs[i];
                                        if (dir.dir && dir.dir.name == 'close-popup' && dir.value == 'overflow') {
                                            dir.value = 1;
                                        }
                                    }
                                }
                            }
                            return vNode;
                        };
                        processNode(vNode);
                        if (this.$props.debug === true) {
                            return true;
                        }
                        return id != null && this.hiddenIds.includes(id);
                    })
                    .map((vNode, index) => {
                        if (vNode.type.name == 'QAvatar') {
                            vNode = h('div', { class: 'q-avatar__wrapper' }, vNode);
                        } else if (vNode.type.name == 'QIcon') {
                            vNode = h('div', { class: 'q-icon__wrapper' }, vNode);
                        } else if (vNode.type.name == 'QKnob') {
                            vNode = h('div', { class: 'q-knob__wrapper' }, vNode);
                        } else if (vNode.type.name == 'QSpinner') {
                            vNode = h('div', { class: 'q-spinner__wrapper' }, vNode);
                        }
                        return vNode;
                    });
            } else {
                vNodes = [];
            }
            return vNodes;
        },
        update(force) {
            if (this.$refs.toolbar == null) {
                return;
            }
            let nodes = [];
            let menuNode = null;
            let contentWidth = 0;
            const elements = Array.from(this.$refs.toolbar.$el.children);
            this.spaceRequired = true;
            elements.forEach((element, index) => {
                if (!element.matches('.q-space')) {
                    const menu = element.getAttribute('qot-menu') === 'true';
                    let id = element.getAttribute('qot-id');
                    let priority = parseInt(element.getAttribute('qot-priority')) || 0;
                    if (typeof id != 'string' || id.length == 0) {
                        const innerElement = element.querySelector('[qot-id]');
                        if (innerElement != null) {
                            id = innerElement.getAttribute('qot-id');
                            priority = parseInt(innerElement.getAttribute('qot-priority')) || 0;
                        }
                    }
                    let width = this.getOutterWidth(element);
                    if (element.matches('.overflow_hidden') && element.style.display === 'none') {
                        width = this.nodeWidths[id] || 0;
                        if (this.forced || force === true) {
                            element.style.display = null;
                            width = this.getOutterWidth(element);
                            element.style.display = 'none';
                        }
                    }
                    if (!menu) {
                        contentWidth += width;
                    }
                    if (typeof id === 'string' && id.length > 0) {
                        if (nodes.find((node) => node.id === id) != undefined) {
                            throw new Error(`Duplicate overflow ID '${id}'!`);
                        }
                        nodes.push({
                            id: id,
                            element: element,
                            width: width,
                            priority: priority,
                        });
                    } else if (menu) {
                        menuNode = {
                            element: element,
                            width: width,
                        };
                    }
                } else {
                    if (!element.matches('.overflow_space')) {
                        this.spaceRequired = false;
                    }
                }
            });
            contentWidth += 10;
            let toolbarWidth = this.getInnerWidth(this.$refs.toolbar.$el);
            nodes = nodes.reverse().sort((node1, node2) => {
                return node2.priority - node1.priority;
            });
            this.hiddenIds = [];
            menuNode.element.style.display = 'none';
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if (contentWidth >= toolbarWidth) {
                    this.hiddenIds.push(node.id);
                    node.element.classList.add('overflow_hidden');
                    node.element.style.display = 'none';
                    this.nodeWidths[node.id] = node.width;
                    contentWidth -= node.width;
                    if (menuNode.element.style.display === 'none' && this.target == true) {
                        menuNode.element.style.display = null;
                        contentWidth += this.getOutterWidth(menuNode.element);
                    }
                } else {
                    node.element.style.display = null;
                    node.element.classList.remove('overflow_hidden');
                    delete this.nodeWidths[node.id];
                }
            }
            if (this.hiddenIds.length === 0) {
                this.$refs.toolbarMenu.hide();
            }
            this.$emit('update');
        },
    },
    emits: ['update:model-value', 'update', 'before-show', 'show', 'before-hide', 'hide'],
    expose: ['update', 'currentComponent', 'hiddenComponentCount'],
});

const _hoisted_1$a = {
  class: "q-overflow-toolbar",
  style: {"overflow":"hidden"}
};
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_resize_observer = resolveComponent("q-resize-observer");
  const _component_viewport = resolveComponent("viewport");
  const _component_q_space = resolveComponent("q-space");
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_bar = resolveComponent("q-bar");
  const _component_q_card_section = resolveComponent("q-card-section");
  const _component_q_card = resolveComponent("q-card");
  const _component_q_popup_proxy = resolveComponent("q-popup-proxy");
  const _component_q_toolbar = resolveComponent("q-toolbar");
  const _directive_close_popup = resolveDirective("close-popup");
  return (openBlock(), createElementBlock("div", _hoisted_1$a, [
    createVNode(_component_q_toolbar, {
      ref: "toolbar",
      inset: _ctx.inset,
      style: normalizeStyle(_ctx.toolbarStyle),
      class: normalizeClass(_ctx.toolbarClass)
    }, {
      default: withCtx(() => [
        createVNode(_component_q_resize_observer, {
          debounce: 0,
          onResize: _cache[0] || (_cache[0] = $event => (_ctx.update()))
        }),
        createVNode(_component_viewport, {
          nodes: _ctx.getContent('toolbar')
        }, null, 8 /* PROPS */, ["nodes"]),
        (_ctx.spaceRequired)
          ? (openBlock(), createBlock(_component_q_space, {
              key: 0,
              class: "overflow_space"
            }))
          : createCommentVNode("v-if", true),
        createVNode(_component_q_btn, mergeProps(_ctx.menuButtonPropsComputed, { "qot-menu": "true" }), {
          default: withCtx(() => [
            createVNode(_component_q_popup_proxy, mergeProps({
              target: _ctx.target,
              breakpoint: _ctx.breakpoint
            }, _ctx.popupProxyProps, {
              ref: "toolbarMenu",
              modelValue: _ctx.modelValueProp,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.modelValueProp) = $event)),
              class: { 'q-overflow-toolbar__menu': true, ['q-overflow-toolbar__menu--btn-align-' + _ctx.buttonAlign]: _ctx.buttonAlign },
              style: { width: _ctx.popupWidth },
              onBeforeShow: _cache[2] || (_cache[2] = $event => (_ctx.$emit('before-show', $event))),
              onShow: _cache[3] || (_cache[3] = $event => (_ctx.$emit('show', $event))),
              onBeforeHide: _cache[4] || (_cache[4] = $event => (_ctx.$emit('before-hide', $event))),
              onHide: _cache[5] || (_cache[5] = $event => (_ctx.$emit('hide', $event)))
            }), {
              default: withCtx(() => [
                createVNode(_component_q_card, {
                  style: normalizeStyle({ width: _ctx.dialogWidth })
                }, {
                  default: withCtx(() => [
                    createVNode(_component_q_bar, { class: "q-overflow-toolbar__menu-bar q-px-none" }, {
                      default: withCtx(() => [
                        createVNode(_component_q_space),
                        withDirectives(createVNode(_component_q_btn, {
                          dense: "",
                          flat: "",
                          round: "",
                          icon: "close",
                          class: "q-mr-xs"
                        }, null, 512 /* NEED_PATCH */), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_q_card_section, { class: "q-overflow-toolbar__menu-content scroll q-pa-none" }, {
                      default: withCtx(() => [
                        createVNode(_component_viewport, {
                          nodes: _ctx.getContent('popup')
                        }, null, 8 /* PROPS */, ["nodes"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["style"])
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */, ["target", "breakpoint", "modelValue", "class", "style"])
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["inset", "style", "class"])
  ]))
}

var css_248z$a = "\n.q-overflow-toolbar[data-v-5ef68498]  .q-btn .q-btn__content {\n    flex-wrap: nowrap;\n    white-space: nowrap;\n}\n.q-overflow-toolbar[data-v-5ef68498]  .q-field .q-field__inner {\n    width: inherit;\n}\n.q-overflow-toolbar[data-v-5ef68498]  .q-checkbox.ellipsis,\n.q-overflow-toolbar[data-v-5ef68498]  .q-toggle.ellipsis,\n.q-overflow-toolbar[data-v-5ef68498]  .q-select.ellipsis {\n    text-overflow: unset;\n    white-space: unset;\n    overflow: unset;\n}\n.q-overflow-toolbar[data-v-5ef68498]  .q-checkbox.ellipsis .q-checkbox__label,\n.q-overflow-toolbar[data-v-5ef68498]  .q-toggle.ellipsis .q-toggle__label,\n.q-overflow-toolbar[data-v-5ef68498]  .q-select.ellipsis .q-field__control .q-field__native > span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n";
styleInject(css_248z$a);

var css_248z$9 = "\n.q-overflow-toolbar__menu.q-dialog {\n    width: unset !important;\n}\n.q-overflow-toolbar__menu.q-menu .q-card {\n    width: unset !important;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-bar {\n    display: none;\n}\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content {\n    max-height: calc(100vh - 80px);\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content,\n.overflow_menuX.q-menu {\n    padding: 5px;\n    max-width: none !important;\n    /* overflow-y: scroll; */\n    /* width: 200px !important; */\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content > *,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content > * {\n    display: flex !important;\n    /* width: 200px !important; */\n    width: 100% !important;\n    margin: 0px;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content > *:not(:first-child),\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content > *:not(:first-child) {\n    margin-top: 5px;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-btn .q-btn__content,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-btn .q-btn__content {\n    flex-wrap: nowrap;\n    white-space: nowrap;\n    /* justify-content: unset; */\n}\n.q-overflow-toolbar__menu.q-overflow-toolbar__menu--btn-align-center .q-overflow-toolbar__menu-content .q-btn .q-btn__content {\n    justify-content: center;\n}\n.q-overflow-toolbar__menu.q-overflow-toolbar__menu--btn-align-left .q-overflow-toolbar__menu-content .q-btn .q-btn__content {\n    justify-content: left;\n}\n.q-overflow-toolbar__menu.q-overflow-toolbar__menu--btn-align-right .q-overflow-toolbar__menu-content .q-btn .q-btn__content {\n    justify-content: right;\n}\n.q-overflow-toolbar__menu.q-overflow-toolbar__menu--btn-align-space-around .q-overflow-toolbar__menu-content .q-btn .q-btn__content {\n    justify-content: space-around;\n}\n.q-overflow-toolbar__menu.q-overflow-toolbar__menu--btn-align-space-between .q-overflow-toolbar__menu-content .q-btn .q-btn__content {\n    justify-content: space-between;\n}\n.q-overflow-toolbar__menu.q-overflow-toolbar__menu--btn-align-unset .q-overflow-toolbar__menu-content .q-btn .q-btn__content {\n    justify-content: unset;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-btn .q-btn__content > span,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-btn .q-btn__content > span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n/* .q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-btn.q-btn--round,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-btn.q-btn--round {\n    border-radius: unset;\n    padding: 4px 16px;\n} */\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-toolbar__title,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-toolbar__title {\n    display: block !important;\n    padding-left: 0px;\n    padding-right: 0px;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-checkbox .q-checkbox__label,\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-toggle .q-toggle__label,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-checkbox .q-checkbox__label,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-toggle .q-toggle__label {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-avatar__wrapper,\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-icon__wrapper,\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-knob__wrapper,\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-spinner__wrapper,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-avatar__wrapper,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-icon__wrapper,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-knob__wrapper,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-spinner__wrapper {\n    justify-content: center;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-btn-group,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-btn-group {\n    flex-direction: column;\n    /* border-radius: 0px; */\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-btn-group > .q-btn-item:first-child,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-btn-group > .q-btn-item:first-child {\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-btn-group > .q-btn-item:last-child,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-btn-group > .q-btn-item:last-child {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: inherit;\n    border-bottom-right-radius: inherit;\n}\n.q-overflow-toolbar__menu.q-menu .q-overflow-toolbar__menu-content .q-select.ellipsis .q-field__control .q-field__native > span,\n.q-overflow-toolbar__menu.q-dialog .q-overflow-toolbar__menu-content .q-select.ellipsis .q-field__control .q-field__native > span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n";
styleInject(css_248z$9);

script$a.render = render$a;
script$a.__scopeId = "data-v-5ef68498";
script$a.__file = "src/components/QOverflowToolbar.vue";

const SSR$5 = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
/*
column: {
    name,
    label,
    field,
    required,
    align,
    sortable,
    sort,
    sortOrder,
    format,
    style,
    classes,
    headerStyle,
    headerClasses,
    ----------------------------
    caption,
    alignHeader,
    width,
    minWidth,
    resizable,
    filterType,
    filterDisabled,
    sortField,
    dlField,
    dlFilterable,
    dlFilterContains,
    csvField,
    hidden,
}
*/
const qTableProps = {
    ...QTable.props,
};
delete qTableProps.onRowClick;
delete qTableProps.onRowDblclick;
delete qTableProps.onRowContextmenu;
var script$9 = defineComponent({
    name: 'QGrid',
    components: {
        QBtn,
        QBtnGroup,
        QCard,
        QCardActions,
        QCardSection,
        QDate,
        QDialog,
        QCheckbox,
        QIcon,
        QInput,
        QItem,
        QItemLabel,
        QItemSection,
        QList,
        QMenu,
        QPopupProxy,
        QResizeObserver,
        QSelect,
        QSeparator,
        QSpace,
        QTable,
        QTd,
        QTh,
        QTooltip,
        QTr,
        QOverflowToolbar: script$a,
    },
    directives: {
        ClosePopup,
        Ripple,
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local',
        });
        return { t };
    },
    created() {
        this.loadTableConfig();
        if (this.loadTypeProp === 'dynamic') {
            if (typeof this.paginationProp === 'object') {
                this.paginationProp.rowsNumber = 1;
            } else {
                this.paginationProp = {
                    rowsNumber: 1,
                };
            }
            this.rowsPerPageOptionsProp = [0];
            this.virtualScrollProp = true;
        } else if (this.loadTypeProp === 'static') {
            if (typeof this.paginationProp === 'object') {
                delete this.paginationProp.rowsNumber;
            }
            this.rowsPerPageOptionsProp = [0];
            this.virtualScrollProp = true;
        }
    },
    mounted() {
        this.updateColumnsResize();
        this.fitColumnsWidth();
        if (this.loadTypeProp === 'dynamic' || this.loadTypeProp === 'static') {
            this.columnsWidthFitted = !this.columnsWidthFittedSuccess;
            this.requestServerInteraction();
        }
        this.updateToolbar();
    },
    updated() {
        this.updateColumnsResize();
    },
    unmounted() {
        this.updateColumnsResize();
    },
    props: {
        ...qTableProps,
        rows: {
            type: Array,
            default: () => [],
        },
        columns: Array,
        selection: {
            type: String,
            default: 'none',
            validator: (v) => ['single', 'multiple', 'none'].includes(v),
        },
        selected: {
            type: Array,
            default: () => [],
        },
        visibleColumns: Array,
        pagination: Object,
        fullscreen: Boolean,
        expanded: Array,
        filter: [String, Object],
        tableConfigKey: {
            type: String,
        },
        tableConfigExtended: {
            type: Boolean,
            default: true,
        },
        tableConfigExternal: {
            type: Object,
            default: null,
        },
        storeTableConfigEnabled: {
            type: Boolean,
            default: false,
        },
        noHover: {
            type: Boolean,
            default: false,
        },
        showRowCount: {
            type: Boolean,
            default: false,
        },
        tableFilter: {
            type: Boolean,
            default: false,
        },
        fullscreenToggle: {
            type: Boolean,
            default: false,
        },
        selectOnRowClick: {
            type: Boolean,
            default: true,
        },
        exportCsv: {
            type: Boolean,
            default: false,
        },
        exportFileName: {
            type: String,
            default: 'export',
        },
        booleanAsCheckbox: {
            type: Boolean,
            default: false,
        },
        columnsMinWidth: {
            type: Number,
        },
        columnsFilter: {
            type: Boolean,
            default: false,
        },
        columnsResize: {
            type: Boolean,
            default: false,
        },
        columnsResizeMode: {
            type: String,
            default: 'self',
            validator: (v) => ['self', 'next'].includes(v),
        },
        columnsResizeToFit: {
            type: Boolean,
            default: false,
        },
        columnsReorder: {
            type: Boolean,
            default: false,
        },
        columnsControl: {
            type: Boolean,
            default: false,
        },
        reload: {
            type: Boolean,
            default: false,
        },
        stickyHeader: {
            type: Boolean,
            default: false,
        },
        stickyColumn: {
            type: Boolean,
            default: false,
        },
        virtualScrollItemSize: {
            type: [Number, String],
        },
        virtualScrollStickySizeStart: {
            type: [Number, String],
        },
        virtualScrollStickySizeEnd: {
            type: [Number, String],
        },
        loadType: {
            type: String,
            default: null,
            validator: (v) => [null, 'static', 'dynamic'].includes(v),
        },
        loadTypeEditable: {
            type: Boolean,
            default: false,
        },
        toolbarSearchInputProps: {
            type: Object,
            default: null,
        },
        toolbarButtonsProps: {
            type: Object,
            default: null,
        },
        toolbarProps: Object,
        toolbarModelValue: {
            type: Boolean,
            default: null,
        },
        style: [String, Array, Object],
        class: [String, Array, Object],
        id: String,
    },
    data() {
        return {
            rowsProp: this.rows,
            columnsProp: [],
            columnsFilterData: {},
            columnsConfigDialog: false,
            columnsFilterEnabled: false,
            columnsFilterDeferred: false,
            columnsWidthFitted: false,
            columnsWidthFittedSuccess: false,
            paginationProp: this.pagination || {},
            selectionProp: this.selection !== 'single' && this.selection !== 'multiple' ? 'none' : this.selection,
            selectedProp: this.selected === undefined ? [] : this.selected,
            filterProp: typeof this.filter === 'string' ? this.filter : this.tableFilter !== true && typeof this.filter === 'object' ? this.filter : '',
            fullscreenProp: this.fullscreen,
            expandedProp: this.expanded,
            visibleColumnsProp: null,
            virtualScrollProp: this.virtualScroll,
            virtualScrollItemSizeProp: this.virtualScrollItemSize,
            virtualScrollStickySizeStartProp: this.virtualScrollStickySizeStart,
            virtualScrollStickySizeEndProp: this.virtualScrollStickySizeEnd,
            rowsPerPageOptionsProp: this.rowsPerPageOptions,
            keyNavigationActive: false,
            loadTypeProp: this.loadType,
            loadTypeEditableProp: this.loadTypeEditable,
            loadTypeState: this.loadType === 'dynamic',
            tableConfig: null,
            tableConfigLoading: false,
        };
    },
    computed: {
        filteredSortedRows() {
            return this.$refs.gridTable.filteredSortedRows;
        },
        computedRows() {
            return this.$refs.gridTable.computedRows;
        },
        computedRowsNumber() {
            return this.$refs.gridTable.computedRowsNumber;
        },
        hidePaginationProp() {
            return this.hidePagination && !this.showRowCount;
        },
        paginationLabelProp() {
            return (
                this.paginationLabel ||
                (this.showRowCount ? (firstRowIndex, endRowIndex, totalRowsNumber) => this.t('rowCount') + ': ' + endRowIndex : undefined)
            );
        },
        filteredRows() {
            let self = this;
            let filterData = self.columnsFilterData;
            let rows = this.rowsProp;
            if (this.columnsFilter && this.columnsFilterEnabled && this.loadTypeProp !== 'dynamic') {
                rows = rows.filter(function (row) {
                    for (let i = 0; i < self.columnsProp.length; i++) {
                        const column = self.columnsProp[i];
                        const name = column.name;
                        const value = self.getCellValue(column, row);
                        if (!(name in filterData) || filterData[name] == '') continue;
                        if (value == null) return true;
                        if (!column.hasOwnProperty('filterType') || column.filterType == 'text') {
                            if (value.toString().toLowerCase().indexOf(filterData[name].toLowerCase()) == -1) {
                                return false;
                            }
                        }
                        if (column.hasOwnProperty('filterType') && column.filterType == 'date') {
                            if (typeof filterData[name] === 'object') {
                                const isFrom = typeof filterData[name].from == 'string' && filterData[name].from.length > 0;
                                const isTo = typeof filterData[name].to == 'string' && filterData[name].to.length > 0;
                                if (isFrom && isTo) {
                                    let fromDate = date.extractDate(filterData[name].from, 'DD.MM.YYYY');
                                    let toDate = date.extractDate(filterData[name].to, 'DD.MM.YYYY');
                                    let compareDate = date.extractDate(value, 'DD.MM.YYYY');
                                    if (!date.isBetweenDates(compareDate, fromDate, toDate, { inclusiveFrom: true, inclusiveTo: true })) {
                                        return false;
                                    }
                                } else if (typeof filterData[name].value == 'string' && filterData[name].value.length > 0) {
                                    if (value.toString().toLowerCase().indexOf(filterData[name].value.toLowerCase()) == -1) {
                                        return false;
                                    }
                                }
                            }
                        }
                        if (column.hasOwnProperty('filterType') && column.filterType == 'number_range') {
                            if (typeof filterData[name] === 'object') {
                                const isFrom = typeof filterData[name].from != 'string';
                                const isTo = typeof filterData[name].to != 'string';
                                if (isFrom || isTo) {
                                    const number = parseFloat(value);
                                    const from = parseFloat(filterData[name].from);
                                    const to = parseFloat(filterData[name].to);
                                    if (isFrom && isTo && !(number >= from && number <= to)) {
                                        return false;
                                    } else if (isFrom && !(number >= from)) {
                                        return false;
                                    } else if (isTo && !(number <= to)) {
                                        return false;
                                    }
                                } else if (typeof filterData[name].value == 'string' && filterData[name].value.length > 0) {
                                    if (value.toString().toLowerCase().indexOf(filterData[name].value.toLowerCase()) == -1) {
                                        return false;
                                    }
                                }
                            }
                        }
                        if (column.hasOwnProperty('filterType') && column.filterType == 'select') {
                            if (filterData[name].length > 0 && filterData[name].indexOf(value.toString().toLowerCase()) == -1) {
                                return false;
                            }
                        }
                    }
                    return true;
                });
            }
            return rows;
        },
        visibleTop() {
            return this.$slots['top'] || this.$slots['toolbar'] || this.title || this.visibleToolbarRight;
        },
        visibleToolbarRight() {
            return (
                this.tableFilter || (this.reload && this.loadTypeProp) || this.exportCsv || this.columnsFilter || this.columnsControl || this.fullscreenToggle
            );
        },
        toolbarModelValueProp: {
            get() {
                return this.toolbarModelValue;
            },
            set(toolbarModelValue) {
                this.$emit('update:toolbar-model-value', toolbarModelValue);
            },
        },
    },
    methods: {
        toggleFullscreen() {
            this.$refs.gridTable.toggleFullscreen();
        },
        setFullscreen() {
            this.$refs.gridTable.setFullscreen();
        },
        exitFullscreen() {
            this.$refs.gridTable.exitFullscreen();
        },
        requestServerInteraction(props) {
            this.$refs.gridTable.requestServerInteraction(props);
        },
        setPagination(pagination, forceServerRequest) {
            this.$refs.gridTable.setPagination(pagination, forceServerRequest);
        },
        firstPage() {
            this.$refs.gridTable.firstPage();
        },
        prevPage() {
            this.$refs.gridTable.prevPage();
        },
        nextPage() {
            this.$refs.gridTable.nextPage();
        },
        lastPage() {
            this.$refs.gridTable.lastPage();
        },
        isRowSelected(key) {
            return this.$refs.gridTable.isRowSelected(key);
        },
        clearSelection() {
            this.$refs.gridTable.clearSelection();
        },
        isRowExpanded(key) {
            return this.$refs.gridTable.isRowExpanded(key);
        },
        setExpanded(expanded) {
            this.$refs.gridTable.setExpanded(expanded);
        },
        sort(col) {
            this.$refs.gridTable.sort(col);
        },
        resetVirtualScroll() {
            this.$refs.gridTable.resetVirtualScroll();
        },
        scrollTo(index, edge) {
            this.$refs.gridTable.scrollTo(index, edge);
        },
        getCellValue(col, row) {
            const val = typeof col.field === 'function' ? col.field(row) : row[col.field];
            return col.format !== void 0 ? col.format(val, row) : val;
        },
        getCellKeyValue(row) {
            const col = { field: this.rowKey };
            return this.getCellValue(col, row);
        },
        extractValue(object, field) {
            if (field.indexOf('.') !== -1 || field.indexOf('(') !== -1 || field.indexOf('[') !== -1 || field.indexOf(' ') !== -1) {
                try {
                    return eval('object.' + field);
                } catch (e) {
                    return null;
                }
            } else {
                return object[field];
            }
        },
        getClass() {
            let classProp = '';
            classProp += this.stickyHeader ? ' q-table--sticky-header' : '';
            classProp += this.stickyColumn ? ' q-table--sticky-column' : '';
            classProp += this.columnsResize ? ' q-table--col-resizable' : '';
            classProp += this.$props.class ? ' ' + this.$props.class : '';
            return classProp;
        },
        forceUpdate() {
            this.$forceUpdate();
        },
        onRowClick(evt, props) {
            if (this.selectOnRowClick === true) {
                props.selected = !props.selected;
            }
            this.$emit('row-click', evt, props.row, props.rowIndex);
        },
        onRowDblclick(evt, props) {
            this.$emit('row-dblclick', evt, props.row, props.rowIndex);
        },
        onRowContextmenu(evt, props) {
            this.$emit('row-contextmenu', evt, props.row, props.rowIndex);
        },
        onRequest(requestProps) {
            if (typeof requestProps !== 'object') {
                requestProps = {
                    pagination: this.paginationProp,
                    filter: this.filterProp,
                    getCellValue: this.getCellValue,
                };
            }
            if (this.loadTypeProp) {
                if (this.loadTypeProp === 'dynamic') {
                    this.paginationProp.sortBy = requestProps.pagination.sortBy;
                    this.paginationProp.descending = requestProps.pagination.descending;
                    const paginationProp = requestProps.pagination;
                    const config = this.getDynamicLoadConfig(paginationProp);
                    requestProps.loadConfig = config;
                }
                requestProps.columnsFilter = extend(true, {}, this.columnsFilterData);
                requestProps.callback = function (rows) {
                    this.rowsProp = rows;
                    this.selectedProp = [];
                    this.$nextTick(() => this.fitColumnsWidth(true));
                }.bind(this);
                this.rowsProp = [];
            }
            this.$emit('request', requestProps);
        },
        onRequestLoad(requestProps) {
            const keys = [];
            for (let i = requestProps.from; i <= requestProps.to; i++) {
                if (this.filteredRows[i] && this.filteredRows[i].__loaded !== true) {
                    keys.push(this.getCellKeyValue(this.filteredRows[i]));
                }
            }
            const callback = function (rowMap) {
                for (let i = 0; i < this.filteredRows.length; i++) {
                    const row = this.filteredRows[i];
                    const data = rowMap[this.getCellKeyValue(row)];
                    if (data != undefined) {
                        data.__loaded = true;
                        this.filteredRows[i] = data;
                    }
                }
            }.bind(this);
            if (keys.length > 0) {
                this.$emit('request-load', {
                    fromIndex: requestProps.from,
                    toIndex: requestProps.to,
                    keys: keys,
                    callback: callback,
                });
            }
        },
        onSelection(details) {
            this.$emit('selection', details);
        },
        onVirtualScroll(details) {
            this.$emit('virtual-scroll', details);
            if (this.loadTypeProp === 'dynamic' && details.from <= details.to) {
                this.onRequestLoad(details);
            }
        },
        reloadData() {
            if (this.loadTypeProp) {
                this.onRequest();
            }
            this.$emit('reload');
        },
        onChangeLoadType(value) {
            const loadTypeKey = this.tableConfigKey + 'qgrid' + (typeof this.id === 'string' ? '-' + this.id : '') + '-loadtype';
            localStorage.setItem(loadTypeKey, value ? 'dynamic' : 'static');
            this.$router.go(0);
        },
        storeTableConfig() {
            if (this.tableConfigLoading || typeof this.tableConfigKey != 'string' || this.tableConfigKey.length == 0) {
                return;
            }
            if (this.storeTableConfigEnabled) {
                const configKey = this.tableConfigKey + 'qgrid' + (typeof this.id === 'string' ? '-' + this.id : '') + '-config';
                if (this.tableConfigExtended) {
                    this.tableConfig = {
                        columns: {},
                        pagination: {
                            sortBy: this.paginationProp.sortBy,
                            descending: this.paginationProp.descending,
                        },
                        filter: this.filterProp,
                        columnsFilter: this.columnsFilterData,
                        columnsFilterEnabled: this.columnsFilterEnabled,
                    };
                } else {
                    this.tableConfig = {
                        columns: {},
                    };
                }
                this.columnsProp.forEach((column, index) => {
                    this.tableConfig.columns[column.name] = {
                        index: index,
                        width: column.width,
                        visible: this.isColumnVisible(column),
                    };
                });
                if (typeof this.tableConfigExternal === 'object') {
                    this.tableConfig.external = this.tableConfigExternal;
                }
                localStorage.setItem(configKey, JSON.stringify(this.tableConfig));
            }
        },
        loadTableConfig() {
            if (typeof this.tableConfigKey != 'string' || this.tableConfigKey.length == 0) {
                this.loadTypeEditableProp = false;
                return;
            }
            if (this.storeTableConfigEnabled) {
                this.tableConfigLoading = true;
                const configKey = this.tableConfigKey + 'qgrid' + (typeof this.id === 'string' ? '-' + this.id : '') + '-config';
                this.tableConfig = JSON.parse(localStorage.getItem(configKey));
                if (typeof this.tableConfig === 'object' && this.tableConfig != null) {
                    if (typeof this.tableConfig.columns === 'object' && this.tableConfig.columns != null) {
                        const columns = this.columnsProp.map(toRaw);
                        const visibleColumnsProp = [];
                        columns.sort((column1, column2) => {
                            return this.tableConfig.columns[column1.name].index - this.tableConfig.columns[column2.name].index;
                        });
                        columns.forEach((column) => {
                            const config = this.tableConfig.columns[column.name];
                            column.width = config.width;
                            if (config.visible) {
                                visibleColumnsProp.push(column.name);
                            }
                        });
                        this.columnsProp = columns;
                        this.visibleColumnsProp = visibleColumnsProp;
                    }
                    if (this.tableConfigExtended) {
                        if (typeof this.tableConfig.pagination === 'object') {
                            this.paginationProp.sortBy = this.tableConfig.pagination.sortBy;
                            this.paginationProp.descending = this.tableConfig.pagination.descending;
                        }
                        if (this.tableConfig.filter != void 0) {
                            this.filterProp = this.tableConfig.filter;
                        }
                        if (this.tableConfig.columnsFilter != void 0) {
                            this.columnsFilterData = this.tableConfig.columnsFilter;
                        }
                        this.columnsFilterEnabled = this.tableConfig.columnsFilterEnabled;
                    }
                    if (typeof this.tableConfig.external === 'object') {
                        this.$emit('update:table-config-external', this.tableConfig.external);
                    }
                }
                this.$nextTick(() => (this.tableConfigLoading = false));
            }
            if (this.loadTypeProp && this.loadTypeEditableProp) {
                const loadTypeKey = this.tableConfigKey + 'qgrid' + (typeof this.id === 'string' ? '-' + this.id : '') + '-loadtype';
                const loadType = localStorage.getItem(loadTypeKey);
                this.loadTypeProp = loadType === 'static' || loadType === 'dynamic' ? loadType : this.loadTypeProp;
                this.loadTypeState = this.loadTypeProp === 'dynamic';
            }
        },
        getDynamicLoadConfig(paginationProp) {
            const dynamicLoadConfig = {
                attributes: [],
            };
            const filterCondition = [];
            const globalFilterCondition = [];
            let conditionRequired = false;
            const columns = this.columnsProp.map(toRaw);
            columns.forEach((column) => {
                if (this.isColumnVisible(column)) {
                    const name = typeof column.dlField === 'string' && column.dlField.length > 0 ? column.dlField : column.field;
                    let attribute = {};
                    if (this.columnsFilter && this.columnsFilterEnabled && column.filterDisabled !== true && column.dlFilterable !== false) {
                        const columnFilter = this.columnsFilterData[column.name];
                        if (!column.hasOwnProperty('filterType') || column.filterType == 'text') {
                            if (typeof columnFilter === 'string') {
                                const filterValue = columnFilter;
                                if (filterValue && filterValue.length > 0 && filterValue !== '*') {
                                    attribute.name = name;
                                    attribute.filter = column.dlFilterContains === true ? `*${filterValue}*` : filterValue;
                                    dynamicLoadConfig.attributes.push(attribute);
                                    filterCondition.push('{' + (dynamicLoadConfig.attributes.length - 1) + '}');
                                }
                            }
                        }
                        if (column.hasOwnProperty('filterType') && column.filterType == 'date') {
                            if (typeof columnFilter === 'object') {
                                let filterValue;
                                const isFrom = typeof columnFilter.from == 'string' && columnFilter.from.length > 0;
                                const isTo = typeof columnFilter.to == 'string' && columnFilter.to.length > 0;
                                if (isFrom && isTo) {
                                    filterValue = columnFilter.from + '~' + columnFilter.to;
                                } else if (typeof columnFilter.value == 'string' && columnFilter.value.length > 0) {
                                    filterValue = columnFilter.value;
                                }
                                if (filterValue && filterValue.length > 0 && filterValue !== '*') {
                                    attribute.name = name;
                                    attribute.filter = filterValue;
                                    dynamicLoadConfig.attributes.push(attribute);
                                    filterCondition.push('{' + (dynamicLoadConfig.attributes.length - 1) + '}');
                                }
                            }
                        }
                        if (column.hasOwnProperty('filterType') && column.filterType == 'number_range') {
                            if (typeof columnFilter === 'object') {
                                let filterValue;
                                const isFrom = typeof columnFilter.from != 'string';
                                const isTo = typeof columnFilter.to != 'string';
                                if (isFrom || isTo) {
                                    if (isFrom && isTo) {
                                        filterValue = columnFilter.from + '~' + columnFilter.to;
                                    } else if (isFrom) {
                                        filterValue = columnFilter.from;
                                    } else if (isTo) {
                                        filterValue = columnFilter.to;
                                    }
                                } else if (typeof columnFilter.value == 'string' && columnFilter.value.length > 0) {
                                    filterValue = columnFilter.value;
                                }
                                if (filterValue && filterValue.length > 0 && filterValue !== '*') {
                                    attribute.name = name;
                                    attribute.filter = filterValue;
                                    dynamicLoadConfig.attributes.push(attribute);
                                    filterCondition.push('{' + (dynamicLoadConfig.attributes.length - 1) + '}');
                                }
                            }
                        }
                        if (column.hasOwnProperty('filterType') && column.filterType == 'select') {
                            if (columnFilter.length > 0) {
                                const filterSelectCondition = [];
                                for (let i = 0; i < columnFilter.length; i++) {
                                    const filterValue = columnFilter[i];
                                    if (filterValue && filterValue.length > 0 && filterValue !== '*') {
                                        attribute = {};
                                        attribute.name = name;
                                        attribute.filter = filterValue;
                                        dynamicLoadConfig.attributes.push(attribute);
                                        filterSelectCondition.push('{' + (dynamicLoadConfig.attributes.length - 1) + '}');
                                    }
                                }
                                if (filterSelectCondition.length > 0) {
                                    filterCondition.push('(' + filterSelectCondition.join(' OR ') + ')');
                                    conditionRequired = true;
                                }
                            }
                        }
                    }
                    if (paginationProp.sortBy === column.name) {
                        if (attribute.name === name) {
                            attribute.sort = paginationProp.descending === true ? 'desc' : 'asc';
                        } else {
                            attribute = {};
                            attribute.name = name;
                            attribute.sort = paginationProp.descending === true ? 'desc' : 'asc';
                            dynamicLoadConfig.attributes.push(attribute);
                        }
                    }
                }
            });
            const globalFilterValue = typeof this.filterProp === 'string' && this.filterProp.length > 0 ? this.filterProp : null;
            if (globalFilterValue != null) {
                columns.forEach((column) => {
                    if (this.isColumnVisible(column) && column.dlFilterable !== false) {
                        const name = typeof column.dlField === 'string' && column.dlField.length > 0 ? column.dlField : column.field;
                        dynamicLoadConfig.attributes.push({
                            name: name,
                            filter: column.dlFilterContains === true ? `*${globalFilterValue}*` : globalFilterValue,
                        });
                        globalFilterCondition.push('{' + (dynamicLoadConfig.attributes.length - 1) + '}');
                        conditionRequired = true;
                    }
                });
            }
            if (conditionRequired) {
                dynamicLoadConfig.condition = filterCondition.length > 0 ? filterCondition.join(' AND ') : '';
                if (globalFilterCondition.length > 0) {
                    dynamicLoadConfig.condition += (dynamicLoadConfig.condition.length > 0 ? ' AND ' : '') + '(' + globalFilterCondition.join(' OR ') + ')';
                }
            }
            return dynamicLoadConfig;
        },
        updateColumns() {
            let self = this;
            this.columns.filter(function (column) {
                if (column.hasOwnProperty('filterType') && column.filterType == 'select') {
                    self.columnsFilterData[column.name] = [];
                }
                if (column.hasOwnProperty('filterType') && column.filterType == 'date') {
                    self.columnsFilterData[column.name] = { value: '', from: '', to: '' };
                }
                if (column.hasOwnProperty('filterType') && column.filterType == 'number_range') {
                    self.columnsFilterData[column.name] = { value: '', from: '', to: '' };
                }
                const field = column.field;
                if (
                    typeof field === 'string' &&
                    (field.indexOf('.') !== -1 || field.indexOf('(') !== -1 || field.indexOf('[') !== -1 || field.indexOf(' ') !== -1)
                ) {
                    column.field = (row) => self.extractValue(row, field);
                    if (self.loadTypeProp === 'dynamic' && (typeof column.dlField != 'string' || column.dlField.length == 0)) {
                        column.dlField = field;
                    }
                    if (typeof column.csvField != 'string' || column.csvField.length == 0) {
                        column.csvField = field;
                    }
                }
                if (
                    ((typeof column.sortField == 'string' && column.sortField.length > 0) || typeof column.sortField == 'function') &&
                    typeof column.sort !== 'function'
                ) {
                    column.sort = (data, sortBy, descending) => {
                        const dir = descending === true ? -1 : 1;
                        const val = typeof column.sortField === 'function' ? (v) => column.sortField(v) : (v) => v[column.sortField];
                        return data.sort((a, b) => {
                            let A = val(a);
                            let B = val(b);
                            if (A === null || A === void 0) return -1 * dir;
                            if (B === null || B === void 0) return 1 * dir;
                            if (is.number(A) === true && is.number(B) === true) return (A - B) * dir;
                            if (is.date(A) === true && is.date(B) === true) return (new Date(a) - new Date(b)) * dir;
                            if (typeof A === 'boolean' && typeof B === 'boolean') return (A - B) * dir;
                            [A, B] = [A, B].map((s) => (s + '').toLocaleString().toLowerCase());
                            return A < B ? -1 * dir : A === B ? 0 : dir;
                        });
                    };
                }
                if (!column.hasOwnProperty('sortable')) {
                    column.sortable = true;
                }
            });
            this.columnsProp = this.columns;
            this.updateVisibleColumns();
        },
        updateVisibleColumns() {
            if (!this.visibleColumns && !this.visibleColumnsProp) {
                this.visibleColumnsProp = this.columnsProp
                    .filter(function (column) {
                        return column.hidden !== true;
                    })
                    .map(function (column) {
                        return column.name;
                    });
            } else {
                const visibleColumns = !this.visibleColumns ? (!this.visibleColumnsProp ? [] : this.visibleColumnsProp) : this.visibleColumns;
                this.visibleColumnsProp = this.columnsProp
                    .filter(function (column) {
                        return (
                            column.required || visibleColumns.includes(column.name)
                        );
                    })
                    .map(function (column) {
                        return column.name;
                    });
            }
        },
        getColumnOptions(column) {
            let columnOptions = [];
            let columnOptionsSimple = [...new Set(this.rowsProp.map((row) => this.getCellValue(column, row)))];
            columnOptionsSimple.filter(function (col) {
                if (col != undefined && col != null) {
                    columnOptions.push({ label: col.toString(), value: col.toString().toLowerCase().replace(/_/g, '_') });
                }
                return col;
            });
            return columnOptions;
        },
        isColumnVisible(column) {
            return this.visibleColumnsProp.includes(column.name);
        },
        setColumnsVisible(columns, visible) {
            if (!columns) {
                return;
            }
            const extract = function (column) {
                return typeof column === 'object' ? column.name : column;
            };
            let visibleNames = [];
            let hiddenNames = [];
            if (typeof columns === 'string') {
                if (visible === false) {
                    hiddenNames.push(columns);
                } else {
                    visibleNames.push(columns);
                }
            } else if (Array.isArray(columns)) {
                if (visible === false) {
                    columns.forEach((column) => hiddenNames.push(extract(column)));
                } else {
                    columns.forEach((column) => visibleNames.push(extract(column)));
                }
            } else if (typeof columns === 'object') {
                Object.entries(columns).forEach(([column, visible]) => {
                    if (visible === true) {
                        visibleNames.push(column);
                    } else {
                        hiddenNames.push(column);
                    }
                });
            }
            let visibleColumns = this.visibleColumnsProp.map(toRaw);
            const columnNames = this.columnsProp.map((column) => column.name);
            visibleNames = visibleNames.filter((name) => columnNames.includes(name) === false || visibleColumns.includes(name) === false);
            hiddenNames = hiddenNames.filter((name) => columnNames.includes(name) === false || visibleColumns.includes(name) === true);
            this.visibleColumnsProp = visibleColumns.concat(visibleNames).filter((name) => hiddenNames.includes(name) === false);
        },
        getColumnHeaderCellClass(column) {
            let classes = 'q-table__header-cell ellipsis';
            if (column.alignHeader) {
                classes += ` text-${column.alignHeader}`;
            }
            return classes;
        },
        getColumnStyle(column, correction) {
            let columnWidth = '';
            if (this.columnsResize === true && typeof column.width == 'number') {
                let width = column.width - (correction ? correction : 0);
                width = width < 0 ? 0 : width;
                columnWidth = 'width: ' + width + 'px;';
                if (correction > 0 && (column.alignHeader == 'center' || (!column.alignHeader && column.align == 'center'))) {
                    columnWidth += ' padding-left: ' + correction + 'px;';
                }
            }
            return columnWidth;
        },
        getColumnWidth(column, correction) {
            let width = null;
            if (this.columnsResize === true && typeof column.width == 'number') {
                width = column.width - (correction ? correction : 0);
                width = width < 0 ? 0 : width;
            }
            return width;
        },
        setColumnWidth(column, width, nextColumn) {
            if (!column) {
                return;
            }
            if (nextColumn) {
                const minWidth = typeof column.minWidth === 'number' ? column.minWidth : this.columnsMinWidth;
                const nextMinWidth = typeof nextColumn.minWidth === 'number' ? nextColumn.minWidth : this.columnsMinWidth;
                width = typeof minWidth === 'number' && width < minWidth ? minWidth : width;
                let diff = column.width - width;
                let nextWidth = nextColumn.width + diff;
                if (typeof nextMinWidth === 'number' && nextMinWidth > nextWidth) {
                    diff += nextMinWidth - nextWidth;
                    nextWidth = nextMinWidth;
                    width = column.width - diff;
                }
                column.width = width;
                nextColumn.width = nextWidth;
            } else {
                const minWidth = typeof column.minWidth === 'number' ? column.minWidth : this.columnsMinWidth;
                width = typeof minWidth === 'number' && width < minWidth ? minWidth : width;
                column.width = width;
            }
            this.storeTableConfig();
            this.$emit('column-resize', {
                column: column,
                width: width,
                nextColumn: nextColumn,
            });
        },
        fitColumnsWidth(force) {
            if (this.columnsResize !== true || this.columnsResizeToFit !== true || this.grid === true || this.columnsWidthFitted === true) {
                return;
            }
            let table = this.$refs.gridTable.$el.getElementsByTagName('table')[0];
            if (table !== undefined) {
                let columns = [];
                let columnsWidth = 0;
                let tableWidth = table.parentElement.clientWidth;
                const rows = table.getElementsByTagName('tr');
                const cols = rows[0] ? rows[0].children : undefined;
                if (cols) {
                    for (let col = 0; col < cols.length; ++col) {
                        if (col > 0 || !(this.selectionProp != 'none')) {
                            const columnIndex = this.columnElementIndexToColumnIndex(col - (this.selectionProp != 'none' ? 1 : 0));
                            if (typeof this.columnsProp[columnIndex].width == 'number') {
                                columns.push(this.columnsProp[columnIndex]);
                            }
                        }
                        columnsWidth += cols[col].offsetWidth;
                    }
                    columnsWidth = table.offsetWidth;
                    const columnsCount = columns.length;
                    if (columnsCount > 0 && columnsWidth > 0) {
                        if (tableWidth > columnsWidth) {
                            let diff = Math.floor((tableWidth - columnsWidth) / columnsCount);
                            // let rest = tableWidth - columnsWidth - columnsCount * diff - 1;
                            let rest = tableWidth - columnsWidth - columnsCount * diff;
                            for (let i = 0; i < columns.length; i++) {
                                const column = columns[i];
                                column.width += diff + (rest <= 0 ? 0 : rest--);
                            }
                            this.columnsWidthFittedSuccess = true;
                        } else if (tableWidth < columnsWidth && force === true) {
                            let diff = Math.floor((columnsWidth - tableWidth) / columnsCount);
                            let rest = columnsWidth - tableWidth - columnsCount * diff + 1;
                            for (let i = 0; i < columns.length; i++) {
                                const column = columns[i];
                                column.width -= diff + (rest <= 0 ? 0 : rest--);
                            }
                        }
                    }
                    this.columnsWidthFitted = true;
                }
            }
        },
        setColumnIndex(fromIndex, toIndex) {
            const length = this.columnsProp.length;
            if (fromIndex < 0 || fromIndex >= length || toIndex < 0 || toIndex >= length || fromIndex === toIndex) {
                return;
            }
            let column = null;
            [column] = this.columnsProp.splice(fromIndex, 1);
            this.columnsProp.splice(toIndex, 0, column);
            this.storeTableConfig();
            this.$emit('column-reorder', {
                column: column,
                fromIndex: fromIndex,
                toIndex: toIndex,
            });
        },
        sortColumn(column, sorted, sortOrder) {
            if (!column || column.sortable !== true) {
                return;
            }
            if (typeof column === 'string') {
                column = this.columnsProp.find((element) => element.name === column);
            }
            this.paginationProp.sortBy = sorted === true ? column.name : null;
            this.paginationProp.descending = sortOrder === 'da';
        },
        filterColumn(column, value) {
            if (this.columnsFilter !== true || !column) {
                return;
            }
            this.columnsFilterEnabled = true;
            if (typeof column === 'string') {
                column = this.columnsProp.find((element) => element.name === column);
            }
            this.columnsFilterData[column.name] = value;
        },
        getRowsSelected(callback) {
            let selectedRows = this.selectedProp;
            if (this.loadTypeProp === 'dynamic') {
                const keys = [];
                selectedRows.forEach((row) => {
                    if (row && row.__loaded !== true) {
                        keys.push(this.getCellKeyValue(row));
                    }
                });
                if (keys.length > 0) {
                    this.$emit('request-load', {
                        fromIndex: 0,
                        toIndex: this.filteredRows.length,
                        keys: keys,
                        callback: function (rowMap) {
                            for (let i = 0; i < this.filteredRows.length; i++) {
                                const row = this.filteredRows[i];
                                const data = rowMap[this.getCellKeyValue(row)];
                                if (data != undefined) {
                                    data.__loaded = true;
                                    this.filteredRows[i] = data;
                                }
                            }
                            selectedRows = [];
                            for (let i = 0; i < this.selectedProp.length; i++) {
                                const row = this.selectedProp[i];
                                const data = rowMap[this.getCellKeyValue(row)];
                                if (data != undefined) {
                                    data.__loaded = true;
                                    this.selectedProp[i] = data;
                                }
                                selectedRows.push(this.selectedProp[i]);
                            }
                            callback(selectedRows);
                        }.bind(this),
                    });
                } else {
                    callback(selectedRows);
                }
            } else {
                callback(selectedRows);
            }
        },
        setRowsSelected(rowKeys, selected) {
            if (!rowKeys) {
                return;
            }
            const selectKeys = [];
            const unselectKeys = [];
            if (typeof rowKeys === 'string') {
                if (selected === false) {
                    unselectKeys.push(rowKeys);
                } else {
                    selectKeys.push(rowKeys);
                }
            } else if (Array.isArray(rowKeys)) {
                if (selected === false) {
                    rowKeys.forEach((rowKey) => unselectKeys.push(rowKey));
                } else {
                    rowKeys.forEach((rowKey) => selectKeys.push(rowKey));
                }
            } else if (typeof rowKeys === 'object') {
                Object.entries(rowKeys).forEach(([rowKey, select]) => {
                    if (select === true) {
                        selectKeys.push(rowKey);
                    } else {
                        unselectKeys.push(rowKey);
                    }
                });
            }
            let selectedRows = this.selectedProp;
            let selectRows = this.rowsProp.filter((row) => selectKeys.includes(this.getCellKeyValue(row)));
            let unselectRows = this.rowsProp.filter((row) => unselectKeys.includes(this.getCellKeyValue(row)));
            selectRows = selectRows.filter((row) => (selectedRows.includes(row) ? false : true));
            unselectRows = unselectRows.filter((row) => (selectedRows.includes(row) ? true : false));
            this.selectedProp = selectedRows.concat(selectRows).filter((row) => (unselectRows.includes(row) ? false : true));
            if (selectRows.length > 0) {
                this.onSelection({ added: true, evt: undefined, keys: selectRows.map((row) => this.getCellKeyValue(row)), rows: selectRows });
            }
            if (unselectRows.length > 0) {
                this.onSelection({ added: false, evt: undefined, keys: unselectRows.map((row) => this.getCellKeyValue(row)), rows: unselectRows });
            }
        },
        setRowsSelectedAll(selected) {
            this.setRowsSelected(
                this.rowsProp.map((row) => this.getCellKeyValue(row)),
                selected
            );
        },
        columnElementIndexToColumnIndex(elementIndex) {
            let visibleIndex = -1;
            for (let columnIndex = 0; columnIndex < this.columnsProp.length; columnIndex++) {
                const column = this.columnsProp[columnIndex];
                if (this.isColumnVisible(column)) {
                    visibleIndex++;
                    if (visibleIndex === elementIndex) {
                        return columnIndex;
                    }
                }
            }
            return null;
        },
        columnIndexToColumnElementIndex(columnIndex) {
            let elementIndex = -1;
            for (let currentIndex = 0; currentIndex < this.columnsProp.length; currentIndex++) {
                const column = this.columnsProp[currentIndex];
                if (this.isColumnVisible(column)) {
                    elementIndex++;
                    if (currentIndex === columnIndex) {
                        return elementIndex;
                    }
                }
            }
            return null;
        },
        updateFilterData(column) {
            const value = this.columnsFilterData[column.name];
            if (value == undefined || value == null) {
                this.columnsFilterData[column.name] = { value: '', from: '', to: '' };
            } else {
                const from = typeof value == 'string' ? value : value.from;
                const to = typeof value == 'string' ? value : value.to;
                const fromString = String(from);
                const toString = String(to);
                this.columnsFilterData[column.name] = {
                    value: typeof value == 'string' ? value : fromString + (fromString.length > 0 && toString.length > 0 ? ' - ' : '') + toString,
                    from: from,
                    to: to,
                };
            }
        },
        exportCsvTable() {
            if (this.loadTypeProp === 'dynamic') {
                this.$emit('export-csv', { csvConfig: this.getCsvConfig() });
            } else {
                const columns = this.columnsProp.filter((col) => this.isColumnVisible(col));
                const content = [columns.map((col) => wrapCsvValue(col.label)).join(';')]
                    .concat(
                        this.$refs.gridTable.filteredSortedRows.map((row) =>
                            columns
                                .map((col) =>
                                    wrapCsvValue(
                                        typeof col.field === 'function' ? col.field(row) : row[col.field === void 0 ? col.name : col.field],
                                        col.format
                                    )
                                )
                                .join(';')
                        )
                    )
                    .join('\r\n');
                const status = exportFile(this.exportFileName + '.csv', content, 'text/csv');
                if (status !== true) {
                    this.$q.notify({
                        message: this.t('exportFileError'),
                        color: 'negative',
                        icon: 'error',
                    });
                }
            }
            function wrapCsvValue(val, formatFn) {
                let formatted = formatFn !== void 0 ? formatFn(val) : val;
                formatted = formatted === void 0 || formatted === null ? '' : String(formatted);
                formatted = formatted.split('"').join('""');
                return `"${formatted}"`;
            }
        },
        getCsvConfig: function (keyField) {
            if (keyField == undefined || keyField == null) {
                keyField = this.rowKey;
            }
            if (keyField == undefined || keyField == null) {
                return null;
            }
            const idList = this.filteredRows.map((row) => this.getCellValue({ field: keyField }, row));
            const columnList = this.columnsProp
                .filter((column) => this.isColumnVisible(column))
                .map((column) => {
                    const path = typeof column.csvField === 'string' && column.csvField.length > 0 ? column.csvField : column.field;
                    return {
                        name: column.label,
                        path: path,
                    };
                });
            const csvConfig = {
                columnList: columnList,
                idList: idList,
            };
            return csvConfig;
        },
        updateColumnsResize() {
            if (SSR$5) return;
            const columnsResizeEngine = this.__columnsResizeEngine;
            const gridTable = this.columnsResize ? this.$refs.gridTable : undefined;
            let tables = gridTable ? gridTable.$el.getElementsByTagName('table') : undefined;
            if (this.grid === true) {
                tables = undefined;
            }
            if (columnsResizeEngine === undefined && tables !== undefined) {
                this.__columnsResizeEngine = new ColumnsResizeEngine(this, tables[0]);
            } else if (columnsResizeEngine !== undefined && tables === undefined) {
                columnsResizeEngine.destroy();
                delete this.__columnsResizeEngine;
            } else if (columnsResizeEngine !== undefined && tables !== undefined) {
                if (!columnsResizeEngine.resizing) {
                    columnsResizeEngine.destroy();
                    delete this.__columnsResizeEngine;
                    this.__columnsResizeEngine = new ColumnsResizeEngine(this, tables[0]);
                }
            }
        },
        getToolbar() {
            return this.$refs.gridTableToolbar;
        },
        updateToolbar() {
            this.$refs.gridTableToolbar && this.$refs.gridTableToolbar.update();
        },
        onDragStart(evt, column, index) {
            evt.dataTransfer.effectAllowed = 'move';
            this.__dragData = {
                column: column,
                index: index,
                element: evt.target,
            };
            evt.target.classList.add('dragged');
            evt.target.style.transform = 'translateZ(0)';
            setTimeout(() => {
                evt.target.style.opacity = 0.3;
            }, 10);
        },
        onDragEnd(evt, column, index) {
            evt.target.style.opacity = 1;
            evt.target.style.transform = null;
            this.__dragData.element.classList.remove('dragged');
            Array.from(this.__dragData.element.parentNode.children).forEach((element) => {
                element.style.backgroundColor = null;
            });
        },
        onDragEnter(evt, column, index) {
            evt.dataTransfer.dropEffect = 'move';
            evt.preventDefault();
            evt.stopPropagation();
            if (evt.currentTarget.contains(evt.relatedTarget)) {
                return;
            }
            if (!evt.currentTarget.matches('.dragged')) {
                evt.currentTarget.style.backgroundColor = '#eee';
            }
        },
        onDragLeave(evt, column, index) {
            if (evt.currentTarget.contains(evt.relatedTarget)) {
                return;
            }
            if (!evt.currentTarget.matches('.draggedx')) {
                evt.currentTarget.style.backgroundColor = null;
            }
        },
        onDragOver(evt, column, index) {
            evt.dataTransfer.dropEffect = 'move';
            evt.preventDefault();
            evt.stopPropagation();
        },
        onDrop(evt, column, index) {
            if (this.__dragData.index != index) {
                this.setColumnIndex(this.__dragData.index, index);
            }
        },
        onKeyNavigation(evt) {
            if (this.keyNavigationActive !== true) {
                return;
            }
            let success = false;
            if (evt.keyCode === 65 && evt.ctrlKey === true && this.selectionProp === 'multiple') {
                this.setRowsSelectedAll(true);
                success = true;
            } else if (evt.keyCode === 27) {
                this.setRowsSelectedAll(false);
                success = true;
            }
            if (success) {
                evt.preventDefault();
                evt.stopPropagation();
            }
        },
    },
    watch: {
        columns: {
            handler() {
                this.updateColumns();
            },
            immediate: true,
            deep: false,
        },
        visibleColumns: {
            handler() {
                this.updateVisibleColumns();
            },
            immediate: false,
            deep: true,
        },
        visibleColumnsProp: {
            handler() {
                this.storeTableConfig();
                this.$emit('column-toggle', { visibleColumns: this.visibleColumnsProp.map(toRaw) });
            },
            immediate: false,
            deep: false,
        },
        pagination: {
            handler() {
                this.paginationProp = this.pagination;
            },
            immediate: false,
            deep: true,
        },
        paginationProp: {
            handler(newValue, oldValue) {
                if (this.tableConfigExtended) {
                    let pagination = null;
                    if (typeof this.tableConfig === 'object' && this.tableConfig != null && typeof this.tableConfig.pagination === 'object') {
                        pagination = this.tableConfig.pagination;
                    }
                    if (pagination == null || pagination.sortBy !== newValue.sortBy || pagination.descending !== newValue.descending) {
                        this.storeTableConfig();
                    }
                }
                this.$emit('update:pagination', this.paginationProp);
            },
            immediate: false,
            deep: true,
        },
        selection: function () {
            this.selectionProp = this.selection !== 'single' && this.selection !== 'multiple' ? 'none' : this.selection;
        },
        selected: function () {
            this.selectedProp = this.selected === undefined ? [] : this.selected;
        },
        selectedProp: function () {
            this.$emit('update:selected', this.selectedProp);
        },
        columnsResize: function () {
            this.updateColumnsResize();
        },
        filter: function () {
            this.filterProp = typeof this.filter === 'string' ? this.filter : this.tableFilter !== true && typeof this.filter === 'object' ? this.filter : '';
        },
        filterProp: function () {
            if (this.tableConfigExtended && this.tableConfig?.filter !== this.filterProp) {
                this.storeTableConfig();
            }
            this.$emit('filter', { filter: this.filterProp, columnsFilter: !this.columnsFilterEnabled ? null : extend(true, {}, this.columnsFilterData) });
        },
        columnsFilterData: {
            handler() {
                if (this.tableConfigExtended) {
                    this.storeTableConfig();
                }
                if (this.loadTypeProp === 'dynamic' && this.columnsFilterDeferred !== true && this.tableConfigLoading !== true) {
                    this.onRequest();
                }
                this.$emit('filter', { filter: this.filterProp, columnsFilter: !this.columnsFilterEnabled ? null : extend(true, {}, this.columnsFilterData) });
            },
            immediate: false,
            deep: true,
        },
        columnsFilterEnabled: function () {
            if (this.tableConfigExtended && this.tableConfig?.columnsFilterEnabled !== this.columnsFilterEnabled) {
                this.storeTableConfig();
            }
            if (this.loadTypeProp === 'dynamic' && this.columnsFilterDeferred !== true && this.tableConfigLoading !== true) {
                this.onRequest();
            }
            this.$emit('filter', { filter: this.filterProp, columnsFilter: !this.columnsFilterEnabled ? null : extend(true, {}, this.columnsFilterData) });
        },
        fullscreen: function () {
            this.fullscreenProp = this.fullscreen;
        },
        fullscreenProp: function () {
            this.$emit('update:fullscreen', this.fullscreenProp);
        },
        expanded: function () {
            this.expandedProp = this.expanded;
        },
        expandedProp: function () {
            this.$emit('update:expanded', this.expandedProp);
        },
        virtualScroll: function () {
            this.virtualScrollProp = this.virtualScroll;
        },
        virtualScrollItemSize: {
            handler() {
                this.virtualScrollItemSizeProp =
                    this.virtualScrollItemSize !== undefined
                        ? this.virtualScrollItemSize
                        : this.selectionProp === 'none'
                        ? this.dense === true
                            ? 28
                            : 48
                        : this.dense === true
                        ? 29
                        : 55;
            },
            immediate: true,
            deep: false,
        },
        virtualScrollStickySizeStart: {
            handler() {
                if (this.virtualScrollStickySizeStart === undefined) {
                    this.virtualScrollStickySizeStartProp = 0;
                    if (this.stickyHeader === true) {
                        this.virtualScrollStickySizeStartProp += this.virtualScrollItemSizeProp;
                        if (this.columnsFilter === true) {
                            this.virtualScrollStickySizeStartProp += this.dense === true ? 41 : 48;
                        }
                    }
                }
            },
            immediate: true,
            deep: false,
        },
        virtualScrollStickySizeEnd: {
            handler() {
                if (this.virtualScrollStickySizeEnd === undefined) {
                    this.virtualScrollStickySizeEndProp = 0;
                }
            },
            immediate: true,
            deep: false,
        },
        rowsPerPageOptions: function () {
            this.rowsPerPageOptionsProp = this.rowsPerPageOptions;
        },
        tableConfigExternal: {
            handler() {
                this.storeTableConfig();
            },
            immediate: false,
            deep: true,
        },
    },
    emits: [
        'row-click',
        'row-dblclick',
        'row-contextmenu',
        'request',
        'request-load',
        'selection',
        'virtual-scroll',
        'update:pagination',
        'update:selected',
        'update:fullscreen',
        'update:expanded',
        'update:toolbar-model-value',
        'update:table-config-external',
        'column-resize',
        'column-reorder',
        'column-toggle',
        'export-csv',
        'filter',
        'reload',
    ],
    expose: [
        'filteredSortedRows',
        'computedRows',
        'computedRowsNumber',
        'toggleFullscreen',
        'setFullscreen',
        'exitFullscreen',
        'requestServerInteraction',
        'setPagination',
        'firstPage',
        'prevPage',
        'nextPage',
        'lastPage',
        'isRowSelected',
        'clearSelection',
        'isRowExpanded',
        'setExpanded',
        'sort',
        'resetVirtualScroll',
        'scrollTo',
        'getCellValue',
        'getCellKeyValue',
        'forceUpdate',
        'reloadData',
        'storeTableConfig',
        'loadTableConfig',
        'isColumnVisible',
        'setColumnsVisible',
        'getColumnWidth',
        'setColumnWidth',
        'fitColumnsWidth',
        'setColumnIndex',
        'sortColumn',
        'filterColumn',
        'getRowsSelected',
        'setRowsSelected',
        'setRowsSelectedAll',
        'exportCsvTable',
        'getCsvConfig',
        'getToolbar',
        'updateToolbar',
    ],
});
class ColumnsResizeEngine {
    constructor(component, table) {
        this.component = component;
        this.table = table;
        this.resizing = false;
        this.pageX = undefined;
        this.currentColumn = undefined;
        this.currentColumnWidth = undefined;
        this.currentColumnIndex = undefined;
        this.nextColumn = undefined;
        this.nextColumnWidth = undefined;
        this.nextColumnIndex = undefined;
        this.divs = [];
        this.init();
    }
    init() {
        const rows = this.table.getElementsByTagName('tr');
        const cols = rows[0] ? rows[0].children : undefined;
        if (!cols) return;
        let tableHeight = this.table.parentElement.clientHeight;
        if (this.component.stickyHeader !== true) {
            tableHeight = this.table.clientHeight;
        }
        for (let row = 0; row < rows.length; ++row) {
            const cols = rows[row] ? rows[row].children : [];
            for (let col = 0; col < cols.length; ++col) {
                if (row === 0) {
                    if (col > 0 || !(this.component.selectionProp != 'none')) {
                        const column = this.component.columnsProp[col - (this.component.selectionProp != 'none' ? 1 : 0)];
                        const enabled = typeof column.width == 'number' && column.resizable !== false;
                        const div = this.createDiv(tableHeight, enabled);
                        this.divs.push(div);
                        cols[col].appendChild(div);
                        this.setListeners(div);
                        cols[col].style.position = 'relative';
                    }
                }
            }
        }
    }
    clearState() {
        this.resizing = false;
        this.table.style.paddingRight = '0px';
        this.updateDivs();
        this.pageX = undefined;
        this.currentColumn = undefined;
        this.currentColumnWidth = undefined;
        this.currentColumnIndex = undefined;
        this.nextColumn = undefined;
        this.nextColumnWidth = undefined;
        this.nextColumnIndex = undefined;
    }
    createDiv(height, enabled) {
        const div = document.createElement('div');
        div.style.top = 0;
        div.style.right = 0;
        div.style.width = '5px';
        div.style.position = 'absolute';
        div.style.cursor = 'col-resize';
        div.style.userSelect = 'none';
        div.style.height = height + 'px';
        div.style.zIndex = 100;
        if (!enabled) {
            div.style.display = 'none';
        }
        return div;
    }
    updateDivs() {
        let tableHeight = this.table.parentElement.clientHeight;
        if (this.component.stickyHeader !== true) {
            tableHeight = this.table.clientHeight;
        }
        if (this.tableHeight !== tableHeight) {
            this.divs.forEach((div) => {
                div.style.height = tableHeight + 'px';
            });
            this.tableHeight = tableHeight;
        }
    }
    removeDiv(div) {
        div.parentElement.removeChild(div);
    }
    removeAllDivs() {
        this.divs.forEach((div) => {
            this.removeListener(div);
            this.removeDiv(div);
        });
        this.divs.splice(0, this.divs.length);
    }
    destroy() {
        this.removeAllDivs();
    }
    setListeners(div) {
        div.addEventListener('click', (e) => this.click(e));
        div.addEventListener('mousedown', (e) => this.onMouseDown(e));
        div.addEventListener('mouseover', (e) => this.onMouseOver(e));
        div.addEventListener('mouseout', (e) => this.onMouseOut(e));
        document.addEventListener('mousemove', (e) => this.onMouseMove(e));
        document.addEventListener('mouseup', (e) => this.onMouseUp(e));
    }
    removeListener(div) {
        div.removeEventListener('click', (e) => this.click(e));
        div.removeEventListener('mousedown', (e) => this.onMouseDown(e));
        div.removeEventListener('mouseover', (e) => this.onMouseOver(e));
        div.removeEventListener('mouseout', (e) => this.onMouseOut(e));
        document.removeEventListener('mousemove', (e) => this.onMouseMove(e));
        document.removeEventListener('mouseup', (e) => this.onMouseUp(e));
    }
    removeListeners() {
        this.divs.forEach((div) => this.removeListener(div));
    }
    onMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
        this.resizing = true;
        this.pageX = e.pageX;
        this.currentColumn = e.target.parentElement;
        this.currentColumnIndex = Array.from(this.currentColumn.parentNode.children).indexOf(this.currentColumn);
        if (this.component.selectionProp != 'none') {
            this.currentColumnIndex--;
        }
        this.currentColumnIndex = this.component.columnElementIndexToColumnIndex(this.currentColumnIndex);
        this.currentColumnWidth = this.component.columnsProp[this.currentColumnIndex].width - this.paddingDiff(this.currentColumn);
        if (this.component.columnsResizeMode === 'next') {
            this.nextColumn = this.currentColumn.nextElementSibling;
            if (this.nextColumn) {
                this.nextColumnIndex = Array.from(this.currentColumn.parentNode.children).indexOf(this.nextColumn);
                if (this.component.selectionProp != 'none') {
                    this.nextColumnIndex--;
                }
                this.nextColumnIndex = this.component.columnElementIndexToColumnIndex(this.nextColumnIndex);
                this.nextColumnWidth = this.component.columnsProp[this.nextColumnIndex].width - this.paddingDiff(this.nextColumn);
            }
        }
    }
    onMouseMove(e) {
        if (this.currentColumn) {
            const diffX = e.pageX - this.pageX;
            //     let margin = diffX * -1;
            const currentColumn = this.component.columnsProp[this.currentColumnIndex];
            const nextColumn = this.nextColumn && this.component.columnsProp[this.nextColumnIndex];
            this.component.setColumnWidth(currentColumn, this.currentColumnWidth + diffX, nextColumn);
            if (this.component.columnsResizeMode !== 'next') {
                let margin = diffX * -1;
                if (margin >= 0) {
                    this.table.style.paddingRight = margin + 'px';
                }
            }
            this.updateDivs();
        }
    }
    onMouseOver(e) {
        e.target.style.borderRight = '2px solid #c0c0c0';
    }
    onMouseOut(e) {
        e.target.style.borderRight = '';
    }
    onMouseUp(e) {
        this.clearState();
    }
    click(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    paddingDiff(col) {
        if (SSR$5) {
            return 0;
        }
        const style = window.getComputedStyle(col, null);
        if (style.getPropertyValue('box-sizing') === 'border-box') {
            return 0;
        }
        const paddingLeft = style.getPropertyValue('padding-left');
        const paddingRight = style.getPropertyValue('padding-right');
        return parseInt(paddingLeft, 10) + parseInt(paddingRight, 10);
    }
}

const _hoisted_1$9 = ["title"];
const _hoisted_2$6 = ["title"];
const _hoisted_3$5 = ["title"];
const _hoisted_4$3 = { class: "row items-center justify-end" };
const _hoisted_5$3 = ["title"];
const _hoisted_6$3 = { class: "text-h6" };
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_checkbox = resolveComponent("q-checkbox");
  const _component_q_th = resolveComponent("q-th");
  const _component_q_tr = resolveComponent("q-tr");
  const _component_q_icon = resolveComponent("q-icon");
  const _component_q_input = resolveComponent("q-input");
  const _component_q_item_section = resolveComponent("q-item-section");
  const _component_q_item_label = resolveComponent("q-item-label");
  const _component_q_item = resolveComponent("q-item");
  const _component_q_select = resolveComponent("q-select");
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_date = resolveComponent("q-date");
  const _component_q_popup_proxy = resolveComponent("q-popup-proxy");
  const _component_q_td = resolveComponent("q-td");
  const _component_q_space = resolveComponent("q-space");
  const _component_q_overflow_toolbar = resolveComponent("q-overflow-toolbar");
  const _component_q_table = resolveComponent("q-table");
  const _component_q_resize_observer = resolveComponent("q-resize-observer");
  const _component_q_card_section = resolveComponent("q-card-section");
  const _component_q_separator = resolveComponent("q-separator");
  const _component_q_tooltip = resolveComponent("q-tooltip");
  const _component_q_btn_group = resolveComponent("q-btn-group");
  const _component_q_list = resolveComponent("q-list");
  const _component_q_menu = resolveComponent("q-menu");
  const _component_q_card_actions = resolveComponent("q-card-actions");
  const _component_q_card = resolveComponent("q-card");
  const _component_q_dialog = resolveComponent("q-dialog");
  const _directive_close_popup = resolveDirective("close-popup");
  const _directive_ripple = resolveDirective("ripple");
  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_q_table, {
      ref: "gridTable",
      id: _ctx.id,
      rows: _ctx.filteredRows,
      columns: _ctx.columnsProp,
      "visible-columns": _ctx.visibleColumnsProp,
      selection: _ctx.selectionProp,
      filter: _ctx.filterProp,
      selected: _ctx.selectedProp,
      "onUpdate:selected": _cache[15] || (_cache[15] = $event => ((_ctx.selectedProp) = $event)),
      pagination: _ctx.paginationProp,
      "onUpdate:pagination": _cache[16] || (_cache[16] = $event => ((_ctx.paginationProp) = $event)),
      fullscreen: _ctx.fullscreenProp,
      "onUpdate:fullscreen": _cache[17] || (_cache[17] = $event => ((_ctx.fullscreenProp) = $event)),
      expanded: _ctx.expandedProp,
      "onUpdate:expanded": _cache[18] || (_cache[18] = $event => ((_ctx.expandedProp) = $event)),
      "row-key": _ctx.rowKey,
      loading: _ctx.loading,
      "icon-first-page": _ctx.iconFirstPage,
      "icon-prev-page": _ctx.iconPrevPage,
      "icon-next-page": _ctx.iconNextPage,
      "icon-last-page": _ctx.iconLastPage,
      title: _ctx.title,
      "hide-header": _ctx.hideHeader,
      grid: _ctx.grid,
      "grid-header": _ctx.gridHeader,
      dense: _ctx.dense,
      flat: _ctx.flat,
      bordered: _ctx.bordered,
      square: _ctx.square,
      separator: _ctx.separator,
      "wrap-cells": _ctx.wrapCells,
      "virtual-scroll": _ctx.virtualScrollProp,
      "virtual-scroll-target": _ctx.virtualScrollTarget,
      "virtual-scroll-slice-size": _ctx.virtualScrollSliceSize,
      "virtual-scroll-slice-ratio-before": _ctx.virtualScrollSliceRatioBefore,
      "virtual-scroll-slice-ratio-after": _ctx.virtualScrollSliceRatioAfter,
      "virtual-scroll-item-size": _ctx.virtualScrollItemSizeProp,
      "virtual-scroll-sticky-size-start": _ctx.virtualScrollStickySizeStartProp,
      "virtual-scroll-sticky-size-end": _ctx.virtualScrollStickySizeEndProp,
      "table-colspan": _ctx.tableColspan,
      "no-data-label": _ctx.noDataLabel,
      "no-results-label": _ctx.noResultsLabel,
      "loading-label": _ctx.loadingLabel,
      "selected-rows-label": _ctx.selectedRowsLabel,
      "rows-per-page-label": _ctx.rowsPerPageLabel,
      "pagination-label": _ctx.paginationLabelProp,
      color: _ctx.color,
      "title-class": _ctx.titleClass,
      "table-style": _ctx.tableStyle,
      "table-class": _ctx.tableClass,
      "table-header-style": _ctx.tableHeaderStyle,
      "table-header-class": _ctx.tableHeaderClass,
      "card-container-class": _ctx.cardContainerClass,
      "card-container-style": _ctx.cardContainerStyle,
      "card-style": _ctx.cardStyle,
      "card-class": _ctx.cardClass,
      "hide-bottom": _ctx.hideBottom,
      "hide-selected-banner": _ctx.hideSelectedBanner,
      "hide-no-data": _ctx.hideNoData,
      "hide-pagination": _ctx.hidePaginationProp,
      dark: _ctx.dark,
      "no-route-fullscreen-exit": _ctx.noRouteFullscreenExit,
      "filter-method": _ctx.filterMethod,
      "rows-per-page-options": _ctx.rowsPerPageOptionsProp,
      "sort-method": _ctx.sortMethod,
      "binary-state-sort": _ctx.binaryStateSort,
      "column-sort-order": _ctx.columnSortOrder,
      onRequest: _ctx.onRequest,
      onSelection: _ctx.onSelection,
      onVirtualScroll: _ctx.onVirtualScroll,
      onFocusin: _cache[19] || (_cache[19] = $event => (_ctx.keyNavigationActive = true)),
      onFocusout: _cache[20] || (_cache[20] = $event => (_ctx.keyNavigationActive = false)),
      onKeydown: _ctx.onKeyNavigation,
      tabindex: 0,
      style: normalizeStyle(_ctx.style),
      class: normalizeClass(_ctx.getClass())
    }, createSlots({
      header: withCtx((props) => [
        renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps(props)), () => [
          createVNode(_component_q_tr, {
            props: props,
            style: normalizeStyle(_ctx.tableHeaderStyle),
            class: normalizeClass(_ctx.tableHeaderClass)
          }, {
            default: withCtx(() => [
              (_ctx.selectionProp != 'none')
                ? (openBlock(), createBlock(_component_q_th, {
                    key: 0,
                    "auto-width": "",
                    class: "ignore-elements",
                    style: normalizeStyle('min-width: ' + (_ctx.dense ? '36px' : '72px'))
                  }, {
                    default: withCtx(() => [
                      (_ctx.selectionProp == 'multiple')
                        ? renderSlot(_ctx.$slots, "header-selection", normalizeProps(mergeProps({ key: 0 }, props)), () => [
                            createVNode(_component_q_checkbox, {
                              modelValue: props.selected,
                              "onUpdate:modelValue": $event => ((props.selected) = $event),
                              "indeterminate-value": "some",
                              dense: _ctx.dense,
                              dark: _ctx.dark,
                              color: _ctx.color
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "dense", "dark", "color"])
                          ])
                        : createCommentVNode("v-if", true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style"]))
                : createCommentVNode("v-if", true),
              createCommentVNode(" <template v-for=\"col in props.cols\" :key=\"col.name\"> "),
              (openBlock(true), createElementBlock(Fragment, null, renderList(props.cols, (col, colIndex) => {
                return renderSlot(_ctx.$slots, 'header-cell-' + col.name, mergeProps({
                  key: col.name
                }, props, { col: col }), () => [
                  renderSlot(_ctx.$slots, 'header-cell', mergeProps(props, { col: col }), () => [
                    (openBlock(), createBlock(_component_q_th, {
                      props: props,
                      key: col.name,
                      onHover: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"])),
                      style: normalizeStyle(_ctx.getColumnStyle(col)),
                      draggable: _ctx.columnsReorder,
                      onDragstart: $event => (_ctx.onDragStart($event, col, colIndex)),
                      onDragend: $event => (_ctx.onDragEnd($event, col, colIndex)),
                      onDragenter: $event => (_ctx.onDragEnter($event, col, colIndex)),
                      onDragleave: $event => (_ctx.onDragLeave($event, col, colIndex)),
                      onDragover: $event => (_ctx.onDragOver($event, col, colIndex)),
                      onDrop: $event => (_ctx.onDrop($event, col, colIndex))
                    }, {
                      default: withCtx(() => [
                        (col.caption == void 0)
                          ? (openBlock(), createElementBlock("div", {
                              key: 0,
                              class: normalizeClass(_ctx.getColumnHeaderCellClass(col)),
                              style: normalizeStyle(_ctx.getColumnStyle(col, col.sortable ? 18 : 0)),
                              title: col.label
                            }, toDisplayString(col.label), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_1$9))
                          : (openBlock(), createElementBlock("div", {
                              key: 1,
                              class: normalizeClass(_ctx.getColumnHeaderCellClass(col)),
                              style: normalizeStyle(_ctx.getColumnStyle(col, col.sortable ? 18 : 0))
                            }, [
                              createElementVNode("div", {
                                class: "ellipsis",
                                title: col.label
                              }, toDisplayString(col.label), 9 /* TEXT, PROPS */, _hoisted_2$6),
                              createElementVNode("div", {
                                class: "ellipsis q-item__label--caption text-caption",
                                title: col.caption
                              }, toDisplayString(col.caption), 9 /* TEXT, PROPS */, _hoisted_3$5)
                            ], 6 /* CLASS, STYLE */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props", "style", "draggable", "onDragstart", "onDragend", "onDragenter", "onDragleave", "onDragover", "onDrop"]))
                  ])
                ])
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props", "style", "class"])
        ]),
        (_ctx.columnsFilter)
          ? withDirectives((openBlock(), createBlock(_component_q_tr, {
              key: 0,
              props: props,
              class: "q-table__col-filter ignore-elements"
            }, {
              default: withCtx(() => [
                (_ctx.selectionProp != 'none')
                  ? (openBlock(), createBlock(_component_q_th, {
                      key: 0,
                      "auto-width": ""
                    }))
                  : createCommentVNode("v-if", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList(props.cols, (col) => {
                  return (openBlock(), createBlock(_component_q_th, {
                    key: col.name,
                    style: normalizeStyle([{"padding":"0px"}, _ctx.getColumnStyle(col)])
                  }, {
                    default: withCtx(() => [
                      (!col.hasOwnProperty('filterType') || col.filterType == 'text')
                        ? (openBlock(), createBlock(_component_q_input, {
                            key: 0,
                            modelValue: _ctx.columnsFilterData[col.name],
                            "onUpdate:modelValue": $event => ((_ctx.columnsFilterData[col.name]) = $event),
                            disable: col.filterDisabled === true,
                            debounce: "300",
                            class: "q-px-xs",
                            filled: "",
                            dense: "",
                            dark: _ctx.dark,
                            color: _ctx.color
                          }, createSlots({ _: 2 /* DYNAMIC */ }, [
                            (_ctx.columnsFilterData[col.name])
                              ? {
                                  name: "append",
                                  fn: withCtx(() => [
                                    createVNode(_component_q_icon, {
                                      name: "cancel",
                                      onClick: withModifiers($event => (_ctx.columnsFilterData[col.name] = ''), ["stop"]),
                                      class: "cursor-pointer"
                                    }, null, 8 /* PROPS */, ["onClick"])
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "disable", "dark", "color"]))
                        : createCommentVNode("v-if", true),
                      (col.hasOwnProperty('filterType') && col.filterType == 'select')
                        ? (openBlock(), createBlock(_component_q_select, {
                            key: 1,
                            modelValue: _ctx.columnsFilterData[col.name],
                            "onUpdate:modelValue": $event => ((_ctx.columnsFilterData[col.name]) = $event),
                            options: _ctx.getColumnOptions(col),
                            disable: col.filterDisabled === true,
                            style: normalizeStyle(_ctx.getColumnStyle(col, -32)),
                            class: "q-px-xs",
                            "map-options": "",
                            multiple: "",
                            "emit-value": "",
                            filled: "",
                            dense: "",
                            dark: _ctx.dark,
                            color: _ctx.color,
                            onPopupShow: _cache[2] || (_cache[2] = $event => (_ctx.columnsFilterDeferred = true)),
                            onPopupHide: $event => {
                            _ctx.columnsFilterDeferred = false;
                            _ctx.loadTypeProp === 'dynamic' && (_ctx.columnsFilterData[col.name] = [..._ctx.columnsFilterData[col.name]]);
                        }
                          }, {
                            append: withCtx(() => [
                              (_ctx.columnsFilterData[col.name].length > 0)
                                ? (openBlock(), createBlock(_component_q_icon, {
                                    key: 0,
                                    onClick: withModifiers($event => (_ctx.columnsFilterData[col.name] = []), ["stop","prevent"]),
                                    name: "cancel",
                                    class: "cursor-pointer"
                                  }, null, 8 /* PROPS */, ["onClick"]))
                                : createCommentVNode("v-if", true)
                            ]),
                            "before-options": withCtx(() => [
                              createVNode(_component_q_item, {
                                class: "sticky-top",
                                clickable: "",
                                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$refs.filterSelectAll[0].$el.click()))
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_q_item_section, { avatar: "" }, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_checkbox, {
                                        "onUpdate:modelValue": $event => (
                                            _ctx.getColumnOptions(col).length == _ctx.columnsFilterData[col.name].length
                                                ? (_ctx.columnsFilterData[col.name] = [])
                                                : (_ctx.columnsFilterData[col.name] = _ctx.getColumnOptions(col).map((item) => item.value))
                                        ),
                                        "model-value":
                                            _ctx.getColumnOptions(col).length == _ctx.columnsFilterData[col.name].length
                                                ? true
                                                : _ctx.columnsFilterData[col.name].length == 0
                                                ? false
                                                : null
                                        ,
                                        ref_for: true,
                                        ref: "filterSelectAll",
                                        color: _ctx.color
                                      }, null, 8 /* PROPS */, ["onUpdate:modelValue", "model-value", "color"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  createVNode(_component_q_item_section, null, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_item_label, { innerHTML: 'Select All' })
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            option: withCtx((scope) => [
                              createVNode(_component_q_item, mergeProps(scope.itemProps, {
                                onClick: scope.itemEvents
                              }), {
                                default: withCtx(() => [
                                  createVNode(_component_q_item_section, { avatar: "" }, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_checkbox, {
                                        modelValue: _ctx.columnsFilterData[col.name],
                                        "onUpdate:modelValue": $event => ((_ctx.columnsFilterData[col.name]) = $event),
                                        val: scope.opt.value,
                                        color: _ctx.color
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "val", "color"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  createVNode(_component_q_item_section, null, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_item_label, {
                                        innerHTML: scope.opt.label
                                      }, null, 8 /* PROPS */, ["innerHTML"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options", "disable", "style", "dark", "color", "onPopupHide"]))
                        : createCommentVNode("v-if", true),
                      (col.hasOwnProperty('filterType') && col.filterType == 'date')
                        ? (openBlock(), createBlock(_component_q_input, {
                            key: 2,
                            modelValue: _ctx.columnsFilterData[col.name].value,
                            "onUpdate:modelValue": $event => ((_ctx.columnsFilterData[col.name].value) = $event),
                            readonly:
                            typeof _ctx.columnsFilterData[col.name] == 'object' &&
                            (_ctx.columnsFilterData[col.name].from.length > 0 || _ctx.columnsFilterData[col.name].to.length > 0)
                        ,
                            disable: col.filterDisabled === true,
                            debounce: "300",
                            class: "q-px-xs",
                            filled: "",
                            dense: "",
                            dark: _ctx.dark,
                            color: _ctx.color
                          }, {
                            append: withCtx(() => [
                              (_ctx.columnsFilterData[col.name].value)
                                ? (openBlock(), createBlock(_component_q_icon, {
                                    key: 0,
                                    onClick: withModifiers($event => (_ctx.columnsFilterData[col.name] = { value: '', from: '', to: '' }), ["stop"]),
                                    name: "cancel",
                                    class: "cursor-pointer"
                                  }, null, 8 /* PROPS */, ["onClick"]))
                                : createCommentVNode("v-if", true),
                              createVNode(_component_q_icon, {
                                name: "event",
                                class: "cursor-pointer"
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_q_popup_proxy, {
                                    cover: "",
                                    "transition-show": "scale",
                                    "transition-hide": "scale",
                                    onBeforeShow: _cache[3] || (_cache[3] = $event => (_ctx.columnsFilterDeferred = true)),
                                    onBeforeHide: _cache[4] || (_cache[4] = $event => (_ctx.columnsFilterDeferred = false))
                                  }, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_date, {
                                        modelValue: _ctx.columnsFilterData[col.name],
                                        "onUpdate:modelValue": [$event => ((_ctx.columnsFilterData[col.name]) = $event), $event => (_ctx.updateFilterData(col))],
                                        mask: "DD.MM.YYYY",
                                        range: "",
                                        dark: _ctx.dark,
                                        color: _ctx.color
                                      }, {
                                        default: withCtx(() => [
                                          createElementVNode("div", _hoisted_4$3, [
                                            withDirectives(createVNode(_component_q_btn, {
                                              label: _ctx.$q.lang.label.close,
                                              class: "text-capitalize",
                                              color: "primary",
                                              flat: ""
                                            }, null, 8 /* PROPS */, ["label"]), [
                                              [_directive_close_popup]
                                            ])
                                          ])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "dark", "color"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "readonly", "disable", "dark", "color"]))
                        : createCommentVNode("v-if", true),
                      (col.hasOwnProperty('filterType') && col.filterType == 'number_range')
                        ? (openBlock(), createBlock(_component_q_input, {
                            key: 3,
                            modelValue: _ctx.columnsFilterData[col.name].value,
                            "onUpdate:modelValue": $event => ((_ctx.columnsFilterData[col.name].value) = $event),
                            readonly: typeof _ctx.columnsFilterData[col.name].from != 'string' || typeof _ctx.columnsFilterData[col.name].to != 'string',
                            disable: col.filterDisabled === true,
                            debounce: "300",
                            class: "q-px-xs",
                            filled: "",
                            dense: "",
                            dark: _ctx.dark,
                            color: _ctx.color
                          }, {
                            append: withCtx(() => [
                              (_ctx.columnsFilterData[col.name].value)
                                ? (openBlock(), createBlock(_component_q_icon, {
                                    key: 0,
                                    onClick: withModifiers($event => (_ctx.columnsFilterData[col.name] = { value: '', from: '', to: '' }), ["stop"]),
                                    name: "cancel",
                                    class: "cursor-pointer"
                                  }, null, 8 /* PROPS */, ["onClick"]))
                                : createCommentVNode("v-if", true),
                              createVNode(_component_q_icon, {
                                name: "tag",
                                class: "cursor-pointer"
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_q_popup_proxy, {
                                    cover: "",
                                    class: "row q-pa-sm",
                                    "transition-show": "scale",
                                    "transition-hide": "scale",
                                    dark: _ctx.dark,
                                    onBeforeShow: _cache[5] || (_cache[5] = $event => (_ctx.columnsFilterDeferred = true)),
                                    onBeforeHide: _cache[6] || (_cache[6] = $event => (_ctx.columnsFilterDeferred = false))
                                  }, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_input, {
                                        modelValue: _ctx.columnsFilterData[col.name].from,
                                        "onUpdate:modelValue": [$event => ((_ctx.columnsFilterData[col.name].from) = $event), $event => (_ctx.updateFilterData(col))],
                                        modelModifiers: { number: true },
                                        label: _ctx.t('columnFilterFrom'),
                                        type: "number",
                                        debounce: "300",
                                        class: "q-px-xs",
                                        filled: "",
                                        dark: _ctx.dark,
                                        color: _ctx.color
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "label", "dark", "color"]),
                                      createVNode(_component_q_input, {
                                        modelValue: _ctx.columnsFilterData[col.name].to,
                                        "onUpdate:modelValue": [$event => ((_ctx.columnsFilterData[col.name].to) = $event), $event => (_ctx.updateFilterData(col))],
                                        modelModifiers: { number: true },
                                        label: _ctx.t('columnFilterTo'),
                                        type: "number",
                                        debounce: "300",
                                        class: "q-px-xs",
                                        filled: "",
                                        dark: _ctx.dark,
                                        color: _ctx.color
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "label", "dark", "color"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["dark"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "readonly", "disable", "dark", "color"]))
                        : createCommentVNode("v-if", true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"])), [
              [vShow, _ctx.columnsFilterEnabled]
            ])
          : createCommentVNode("v-if", true)
      ]),
      body: withCtx((props) => [
        renderSlot(_ctx.$slots, "body", normalizeProps(guardReactiveProps(props)), () => [
          createVNode(_component_q_tr, {
            props: props,
            "no-hover": _ctx.noHover,
            onClick: $event => (_ctx.onRowClick($event, props)),
            onDblclick: $event => (_ctx.onRowDblclick($event, props)),
            onContextmenu: $event => (_ctx.onRowContextmenu($event, props))
          }, {
            default: withCtx(() => [
              (_ctx.selectionProp != 'none')
                ? (openBlock(), createBlock(_component_q_td, {
                    key: 0,
                    "auto-width": "",
                    class: "text-center"
                  }, {
                    default: withCtx(() => [
                      renderSlot(_ctx.$slots, "body-selection", normalizeProps(guardReactiveProps(props)), () => [
                        createVNode(_component_q_checkbox, {
                          modelValue: props.selected,
                          "onUpdate:modelValue": $event => ((props.selected) = $event),
                          dense: _ctx.dense,
                          dark: _ctx.dark,
                          color: _ctx.color
                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "dense", "dark", "color"])
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                : createCommentVNode("v-if", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList(props.cols, (col) => {
                return renderSlot(_ctx.$slots, 'body-cell-' + col.name, mergeProps({
                  key: col.name
                }, props, {
                  col: col,
                  value: col.value
                }), () => [
                  renderSlot(_ctx.$slots, 'body-cell', mergeProps(props, {
                    col: col,
                    value: col.value
                  }), () => [
                    (openBlock(), createBlock(_component_q_td, {
                      props: props,
                      key: col.name,
                      onHover: _cache[7] || (_cache[7] = withModifiers(() => {}, ["stop","prevent"])),
                      style: normalizeStyle(_ctx.getColumnStyle(col))
                    }, {
                      default: withCtx(() => [
                        (_ctx.booleanAsCheckbox && typeof col.value === 'boolean')
                          ? (openBlock(), createBlock(_component_q_checkbox, {
                              key: 0,
                              class: "q-table__body-cell-checkbox",
                              "model-value": col.value,
                              disable: true,
                              dense: _ctx.dense,
                              dark: _ctx.dark,
                              color: _ctx.color
                            }, null, 8 /* PROPS */, ["model-value", "dense", "dark", "color"]))
                          : (openBlock(), createElementBlock("div", {
                              key: 1,
                              title: col.value,
                              class: "q-table__body-cell ellipsis"
                            }, toDisplayString(col.value), 9 /* TEXT, PROPS */, _hoisted_5$3))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props", "style"]))
                  ])
                ])
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props", "no-hover", "onClick", "onDblclick", "onContextmenu"])
        ])
      ]),
      _: 2 /* DYNAMIC */
    }, [
      (_ctx.visibleTop)
        ? {
            name: "top",
            fn: withCtx((props) => [
              renderSlot(_ctx.$slots, "top", mergeProps(props, {
                tableFilter: _ctx.tableFilter,
                exportCsv: _ctx.exportCsv,
                fullscreenToggle: _ctx.fullscreenToggle,
                filter: _ctx.filterProp,
                exportCsvTable: _ctx.exportCsvTable,
                columnsConfigDialog: _ctx.columnsConfigDialog
              }), () => [
                createVNode(_component_q_overflow_toolbar, mergeProps({ "button-align": "left" }, _ctx.toolbarProps, {
                  modelValue: _ctx.toolbarModelValueProp,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.toolbarModelValueProp) = $event)),
                  ref: "gridTableToolbar",
                  style: {"width":"100%"}
                }), {
                  default: withCtx(() => [
                    (_ctx.title)
                      ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          class: normalizeClass(['q-table__title', _ctx.titleClass]),
                          "qot-id": "QGrid-Toolbar-01"
                        }, toDisplayString(_ctx.title), 3 /* TEXT, CLASS */))
                      : createCommentVNode("v-if", true),
                    renderSlot(_ctx.$slots, "toolbar", normalizeProps(guardReactiveProps(props))),
                    (_ctx.visibleToolbarRight)
                      ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                          createVNode(_component_q_space),
                          (_ctx.tableFilter)
                            ? (openBlock(), createBlock(_component_q_input, mergeProps({
                                key: 0,
                                modelValue: _ctx.filterProp,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.filterProp) = $event)),
                                placeholder: _ctx.$q.lang.label.search,
                                debounce: "300",
                                filled: "",
                                borderless: "",
                                dense: "",
                                dark: _ctx.dark,
                                color: _ctx.color,
                                class: "q-ml-sm",
                                style: {"width":"200px"}
                              }, _ctx.toolbarSearchInputProps, { "qot-id": "QGrid-Toolbar-02" }), {
                                append: withCtx(() => [
                                  (_ctx.filterProp)
                                    ? (openBlock(), createBlock(_component_q_icon, {
                                        key: 0,
                                        name: "cancel",
                                        onClick: _cache[8] || (_cache[8] = withModifiers($event => (_ctx.filterProp = ''), ["stop"])),
                                        class: "cursor-pointer"
                                      }))
                                    : (openBlock(), createBlock(_component_q_icon, {
                                        key: 1,
                                        name: "search"
                                      }))
                                ]),
                                _: 1 /* STABLE */
                              }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "dark", "color"]))
                            : createCommentVNode("v-if", true),
                          (_ctx.reload && _ctx.loadTypeProp)
                            ? withDirectives((openBlock(), createBlock(_component_q_btn, mergeProps({
                                key: 1,
                                title: _ctx.t('refresh'),
                                icon: "refresh",
                                "no-caps": "",
                                class: "q-ml-sm"
                              }, _ctx.toolbarButtonsProps, {
                                "qot-id": "QGrid-Toolbar-03",
                                onClick: _cache[10] || (_cache[10] = $event => (_ctx.reloadData()))
                              }), null, 16 /* FULL_PROPS */, ["title"])), [
                                [_directive_close_popup, 'overflow']
                              ])
                            : createCommentVNode("v-if", true),
                          (_ctx.exportCsv)
                            ? withDirectives((openBlock(), createBlock(_component_q_btn, mergeProps({
                                key: 2,
                                title: _ctx.t('exportCsv'),
                                icon: "file_download",
                                "no-caps": "",
                                class: "q-ml-sm"
                              }, _ctx.toolbarButtonsProps, {
                                "qot-id": "QGrid-Toolbar-04",
                                onClick: _cache[11] || (_cache[11] = $event => (_ctx.exportCsvTable()))
                              }), null, 16 /* FULL_PROPS */, ["title"])), [
                                [_directive_close_popup, 'overflow']
                              ])
                            : createCommentVNode("v-if", true),
                          (_ctx.columnsFilter)
                            ? withDirectives((openBlock(), createBlock(_component_q_btn, mergeProps({
                                key: 3,
                                title: _ctx.columnsFilterEnabled ? _ctx.t('filterDeactivate') : _ctx.t('filterActivate'),
                                icon: _ctx.columnsFilterEnabled ? 'filter_alt' : 'filter_alt_off',
                                "no-caps": "",
                                class: "q-ml-sm"
                              }, _ctx.toolbarButtonsProps, {
                                "qot-id": "QGrid-Toolbar-05",
                                onClick: _cache[12] || (_cache[12] = $event => (_ctx.columnsFilterEnabled = !_ctx.columnsFilterEnabled))
                              }), {
                                default: withCtx(() => [
                                  createCommentVNode(" <q-badge floating :color=\"columnsFilterEnabled ? 'green' : 'red'\" rounded /> ")
                                ]),
                                _: 1 /* STABLE */
                              }, 16 /* FULL_PROPS */, ["title", "icon"])), [
                                [_directive_close_popup, 'overflow']
                              ])
                            : createCommentVNode("v-if", true),
                          (_ctx.columnsControl)
                            ? withDirectives((openBlock(), createBlock(_component_q_btn, mergeProps({
                                key: 4,
                                title: _ctx.t('tableConfig.title'),
                                icon: "settings",
                                "no-caps": "",
                                class: "q-ml-sm"
                              }, _ctx.toolbarButtonsProps, {
                                "qot-id": "QGrid-Toolbar-06",
                                onClick: _cache[13] || (_cache[13] = $event => (_ctx.columnsConfigDialog = true))
                              }), null, 16 /* FULL_PROPS */, ["title"])), [
                                [_directive_close_popup, 'overflow']
                              ])
                            : createCommentVNode("v-if", true),
                          (_ctx.fullscreenToggle)
                            ? (openBlock(), createBlock(_component_q_btn, mergeProps({
                                key: 5,
                                title: props.inFullscreen ? _ctx.t('minimize') : _ctx.t('maximize'),
                                icon: props.inFullscreen ? 'fullscreen_exit' : 'fullscreen',
                                "no-caps": "",
                                class: "q-ml-sm"
                              }, _ctx.toolbarButtonsProps, {
                                "qot-id": "QGrid-Toolbar-07",
                                onClick: props.toggleFullscreen
                              }), null, 16 /* FULL_PROPS */, ["title", "icon", "onClick"]))
                            : createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["modelValue"])
              ])
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.$slots['loading'])
        ? {
            name: "loading",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "loading")
            ]),
            key: "1"
          }
        : undefined,
      (_ctx.$slots['item'])
        ? {
            name: "item",
            fn: withCtx((props) => [
              renderSlot(_ctx.$slots, "item", normalizeProps(guardReactiveProps(props)))
            ]),
            key: "2"
          }
        : undefined,
      (_ctx.$slots['top-row'])
        ? {
            name: "top-row",
            fn: withCtx((props) => [
              renderSlot(_ctx.$slots, "top-row", normalizeProps(guardReactiveProps(props)))
            ]),
            key: "3"
          }
        : undefined,
      (_ctx.$slots['bottom-row'])
        ? {
            name: "bottom-row",
            fn: withCtx((props) => [
              renderSlot(_ctx.$slots, "bottom-row", normalizeProps(guardReactiveProps(props)))
            ]),
            key: "4"
          }
        : undefined,
      (_ctx.$slots['bottom'])
        ? {
            name: "bottom",
            fn: withCtx((props) => [
              renderSlot(_ctx.$slots, "bottom", normalizeProps(guardReactiveProps(props)))
            ]),
            key: "5"
          }
        : undefined,
      (_ctx.$slots['pagination'])
        ? {
            name: "pagination",
            fn: withCtx((props) => [
              renderSlot(_ctx.$slots, "pagination", normalizeProps(guardReactiveProps(props)))
            ]),
            key: "6"
          }
        : undefined,
      (_ctx.$slots['no-data'])
        ? {
            name: "no-data",
            fn: withCtx((props) => [
              renderSlot(_ctx.$slots, "no-data", normalizeProps(guardReactiveProps(props)))
            ]),
            key: "7"
          }
        : undefined
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "rows", "columns", "visible-columns", "selection", "filter", "selected", "pagination", "fullscreen", "expanded", "row-key", "loading", "icon-first-page", "icon-prev-page", "icon-next-page", "icon-last-page", "title", "hide-header", "grid", "grid-header", "dense", "flat", "bordered", "square", "separator", "wrap-cells", "virtual-scroll", "virtual-scroll-target", "virtual-scroll-slice-size", "virtual-scroll-slice-ratio-before", "virtual-scroll-slice-ratio-after", "virtual-scroll-item-size", "virtual-scroll-sticky-size-start", "virtual-scroll-sticky-size-end", "table-colspan", "no-data-label", "no-results-label", "loading-label", "selected-rows-label", "rows-per-page-label", "pagination-label", "color", "title-class", "table-style", "table-class", "table-header-style", "table-header-class", "card-container-class", "card-container-style", "card-style", "card-class", "hide-bottom", "hide-selected-banner", "hide-no-data", "hide-pagination", "dark", "no-route-fullscreen-exit", "filter-method", "rows-per-page-options", "sort-method", "binary-state-sort", "column-sort-order", "onRequest", "onSelection", "onVirtualScroll", "onKeydown", "style", "class"]),
    createVNode(_component_q_dialog, {
      modelValue: _ctx.columnsConfigDialog,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((_ctx.columnsConfigDialog) = $event)),
      class: "q-table__col-config-dialog"
    }, {
      default: withCtx(() => [
        createVNode(_component_q_resize_observer, {
          onResize: _cache[21] || (_cache[21] = $event => {
                _ctx.$refs.colConfigDialogMenu &&
                    _ctx.$refs.colConfigDialogMenu.forEach((el) => {
                        el.hide();
                    });
            })
        }),
        createVNode(_component_q_card, { dark: _ctx.dark }, {
          default: withCtx(() => [
            createVNode(_component_q_card_section, null, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_6$3, toDisplayString(_ctx.t('tableConfig.title')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_q_separator),
            (_ctx.loadTypeProp && _ctx.loadTypeEditableProp)
              ? (openBlock(), createBlock(_component_q_card_section, {
                  key: 0,
                  class: "q-pa-none"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_q_item, null, {
                      default: withCtx(() => [
                        createVNode(_component_q_item_section, { avatar: "" }, {
                          default: withCtx(() => [
                            createVNode(_component_q_checkbox, {
                              ref: "loadTypeStateCheckbox",
                              modelValue: _ctx.loadTypeState,
                              "onUpdate:modelValue": [
                                _cache[22] || (_cache[22] = $event => ((_ctx.loadTypeState) = $event)),
                                _ctx.onChangeLoadType
                              ],
                              dark: _ctx.dark,
                              color: _ctx.color
                            }, null, 8 /* PROPS */, ["modelValue", "dark", "color", "onUpdate:modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        createVNode(_component_q_item_section, {
                          class: "cursor-pointer",
                          onClick: _cache[23] || (_cache[23] = $event => (_ctx.$refs.loadTypeStateCheckbox.toggle()))
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_q_item_label, { class: "text-weight-bold ellipsis" }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(_ctx.t('tableConfig.dynamicLoad')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true),
            (_ctx.loadTypeProp && _ctx.loadTypeEditableProp)
              ? (openBlock(), createBlock(_component_q_separator, { key: 1 }))
              : createCommentVNode("v-if", true),
            createCommentVNode(" <q-card-section style=\"max-height: 50vh\" class=\"scroll q-pa-none\"> "),
            createVNode(_component_q_card_section, {
              style: normalizeStyle('min-height: 110px; max-height: calc(100vh - ' + (_ctx.loadTypeProp && _ctx.loadTypeEditableProp ? '225' : '168') + 'px)'),
              class: "scroll q-pa-none"
            }, {
              default: withCtx(() => [
                createVNode(_component_q_list, null, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columnsProp, (col, colIndex) => {
                      return (openBlock(), createBlock(_component_q_item, {
                        key: col,
                        draggable: _ctx.columnsReorder,
                        onDragstart: $event => (_ctx.onDragStart($event, col, colIndex)),
                        onDragend: $event => (_ctx.onDragEnd($event, col, colIndex)),
                        onDragenter: $event => (_ctx.onDragEnter($event, col, colIndex)),
                        onDragleave: $event => (_ctx.onDragLeave($event, col, colIndex)),
                        onDragover: $event => (_ctx.onDragOver($event, col, colIndex)),
                        onDrop: $event => (_ctx.onDrop($event, col, colIndex)),
                        class: normalizeClass(
                            (col.sortable
                                ? ' sortable' + (_ctx.paginationProp.sortBy === col.name ? ' sorted' + (_ctx.paginationProp.descending ? ' sort-desc' : '') : '')
                                : '') + (_ctx.columnsReorder ? ' draggable' : '')
                        )
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_q_item_section, {
                            avatar: "",
                            class: "q-pr-xs",
                            style: {"min-width":"unset"}
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_q_checkbox, {
                                modelValue: _ctx.visibleColumnsProp,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => ((_ctx.visibleColumnsProp) = $event)),
                                val: col.name,
                                disable: col.required,
                                dark: _ctx.dark,
                                color: _ctx.color
                              }, null, 8 /* PROPS */, ["modelValue", "val", "disable", "dark", "color"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          createVNode(_component_q_item_section, {
                            onClick: $event => (col.sortable && _ctx.sort(col))
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_q_item_label, { class: "ellipsis" }, {
                                default: withCtx(() => [
                                  createVNode(_component_q_icon, {
                                    name: "arrow_upward",
                                    class: "q-table__sort-icon q-mr-xs"
                                  }),
                                  createElementVNode("span", null, toDisplayString(col.label), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                          (_ctx.columnsResize || _ctx.columnsReorder)
                            ? (openBlock(), createBlock(_component_q_item_section, {
                                key: 0,
                                avatar: "",
                                class: "gt-xs"
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_q_btn_group, null, {
                                    default: withCtx(() => [
                                      (_ctx.columnsResize)
                                        ? (openBlock(), createBlock(_component_q_btn, {
                                            key: 0,
                                            icon: "open_in_full",
                                            outline: false,
                                            disable: (typeof col.width == 'number' ? false : true) || col.resizable === false,
                                            onClick: $event => (_ctx.setColumnWidth(col, col.width + 10, _ctx.columnsResizeMode === 'next' ? _ctx.columnsProp[colIndex + 1] : undefined))
                                          }, {
                                            default: withCtx(() => [
                                              createVNode(_component_q_tooltip, {
                                                anchor: "top middle",
                                                self: "bottom middle",
                                                "transition-show": "fade",
                                                "transition-hide": "fade",
                                                offset: [10, 10]
                                              }, {
                                                default: withCtx(() => [
                                                  createElementVNode("strong", null, toDisplayString(col.width) + "px", 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disable", "onClick"]))
                                        : createCommentVNode("v-if", true),
                                      (_ctx.columnsResize)
                                        ? (openBlock(), createBlock(_component_q_btn, {
                                            key: 1,
                                            icon: "close_fullscreen",
                                            outline: false,
                                            disable: (typeof col.width == 'number' ? false : true) || col.resizable === false,
                                            onClick: $event => (_ctx.setColumnWidth(col, col.width - 10, _ctx.columnsResizeMode === 'next' ? _ctx.columnsProp[colIndex + 1] : undefined))
                                          }, {
                                            default: withCtx(() => [
                                              createVNode(_component_q_tooltip, {
                                                anchor: "top middle",
                                                self: "bottom middle",
                                                "transition-show": "fade",
                                                "transition-hide": "fade",
                                                offset: [10, 10]
                                              }, {
                                                default: withCtx(() => [
                                                  createElementVNode("strong", null, toDisplayString(col.width) + "px", 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disable", "onClick"]))
                                        : createCommentVNode("v-if", true),
                                      (_ctx.columnsReorder)
                                        ? (openBlock(), createBlock(_component_q_btn, {
                                            key: 2,
                                            icon: "arrow_upward",
                                            outline: false,
                                            onClick: $event => (_ctx.setColumnIndex(colIndex, colIndex - 1))
                                          }, null, 8 /* PROPS */, ["onClick"]))
                                        : createCommentVNode("v-if", true),
                                      (_ctx.columnsReorder)
                                        ? (openBlock(), createBlock(_component_q_btn, {
                                            key: 3,
                                            icon: "arrow_downward",
                                            outline: false,
                                            onClick: $event => (_ctx.setColumnIndex(colIndex, colIndex + 1))
                                          }, null, 8 /* PROPS */, ["onClick"]))
                                        : createCommentVNode("v-if", true)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : createCommentVNode("v-if", true),
                          ((_ctx.columnsResize && typeof col.width == 'number') || _ctx.columnsReorder)
                            ? (openBlock(), createBlock(_component_q_item_section, {
                                key: 1,
                                avatar: "",
                                class: "xs"
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_q_btn, {
                                    icon: "more_vert",
                                    outline: false
                                  }, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_menu, {
                                        ref_for: true,
                                        ref: "colConfigDialogMenu",
                                        dark: _ctx.dark
                                      }, {
                                        default: withCtx(() => [
                                          createVNode(_component_q_list, { style: {"min-width":"100px"} }, {
                                            default: withCtx(() => [
                                              (_ctx.columnsResize && typeof col.width == 'number' && col.resizable !== false)
                                                ? withDirectives((openBlock(), createBlock(_component_q_item, {
                                                    key: 0,
                                                    clickable: "",
                                                    onClick: $event => (_ctx.setColumnWidth(col, col.width + 10, _ctx.columnsResizeMode === 'next' ? _ctx.columnsProp[colIndex + 1] : undefined))
                                                  }, {
                                                    default: withCtx(() => [
                                                      createVNode(_component_q_item_section, { avatar: "" }, {
                                                        default: withCtx(() => [
                                                          createVNode(_component_q_icon, { name: "open_in_full" })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      }),
                                                      createVNode(_component_q_item_section, null, {
                                                        default: withCtx(() => [
                                                          createTextVNode(toDisplayString(_ctx.t('columnExpand')), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      }),
                                                      createVNode(_component_q_tooltip, {
                                                        anchor: "top middle",
                                                        self: "bottom middle",
                                                        "transition-show": "fade",
                                                        "transition-hide": "fade",
                                                        offset: [10, 10]
                                                      }, {
                                                        default: withCtx(() => [
                                                          createElementVNode("strong", null, toDisplayString(col.width) + "px", 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                                    [_directive_ripple]
                                                  ])
                                                : createCommentVNode("v-if", true),
                                              (_ctx.columnsResize && typeof col.width == 'number' && col.resizable !== false)
                                                ? withDirectives((openBlock(), createBlock(_component_q_item, {
                                                    key: 1,
                                                    clickable: "",
                                                    onClick: $event => (_ctx.setColumnWidth(col, col.width - 10, _ctx.columnsResizeMode === 'next' ? _ctx.columnsProp[colIndex + 1] : undefined))
                                                  }, {
                                                    default: withCtx(() => [
                                                      createVNode(_component_q_item_section, { avatar: "" }, {
                                                        default: withCtx(() => [
                                                          createVNode(_component_q_icon, { name: "close_fullscreen" })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      }),
                                                      createVNode(_component_q_item_section, null, {
                                                        default: withCtx(() => [
                                                          createTextVNode(toDisplayString(_ctx.t('columnReduce')), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      }),
                                                      createVNode(_component_q_tooltip, {
                                                        anchor: "top middle",
                                                        self: "bottom middle",
                                                        "transition-show": "fade",
                                                        "transition-hide": "fade",
                                                        offset: [10, 10]
                                                      }, {
                                                        default: withCtx(() => [
                                                          createElementVNode("strong", null, toDisplayString(col.width) + "px", 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                                    [_directive_ripple]
                                                  ])
                                                : createCommentVNode("v-if", true),
                                              (_ctx.columnsResize && _ctx.columnsReorder)
                                                ? (openBlock(), createBlock(_component_q_separator, { key: 2 }))
                                                : createCommentVNode("v-if", true),
                                              (_ctx.columnsReorder)
                                                ? withDirectives((openBlock(), createBlock(_component_q_item, {
                                                    key: 3,
                                                    clickable: "",
                                                    onClick: $event => (_ctx.setColumnIndex(colIndex, colIndex - 1))
                                                  }, {
                                                    default: withCtx(() => [
                                                      createVNode(_component_q_item_section, { avatar: "" }, {
                                                        default: withCtx(() => [
                                                          createVNode(_component_q_icon, { name: "arrow_upward" })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      }),
                                                      createVNode(_component_q_item_section, null, {
                                                        default: withCtx(() => [
                                                          createTextVNode(toDisplayString(_ctx.t('columnMoveUp')), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      })
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                                    [_directive_ripple],
                                                    [_directive_close_popup]
                                                  ])
                                                : createCommentVNode("v-if", true),
                                              (_ctx.columnsReorder)
                                                ? withDirectives((openBlock(), createBlock(_component_q_item, {
                                                    key: 4,
                                                    clickable: "",
                                                    onClick: $event => (_ctx.setColumnIndex(colIndex, colIndex + 1))
                                                  }, {
                                                    default: withCtx(() => [
                                                      createVNode(_component_q_item_section, { avatar: "" }, {
                                                        default: withCtx(() => [
                                                          createVNode(_component_q_icon, { name: "arrow_downward" })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      }),
                                                      createVNode(_component_q_item_section, null, {
                                                        default: withCtx(() => [
                                                          createTextVNode(toDisplayString(_ctx.t('columnMoveDown')), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      })
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                                    [_directive_ripple],
                                                    [_directive_close_popup]
                                                  ])
                                                : createCommentVNode("v-if", true)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["dark"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : createCommentVNode("v-if", true)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["draggable", "onDragstart", "onDragend", "onDragenter", "onDragleave", "onDragover", "onDrop", "class"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"]),
            createVNode(_component_q_separator),
            createVNode(_component_q_card_actions, { align: "right" }, {
              default: withCtx(() => [
                withDirectives(createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$q.lang.label.close,
                  "no-caps": ""
                }, null, 8 /* PROPS */, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["dark"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}

var css_248z$8 = "\n.q-table__container[data-v-77cac7d7]  {\n    outline: 0;\n}\n.q-table__container[data-v-77cac7d7]  .q-table__top {\n    padding: 12px 8px;\n}\n.q-table__container.q-table--dense[data-v-77cac7d7]  .q-table__top {\n    padding: 6px 4px;\n}\n.q-table--horizontal-separator.fit tbody tr:last-child > td[data-v-77cac7d7],\n.q-table--horizontal-separator.full-height tbody tr:last-child > td[data-v-77cac7d7],\n.q-table--horizontal-separator.absolute-full tbody tr:last-child > td[data-v-77cac7d7],\n.q-table--cell-separator.fit tbody tr:last-child > td[data-v-77cac7d7],\n.q-table--cell-separator.full-height tbody tr:last-child > td[data-v-77cac7d7],\n.q-table--cell-separator.absolute-full tbody tr:last-child > td[data-v-77cac7d7] {\n    border-bottom-width: 1px;\n}\n.q-table--dense .q-table th[data-v-77cac7d7]:first-child,\n.q-table--dense .q-table td[data-v-77cac7d7]:first-child {\n    padding-left: 8px;\n}\n.q-table--dense .q-table th[data-v-77cac7d7]:last-child,\n.q-table--dense .q-table td[data-v-77cac7d7]:last-child {\n    padding-right: 8px;\n}\n.q-table__header-cell[data-v-77cac7d7] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.q-table__body-cell[data-v-77cac7d7] {\n    width: inherit;\n}\n.q-table__body-cell-checkbox[data-v-77cac7d7] {\n    opacity: 1 !important;\n    cursor: default !important;\n}\n.q-table__body-cell-checkbox[data-v-77cac7d7]  * {\n    cursor: default !important;\n}\n.q-table--grid[data-v-77cac7d7]  .q-table__grid-content {\n    overflow: auto;\n}\n.q-table--grid[data-v-77cac7d7]  .q-table__middle {\n    min-height: auto;\n}\n.q-table--col-resizable[data-v-77cac7d7]  table {\n    width: auto;\n}\n.q-table--col-resizable.q-table--vertical-separator[data-v-77cac7d7]  table > thead > tr > th:last-child,\n.q-table--col-resizable.q-table--vertical-separator[data-v-77cac7d7]  table > tbody > tr > td:last-child,\n.q-table--col-resizable.q-table--cell-separator[data-v-77cac7d7]  table > thead > tr > th:last-child,\n.q-table--col-resizable.q-table--cell-separator[data-v-77cac7d7]  table > tbody > tr > td:last-child {\n    border-right-width: 1px;\n}\n.q-table--sticky-header[data-v-77cac7d7]  thead {\n    position: sticky;\n    z-index: 2;\n    top: 0;\n}\n.q-table--sticky-header[data-v-77cac7d7]  thead tr th {\n    background: #fff;\n}\n.q-table--sticky-header.q-dark[data-v-77cac7d7]  thead tr th {\n    background: var(--q-dark);\n}\n.q-table--sticky-column[data-v-77cac7d7]  thead th:first-child,\n.q-table--sticky-column[data-v-77cac7d7]  tbody:not(.q-virtual-scroll__padding) td:first-child,\n.q-table--sticky-column[data-v-77cac7d7]  tbody:not(.q-virtual-scroll__padding) th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 1;\n    background: #fff;\n}\n.q-table--sticky-column.q-dark[data-v-77cac7d7]  thead th:first-child,\n.q-table--sticky-column.q-dark[data-v-77cac7d7]  tbody:not(.q-virtual-scroll__padding) td:first-child,\n.q-table--sticky-column.q-dark[data-v-77cac7d7]  tbody:not(.q-virtual-scroll__padding) th:first-child {\n    background: var(--q-dark);\n}\n.q-table--sticky-column[data-v-77cac7d7]  thead th:first-child {\n    z-index: 3;\n}\n.q-table__col-filter[data-v-77cac7d7]  .q-select .q-field__control-container .q-field__native span {\n    text-overflow: ellipsis !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n}\n.q-table__col-config-dialog .q-item.sortable .q-item__section--main[data-v-77cac7d7] {\n    cursor: pointer;\n}\n.q-table__col-config-dialog .q-item.sortable .q-item__section--main:hover .q-table__sort-icon[data-v-77cac7d7] {\n    opacity: 0.64;\n}\n.q-table__col-config-dialog .q-item.sorted .q-table__sort-icon[data-v-77cac7d7] {\n    opacity: 0.86 !important;\n}\n.q-table__col-config-dialog .q-item.sort-desc .q-table__sort-icon[data-v-77cac7d7] {\n    transform: rotate(180deg);\n}\n/* .q-table__col-config-dialog .q-item.draggable {\n    background-color: #fff;\n} */\n";
styleInject(css_248z$8);

function block0$3 (Component) {
  Component.__i18n = Component.__i18n || [];
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "sk": {
        "tableConfig": {
          "title": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfigurácia tabuľky"])};fn.source="Konfigurácia tabuľky";return fn;})(),
          "dynamicLoad": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať dynamické načítanie"])};fn.source="Aktivovať dynamické načítanie";return fn;})()
        },
        "columnExpand": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zväčšiť"])};fn.source="Zväčšiť";return fn;})(),
        "columnReduce": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmenšiť"])};fn.source="Zmenšiť";return fn;})(),
        "columnMoveUp": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Presunúť hore"])};fn.source="Presunúť hore";return fn;})(),
        "columnMoveDown": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Presunúť dole"])};fn.source="Presunúť dole";return fn;})(),
        "columnFilterFrom": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Od"])};fn.source="Od";return fn;})(),
        "columnFilterTo": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do"])};fn.source="Do";return fn;})(),
        "exportFileError": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prehliadač zamietol sťahovanie súboru!"])};fn.source="Prehliadač zamietol sťahovanie súboru!";return fn;})(),
        "refresh": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obnoviť"])};fn.source="Obnoviť";return fn;})(),
        "exportCsv": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exportovať CSV"])};fn.source="Exportovať CSV";return fn;})(),
        "filterActivate": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať filter"])};fn.source="Aktivovať filter";return fn;})(),
        "filterDeactivate": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovať filter"])};fn.source="Deaktivovať filter";return fn;})(),
        "minimize": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minimalizovať"])};fn.source="Minimalizovať";return fn;})(),
        "maximize": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maximalizovať"])};fn.source="Maximalizovať";return fn;})(),
        "rowCount": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Počet záznamov"])};fn.source="Počet záznamov";return fn;})()
      }
    }
  });
}

if (typeof block0$3 === 'function') block0$3(script$9);

script$9.render = render$9;
script$9.__scopeId = "data-v-77cac7d7";
script$9.__file = "src/components/QGrid.vue";

var script$8 = defineComponent({
    name: 'QChooseInput',
    components: {
        QBtn,
        QCard,
        QCardActions,
        QCardSection,
        QDialog,
        QField,
        QIcon,
        QItem,
        QItemLabel,
        QItemSection,
        QList,
        QResizeObserver,
        QScrollArea,
        QSeparator,
        QGrid: script$9,
    },
    directives: {
        ClosePopup,
    },
    mounted() {
        if (this.multiple && typeof this.height === 'number' && this.$refs.chooseInputField) {
            const control = this.$refs.chooseInputField.$el.querySelector('.q-field__control');
            control.style.height = this.height + 'px';
        }
        if (this.multiple !== true && this.chooseOnClick === true && this.$refs.chooseInputField) {
            this.$refs.chooseInputField.$el.querySelector('.q-field__control-container').addEventListener('click', (evt) => this.openChooseTable(evt));
        }
    },
    updated() {
        if (this.multiple && typeof this.height === 'number' && this.$refs.chooseInputField) {
            const control = this.$refs.chooseInputField.$el.querySelector('.q-field__control');
            control.style.height = this.height + 'px';
        }
    },
    props: {
        label: String,
        stackLabel: Boolean,
        hint: String,
        hideHint: Boolean,
        labelColor: String,
        color: String,
        bgColor: String,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        loading: Boolean,
        hideBottomSpace: Boolean,
        rounded: Boolean,
        dense: Boolean,
        itemAligned: Boolean,
        counter: Boolean,
        clearable: Boolean,
        clearIcon: String,
        disable: Boolean,
        readonly: Boolean,
        autofocus: Boolean,
        for: String,
        maxlength: [Number, String],
        dark: {
            type: Boolean,
            default: null,
        },
        modelValue: {},
        error: {
            type: Boolean,
            default: null,
        },
        errorMessage: String,
        noErrorIcon: Boolean,
        rules: Array,
        reactiveRules: Boolean,
        lazyRules: {
            type: [Boolean, String],
            validator: (v) => [true, false, 'ondemand'].includes(v),
        },
        name: String,
        multiple: Boolean,
        chooseOnClick: {
            type: Boolean,
            default: false,
        },
        confirmOnSelect: {
            type: Boolean,
            default: true,
        },
        uniqueChoose: {
            type: Boolean,
            default: true,
        },
        itemKeyField: [String, Function],
        itemValueField: [String, Function],
        itemCaptionField: [String, Function],
        chooseIcon: {
            type: String,
            default: 'search',
        },
        placeholder: String,
        dialogProps: Object,
        height: {
            type: Number,
            default: 250,
        },
        gridLoadType: {
            type: String,
            default: null,
        },
        gridColumns: Array,
        gridDense: Boolean,
        gridLoading: Boolean,
        gridSeparator: {
            type: String,
            default: 'cell',
            validator: (v) => ['horizontal', 'vertical', 'cell', 'none'].includes(v),
        },
        gridPagination: Object,
        gridRowsPerPageOptions: {
            type: Array,
            default: () => [0],
        },
        gridHideBottom: Boolean,
        gridHideSelectedBanner: Boolean,
        gridHideNoData: Boolean,
        gridHidePagination: {
            type: Boolean,
            default: true,
        },
        gridVirtualScroll: Boolean,
        gridVirtualScrollSliceSize: [Number, String],
        gridVirtualScrollSliceRatioBefore: [Number, String],
        gridVirtualScrollSliceRatioAfter: [Number, String],
        gridVirtualScrollItemSize: [Number, String],
        gridVirtualScrollStickySizeStart: [Number, String],
        gridVirtualScrollStickySizeEnd: [Number, String],
        gridToolbarModelValue: {
            type: Boolean,
            default: null,
        },
        gridToolbarProps: Object,
        gridProps: Object,
        style: [String, Array, Object],
        class: [String, Array, Object],
        id: String,
    },
    data() {
        return {
            chooseTableDialog: false,
            focused: false,
            rowsProp: [],
            selectedProp: [],
        };
    },
    computed: {
        hasError() {
            return this.$refs.chooseInputField.hasError;
        },
        nameProp() {
            return this.name || this.for;
        },
        hasValue() {
            return this.modelValue !== void 0 && this.modelValue !== null && ('' + this.modelValue).length > 0;
        },
        isLoading() {
            return this.loading === true;
        },
        isClearable() {
            return this.isLoading !== true && this.clearable === true && this.disable !== true && this.readonly !== true && this.hasValue === true;
        },
        gridPaginationProp: {
            get() {
                return this.gridPagination;
            },
            set(gridPagination) {
                this.$emit('update:grid-pagination', gridPagination);
            },
        },
        gridToolbarModelValueProp: {
            get() {
                return this.gridToolbarModelValue;
            },
            set(gridToolbarModelValue) {
                this.$emit('update:grid-toolbar-model-value', gridToolbarModelValue);
            },
        },
        slotProps() {
            return {
                name: this.nameProp,
                placeholder: this.placeholder,
                disable: this.disable,
                readonly: this.readonly,
                hasValue: this.hasValue,
                isLoading: this.isLoading,
                key: this.getKey(),
                value: this.getValue(),
                caption: this.getCaption(),
                modelValue: this.modelValue,
                open: this.open,
                clear: this.clear,
            };
        },
    },
    methods: {
        open() {
            this.openChooseTable();
        },
        clear() {
            this.onUpdateModelValue(null);
        },
        getKey() {
            if (this.multiple !== true) {
                return this.getFieldValue(this.itemKeyField, this.modelValue);
            } else {
                if (Array.isArray(this.modelValue)) {
                    return this.itemKeyField ? this.modelValue.map((item) => this.getFieldValue(this.itemKeyField, item)) : [];
                }
                return [];
            }
        },
        getValue() {
            if (this.multiple !== true) {
                return this.getFieldValue(this.itemValueField, this.modelValue);
            } else {
                if (Array.isArray(this.modelValue)) {
                    return this.itemValueField ? this.modelValue.map((item) => this.getFieldValue(this.itemValueField, item)) : [];
                }
                return [];
            }
        },
        getCaption() {
            if (this.multiple !== true) {
                return this.getFieldValue(this.itemCaptionField, this.modelValue);
            } else {
                if (Array.isArray(this.modelValue)) {
                    return this.itemCaptionField ? this.modelValue.map((item) => this.getFieldValue(this.itemCaptionField, item)) : [];
                }
                return [];
            }
        },
        onDataLoad(dataLoadProps) {
            this.$emit('data-load', dataLoadProps);
        },
        onDataRequest(dataRequestProps) {
            const callback = dataRequestProps.callback;
            dataRequestProps.callback = function (rows) {
                this.setTableRows(rows, callback);
            }.bind(this);
            this.$emit('data-request', dataRequestProps);
        },
        onDataRequestLoad(dataRequestLoadProps) {
            this.$emit('data-request-load', dataRequestLoadProps);
        },
        onSelection(selectionProps) {
            if (this.multiple !== true && this.confirmOnSelect === true && selectionProps.added === true && selectionProps.rows.length === 1) {
                this.onUpdateModelValue(selectionProps.rows[0]);
                this.chooseTableDialog = false;
            }
        },
        onChoose(chooseProps) {
            this.$emit('choose', chooseProps);
        },
        getStyle() {
            if (this.multiple !== true) {
                return this.style;
            }
            return {
                ...this.style,
            };
        },
        getClass() {
            let classProp = this.multiple !== true ? 'q-choose-input' : 'q-multi-choose-input';
            if (!this.$slots['default']) {
                classProp += this.multiple !== true && this.chooseOnClick === true ? ' q-choose-input--clickable' : '';
                classProp += this.stackLabel ? ' q-field--stack-label' : '';
                classProp += this.isClearable ? ' q-field--clearable' : '';
                classProp += this.isLoading ? ' q-field--loading' : '';
                classProp += this.focused ? ' q-field--focused q-field--highlighted q-field--float' : '';
                classProp += this.$props.class ? ' ' + this.$props.class : '';
            }
            return classProp;
        },
        onButtonClick(evt) {
            if (evt == undefined || evt == null) {
                return;
            }
            evt.cancelable !== false && evt.preventDefault();
            evt.stopPropagation();
            const state = {
                rootRef: this.$refs.chooseInputField.$el,
                targetRef: this.$refs.chooseInputField.$el.querySelector('.q-field__native.row'),
            };
            if (this.$q.platform.is.mobile !== true) {
                const el = (state.targetRef !== void 0 && state.targetRef) || state.rootRef;
                el.focus();
            } else if (state.rootRef.contains(document.activeElement) === true) {
                document.activeElement.blur();
            }
        },
        openChooseTable(evt) {
            if (this.disable == true || this.readonly == true) {
                return;
            }
            this.onButtonClick(evt);
            if (this.gridLoadType !== 'static' && this.gridLoadType !== 'dynamic') {
                const dataLoadProps = {
                    callback: function (rows) {
                        this.selectedProp = [];
                        this.setTableRows(rows);
                        this.chooseTableDialog = true;
                    }.bind(this),
                };
                this.onDataLoad(dataLoadProps);
            } else {
                this.selectedProp = [];
                this.chooseTableDialog = true;
            }
        },
        onShowChooseTable() {
            const contentEl = this.$refs.chooseTableDialog.contentEl;
            const intervalId = setInterval(() => {
                if (contentEl.clientWidth <= contentEl.getBoundingClientRect().width) {
                    this.$refs.chooseInputGrid.updateToolbar();
                    clearInterval(intervalId);
                }
            }, 10);
        },
        confirmChooseTable(evt) {
            this.$refs.chooseInputGrid.getRowsSelected(
                function () {
                    if (this.multiple !== true) {
                        this.onUpdateModelValue(this.selectedProp.length == 0 ? null : this.selectedProp[0]);
                    } else {
                        if (this.uniqueChoose === true && Array.isArray(this.modelValue)) {
                            this.onUpdateModelValue([...this.modelValue, ...this.selectedProp]);
                        } else {
                            this.onUpdateModelValue([...this.selectedProp]);
                        }
                    }
                }.bind(this)
            );
            this.chooseTableDialog = false;
        },
        setTableRows(rows, callback) {
            if (!Array.isArray(rows)) {
                return;
            }
            if (this.multiple !== true) {
                if (typeof this.modelValue === 'object' && this.modelValue != null && this.confirmOnSelect !== true) {
                    this.selectedProp = [this.modelValue];
                }
            } else {
                if (this.uniqueChoose === true) {
                    let choosedKeys = [];
                    if (Array.isArray(this.modelValue)) {
                        choosedKeys = this.itemKeyField ? this.modelValue.map((item) => this.getFieldValue(this.itemKeyField, item)) : [];
                    }
                    rows = rows.filter((row) => {
                        return !choosedKeys.includes(this.getFieldValue(this.itemKeyField, row));
                    });
                } else {
                    if (Array.isArray(this.modelValue)) {
                        this.selectedProp = [...this.modelValue];
                    } else {
                        this.selectedProp = [];
                    }
                }
            }
            if (typeof callback === 'function') {
                callback(rows);
            } else {
                this.rowsProp = rows;
            }
        },
        isFieldComplex(field) {
            return (
                typeof field === 'string' && (field.indexOf('.') !== -1 || field.indexOf('(') !== -1 || field.indexOf('[') !== -1 || field.indexOf(' ') !== -1)
            );
        },
        getFieldValue(field, item) {
            if (typeof field === 'function') {
                return field(item);
            } else if (this.isFieldComplex(field)) {
                return this.extractValue(item, field);
            } else {
                if (this.multiple !== true) {
                    return field && item ? item[field] : '';
                } else {
                    return item[field];
                }
            }
        },
        extractValue(object, field) {
            if (field.indexOf('.') !== -1 || field.indexOf('(') !== -1 || field.indexOf('[') !== -1 || field.indexOf(' ') !== -1) {
                try {
                    return eval('object.' + field);
                } catch (e) {
                    return null;
                }
            } else {
                return object[field];
            }
        },
        resetValidation() {
            this.$refs.chooseInputField && this.$refs.chooseInputField.resetValidation();
        },
        validate(value) {
            return this.$refs.chooseInputField && this.$refs.chooseInputField.validate(value);
        },
        focus() {
            this.$refs.chooseInputField && this.$refs.chooseInputField.focus();
        },
        blur() {
            this.$refs.chooseInputField && this.$refs.chooseInputField.blur();
        },
        onUpdateModelValue(value) {
            this.focused = this.$refs.chooseInputField && this.$refs.chooseInputField.$el.matches('.q-field--focused');
            if (this.multiple !== true) {
                this.$emit('update:model-value', value);
                this.onChoose(value);
            } else {
                value = Array.isArray(value) ? value : [];
                this.$emit('update:model-value', value);
                this.onChoose(value.map(toRaw));
            }
            this.$nextTick(() => {
                if (this.focused) {
                    this.focus();
                    this.focused = false;
                }
            });
        },
        onClear(value) {
            this.$emit('clear', value);
            this.$nextTick(() => {
                this.resetValidation();
            });
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
    },
    emits: [
        'update:model-value',
        'clear',
        'focus',
        'blur',
        'data-load',
        'data-request',
        'data-request-load',
        'choose',
        'update:grid-pagination',
        'update:grid-toolbar-model-value',
        'dialog-before-show',
        'dialog-show',
        'dialog-before-hide',
        'dialog-hide',
        'dialog-shake',
        'dialog-escape-key',
    ],
    expose: ['open', 'clear', 'getKey', 'getValue', 'getCaption', 'resetValidation', 'validate', 'focus', 'blur', 'hasError'],
});

const _hoisted_1$8 = {
  key: 0,
  class: "self-center full-width no-outline ellipsis",
  tabindex: "0"
};
const _hoisted_2$5 = {
  key: 1,
  class: "q-choose-input__placeholder self-center full-width no-outline ellipsis"
};
const _hoisted_3$4 = ["name", "value", "disabled"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_icon = resolveComponent("q-icon");
  const _component_q_item_label = resolveComponent("q-item-label");
  const _component_q_item_section = resolveComponent("q-item-section");
  const _component_q_item = resolveComponent("q-item");
  const _component_q_list = resolveComponent("q-list");
  const _component_q_scroll_area = resolveComponent("q-scroll-area");
  const _component_q_field = resolveComponent("q-field");
  const _component_q_resize_observer = resolveComponent("q-resize-observer");
  const _component_q_grid = resolveComponent("q-grid");
  const _component_q_card_section = resolveComponent("q-card-section");
  const _component_q_separator = resolveComponent("q-separator");
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_card_actions = resolveComponent("q-card-actions");
  const _component_q_card = resolveComponent("q-card");
  const _component_q_dialog = resolveComponent("q-dialog");
  const _directive_close_popup = resolveDirective("close-popup");
  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" <slot v-if=\"$slots['default']\" v-bind=\"slotProps\"></slot> "),
    (_ctx.$slots['default'])
      ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          class: _ctx.getClass()
        }, _ctx.$attrs), [
          renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(_ctx.slotProps)))
        ], 16 /* FULL_PROPS */))
      : (openBlock(), createBlock(_component_q_field, mergeProps({
          key: 1,
          ref: "chooseInputField",
          id: _ctx.id,
          label: _ctx.label,
          "stack-label": _ctx.stackLabel,
          hint: _ctx.hint,
          "hide-hint": _ctx.hideHint,
          "label-color": _ctx.labelColor,
          color: _ctx.color,
          "bg-color": _ctx.bgColor,
          filled: _ctx.filled,
          outlined: _ctx.outlined,
          borderless: _ctx.borderless,
          standout: _ctx.standout,
          square: _ctx.square,
          loading: _ctx.loading,
          "hide-bottom-space": _ctx.hideBottomSpace,
          rounded: _ctx.rounded,
          dense: _ctx.dense,
          "item-aligned": _ctx.itemAligned,
          counter: _ctx.counter,
          clearable: _ctx.clearable,
          "clear-icon": _ctx.clearIcon,
          disable: _ctx.disable,
          readonly: _ctx.readonly,
          autofocus: _ctx.autofocus,
          for: _ctx.$props.for,
          maxlength: _ctx.maxlength,
          dark: _ctx.dark,
          "model-value": _ctx.modelValue,
          error: _ctx.error,
          "error-message": _ctx.errorMessage,
          "no-error-icon": _ctx.noErrorIcon,
          rules: _ctx.rules,
          "reactive-rules": _ctx.reactiveRules,
          "lazy-rules": _ctx.lazyRules,
          "onUpdate:modelValue": _ctx.onUpdateModelValue,
          onClear: _ctx.onClear,
          onFocus: _ctx.onFocus,
          onBlur: _ctx.onBlur,
          style: _ctx.getStyle(),
          class: _ctx.getClass()
        }, _ctx.$attrs), createSlots({
          append: withCtx(() => [
            (_ctx.disable !== true && _ctx.readonly !== true)
              ? (openBlock(), createBlock(_component_q_icon, {
                  key: 0,
                  class: "q-field__focusable-action",
                  tag: "button",
                  name: _ctx.chooseIcon,
                  tabindex: "0",
                  type: "button",
                  "aria-hidden": null,
                  role: null,
                  onClick: _ctx.openChooseTable
                }, null, 8 /* PROPS */, ["name", "onClick"]))
              : createCommentVNode("v-if", true),
            renderSlot(_ctx.$slots, "append")
          ]),
          _: 2 /* DYNAMIC */
        }, [
          (_ctx.multiple !== true)
            ? {
                name: "control",
                fn: withCtx(() => [
                  (_ctx.hasValue)
                    ? (openBlock(), createElementBlock("div", _hoisted_1$8, toDisplayString(_ctx.getFieldValue(_ctx.itemValueField, _ctx.modelValue)), 1 /* TEXT */))
                    : createCommentVNode("v-if", true),
                  (_ctx.placeholder && !_ctx.hasValue)
                    ? (openBlock(), createElementBlock("div", _hoisted_2$5, toDisplayString(_ctx.placeholder), 1 /* TEXT */))
                    : createCommentVNode("v-if", true),
                  createElementVNode("input", {
                    type: "hidden",
                    name: _ctx.nameProp,
                    value: _ctx.getFieldValue(_ctx.itemKeyField, _ctx.modelValue),
                    disabled: _ctx.disable
                  }, null, 8 /* PROPS */, _hoisted_3$4)
                ]),
                key: "0"
              }
            : {
                name: "control",
                fn: withCtx(() => [
                  (_ctx.hasValue)
                    ? (openBlock(), createBlock(_component_q_scroll_area, {
                        key: 0,
                        style: {"width":"100%","height":"100%"},
                        "content-style": { width: '100%' },
                        "content-active-style": { width: '100%' }
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_q_list, {
                            dense: _ctx.dense,
                            bordered: "",
                            separator: "",
                            style: {"width":"100%"}
                          }, {
                            default: withCtx(() => [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, (item, itemIndex) => {
                                return (openBlock(), createBlock(_component_q_item, {
                                  key: itemIndex,
                                  disable: _ctx.disable,
                                  clickable: true,
                                  manualFocus: true,
                                  class: "q-hoverable",
                                  style: {"cursor":"default !important"}
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_q_item_section, null, {
                                      default: withCtx(() => [
                                        (_ctx.itemValueField)
                                          ? (openBlock(), createBlock(_component_q_item_label, {
                                              key: 0,
                                              class: "ellipsis"
                                            }, {
                                              default: withCtx(() => [
                                                createTextVNode(toDisplayString(_ctx.getFieldValue(_ctx.itemValueField, item)), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */))
                                          : createCommentVNode("v-if", true),
                                        (_ctx.itemCaptionField)
                                          ? (openBlock(), createBlock(_component_q_item_label, {
                                              key: 1,
                                              caption: "",
                                              lines: "1"
                                            }, {
                                              default: withCtx(() => [
                                                createTextVNode(toDisplayString(_ctx.getFieldValue(_ctx.itemCaptionField, item)), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */))
                                          : createCommentVNode("v-if", true)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    createVNode(_component_q_item_section, { side: "" }, {
                                      default: withCtx(() => [
                                        (_ctx.disable !== true && _ctx.readonly !== true)
                                          ? (openBlock(), createBlock(_component_q_icon, {
                                              key: 0,
                                              class: "q-field__focusable-action",
                                              tag: "button",
                                              name: _ctx.$q.iconSet.field.clear,
                                              tabindex: "0",
                                              type: "button",
                                              "aria-hidden": null,
                                              role: null,
                                              onClick: $event => (_ctx.onUpdateModelValue(_ctx.modelValue.filter((item, index) => index !== itemIndex)))
                                            }, null, 8 /* PROPS */, ["name", "onClick"]))
                                          : createCommentVNode("v-if", true)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disable"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["dense"])
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : createCommentVNode("v-if", true),
                  (_ctx.placeholder && !_ctx.hasValue)
                    ? (openBlock(), createElementBlock("div", {
                        key: 1,
                        class: "q-multi-choose-input__placeholder absolute-full"
                      }, [
                        createElementVNode("span", { class: "ellipsis" }, toDisplayString(_ctx.placeholder), 1 /* TEXT */)
                      ]))
                    : createCommentVNode("v-if", true),
                  createElementVNode("input", {
                    type: "hidden",
                    name: _ctx.nameProp,
                    value: _ctx.itemKeyField && Array.isArray(_ctx.modelValue) ? _ctx.modelValue.map((item) => _ctx.getFieldValue(_ctx.itemKeyField, item)) : '',
                    disabled: _ctx.disable
                  }, null, 8 /* PROPS */, ["name", "value", "disabled"])
                ]),
                key: "1"
              },
          (_ctx.$slots['field-default'])
            ? {
                name: "default",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "field-default")
                ]),
                key: "2"
              }
            : undefined,
          (_ctx.$slots['prepend'])
            ? {
                name: "prepend",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "prepend")
                ]),
                key: "3"
              }
            : undefined,
          (_ctx.$slots['before'])
            ? {
                name: "before",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "before")
                ]),
                key: "4"
              }
            : undefined,
          (_ctx.$slots['after'])
            ? {
                name: "after",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "after")
                ]),
                key: "5"
              }
            : undefined,
          (_ctx.$slots['label'])
            ? {
                name: "label",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "label")
                ]),
                key: "6"
              }
            : undefined,
          (_ctx.$slots['error'])
            ? {
                name: "error",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "error")
                ]),
                key: "7"
              }
            : undefined,
          (_ctx.$slots['hint'])
            ? {
                name: "hint",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "hint")
                ]),
                key: "8"
              }
            : undefined,
          (_ctx.$slots['counter'])
            ? {
                name: "counter",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "counter")
                ]),
                key: "9"
              }
            : undefined,
          (_ctx.$slots['loading'])
            ? {
                name: "loading",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "loading")
                ]),
                key: "10"
              }
            : undefined
        ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["id", "label", "stack-label", "hint", "hide-hint", "label-color", "color", "bg-color", "filled", "outlined", "borderless", "standout", "square", "loading", "hide-bottom-space", "rounded", "dense", "item-aligned", "counter", "clearable", "clear-icon", "disable", "readonly", "autofocus", "for", "maxlength", "dark", "model-value", "error", "error-message", "no-error-icon", "rules", "reactive-rules", "lazy-rules", "onUpdate:modelValue", "onClear", "onFocus", "onBlur", "style", "class"])),
    createVNode(_component_q_dialog, mergeProps(_ctx.dialogProps, {
      ref: "chooseTableDialog",
      modelValue: _ctx.chooseTableDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.chooseTableDialog) = $event)),
      class: _ctx.multiple !== true ? 'q-choose-input-dialog' : 'q-multi-choose-input-dialog',
      onBeforeShow: _cache[5] || (_cache[5] = $event => (_ctx.$emit('dialog-before-show', $event))),
      onShow: _cache[6] || (_cache[6] = $event => {
            _ctx.onShowChooseTable($event);
            _ctx.$emit('dialog-show', $event);
        }),
      onBeforeHide: _cache[7] || (_cache[7] = $event => (_ctx.$emit('dialog-before-hide', $event))),
      onHide: _cache[8] || (_cache[8] = $event => {
            _ctx.focus();
            _ctx.$emit('dialog-hide', $event);
        }),
      onShake: _cache[9] || (_cache[9] = $event => (_ctx.$emit('dialog-shake', $event))),
      onEscapeKey: _cache[10] || (_cache[10] = $event => (_ctx.$emit('dialog-escape-key', $event)))
    }), {
      default: withCtx(() => [
        createVNode(_component_q_resize_observer, {
          debounce: 0,
          onResize: _cache[0] || (_cache[0] = $event => (_ctx.$refs.chooseInputGrid.$forceUpdate()))
        }),
        createVNode(_component_q_card, {
          dark: _ctx.dark,
          class: "column",
          style: {"width":"1000px","max-width":"90vw","height":"100%","max-height":"600px"}
        }, {
          default: withCtx(() => [
            createVNode(_component_q_card_section, {
              class: "q-pa-none",
              style: {"flex":"1 0 auto"}
            }, {
              default: withCtx(() => [
                createVNode(_component_q_grid, mergeProps({
                  ref: "chooseInputGrid",
                  rows: _ctx.rowsProp,
                  columns: _ctx.gridColumns,
                  selection: _ctx.multiple !== true ? 'single' : 'multiple',
                  selected: _ctx.selectedProp,
                  "onUpdate:selected": _cache[1] || (_cache[1] = $event => ((_ctx.selectedProp) = $event)),
                  pagination: _ctx.gridPaginationProp,
                  "onUpdate:pagination": _cache[2] || (_cache[2] = $event => ((_ctx.gridPaginationProp) = $event)),
                  "toolbar-model-value": _ctx.gridToolbarModelValueProp,
                  "onUpdate:toolbar-model-value": _cache[3] || (_cache[3] = $event => ((_ctx.gridToolbarModelValueProp) = $event)),
                  "toolbar-props": _ctx.gridToolbarProps,
                  "row-key": _ctx.itemKeyField,
                  loading: _ctx.gridLoading,
                  title: _ctx.label,
                  dense: _ctx.gridDense,
                  flat: true,
                  separator: _ctx.gridSeparator,
                  "wrap-cells": false,
                  "virtual-scroll": _ctx.gridVirtualScroll,
                  "virtual-scroll-slice-size": _ctx.gridVirtualScrollSliceSize,
                  "virtual-scroll-slice-ratio-before": _ctx.gridVirtualScrollSliceRatioBefore,
                  "virtual-scroll-slice-ratio-after": _ctx.gridVirtualScrollSliceRatioAfter,
                  "virtual-scroll-item-size": _ctx.gridVirtualScrollItemSize,
                  "virtual-scroll-sticky-size-start": _ctx.gridVirtualScrollStickySizeStart,
                  "virtual-scroll-sticky-size-end": _ctx.gridVirtualScrollStickySizeEnd,
                  "hide-bottom": _ctx.gridHideBottom,
                  "hide-selected-banner": _ctx.gridHideSelectedBanner,
                  "hide-no-data": _ctx.gridHideNoData,
                  "hide-pagination": _ctx.gridHidePagination,
                  dark: _ctx.dark,
                  color: _ctx.color,
                  "rows-per-page-options": _ctx.gridRowsPerPageOptions,
                  "show-row-count": true,
                  "table-filter": true,
                  "fullscreen-toggle": false,
                  "select-on-row-click": true,
                  "export-csv": false,
                  "boolean-as-checkbox": true,
                  "columns-min-width": 50,
                  "columns-filter": true,
                  "columns-resize": true,
                  "columns-resize-to-fit": true,
                  "columns-reorder": true,
                  "columns-control": true,
                  reload: true,
                  "sticky-header": true,
                  "sticky-column": true,
                  "load-type": _ctx.gridLoadType
                }, _ctx.gridProps, {
                  class: "absolute-full",
                  onRequest: _ctx.onDataRequest,
                  onRequestLoad: _ctx.onDataRequestLoad,
                  onSelection: _ctx.onSelection
                }), null, 16 /* FULL_PROPS */, ["rows", "columns", "selection", "selected", "pagination", "toolbar-model-value", "toolbar-props", "row-key", "loading", "title", "dense", "separator", "virtual-scroll", "virtual-scroll-slice-size", "virtual-scroll-slice-ratio-before", "virtual-scroll-slice-ratio-after", "virtual-scroll-item-size", "virtual-scroll-sticky-size-start", "virtual-scroll-sticky-size-end", "hide-bottom", "hide-selected-banner", "hide-no-data", "hide-pagination", "dark", "color", "rows-per-page-options", "load-type", "onRequest", "onRequestLoad", "onSelection"])
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_q_separator),
            createVNode(_component_q_card_actions, { align: "right" }, {
              default: withCtx(() => [
                createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$q.lang.label.ok,
                  "no-caps": "",
                  onClick: _ctx.confirmChooseTable
                }, null, 8 /* PROPS */, ["label", "onClick"]),
                withDirectives(createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$q.lang.label.close,
                  "no-caps": ""
                }, null, 8 /* PROPS */, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["dark"])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["modelValue", "class"])
  ], 64 /* STABLE_FRAGMENT */))
}

var css_248z$7 = "\n.q-choose-input.q-field[data-v-115631f2]  .q-field__control-container .q-field__native .q-choose-input__placeholder {\n    color: rgba(0, 0, 0, 0.54);\n}\n.q-choose-input.q-field.q-field--labeled[data-v-115631f2]:not(.q-field--float)  .q-field__control-container .q-field__native .q-choose-input__placeholder {\n    color: transparent;\n}\n.q-choose-input.q-field:not(.q-field--readonly):not(.q-field--disabled).q-choose-input--clickable[data-v-115631f2]  .q-field__control-container {\n    cursor: pointer;\n}\n\n/* .q-multi-choose-input.q-field:deep() .q-field__control {\n    height: 100%;\n} */\n.q-multi-choose-input.q-field[data-v-115631f2]  .q-field__control-container {\n    padding-top: 55px;\n}\n.q-multi-choose-input.q-field.q-field--dense[data-v-115631f2]  .q-field__control-container {\n    padding-top: 40px;\n}\n.q-multi-choose-input.q-field.q-field--stack-label[data-v-115631f2]  .q-field__control-container .q-field__label {\n    transform: translateY(3px) scale(0.75);\n}\n.q-multi-choose-input.q-field[data-v-115631f2]  .q-field__control-container .q-field__native {\n    position: relative;\n    padding-bottom: 0px;\n}\n.q-multi-choose-input.q-field.q-field--outlined[data-v-115631f2]  .q-field__control-container .q-field__native,\n.q-multi-choose-input.q-field.q-field--filled[data-v-115631f2]  .q-field__control-container .q-field__native,\n.q-multi-choose-input.q-field.q-field--standout[data-v-115631f2]  .q-field__control-container .q-field__native {\n    padding-bottom: 12px;\n}\n.q-multi-choose-input.q-field[data-v-115631f2]  .q-field__control-container .q-field__native .q-multi-choose-input__placeholder {\n    display: flex;\n    align-items: center;\n    color: rgba(0, 0, 0, 0.54);\n}\n.q-multi-choose-input.q-field[data-v-115631f2]  .q-field__append {\n    position: absolute;\n    padding: 0px;\n    right: 0px;\n}\n.q-multi-choose-input.q-field[data-v-115631f2]  .q-field__append:last-child {\n    right: 0px;\n}\n.q-multi-choose-input.q-field.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 52px;\n}\n.q-multi-choose-input.q-field.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3) {\n    right: 26px;\n}\n.q-multi-choose-input.q-field.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 26px;\n}\n.q-multi-choose-input.q-field.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3) {\n    right: 0px;\n}\n.q-multi-choose-input.q-field.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 26px;\n}\n.q-multi-choose-input.q-field.q-field--disabled.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--disabled.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--disabled.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--readonly.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--readonly.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--readonly.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 0px;\n}\n.q-multi-choose-input.q-field.q-field--outlined[data-v-115631f2]  .q-field__append:last-child,\n.q-multi-choose-input.q-field.q-field--filled[data-v-115631f2]  .q-field__append:last-child,\n.q-multi-choose-input.q-field.q-field--standout[data-v-115631f2]  .q-field__append:last-child {\n    right: 12px;\n}\n.q-multi-choose-input.q-field.q-field--outlined.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 64px;\n}\n.q-multi-choose-input.q-field.q-field--outlined.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--filled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--filled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--standout.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--standout.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3) {\n    right: 38px;\n}\n.q-multi-choose-input.q-field.q-field--outlined.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 38px;\n}\n.q-multi-choose-input.q-field.q-field--outlined.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--filled.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--filled.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--filled.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--filled.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--standout.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--standout.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--standout.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3),\n.q-multi-choose-input.q-field.q-field--standout.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__append:nth-child(3) {\n    right: 12px;\n}\n.q-multi-choose-input.q-field.q-field--outlined.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 38px;\n}\n.q-multi-choose-input.q-field.q-field--outlined.q-field--disabled.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--disabled.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--disabled.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--readonly.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--readonly.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--outlined.q-field--readonly.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--disabled.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--disabled.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--disabled.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--readonly.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--readonly.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--filled.q-field--readonly.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--disabled.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--disabled.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--disabled.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--readonly.q-field--clearable[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--readonly.q-field--loading[data-v-115631f2]  .q-field__append:nth-child(2),\n.q-multi-choose-input.q-field.q-field--standout.q-field--readonly.q-field--error[data-v-115631f2]  .q-field__append:nth-child(2) {\n    right: 12px;\n}\n.q-multi-choose-input.q-field[data-v-115631f2]  .q-field__control-container .q-field__label {\n    padding-right: 40px;\n}\n.q-multi-choose-input.q-field.q-field--clearable[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--loading[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label {\n    padding-right: 70px;\n}\n.q-multi-choose-input.q-field.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--loading.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label {\n    padding-right: 110px;\n}\n.q-multi-choose-input.q-field.q-field--disabled[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--readonly[data-v-115631f2]  .q-field__control-container .q-field__label {\n    padding-right: 0px;\n}\n.q-multi-choose-input.q-field.q-field--disabled.q-field--clearable[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--disabled.q-field--loading[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--disabled.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--readonly.q-field--clearable[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--readonly.q-field--loading[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--readonly.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label {\n    padding-right: 40px;\n}\n.q-multi-choose-input.q-field.q-field--disabled.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--disabled.q-field--loading.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--readonly.q-field--clearable.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label,\n.q-multi-choose-input.q-field.q-field--readonly.q-field--loading.q-field--error[data-v-115631f2]  .q-field__control-container .q-field__label {\n    padding-right: 70px;\n}\n";
styleInject(css_248z$7);

script$8.render = render$8;
script$8.__scopeId = "data-v-115631f2";
script$8.__file = "src/components/QChooseInput.vue";

const SSR$4 = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
var script$7 = defineComponent({
    name: 'QImgCropper',
    mounted() {
        const options = {};
        const { src, alt, crossorigin, imgStyle, ...cropperProps } = this.$options.props;
        for (const key in cropperProps) {
            if (this[key] !== undefined) {
                options[key] = this[key];
            }
        }
        this.$refs.img.addEventListener('ready', () => this.$emit('ready'));
        this.$refs.img.addEventListener('cropstart', (event) => this.$emit('cropstart', event));
        this.$refs.img.addEventListener('cropmove', (event) => this.$emit('cropmove', event));
        this.$refs.img.addEventListener('cropend', (event) => this.$emit('cropend', event));
        this.$refs.img.addEventListener('crop', (event) => this.$emit('crop', event));
        this.$refs.img.addEventListener('zoom', (event) => this.$emit('zoom', event));
        this.cropper = new Cropper(this.$refs.img, options);
    },
    props: {
        src: {
            type: String,
            default: '',
        },
        alt: {
            type: String,
            default: 'image',
        },
        crossorigin: {
            type: String,
        },
        imgStyle: [String, Array, Object],
        viewMode: {
            type: Number,
            default: 0,
            validator: (v) => [0, 1, 2, 3].includes(v),
        },
        dragMode: {
            type: String,
            default: 'crop',
            validator: (v) => ['crop', 'move', 'none'].includes(v),
        },
        initialAspectRatio: {
            type: Number,
            default: NaN,
        },
        aspectRatio: {
            type: Number,
            default: NaN,
        },
        data: {
            type: Object,
            default: null,
        },
        preview: {
            type: SSR$4 ? [String, Array] : [String, Array, Element, NodeList],
            default: '',
        },
        responsive: {
            type: Boolean,
            default: true,
        },
        restore: {
            type: Boolean,
            default: true,
        },
        checkCrossOrigin: {
            type: Boolean,
            default: true,
        },
        checkOrientation: {
            type: Boolean,
            default: true,
        },
        modal: {
            type: Boolean,
            default: true,
        },
        guides: {
            type: Boolean,
            default: true,
        },
        center: {
            type: Boolean,
            default: true,
        },
        highlight: {
            type: Boolean,
            default: true,
        },
        background: {
            type: Boolean,
            default: true,
        },
        autoCrop: {
            type: Boolean,
            default: true,
        },
        autoCropArea: {
            type: Number,
            default: 0.8,
            validator: (v) => v >= 0 && v <= 1,
        },
        movable: {
            type: Boolean,
            default: true,
        },
        rotatable: {
            type: Boolean,
            default: true,
        },
        scalable: {
            type: Boolean,
            default: true,
        },
        zoomable: {
            type: Boolean,
            default: true,
        },
        zoomOnTouch: {
            type: Boolean,
            default: true,
        },
        zoomOnWheel: {
            type: Boolean,
            default: true,
        },
        wheelZoomRatio: {
            type: Number,
            default: 0.1,
        },
        cropBoxMovable: {
            type: Boolean,
            default: true,
        },
        cropBoxResizable: {
            type: Boolean,
            default: true,
        },
        toggleDragModeOnDblclick: {
            type: Boolean,
            default: true,
        },
        minContainerWidth: {
            type: Number,
            default: 200,
        },
        minContainerHeight: {
            type: Number,
            default: 100,
        },
        minCanvasWidth: {
            type: Number,
            default: 0,
        },
        minCanvasHeight: {
            type: Number,
            default: 0,
        },
        minCropBoxWidth: {
            type: Number,
            default: 0,
        },
        minCropBoxHeight: {
            type: Number,
            default: 0,
        },
        ready: {
            type: Function,
            default: null,
        },
        cropstart: {
            type: Function,
            default: null,
        },
        cropmove: {
            type: Function,
            default: null,
        },
        cropend: {
            type: Function,
            default: null,
        },
        crop: {
            type: Function,
            default: null,
        },
        zoom: {
            type: Function,
            default: null,
        },
    },
    computed: {
        cropped() {
            return typeof this.cropper === 'object' ? this.cropper.cropped : false;
        },
    },
    methods: {
        getCropper() {
            return this.cropper;
        },
        cropShow() {
            return this.cropper.crop();
        },
        reset() {
            return this.cropper.reset();
        },
        clear() {
            return this.cropper.clear();
        },
        replace(url, hasSameSize = false) {
            return this.cropper.replace(url, hasSameSize);
        },
        enable() {
            return this.cropper.enable();
        },
        disable() {
            return this.cropper.disable();
        },
        destroy() {
            return this.cropper.destroy();
        },
        move(offsetX, offsetY = offsetX) {
            return this.cropper.move(offsetX, offsetY);
        },
        moveTo(x, y = x) {
            return this.cropper.moveTo(x, y);
        },
        zoomRelative(ratio) {
            return this.cropper.zoom(ratio);
        },
        zoomAbsolute(ratio, pivot) {
            return this.cropper.zoomTo(ratio, pivot);
        },
        rotate(degree) {
            return this.cropper.rotate(degree);
        },
        rotateTo(degree) {
            return this.cropper.rotateTo(degree);
        },
        scale(scaleX, scaleY = scaleX) {
            return this.cropper.scale(scaleX, scaleY);
        },
        scaleX(scaleX) {
            return this.cropper.scaleX(scaleX);
        },
        scaleY(scaleY) {
            return this.cropper.scaleY(scaleY);
        },
        getData(rounded = false) {
            return this.cropper.getData(rounded);
        },
        setData(data) {
            return this.cropper.setData(data);
        },
        getContainerData() {
            return this.cropper.getContainerData();
        },
        getImageData() {
            return this.cropper.getImageData();
        },
        getCanvasData() {
            return this.cropper.getCanvasData();
        },
        setCanvasData(data) {
            return this.cropper.setCanvasData(data);
        },
        getCropBoxData() {
            return this.cropper.getCropBoxData();
        },
        setCropBoxData(data) {
            return this.cropper.setCropBoxData(data);
        },
        getCroppedCanvas(options = {}) {
            return this.cropper.getCroppedCanvas(options);
        },
        setAspectRatio(aspectRatio) {
            return this.cropper.setAspectRatio(aspectRatio);
        },
        setDragMode(mode) {
            return this.cropper.setDragMode(mode);
        },
    },
    emits: ['ready', 'cropstart', 'cropmove', 'cropend', 'crop', 'zoom'],
    expose: [
        'cropped',
        'getCropper',
        'cropShow',
        'reset',
        'clear',
        'replace',
        'enable',
        'disable',
        'destroy',
        'move',
        'moveTo',
        'zoomRelative',
        'zoomAbsolute',
        'rotate',
        'rotateTo',
        'scale',
        'scaleX',
        'scaleY',
        'getData',
        'setData',
        'getContainerData',
        'getImageData',
        'getCanvasData',
        'setCanvasData',
        'getCropBoxData',
        'setCropBoxData',
        'getCroppedCanvas',
        'setAspectRatio',
        'setDragMode',
    ],
});

const _hoisted_1$7 = ["src", "alt", "crossorigin"];
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", null, [
    createElementVNode("img", {
      ref: "img",
      src: _ctx.src,
      alt: _ctx.alt,
      style: normalizeStyle([{ display: 'block', 'max-width': '100%', opacity: 0 }, this.imgStyle]),
      crossorigin: _ctx.crossorigin
    }, null, 12 /* STYLE, PROPS */, _hoisted_1$7)
  ]))
}

script$7.render = render$7;
script$7.__file = "src/components/QImgCropper.vue";

const { humanStorageSize: humanStorageSize$1 } = format;
const SSR$3 = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
const editImageRatios = [
    { label: 'Ľubovoľný', value: NaN },
    { label: '16:9', value: 1.7777777777777777 },
    { label: '4:3', value: 1.3333333333333333 },
    { label: '1:1', value: 1 },
    { label: '2:3', value: 0.6666666666666666 },
];
const editImageCommands = {
    'mode-move': { method: 'setDragMode', argument1: 'move' },
    'mode-crop': { method: 'setDragMode', argument1: 'crop' },
    'zoom-in': { method: 'zoomRelative', argument1: 0.1 },
    'zoom-out': { method: 'zoomRelative', argument1: -0.1 },
    'move-left': { method: 'move', argument1: -10, argument2: 0 },
    'move-right': { method: 'move', argument1: 10, argument2: 0 },
    'move-up': { method: 'move', argument1: 0, argument2: -10 },
    'move-down': { method: 'move', argument1: 0, argument2: 10 },
    'rotate-left': { method: 'rotate', argument1: -10 },
    'rotate-right': { method: 'rotate', argument1: 10 },
    'flip-horizontal': { method: 'scaleX', argument1: -1 },
    'flip-vertical': { method: 'scaleY', argument1: -1 },
    crop: { method: 'cropShow' },
    clear: { method: 'clear' },
};
var script$6 = defineComponent({
    name: 'QFileInput',
    components: {
        QBtn,
        QBtnDropdown,
        QBtnGroup,
        QCard,
        QCardActions,
        QCardSection,
        QDialog,
        QFile,
        QIcon,
        QItem,
        QItemLabel,
        QItemSection,
        QList,
        QScrollArea,
        QSeparator,
        QOverflowToolbar: script$a,
        QImgCropper: script$7,
    },
    directives: {
        ClosePopup,
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local',
        });
        return { t };
    },
    mounted() {
        if (this.multiple && typeof this.height === 'number' && this.$refs.fileInputField) {
            const control = this.$refs.fileInputField.$el.querySelector('.q-field__control');
            control.style.height = this.height + 'px';
        }
        const fileInput = this.$refs.fileInputField.$el.querySelector("input[type='file']");
        if (this.multiple) {
            fileInput.removeAttribute('id');
        } else if (this.imageEditOnChange === true) {
            fileInput.addEventListener('change', () => {
                if (this.disable !== true && this.readonly !== true && this.imageEditable !== false && this.hasImage === true) {
                    this.onEditImage(null, this.modelValue, 0);
                }
            });
        }
    },
    updated() {
        if (this.multiple && typeof this.height === 'number' && this.$refs.fileInputField) {
            const control = this.$refs.fileInputField.$el.querySelector('.q-field__control');
            control.style.height = this.height + 'px';
        }
        if (this.multiple) {
            this.$refs.fileInputField.$el.querySelector("input[type='file']").removeAttribute('id');
        }
    },
    props: {
        label: String,
        stackLabel: Boolean,
        hint: String,
        hideHint: Boolean,
        labelColor: String,
        color: String,
        bgColor: String,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        loading: Boolean,
        hideBottomSpace: Boolean,
        rounded: Boolean,
        dense: Boolean,
        itemAligned: Boolean,
        counter: Boolean,
        clearable: Boolean,
        clearIcon: String,
        disable: Boolean,
        readonly: Boolean,
        autofocus: Boolean,
        for: String,
        maxlength: [Number, String],
        dark: {
            type: Boolean,
            default: null,
        },
        modelValue: !SSR$3 ? [File, FileList, Array] : [Object, Array],
        error: {
            type: Boolean,
            default: null,
        },
        errorMessage: String,
        noErrorIcon: Boolean,
        rules: Array,
        reactiveRules: Boolean,
        lazyRules: {
            type: [Boolean, String],
            validator: (v) => [true, false, 'ondemand'].includes(v),
        },
        name: String,
        multiple: Boolean,
        accept: String,
        capture: String,
        maxFileSize: [Number, String],
        maxTotalSize: [Number, String],
        maxFiles: [Number, String],
        filter: Function,
        append: Boolean,
        tabindex: {
            type: [String, Number],
            default: 0,
        },
        counterLabel: Function,
        height: {
            type: Number,
            default: 250,
        },
        pickFileIcon: {
            type: String,
            default: 'folder_open',
        },
        editImageIcon: {
            type: String,
            default: 'edit',
        },
        caption: {
            type: Boolean,
            default: true,
        },
        noThumbnails: {
            type: Boolean,
            default: false,
        },
        imageEditable: {
            type: Boolean,
            default: true,
        },
        imageEditViewMode: {
            type: Number,
            default: 2,
            validator: (v) => [0, 1, 2, 3].includes(v),
        },
        imageEditAspectRatio: {
            type: Number,
            default: null,
        },
        imageEditOnChange: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        dialogProps: Object,
        style: [String, Array, Object],
        class: [String, Array, Object],
        id: String,
    },
    data() {
        return {
            changed: false,
            editImageFile: null,
            editImageIndex: null,
            editImageDialog: false,
            editImageRatios: editImageRatios,
            editImageRatio: editImageRatios[0],
        };
    },
    computed: {
        hasError() {
            return this.$refs.fileInputField.hasError;
        },
        nativeEl() {
            return this.$refs.fileInputField.nativeEl;
        },
        hasValue() {
            return this.modelValue !== void 0 && this.modelValue !== null && ('' + this.modelValue).length > 0;
        },
        hasImage() {
            return this.hasValue === true && typeof this.modelValue === 'object' && this.isImage(this.modelValue);
        },
        isLoading() {
            return this.loading === true;
        },
        isClearable() {
            return this.isLoading !== true && this.clearable === true && this.disable !== true && this.readonly !== true && this.hasValue === true;
        },
        nameProp() {
            if (typeof this.name === 'string' && this.name !== null && this.name.length > 0) {
                return this.name + (this.multiple === true ? '[]' : '');
            }
            return this.name;
        },
    },
    methods: {
        addFile(name, type, size, lastModified) {
            if (!SSR$3) {
                const file = new File([], name, {
                    type: type,
                    lastModified: lastModified || Date.now(),
                });
                Object.defineProperty(file, 'size', { value: size });
                file.mock = true;
                this.addFiles([file]);
            }
        },
        setChanged(changed) {
            this.changed = changed;
        },
        getLabel(file) {
            const index = file.name ? file.name.lastIndexOf('/') : -1;
            if (index > 0) {
                return file.name.substring(0, index);
            }
            return file.name;
        },
        isImage(file) {
            return file.type && file.type.toUpperCase().startsWith('IMAGE') && file.mock !== true;
        },
        getImage(file) {
            if (SSR$3) {
                return '';
            }
            if (file.image == void 0) {
                file.image = window.URL.createObjectURL(file);
            }
            return file.image;
        },
        humanStorageSize(size) {
            return humanStorageSize$1(size);
        },
        onButtonClick(evt) {
            if (evt == undefined || evt == null) {
                return;
            }
            evt.cancelable !== false && evt.preventDefault();
            evt.stopPropagation();
            const state = {
                rootRef: this.$refs.fileInputField.$el,
                targetRef: this.$refs.fileInputField.$el.querySelector('.q-field__native.row'),
            };
            if (this.$q.platform.is.mobile !== true) {
                const el = (state.targetRef !== void 0 && state.targetRef) || state.rootRef;
                el.focus();
            } else if (state.rootRef.contains(document.activeElement) === true) {
                document.activeElement.blur();
            }
        },
        onPickFiles(evt) {
            this.onButtonClick(evt);
            this.pickFiles(evt);
        },
        onEditImage(evt, file, index) {
            this.onButtonClick(evt);
            this.editImageRatio = editImageRatios[0];
            editImageCommands['flip-horizontal'].argument1 = -1;
            editImageCommands['flip-vertical'].argument1 = -1;
            this.editImageFile = file;
            this.editImageIndex = index;
            this.editImageDialog = true;
        },
        imageEditCommand(command) {
            if (command === 'update-ratio') {
                this.$refs.imageEditCropper.setAspectRatio(this.editImageRatio.value);
            } else {
                command = editImageCommands[command];
                const cropper = this.$refs.imageEditCropper;
                const cropped = cropper.cropped;
                switch (command.method) {
                    case 'rotate':
                        if (cropped && cropper.getCropper().options.viewMode > 0) ;
                        break;
                }
                cropper[command.method](command.argument1, command.argument2);
                switch (command.method) {
                    case 'rotate':
                        if (cropped && cropper.getCropper().options.viewMode > 0) ;
                        break;
                    case 'scaleX':
                    case 'scaleY':
                        command.argument1 = -command.argument1;
                        break;
                }
            }
        },
        editImageConfirm(evt) {
            if (SSR$3) return;
            const callback = function (blob) {
                const file = new File([blob], this.editImageFile.name, {
                    type: this.editImageFile.type,
                    lastModified: this.editImageFile.lastModified,
                });
                if (this.multiple === true) {
                    const modelValue = this.modelValue.map((item, index) => (index === this.editImageIndex ? file : item));
                    this.onUpdateModelValue(modelValue);
                } else {
                    this.onUpdateModelValue(file);
                }
                this.$emit('image-edited', {
                    index: this.editImageIndex,
                    oldFile: this.editImageFile,
                    newFile: this.file,
                    blob: blob,
                });
                this.editImageFile = null;
                this.editImageIndex = null;
                this.editImageDialog = false;
            }.bind(this);
            const canvas = this.$refs.imageEditCropper.getCroppedCanvas();
            if (canvas.msToBlob) {
                callback(canvas.msToBlob());
            } else {
                canvas.toBlob(callback);
            }
        },
        getStyle() {
            if (this.multiple !== true) {
                return this.style;
            }
            return {
                ...this.style,
            };
        },
        getClass() {
            let classProp = 'q-file-input';
            if (this.multiple === true) {
                classProp += ' q-file-input--multiple';
            } else {
                classProp += this.caption === true || (this.noThumbnails !== true && this.hasImage === true) ? ' q-file-input--extended' : '';
            }
            if (!this.$slots['after']) {
                classProp += ' q-file-input--hide_after';
            }
            classProp += this.stackLabel ? ' q-field--stack-label' : '';
            classProp += this.isClearable ? ' q-field--clearable' : '';
            classProp += this.isLoading ? ' q-field--loading' : '';
            classProp += this.$props.class ? ' ' + this.$props.class : '';
            return classProp;
        },
        pickFiles(evt) {
            this.$refs.fileInputField.pickFiles(evt);
        },
        addFiles(files) {
            this.$refs.fileInputField.addFiles(files);
        },
        removeAtIndex(index) {
            this.$refs.fileInputField.removeAtIndex(index);
        },
        removeFile(file) {
            this.$refs.fileInputField.removeFile(file);
        },
        getNativeElement() {
            this.$refs.fileInputField.getNativeElement();
        },
        resetValidation() {
            this.$refs.fileInputField.resetValidation();
        },
        validate(value) {
            return this.$refs.fileInputField.validate(value);
        },
        focus() {
            this.$refs.fileInputField.focus();
        },
        blur() {
            this.$refs.fileInputField.blur();
        },
        onRejected(rejectedEntries) {
            this.$emit('rejected', rejectedEntries);
        },
        onUpdateModelValue(value) {
            this.setChanged(true);
            this.$emit('update:model-value', value);
        },
        onClear(value) {
            this.$emit('clear', value);
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
    },
    emits: [
        'rejected',
        'update:model-value',
        'clear',
        'focus',
        'blur',
        'image-edited',
        'dialog-before-show',
        'dialog-show',
        'dialog-before-hide',
        'dialog-hide',
        'dialog-shake',
        'dialog-escape-key',
    ],
    expose: [
        'addFile',
        'setChanged',
        'pickFiles',
        'addFiles',
        'removeAtIndex',
        'removeFile',
        'getNativeElement',
        'resetValidation',
        'validate',
        'focus',
        'blur',
        'hasError',
        'nativeEl',
    ],
});

const _hoisted_1$6 = ["name", "value", "disabled"];
const _hoisted_2$4 = {
  key: 0,
  class: "q-file-input__placeholder absolute-full"
};
const _hoisted_3$3 = { class: "ellipsis" };
const _hoisted_4$2 = ["src"];
const _hoisted_5$2 = ["src"];
const _hoisted_6$2 = { class: "q-gutter-xs" };
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_icon = resolveComponent("q-icon");
  const _component_q_item_section = resolveComponent("q-item-section");
  const _component_q_item_label = resolveComponent("q-item-label");
  const _component_q_item = resolveComponent("q-item");
  const _component_q_list = resolveComponent("q-list");
  const _component_q_scroll_area = resolveComponent("q-scroll-area");
  const _component_q_file = resolveComponent("q-file");
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_btn_group = resolveComponent("q-btn-group");
  const _component_q_btn_dropdown = resolveComponent("q-btn-dropdown");
  const _component_q_overflow_toolbar = resolveComponent("q-overflow-toolbar");
  const _component_q_card_section = resolveComponent("q-card-section");
  const _component_q_separator = resolveComponent("q-separator");
  const _component_q_img_cropper = resolveComponent("q-img-cropper");
  const _component_q_card_actions = resolveComponent("q-card-actions");
  const _component_q_card = resolveComponent("q-card");
  const _component_q_dialog = resolveComponent("q-dialog");
  const _directive_close_popup = resolveDirective("close-popup");
  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" <viewport> "),
    createVNode(_component_q_file, {
      ref: "fileInputField",
      id: _ctx.id,
      label: _ctx.label,
      "stack-label": _ctx.stackLabel,
      hint: _ctx.hint,
      "hide-hint": _ctx.hideHint,
      "label-color": _ctx.labelColor,
      color: _ctx.color,
      "bg-color": _ctx.bgColor,
      filled: _ctx.filled,
      outlined: _ctx.outlined,
      borderless: _ctx.borderless,
      standout: _ctx.standout,
      square: _ctx.square,
      loading: _ctx.loading,
      "hide-bottom-space": _ctx.hideBottomSpace,
      rounded: _ctx.rounded,
      dense: _ctx.dense,
      "item-aligned": _ctx.itemAligned,
      counter: _ctx.counter,
      clearable: _ctx.clearable,
      "clear-icon": _ctx.clearIcon,
      disable: _ctx.disable,
      readonly: _ctx.readonly,
      autofocus: _ctx.autofocus,
      for: _ctx.$props.for,
      maxlength: _ctx.maxlength,
      dark: _ctx.dark,
      "model-value": _ctx.modelValue,
      error: _ctx.error,
      "error-message": _ctx.errorMessage,
      "no-error-icon": _ctx.noErrorIcon,
      rules: _ctx.rules,
      "reactive-rules": _ctx.reactiveRules,
      "lazy-rules": _ctx.lazyRules,
      name: _ctx.nameProp,
      multiple: _ctx.multiple,
      accept: _ctx.accept,
      capture: _ctx.capture,
      "max-file-size": _ctx.maxFileSize,
      "max-total-size": _ctx.maxTotalSize,
      "max-files": _ctx.maxFiles,
      filter: _ctx.filter,
      append: _ctx.append,
      tabindex: _ctx.tabindex,
      "counter-label": _ctx.counterLabel,
      onRejected: _ctx.onRejected,
      "onUpdate:modelValue": _ctx.onUpdateModelValue,
      onClear: _ctx.onClear,
      onFocus: _ctx.onFocus,
      onBlur: _ctx.onBlur,
      style: normalizeStyle(_ctx.getStyle()),
      class: normalizeClass(_ctx.getClass())
    }, createSlots({
      after: withCtx(() => [
        createElementVNode("input", {
          type: "hidden",
          name: _ctx.name ? _ctx.name + '_changed' : void 0,
          value: _ctx.changed ? '1' : '0',
          disabled: _ctx.disable
        }, null, 8 /* PROPS */, _hoisted_1$6),
        renderSlot(_ctx.$slots, "after")
      ]),
      append: withCtx(() => [
        (_ctx.multiple !== true && _ctx.disable !== true && _ctx.readonly !== true && _ctx.imageEditable !== false && _ctx.hasImage === true)
          ? (openBlock(), createBlock(_component_q_icon, {
              key: 0,
              class: "q-field__focusable-action",
              tag: "button",
              name: _ctx.editImageIcon,
              tabindex: "0",
              type: "button",
              "aria-hidden": null,
              role: null,
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.onEditImage($event, _ctx.modelValue, 0)))
            }, null, 8 /* PROPS */, ["name"]))
          : createCommentVNode("v-if", true),
        (_ctx.disable !== true && _ctx.readonly !== true)
          ? (openBlock(), createBlock(_component_q_icon, {
              key: 1,
              class: "q-field__focusable-action",
              tag: "button",
              name: _ctx.pickFileIcon,
              tabindex: "0",
              type: "button",
              "aria-hidden": null,
              role: null,
              onClick: _ctx.onPickFiles
            }, null, 8 /* PROPS */, ["name", "onClick"]))
          : createCommentVNode("v-if", true),
        renderSlot(_ctx.$slots, "append")
      ]),
      _: 2 /* DYNAMIC */
    }, [
      ((_ctx.placeholder && !_ctx.hasValue) || _ctx.$slots['default'])
        ? {
            name: "default",
            fn: withCtx(() => [
              (_ctx.placeholder && !_ctx.hasValue)
                ? (openBlock(), createElementBlock("div", _hoisted_2$4, [
                    createElementVNode("span", _hoisted_3$3, toDisplayString(_ctx.placeholder), 1 /* TEXT */)
                  ]))
                : createCommentVNode("v-if", true),
              renderSlot(_ctx.$slots, "default")
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.multiple === true || _ctx.caption === true || (_ctx.noThumbnails !== true && _ctx.hasImage === true))
        ? {
            name: "selected",
            fn: withCtx((props) => [
              (_ctx.multiple !== true)
                ? (openBlock(), createBlock(_component_q_item, {
                    key: 0,
                    class: "q-file-input__selected-item"
                  }, {
                    default: withCtx(() => [
                      (_ctx.noThumbnails !== true && _ctx.isImage(props.files[0]))
                        ? (openBlock(), createBlock(_component_q_item_section, {
                            key: 0,
                            avatar: ""
                          }, {
                            default: withCtx(() => [
                              createElementVNode("img", {
                                class: "q-file-input__thumbnail",
                                src: _ctx.getImage(props.files[0])
                              }, null, 8 /* PROPS */, _hoisted_4$2)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        : createCommentVNode("v-if", true),
                      createVNode(_component_q_item_section, null, {
                        default: withCtx(() => [
                          createVNode(_component_q_item_label, { class: "ellipsis" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.getLabel(props.files[0])), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          (_ctx.caption)
                            ? (openBlock(), createBlock(_component_q_item_label, {
                                key: 0,
                                caption: "",
                                lines: "1"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(_ctx.humanStorageSize(props.files[0].size)), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : createCommentVNode("v-if", true)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                : (openBlock(), createBlock(_component_q_scroll_area, {
                    key: 1,
                    style: {"width":"100%","height":"100%"},
                    "content-style": { width: '100%' },
                    "content-active-style": { width: '100%' }
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_q_list, {
                        dense: _ctx.dense,
                        bordered: "",
                        separator: "",
                        style: {"width":"100%"}
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(props.files, (file, fileIndex) => {
                            return (openBlock(), createBlock(_component_q_item, {
                              key: fileIndex,
                              disable: _ctx.disable,
                              clickable: true,
                              manualFocus: true,
                              class: "q-hoverable",
                              style: {"cursor":"default !important"}
                            }, {
                              default: withCtx(() => [
                                (_ctx.noThumbnails !== true && _ctx.isImage(file))
                                  ? (openBlock(), createBlock(_component_q_item_section, {
                                      key: 0,
                                      avatar: ""
                                    }, {
                                      default: withCtx(() => [
                                        createElementVNode("img", {
                                          class: "q-file-input__thumbnail",
                                          src: _ctx.getImage(file)
                                        }, null, 8 /* PROPS */, _hoisted_5$2)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */))
                                  : createCommentVNode("v-if", true),
                                createVNode(_component_q_item_section, null, {
                                  default: withCtx(() => [
                                    createVNode(_component_q_item_label, { class: "ellipsis" }, {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(_ctx.getLabel(file)), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    (_ctx.caption)
                                      ? (openBlock(), createBlock(_component_q_item_label, {
                                          key: 0,
                                          caption: "",
                                          lines: "1"
                                        }, {
                                          default: withCtx(() => [
                                            createTextVNode(toDisplayString(_ctx.humanStorageSize(file.size)), 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */))
                                      : createCommentVNode("v-if", true)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                createVNode(_component_q_item_section, { side: "" }, {
                                  default: withCtx(() => [
                                    createElementVNode("div", _hoisted_6$2, [
                                      (_ctx.multiple === true && _ctx.disable !== true && _ctx.readonly !== true && _ctx.imageEditable !== false && _ctx.isImage(file))
                                        ? (openBlock(), createBlock(_component_q_icon, {
                                            key: 0,
                                            class: "q-field__focusable-action",
                                            tag: "button",
                                            name: _ctx.editImageIcon,
                                            tabindex: "0",
                                            type: "button",
                                            "aria-hidden": null,
                                            role: null,
                                            size: "24px",
                                            onClick: $event => (_ctx.onEditImage($event, file, fileIndex))
                                          }, null, 8 /* PROPS */, ["name", "onClick"]))
                                        : createCommentVNode("v-if", true),
                                      (_ctx.disable !== true && _ctx.readonly !== true)
                                        ? (openBlock(), createBlock(_component_q_icon, {
                                            key: 1,
                                            class: "q-field__focusable-action",
                                            tag: "button",
                                            name: _ctx.$q.iconSet.field.clear,
                                            tabindex: "0",
                                            type: "button",
                                            "aria-hidden": null,
                                            role: null,
                                            size: "24px",
                                            onClick: $event => (_ctx.removeAtIndex(fileIndex))
                                          }, null, 8 /* PROPS */, ["name", "onClick"]))
                                        : createCommentVNode("v-if", true)
                                    ])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disable"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["dense"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
            ]),
            key: "1"
          }
        : undefined,
      (_ctx.$slots['prepend'])
        ? {
            name: "prepend",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "prepend")
            ]),
            key: "2"
          }
        : undefined,
      (_ctx.$slots['before'])
        ? {
            name: "before",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "before")
            ]),
            key: "3"
          }
        : undefined,
      (_ctx.$slots['label'])
        ? {
            name: "label",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "label")
            ]),
            key: "4"
          }
        : undefined,
      (_ctx.$slots['error'])
        ? {
            name: "error",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "error")
            ]),
            key: "5"
          }
        : undefined,
      (_ctx.$slots['hint'])
        ? {
            name: "hint",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "hint")
            ]),
            key: "6"
          }
        : undefined,
      (_ctx.$slots['counter'])
        ? {
            name: "counter",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "counter")
            ]),
            key: "7"
          }
        : undefined,
      (_ctx.$slots['loading'])
        ? {
            name: "loading",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "loading")
            ]),
            key: "8"
          }
        : undefined
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "label", "stack-label", "hint", "hide-hint", "label-color", "color", "bg-color", "filled", "outlined", "borderless", "standout", "square", "loading", "hide-bottom-space", "rounded", "dense", "item-aligned", "counter", "clearable", "clear-icon", "disable", "readonly", "autofocus", "for", "maxlength", "dark", "model-value", "error", "error-message", "no-error-icon", "rules", "reactive-rules", "lazy-rules", "name", "multiple", "accept", "capture", "max-file-size", "max-total-size", "max-files", "filter", "append", "tabindex", "counter-label", "onRejected", "onUpdate:modelValue", "onClear", "onFocus", "onBlur", "style", "class"]),
    createCommentVNode(" </viewport> "),
    createVNode(_component_q_dialog, mergeProps(_ctx.dialogProps, {
      modelValue: _ctx.editImageDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.editImageDialog) = $event)),
      class: "q-file-input__image-crop-dialog",
      onBeforeShow: _cache[16] || (_cache[16] = $event => (_ctx.$emit('dialog-before-show', $event))),
      onShow: _cache[17] || (_cache[17] = $event => {
            _ctx.$refs.imageEditToolbar.update();
            _ctx.$emit('dialog-show', $event);
        }),
      onBeforeHide: _cache[18] || (_cache[18] = $event => (_ctx.$emit('dialog-before-hide', $event))),
      onHide: _cache[19] || (_cache[19] = $event => (_ctx.$emit('dialog-hide', $event))),
      onShake: _cache[20] || (_cache[20] = $event => (_ctx.$emit('dialog-shake', $event))),
      onEscapeKey: _cache[21] || (_cache[21] = $event => (_ctx.$emit('dialog-escape-key', $event)))
    }), {
      default: withCtx(() => [
        createVNode(_component_q_card, {
          dark: _ctx.dark,
          class: "column",
          style: {"width":"90vw","max-width":"1200px","max-height":"unset","overflow":"hidden"}
        }, {
          default: withCtx(() => [
            createVNode(_component_q_card_section, { style: {"width":"100%"} }, {
              default: withCtx(() => [
                createVNode(_component_q_overflow_toolbar, {
                  ref: "imageEditToolbar",
                  "button-align": "left",
                  style: {"width":"100%"}
                }, {
                  default: withCtx(() => [
                    createVNode(_component_q_btn_group, { "qot-id": "qot-id-01" }, {
                      default: withCtx(() => [
                        createVNode(_component_q_btn, {
                          icon: "fa fa-arrows-alt",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.dragModeMove'),
                          onClick: _cache[1] || (_cache[1] = $event => (_ctx.imageEditCommand('mode-move')))
                        }, null, 8 /* PROPS */, ["title"]),
                        createVNode(_component_q_btn, {
                          icon: "fa fa-crop-alt",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.dragModeCrop'),
                          onClick: _cache[2] || (_cache[2] = $event => (_ctx.imageEditCommand('mode-crop')))
                        }, null, 8 /* PROPS */, ["title"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_q_btn_group, {
                      "qot-id": "qot-id-02",
                      class: "q-ml-md"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_q_btn, {
                          icon: "fa fa-search-plus",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.zoomIn'),
                          onClick: _cache[3] || (_cache[3] = $event => (_ctx.imageEditCommand('zoom-in')))
                        }, null, 8 /* PROPS */, ["title"]),
                        createVNode(_component_q_btn, {
                          icon: "fa fa-search-minus",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.zoomOut'),
                          onClick: _cache[4] || (_cache[4] = $event => (_ctx.imageEditCommand('zoom-out')))
                        }, null, 8 /* PROPS */, ["title"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_q_btn_group, {
                      "qot-id": "qot-id-03",
                      class: "q-ml-md"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_q_btn, {
                          icon: "fa fa-arrow-left",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.moveLeft'),
                          onClick: _cache[5] || (_cache[5] = $event => (_ctx.imageEditCommand('move-left')))
                        }, null, 8 /* PROPS */, ["title"]),
                        createVNode(_component_q_btn, {
                          icon: "fa fa-arrow-right",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.moveRight'),
                          onClick: _cache[6] || (_cache[6] = $event => (_ctx.imageEditCommand('move-right')))
                        }, null, 8 /* PROPS */, ["title"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_q_btn_group, {
                      "qot-id": "qot-id-04",
                      class: "q-ml-md"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_q_btn, {
                          icon: "fa fa-arrow-up",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.moveUp'),
                          onClick: _cache[7] || (_cache[7] = $event => (_ctx.imageEditCommand('move-up')))
                        }, null, 8 /* PROPS */, ["title"]),
                        createVNode(_component_q_btn, {
                          icon: "fa fa-arrow-down",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.moveDown'),
                          onClick: _cache[8] || (_cache[8] = $event => (_ctx.imageEditCommand('move-down')))
                        }, null, 8 /* PROPS */, ["title"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_q_btn_group, {
                      "qot-id": "qot-id-05",
                      class: "q-ml-md"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_q_btn, {
                          icon: "fa fa-undo-alt",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.rotateLeft'),
                          onClick: _cache[9] || (_cache[9] = $event => (_ctx.imageEditCommand('rotate-left')))
                        }, null, 8 /* PROPS */, ["title"]),
                        createVNode(_component_q_btn, {
                          icon: "fa fa-redo-alt",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.rotateRight'),
                          onClick: _cache[10] || (_cache[10] = $event => (_ctx.imageEditCommand('rotate-right')))
                        }, null, 8 /* PROPS */, ["title"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_q_btn_group, {
                      "qot-id": "qot-id-06",
                      class: "q-ml-md"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_q_btn, {
                          icon: "fa fa-arrows-alt-h",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.flipHorizontal'),
                          onClick: _cache[11] || (_cache[11] = $event => (_ctx.imageEditCommand('flip-horizontal')))
                        }, null, 8 /* PROPS */, ["title"]),
                        createVNode(_component_q_btn, {
                          icon: "fa fa-arrows-alt-v",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.flipVertical'),
                          onClick: _cache[12] || (_cache[12] = $event => (_ctx.imageEditCommand('flip-vertical')))
                        }, null, 8 /* PROPS */, ["title"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_q_btn_group, {
                      "qot-id": "qot-id-07",
                      class: "q-ml-md"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_q_btn, {
                          icon: "fa fa-sync-alt",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.cropMode'),
                          onClick: _cache[13] || (_cache[13] = $event => (_ctx.imageEditCommand('crop')))
                        }, null, 8 /* PROPS */, ["title"]),
                        createVNode(_component_q_btn, {
                          icon: "fa fa-times",
                          "no-caps": "",
                          title: _ctx.t('editImageDialog.commands.clearMode'),
                          onClick: _cache[14] || (_cache[14] = $event => (_ctx.imageEditCommand('clear')))
                        }, null, 8 /* PROPS */, ["title"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    (_ctx.imageEditAspectRatio == null)
                      ? (openBlock(), createBlock(_component_q_btn_dropdown, {
                          key: 0,
                          "qot-id": "qot-id-08",
                          icon: "fa fa-ruler-combined",
                          label: _ctx.editImageRatio.label,
                          "no-caps": true,
                          class: "q-ml-md"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_q_list, null, {
                              default: withCtx(() => [
                                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.editImageRatios, (ratio, index) => {
                                  return withDirectives((openBlock(), createBlock(_component_q_item, {
                                    key: index,
                                    clickable: "",
                                    onClick: $event => {
                                    _ctx.editImageRatio = ratio;
                                    _ctx.$nextTick(() => _ctx.$refs.imageEditToolbar.update(true));
                                    _ctx.imageEditCommand('update-ratio');
                                }
                                  }, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_item_section, null, {
                                        default: withCtx(() => [
                                          createVNode(_component_q_item_label, null, {
                                            default: withCtx(() => [
                                              createTextVNode(toDisplayString(ratio.label), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                    [_directive_close_popup]
                                  ])
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]))
                      : createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_q_separator),
            createVNode(_component_q_card_section, {
              class: "q-pa-md",
              style: {"width":"100%"}
            }, {
              default: withCtx(() => [
                createVNode(_component_q_img_cropper, {
                  ref: "imageEditCropper",
                  src: _ctx.getImage(_ctx.editImageFile),
                  "view-mode": _ctx.imageEditViewMode,
                  "initial-aspect-ratio": _ctx.imageEditAspectRatio == null ? NaN : _ctx.imageEditAspectRatio,
                  "aspect-ratio": _ctx.imageEditAspectRatio == null ? NaN : _ctx.imageEditAspectRatio,
                  "auto-crop-area": 0.5,
                  "zoom-on-touch": false,
                  "zoom-on-wheel": false,
                  "min-container-width": 1,
                  "min-container-height": 1,
                  "img-style": "margin: auto;",
                  style: {"height":"calc(100vh - 214px)","max-height":"600px"}
                }, null, 8 /* PROPS */, ["src", "view-mode", "initial-aspect-ratio", "aspect-ratio", "auto-crop-area"])
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_q_separator),
            createVNode(_component_q_card_actions, { align: "right" }, {
              default: withCtx(() => [
                createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$q.lang.label.ok,
                  onClick: _ctx.editImageConfirm
                }, null, 8 /* PROPS */, ["label", "onClick"]),
                withDirectives(createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$q.lang.label.close
                }, null, 8 /* PROPS */, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["dark"])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}

var css_248z$6 = "\n.q-file-input.q-file-input--hide_after[data-v-53317c26]  .q-field__after {\n    display: none;\n}\n.q-file-input[data-v-53317c26]  .q-file-input__selected-item {\n    width: 100%;\n    min-height: 24px;\n    padding: 0px;\n    margin-top: 5px;\n}\n.q-file-input[data-v-53317c26]  .q-file-input__thumbnail {\n    width: 50px;\n    height: 40px;\n    object-fit: scale-down;\n}\n.q-file-input.q-file-input--extended[data-v-53317c26]  .q-field__control .q-field__append {\n    /* padding-top: 18px; */\n    align-self: center;\n}\n\n/* .q-file-input.q-file-input--multiple:deep() .q-field__control {\n    height: 100%;\n} */\n.q-file-input.q-file-input--multiple[data-v-53317c26]  .q-field__control-container {\n    padding-top: 55px;\n}\n.q-file-input.q-file-input--multiple.q-field--dense[data-v-53317c26]  .q-field__control-container {\n    padding-top: 40px;\n}\n.q-file-input.q-file-input--multiple.q-field--stack-label[data-v-53317c26]  .q-field__control-container .q-field__label {\n    transform: translateY(3px) scale(0.75);\n}\n.q-file-input.q-file-input--multiple[data-v-53317c26]  .q-field__control-container .q-field__native {\n    position: relative;\n    padding-bottom: 0px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined[data-v-53317c26]  .q-field__control-container .q-field__native,\n.q-file-input.q-file-input--multiple.q-field--filled[data-v-53317c26]  .q-field__control-container .q-field__native,\n.q-file-input.q-file-input--multiple.q-field--standout[data-v-53317c26]  .q-field__control-container .q-field__native {\n    padding-bottom: 12px;\n}\n.q-file-input[data-v-53317c26]  .q-field__control-container .q-file-input__placeholder {\n    display: flex;\n    align-items: center;\n    color: rgba(0, 0, 0, 0.54);\n    padding-top: inherit;\n}\n.q-file-input[data-v-53317c26]:not(.q-file-input--multiple)  .q-field__control-container .q-file-input__placeholder {\n    cursor: pointer;\n}\n.q-file-input:not(.q-file-input--multiple).q-field--labeled[data-v-53317c26]:not(.q-field--float)  .q-field__control-container .q-file-input__placeholder {\n    color: transparent;\n}\n.q-file-input.q-file-input--multiple[data-v-53317c26]  .q-field__append {\n    position: absolute;\n    padding: 0px;\n    right: 0px;\n}\n.q-file-input.q-file-input--multiple[data-v-53317c26]  .q-field__append:last-child {\n    right: 0px;\n}\n.q-file-input.q-file-input--multiple.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 52px;\n}\n.q-file-input.q-file-input--multiple.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3) {\n    right: 26px;\n}\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 26px;\n}\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3) {\n    right: 0px;\n}\n.q-file-input.q-file-input--multiple.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 26px;\n}\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 0px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined[data-v-53317c26]  .q-field__append:last-child,\n.q-file-input.q-file-input--multiple.q-field--filled[data-v-53317c26]  .q-field__append:last-child,\n.q-file-input.q-file-input--multiple.q-field--standout[data-v-53317c26]  .q-field__append:last-child {\n    right: 12px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 64px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3) {\n    right: 38px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 38px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__append:nth-child(3) {\n    right: 12px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 38px;\n}\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--disabled.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--disabled.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--disabled.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--readonly.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--readonly.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--outlined.q-field--readonly.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--disabled.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--disabled.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--disabled.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--readonly.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--readonly.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--filled.q-field--readonly.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--disabled.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--disabled.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--disabled.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--readonly.q-field--clearable[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--readonly.q-field--loading[data-v-53317c26]  .q-field__append:nth-child(2),\n.q-file-input.q-file-input--multiple.q-field--standout.q-field--readonly.q-field--error[data-v-53317c26]  .q-field__append:nth-child(2) {\n    right: 12px;\n}\n.q-file-input.q-file-input--multiple[data-v-53317c26]  .q-field__control-container .q-field__label {\n    padding-right: 40px;\n}\n.q-file-input.q-file-input--multiple.q-field--clearable[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--loading[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label {\n    padding-right: 70px;\n}\n.q-file-input.q-file-input--multiple.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--loading.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label {\n    padding-right: 110px;\n}\n.q-file-input.q-file-input--multiple.q-field--disabled[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--readonly[data-v-53317c26]  .q-field__control-container .q-field__label {\n    padding-right: 0px;\n}\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--clearable[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--loading[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--clearable[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--loading[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label {\n    padding-right: 40px;\n}\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--disabled.q-field--loading.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--clearable.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label,\n.q-file-input.q-file-input--multiple.q-field--readonly.q-field--loading.q-field--error[data-v-53317c26]  .q-field__control-container .q-field__label {\n    padding-right: 70px;\n}\n.q-file-input.q-file-input--multiple[data-v-53317c26]  .q-field__control .q-field__native input[type='file'] {\n    width: 0px !important;\n    height: 0px !important;\n    top: 0px;\n    left: 0px;\n    right: unset !important;\n    bottom: unset !important;\n}\n";
styleInject(css_248z$6);

function block0$2 (Component) {
  Component.__i18n = Component.__i18n || [];
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "sk": {
        "editImageDialog": {
          "commands": {
            "dragModeMove": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Režim posunu"])};fn.source="Režim posunu";return fn;})(),
            "dragModeCrop": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Režim orezania"])};fn.source="Režim orezania";return fn;})(),
            "zoomIn": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priblížiť"])};fn.source="Priblížiť";return fn;})(),
            "zoomOut": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oddialiť"])};fn.source="Oddialiť";return fn;})(),
            "moveLeft": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Posunúť doľava"])};fn.source="Posunúť doľava";return fn;})(),
            "moveRight": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Posunúť doprava"])};fn.source="Posunúť doprava";return fn;})(),
            "moveUp": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Posunúť nahor"])};fn.source="Posunúť nahor";return fn;})(),
            "moveDown": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Posunúť nadol"])};fn.source="Posunúť nadol";return fn;})(),
            "rotateLeft": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otočiť doľava"])};fn.source="Otočiť doľava";return fn;})(),
            "rotateRight": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otočiť doprava"])};fn.source="Otočiť doprava";return fn;})(),
            "flipHorizontal": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prevrátiť horizontálne"])};fn.source="Prevrátiť horizontálne";return fn;})(),
            "flipVertical": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prevrátiť vertikálne"])};fn.source="Prevrátiť vertikálne";return fn;})(),
            "cropMode": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať orezanie"])};fn.source="Aktivovať orezanie";return fn;})(),
            "clearMode": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovať orezanie"])};fn.source="Deaktivovať orezanie";return fn;})()
          }
        }
      }
    }
  });
}

if (typeof block0$2 === 'function') block0$2(script$6);

script$6.render = render$6;
script$6.__scopeId = "data-v-53317c26";
script$6.__file = "src/components/QFileInput.vue";

var css_248z$5 = ".tox {\n  box-shadow: none;\n  box-sizing: content-box;\n  color: #222f3e;\n  cursor: auto;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: normal;\n  -webkit-tap-highlight-color: transparent;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  vertical-align: initial;\n  white-space: normal;\n}\n.tox *:not(svg):not(rect) {\n  box-sizing: inherit;\n  color: inherit;\n  cursor: inherit;\n  direction: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  -webkit-tap-highlight-color: inherit;\n  text-align: inherit;\n  text-decoration: inherit;\n  text-shadow: inherit;\n  text-transform: inherit;\n  vertical-align: inherit;\n  white-space: inherit;\n}\n.tox *:not(svg):not(rect) {\n  /* stylelint-disable-line no-duplicate-selectors */\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  float: none;\n  height: auto;\n  margin: 0;\n  max-width: none;\n  outline: 0;\n  padding: 0;\n  position: static;\n  width: auto;\n}\n.tox:not([dir=rtl]) {\n  direction: ltr;\n  text-align: left;\n}\n.tox[dir=rtl] {\n  direction: rtl;\n  text-align: right;\n}\n.tox-tinymce {\n  border: 2px solid #eeeeee;\n  border-radius: 10px;\n  box-shadow: none;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  overflow: hidden;\n  position: relative;\n  visibility: inherit !important;\n}\n.tox.tox-tinymce-inline {\n  border: none;\n  box-shadow: none;\n  overflow: initial;\n}\n.tox.tox-tinymce-inline .tox-editor-container {\n  overflow: initial;\n}\n.tox.tox-tinymce-inline .tox-editor-header {\n  background-color: #fff;\n  border: 2px solid #eeeeee;\n  border-radius: 10px;\n  box-shadow: none;\n  overflow: hidden;\n}\n.tox-tinymce-aux {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  z-index: 1300;\n}\n.tox-tinymce *:focus,\n.tox-tinymce-aux *:focus {\n  outline: none;\n}\nbutton::-moz-focus-inner {\n  border: 0;\n}\n.tox[dir=rtl] .tox-icon--flip svg {\n  transform: rotateY(180deg);\n}\n.tox .accessibility-issue__header {\n  align-items: center;\n  display: flex;\n  margin-bottom: 4px;\n}\n.tox .accessibility-issue__description {\n  align-items: stretch;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n}\n.tox .accessibility-issue__description > div {\n  padding-bottom: 4px;\n}\n.tox .accessibility-issue__description > div > div {\n  align-items: center;\n  display: flex;\n  margin-bottom: 4px;\n}\n.tox .accessibility-issue__description > div > div .tox-icon svg {\n  display: block;\n}\n.tox .accessibility-issue__repair {\n  margin-top: 16px;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .accessibility-issue__description {\n  background-color: rgba(0, 101, 216, 0.1);\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .tox-form__group h2 {\n  color: #006ce7;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .tox-icon svg {\n  fill: #006ce7;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon {\n  background-color: #006ce7;\n  color: #fff;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon:hover,\n.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon:focus {\n  background-color: #0060ce;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon:active {\n  background-color: #0054b4;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .accessibility-issue__description {\n  background-color: rgba(255, 165, 0, 0.08);\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .tox-form__group h2 {\n  color: #8f5d00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .tox-icon svg {\n  fill: #8f5d00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon {\n  background-color: #FFE89D;\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon:hover,\n.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon:focus {\n  background-color: #F2D574;\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon:active {\n  background-color: #E8C657;\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .accessibility-issue__description {\n  background-color: rgba(204, 0, 0, 0.1);\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .tox-form__group h2 {\n  color: #c00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .tox-icon svg {\n  fill: #c00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon {\n  background-color: #F2BFBF;\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon:hover,\n.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon:focus {\n  background-color: #E9A4A4;\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon:active {\n  background-color: #EE9494;\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description {\n  background-color: rgba(120, 171, 70, 0.1);\n  color: #222f3e;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description > *:last-child {\n  display: none;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .tox-form__group h2 {\n  color: #527530;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .tox-icon svg {\n  fill: #527530;\n}\n.tox .tox-dialog__body-content .accessibility-issue__header .tox-form__group h1,\n.tox .tox-dialog__body-content .tox-form__group .accessibility-issue__description h2 {\n  font-size: 14px;\n  margin-top: 0;\n}\n.tox:not([dir=rtl]) .tox-dialog__body-content .accessibility-issue__header .tox-button {\n  margin-left: 4px;\n}\n.tox:not([dir=rtl]) .tox-dialog__body-content .accessibility-issue__header > *:nth-last-child(2) {\n  margin-left: auto;\n}\n.tox:not([dir=rtl]) .tox-dialog__body-content .accessibility-issue__description {\n  padding: 4px 4px 4px 8px;\n}\n.tox[dir=rtl] .tox-dialog__body-content .accessibility-issue__header .tox-button {\n  margin-right: 4px;\n}\n.tox[dir=rtl] .tox-dialog__body-content .accessibility-issue__header > *:nth-last-child(2) {\n  margin-right: auto;\n}\n.tox[dir=rtl] .tox-dialog__body-content .accessibility-issue__description {\n  padding: 4px 8px 4px 4px;\n}\n.tox .tox-anchorbar {\n  display: flex;\n  flex: 0 0 auto;\n}\n.tox .tox-bar {\n  display: flex;\n  flex: 0 0 auto;\n}\n.tox .tox-button {\n  background-color: #006ce7;\n  background-image: none;\n  background-position: 0 0;\n  background-repeat: repeat;\n  border-color: #006ce7;\n  border-radius: 6px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  line-height: 24px;\n  margin: 0;\n  outline: none;\n  padding: 4px 16px;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  text-transform: none;\n  white-space: nowrap;\n}\n.tox .tox-button::before {\n  border-radius: 6px;\n  bottom: -1px;\n  box-shadow: inset 0 0 0 2px #fff, 0 0 0 1px #006ce7, 0 0 0 3px rgba(0, 108, 231, 0.25);\n  content: '';\n  left: -1px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  right: -1px;\n  top: -1px;\n}\n.tox .tox-button[disabled] {\n  background-color: #006ce7;\n  background-image: none;\n  border-color: #006ce7;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-button:focus:not(:disabled) {\n  background-color: #0060ce;\n  background-image: none;\n  border-color: #0060ce;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button:focus-visible:not(:disabled)::before {\n  opacity: 1;\n}\n.tox .tox-button:hover:not(:disabled) {\n  background-color: #0060ce;\n  background-image: none;\n  border-color: #0060ce;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button:active:not(:disabled) {\n  background-color: #0054b4;\n  background-image: none;\n  border-color: #0054b4;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button--secondary {\n  background-color: #f0f0f0;\n  background-image: none;\n  background-position: 0 0;\n  background-repeat: repeat;\n  border-color: #f0f0f0;\n  border-radius: 6px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  color: #222f3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  outline: none;\n  padding: 4px 16px;\n  text-decoration: none;\n  text-transform: none;\n}\n.tox .tox-button--secondary[disabled] {\n  background-color: #f0f0f0;\n  background-image: none;\n  border-color: #f0f0f0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-button--secondary:focus:not(:disabled) {\n  background-color: #e3e3e3;\n  background-image: none;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--secondary:hover:not(:disabled) {\n  background-color: #e3e3e3;\n  background-image: none;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--secondary:active:not(:disabled) {\n  background-color: #d6d6d6;\n  background-image: none;\n  border-color: #d6d6d6;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--icon,\n.tox .tox-button.tox-button--icon,\n.tox .tox-button.tox-button--secondary.tox-button--icon {\n  padding: 4px;\n}\n.tox .tox-button--icon .tox-icon svg,\n.tox .tox-button.tox-button--icon .tox-icon svg,\n.tox .tox-button.tox-button--secondary.tox-button--icon .tox-icon svg {\n  display: block;\n  fill: currentColor;\n}\n.tox .tox-button-link {\n  background: 0;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 1.3;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n.tox .tox-button-link--sm {\n  font-size: 14px;\n}\n.tox .tox-button--naked {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: unset;\n  color: #222f3e;\n}\n.tox .tox-button--naked[disabled] {\n  background-color: rgba(34, 47, 62, 0.12);\n  border-color: transparent;\n  box-shadow: unset;\n  color: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-button--naked:hover:not(:disabled) {\n  background-color: rgba(34, 47, 62, 0.12);\n  border-color: transparent;\n  box-shadow: unset;\n  color: #222f3e;\n}\n.tox .tox-button--naked:focus:not(:disabled) {\n  background-color: rgba(34, 47, 62, 0.12);\n  border-color: transparent;\n  box-shadow: unset;\n  color: #222f3e;\n}\n.tox .tox-button--naked:active:not(:disabled) {\n  background-color: rgba(34, 47, 62, 0.18);\n  border-color: transparent;\n  box-shadow: unset;\n  color: #222f3e;\n}\n.tox .tox-button--naked .tox-icon svg {\n  fill: currentColor;\n}\n.tox .tox-button--naked.tox-button--icon:hover:not(:disabled) {\n  color: #222f3e;\n}\n.tox .tox-checkbox {\n  align-items: center;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  height: 36px;\n  min-width: 36px;\n}\n.tox .tox-checkbox__input {\n  /* Hide from view but visible to screen readers */\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  top: auto;\n  width: 1px;\n}\n.tox .tox-checkbox__icons {\n  align-items: center;\n  border-radius: 6px;\n  box-shadow: 0 0 0 2px transparent;\n  box-sizing: content-box;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  padding: calc(4px - 1px);\n  width: 24px;\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  display: block;\n  fill: rgba(34, 47, 62, 0.3);\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {\n  display: none;\n  fill: #006ce7;\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__checked svg {\n  display: none;\n  fill: #006ce7;\n}\n.tox .tox-checkbox--disabled {\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__checked svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  display: none;\n}\n.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__checked svg {\n  display: block;\n}\n.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  display: none;\n}\n.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {\n  display: block;\n}\n.tox input.tox-checkbox__input:focus + .tox-checkbox__icons {\n  border-radius: 6px;\n  box-shadow: inset 0 0 0 1px #006ce7;\n  padding: calc(4px - 1px);\n}\n.tox:not([dir=rtl]) .tox-checkbox__label {\n  margin-left: 4px;\n}\n.tox:not([dir=rtl]) .tox-checkbox__input {\n  left: -10000px;\n}\n.tox:not([dir=rtl]) .tox-bar .tox-checkbox {\n  margin-left: 4px;\n}\n.tox[dir=rtl] .tox-checkbox__label {\n  margin-right: 4px;\n}\n.tox[dir=rtl] .tox-checkbox__input {\n  right: -10000px;\n}\n.tox[dir=rtl] .tox-bar .tox-checkbox {\n  margin-right: 4px;\n}\n.tox {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox .tox-collection--toolbar .tox-collection__group {\n  display: flex;\n  padding: 0;\n}\n.tox .tox-collection--grid .tox-collection__group {\n  display: flex;\n  flex-wrap: wrap;\n  max-height: 208px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0;\n}\n.tox .tox-collection--list .tox-collection__group {\n  border-bottom-width: 0;\n  border-color: #e3e3e3;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-style: solid;\n  border-top-width: 1px;\n  padding: 4px 0;\n}\n.tox .tox-collection--list .tox-collection__group:first-child {\n  border-top-width: 0;\n}\n.tox .tox-collection__group-heading {\n  background-color: #fcfcfc;\n  color: rgba(34, 47, 62, 0.7);\n  cursor: default;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  margin-bottom: 4px;\n  margin-top: -4px;\n  padding: 4px 8px;\n  text-transform: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n.tox .tox-collection__item {\n  align-items: center;\n  border-radius: 3px;\n  color: #222f3e;\n  display: flex;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n.tox .tox-collection--list .tox-collection__item {\n  padding: 4px 8px;\n}\n.tox .tox-collection--toolbar .tox-collection__item {\n  border-radius: 3px;\n  padding: 4px;\n}\n.tox .tox-collection--grid .tox-collection__item {\n  border-radius: 3px;\n  padding: 4px;\n}\n.tox .tox-collection--list .tox-collection__item--enabled {\n  background-color: #fff;\n  color: #222f3e;\n}\n.tox .tox-collection--list .tox-collection__item--active {\n  background-color: #cce2fa;\n}\n.tox .tox-collection--toolbar .tox-collection__item--enabled {\n  background-color: #a6ccf7;\n  color: #222f3e;\n}\n.tox .tox-collection--toolbar .tox-collection__item--active {\n  background-color: #cce2fa;\n}\n.tox .tox-collection--grid .tox-collection__item--enabled {\n  background-color: #a6ccf7;\n  color: #222f3e;\n}\n.tox .tox-collection--grid .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  background-color: #cce2fa;\n  color: #222f3e;\n}\n.tox .tox-collection--list .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  color: #222f3e;\n}\n.tox .tox-collection--toolbar .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  color: #222f3e;\n}\n.tox .tox-collection__item-icon,\n.tox .tox-collection__item-checkmark {\n  align-items: center;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  width: 24px;\n}\n.tox .tox-collection__item-icon svg,\n.tox .tox-collection__item-checkmark svg {\n  fill: currentColor;\n}\n.tox .tox-collection--toolbar-lg .tox-collection__item-icon {\n  height: 48px;\n  width: 48px;\n}\n.tox .tox-collection__item-label {\n  color: currentColor;\n  display: inline-block;\n  flex: 1;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 24px;\n  text-transform: none;\n  word-break: break-all;\n}\n.tox .tox-collection__item-accessory {\n  color: rgba(34, 47, 62, 0.7);\n  display: inline-block;\n  font-size: 14px;\n  height: 24px;\n  line-height: 24px;\n  text-transform: none;\n}\n.tox .tox-collection__item-caret {\n  align-items: center;\n  display: flex;\n  min-height: 24px;\n}\n.tox .tox-collection__item-caret::after {\n  content: '';\n  font-size: 0;\n  min-height: inherit;\n}\n.tox .tox-collection__item-caret svg {\n  fill: #222f3e;\n}\n.tox .tox-collection__item--state-disabled {\n  background-color: transparent;\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-collection__item--state-disabled .tox-collection__item-caret svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-checkmark svg {\n  display: none;\n}\n.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-accessory + .tox-collection__item-checkmark {\n  display: none;\n}\n.tox .tox-collection--horizontal {\n  background-color: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 6px;\n  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);\n  display: flex;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n  margin-bottom: 0;\n  overflow-x: auto;\n  padding: 0;\n}\n.tox .tox-collection--horizontal .tox-collection__group {\n  align-items: center;\n  display: flex;\n  flex-wrap: nowrap;\n  margin: 0;\n  padding: 0 4px;\n}\n.tox .tox-collection--horizontal .tox-collection__item {\n  height: 28px;\n  margin: 6px 1px 5px 0;\n  padding: 0 4px;\n}\n.tox .tox-collection--horizontal .tox-collection__item-label {\n  white-space: nowrap;\n}\n.tox .tox-collection--horizontal .tox-collection__item-caret {\n  margin-left: 4px;\n}\n.tox .tox-collection__item-container {\n  display: flex;\n}\n.tox .tox-collection__item-container--row {\n  align-items: center;\n  flex: 1 1 auto;\n  flex-direction: row;\n}\n.tox .tox-collection__item-container--row.tox-collection__item-container--align-left {\n  margin-right: auto;\n}\n.tox .tox-collection__item-container--row.tox-collection__item-container--align-right {\n  justify-content: flex-end;\n  margin-left: auto;\n}\n.tox .tox-collection__item-container--row.tox-collection__item-container--valign-top {\n  align-items: flex-start;\n  margin-bottom: auto;\n}\n.tox .tox-collection__item-container--row.tox-collection__item-container--valign-middle {\n  align-items: center;\n}\n.tox .tox-collection__item-container--row.tox-collection__item-container--valign-bottom {\n  align-items: flex-end;\n  margin-top: auto;\n}\n.tox .tox-collection__item-container--column {\n  align-self: center;\n  flex: 1 1 auto;\n  flex-direction: column;\n}\n.tox .tox-collection__item-container--column.tox-collection__item-container--align-left {\n  align-items: flex-start;\n}\n.tox .tox-collection__item-container--column.tox-collection__item-container--align-right {\n  align-items: flex-end;\n}\n.tox .tox-collection__item-container--column.tox-collection__item-container--valign-top {\n  align-self: flex-start;\n}\n.tox .tox-collection__item-container--column.tox-collection__item-container--valign-middle {\n  align-self: center;\n}\n.tox .tox-collection__item-container--column.tox-collection__item-container--valign-bottom {\n  align-self: flex-end;\n}\n.tox:not([dir=rtl]) .tox-collection--horizontal .tox-collection__group:not(:last-of-type) {\n  border-right: 1px solid transparent;\n}\n.tox:not([dir=rtl]) .tox-collection--list .tox-collection__item > *:not(:first-child) {\n  margin-left: 8px;\n}\n.tox:not([dir=rtl]) .tox-collection--list .tox-collection__item > .tox-collection__item-label:first-child {\n  margin-left: 4px;\n}\n.tox:not([dir=rtl]) .tox-collection__item-accessory {\n  margin-left: 16px;\n  text-align: right;\n}\n.tox:not([dir=rtl]) .tox-collection .tox-collection__item-caret {\n  margin-left: 16px;\n}\n.tox[dir=rtl] .tox-collection--horizontal .tox-collection__group:not(:last-of-type) {\n  border-left: 1px solid transparent;\n}\n.tox[dir=rtl] .tox-collection--list .tox-collection__item > *:not(:first-child) {\n  margin-right: 8px;\n}\n.tox[dir=rtl] .tox-collection--list .tox-collection__item > .tox-collection__item-label:first-child {\n  margin-right: 4px;\n}\n.tox[dir=rtl] .tox-collection__item-accessory {\n  margin-right: 16px;\n  text-align: left;\n}\n.tox[dir=rtl] .tox-collection .tox-collection__item-caret {\n  margin-right: 16px;\n  transform: rotateY(180deg);\n}\n.tox[dir=rtl] .tox-collection--horizontal .tox-collection__item-caret {\n  margin-right: 4px;\n}\n.tox .tox-color-picker-container {\n  display: flex;\n  flex-direction: row;\n  height: 225px;\n  margin: 0;\n}\n.tox .tox-sv-palette {\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n}\n.tox .tox-sv-palette-spectrum {\n  height: 100%;\n}\n.tox .tox-sv-palette,\n.tox .tox-sv-palette-spectrum {\n  width: 225px;\n}\n.tox .tox-sv-palette-thumb {\n  background: none;\n  border: 1px solid black;\n  border-radius: 50%;\n  box-sizing: content-box;\n  height: 12px;\n  position: absolute;\n  width: 12px;\n}\n.tox .tox-sv-palette-inner-thumb {\n  border: 1px solid white;\n  border-radius: 50%;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n}\n.tox .tox-hue-slider {\n  box-sizing: border-box;\n  height: 100%;\n  width: 25px;\n}\n.tox .tox-hue-slider-spectrum {\n  background: linear-gradient(to bottom, #f00, #ff0080, #f0f, #8000ff, #00f, #0080ff, #0ff, #00ff80, #0f0, #80ff00, #ff0, #ff8000, #f00);\n  height: 100%;\n  width: 100%;\n}\n.tox .tox-hue-slider,\n.tox .tox-hue-slider-spectrum {\n  width: 20px;\n}\n.tox .tox-hue-slider-thumb {\n  background: white;\n  border: 1px solid black;\n  box-sizing: content-box;\n  height: 4px;\n  width: 100%;\n}\n.tox .tox-rgb-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.tox .tox-rgb-form div {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  width: inherit;\n}\n.tox .tox-rgb-form input {\n  width: 6em;\n}\n.tox .tox-rgb-form input.tox-invalid {\n  /* Need !important to override Chrome's focus styling unfortunately */\n  border: 1px solid red !important;\n}\n.tox .tox-rgb-form .tox-rgba-preview {\n  border: 1px solid black;\n  flex-grow: 2;\n  margin-bottom: 0;\n}\n.tox:not([dir=rtl]) .tox-sv-palette {\n  margin-right: 15px;\n}\n.tox:not([dir=rtl]) .tox-hue-slider {\n  margin-right: 15px;\n}\n.tox:not([dir=rtl]) .tox-hue-slider-thumb {\n  margin-left: -1px;\n}\n.tox:not([dir=rtl]) .tox-rgb-form label {\n  margin-right: 0.5em;\n}\n.tox[dir=rtl] .tox-sv-palette {\n  margin-left: 15px;\n}\n.tox[dir=rtl] .tox-hue-slider {\n  margin-left: 15px;\n}\n.tox[dir=rtl] .tox-hue-slider-thumb {\n  margin-right: -1px;\n}\n.tox[dir=rtl] .tox-rgb-form label {\n  margin-left: 0.5em;\n}\n.tox .tox-toolbar .tox-swatches,\n.tox .tox-toolbar__primary .tox-swatches,\n.tox .tox-toolbar__overflow .tox-swatches {\n  margin: 5px 0 6px 11px;\n}\n.tox .tox-collection--list .tox-collection__group .tox-swatches-menu {\n  border: 0;\n  margin: -4px -4px;\n}\n.tox .tox-swatches__row {\n  display: flex;\n}\n.tox .tox-swatch {\n  height: 30px;\n  transition: transform 0.15s, box-shadow 0.15s;\n  width: 30px;\n}\n.tox .tox-swatch:hover,\n.tox .tox-swatch:focus {\n  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.3) inset;\n  transform: scale(0.8);\n}\n.tox .tox-swatch--remove {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.tox .tox-swatch--remove svg path {\n  stroke: #e74c3c;\n}\n.tox .tox-swatches__picker-btn {\n  align-items: center;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  display: flex;\n  height: 30px;\n  justify-content: center;\n  outline: none;\n  padding: 0;\n  width: 30px;\n}\n.tox .tox-swatches__picker-btn svg {\n  fill: #222f3e;\n  height: 24px;\n  width: 24px;\n}\n.tox .tox-swatches__picker-btn:hover {\n  background: #cce2fa;\n}\n.tox div.tox-swatch:not(.tox-swatch--remove) svg {\n  display: none;\n  fill: #222f3e;\n  height: 24px;\n  margin: calc((30px - 24px) / 2) calc((30px - 24px) / 2);\n  width: 24px;\n}\n.tox div.tox-swatch:not(.tox-swatch--remove) svg path {\n  fill: #fff;\n  paint-order: stroke;\n  stroke: #222f3e;\n  stroke-width: 2px;\n}\n.tox div.tox-swatch:not(.tox-swatch--remove)[aria-checked=\"true\"] svg {\n  display: block;\n}\n.tox:not([dir=rtl]) .tox-swatches__picker-btn {\n  margin-left: auto;\n}\n.tox[dir=rtl] .tox-swatches__picker-btn {\n  margin-right: auto;\n}\n.tox .tox-comment-thread {\n  background: #fff;\n  position: relative;\n}\n.tox .tox-comment-thread > *:not(:first-child) {\n  margin-top: 8px;\n}\n.tox .tox-comment {\n  background: #fff;\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);\n  padding: 8px 8px 16px 8px;\n  position: relative;\n}\n.tox .tox-comment__header {\n  align-items: center;\n  color: #222f3e;\n  display: flex;\n  justify-content: space-between;\n}\n.tox .tox-comment__date {\n  color: #222f3e;\n  font-size: 12px;\n  line-height: 18px;\n}\n.tox .tox-comment__body {\n  color: #222f3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  margin-top: 8px;\n  position: relative;\n  text-transform: initial;\n}\n.tox .tox-comment__body textarea {\n  resize: none;\n  white-space: normal;\n  width: 100%;\n}\n.tox .tox-comment__expander {\n  padding-top: 8px;\n}\n.tox .tox-comment__expander p {\n  color: rgba(34, 47, 62, 0.7);\n  font-size: 14px;\n  font-style: normal;\n}\n.tox .tox-comment__body p {\n  margin: 0;\n}\n.tox .tox-comment__buttonspacing {\n  padding-top: 16px;\n  text-align: center;\n}\n.tox .tox-comment-thread__overlay::after {\n  background: #fff;\n  bottom: 0;\n  content: \"\";\n  display: flex;\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 5;\n}\n.tox .tox-comment__reply {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 8px;\n}\n.tox .tox-comment__reply > *:first-child {\n  margin-bottom: 8px;\n  width: 100%;\n}\n.tox .tox-comment__edit {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n.tox .tox-comment__gradient::after {\n  background: linear-gradient(rgba(255, 255, 255, 0), #fff);\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 5em;\n  margin-top: -40px;\n  position: absolute;\n  width: 100%;\n}\n.tox .tox-comment__overlay {\n  background: #fff;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 0;\n  z-index: 5;\n}\n.tox .tox-comment__loading-text {\n  align-items: center;\n  color: #222f3e;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.tox .tox-comment__loading-text > div {\n  padding-bottom: 16px;\n}\n.tox .tox-comment__overlaytext {\n  bottom: 0;\n  flex-direction: column;\n  font-size: 14px;\n  left: 0;\n  padding: 1em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n.tox .tox-comment__overlaytext p {\n  background-color: #fff;\n  box-shadow: 0 0 8px 8px #fff;\n  color: #222f3e;\n  text-align: center;\n}\n.tox .tox-comment__overlaytext div:nth-of-type(2) {\n  font-size: 0.8em;\n}\n.tox .tox-comment__busy-spinner {\n  align-items: center;\n  background-color: #fff;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 20;\n}\n.tox .tox-comment__scroll {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 1;\n  overflow: auto;\n}\n.tox .tox-conversations {\n  margin: 8px;\n}\n.tox:not([dir=rtl]) .tox-comment__edit {\n  margin-left: 8px;\n}\n.tox:not([dir=rtl]) .tox-comment__buttonspacing > *:last-child,\n.tox:not([dir=rtl]) .tox-comment__edit > *:last-child,\n.tox:not([dir=rtl]) .tox-comment__reply > *:last-child {\n  margin-left: 8px;\n}\n.tox[dir=rtl] .tox-comment__edit {\n  margin-right: 8px;\n}\n.tox[dir=rtl] .tox-comment__buttonspacing > *:last-child,\n.tox[dir=rtl] .tox-comment__edit > *:last-child,\n.tox[dir=rtl] .tox-comment__reply > *:last-child {\n  margin-right: 8px;\n}\n.tox .tox-user {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-user__avatar svg {\n  fill: rgba(34, 47, 62, 0.7);\n}\n.tox .tox-user__avatar img {\n  border-radius: 50%;\n  height: 36px;\n  object-fit: cover;\n  vertical-align: middle;\n  width: 36px;\n}\n.tox .tox-user__name {\n  color: #222f3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: bold;\n  line-height: 18px;\n  text-transform: none;\n}\n.tox:not([dir=rtl]) .tox-user__avatar svg,\n.tox:not([dir=rtl]) .tox-user__avatar img {\n  margin-right: 8px;\n}\n.tox:not([dir=rtl]) .tox-user__avatar + .tox-user__name {\n  margin-left: 8px;\n}\n.tox[dir=rtl] .tox-user__avatar svg,\n.tox[dir=rtl] .tox-user__avatar img {\n  margin-left: 8px;\n}\n.tox[dir=rtl] .tox-user__avatar + .tox-user__name {\n  margin-right: 8px;\n}\n.tox .tox-dialog-wrap {\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1100;\n}\n.tox .tox-dialog-wrap__backdrop {\n  background-color: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.tox .tox-dialog-wrap__backdrop--opaque {\n  background-color: #fff;\n}\n.tox .tox-dialog {\n  background-color: #fff;\n  border-color: #eeeeee;\n  border-radius: 10px;\n  border-style: solid;\n  border-width: 0px;\n  box-shadow: 0 16px 16px -10px rgba(34, 47, 62, 0.15), 0 0 40px 1px rgba(34, 47, 62, 0.15);\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n  max-width: 480px;\n  overflow: hidden;\n  position: relative;\n  width: 95vw;\n  z-index: 2;\n}\n@media only screen and (max-width: 767px ) {\n  body:not(.tox-force-desktop) .tox .tox-dialog {\n    align-self: flex-start;\n    margin: 8px auto;\n    max-height: calc(100vh - 8px * 2);\n    width: calc(100vw - 16px);\n  }\n}\n.tox .tox-dialog-inline {\n  z-index: 1100;\n}\n.tox .tox-dialog__header {\n  align-items: center;\n  background-color: #fff;\n  border-bottom: none;\n  color: #222f3e;\n  display: flex;\n  font-size: 16px;\n  justify-content: space-between;\n  padding: 8px 16px 0 16px;\n  position: relative;\n}\n.tox .tox-dialog__header .tox-button {\n  z-index: 1;\n}\n.tox .tox-dialog__draghandle {\n  cursor: grab;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.tox .tox-dialog__draghandle:active {\n  cursor: grabbing;\n}\n.tox .tox-dialog__dismiss {\n  margin-left: auto;\n}\n.tox .tox-dialog__title {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  margin: 0;\n  text-transform: none;\n}\n.tox .tox-dialog__body {\n  color: #222f3e;\n  display: flex;\n  flex: 1;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  min-width: 0;\n  text-align: left;\n  text-transform: none;\n}\n@media only screen and (max-width: 767px ) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body {\n    flex-direction: column;\n  }\n}\n.tox .tox-dialog__body-nav {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px;\n}\n@media only screen and (max-width: 767px ) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {\n    flex-direction: row;\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    padding-bottom: 0;\n  }\n}\n.tox .tox-dialog__body-nav-item {\n  border-bottom: 2px solid transparent;\n  color: rgba(34, 47, 62, 0.7);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 1.3;\n  margin-bottom: 8px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n.tox .tox-dialog__body-nav-item:focus {\n  background-color: rgba(0, 108, 231, 0.1);\n}\n.tox .tox-dialog__body-nav-item--active {\n  border-bottom: 2px solid #006ce7;\n  color: #006ce7;\n}\n.tox .tox-dialog__body-content {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  max-height: 650px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 16px 16px;\n}\n.tox .tox-dialog__body-content > * {\n  margin-bottom: 0;\n  margin-top: 16px;\n}\n.tox .tox-dialog__body-content > *:first-child {\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content > *:last-child {\n  margin-bottom: 0;\n}\n.tox .tox-dialog__body-content > *:only-child {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content a {\n  color: #006ce7;\n  cursor: pointer;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content a:hover,\n.tox .tox-dialog__body-content a:focus {\n  color: #0054b4;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content a:active {\n  color: #0054b4;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content svg {\n  fill: #222f3e;\n}\n.tox .tox-dialog__body-content ul {\n  display: block;\n  list-style-type: disc;\n  margin-bottom: 16px;\n  margin-inline-end: 0;\n  margin-inline-start: 0;\n  padding-inline-start: 2.5rem;\n}\n.tox .tox-dialog__body-content .tox-form__group h1 {\n  color: #222f3e;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  margin-bottom: 16px;\n  margin-top: 2rem;\n  text-transform: none;\n}\n.tox .tox-dialog__body-content .tox-form__group h2 {\n  color: #222f3e;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  margin-bottom: 16px;\n  margin-top: 2rem;\n  text-transform: none;\n}\n.tox .tox-dialog__body-content .tox-form__group p {\n  margin-bottom: 16px;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:first-child,\n.tox .tox-dialog__body-content .tox-form__group h2:first-child,\n.tox .tox-dialog__body-content .tox-form__group p:first-child {\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:last-child,\n.tox .tox-dialog__body-content .tox-form__group h2:last-child,\n.tox .tox-dialog__body-content .tox-form__group p:last-child {\n  margin-bottom: 0;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:only-child,\n.tox .tox-dialog__body-content .tox-form__group h2:only-child,\n.tox .tox-dialog__body-content .tox-form__group p:only-child {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.tox .tox-dialog--width-lg {\n  height: 650px;\n  max-width: 1200px;\n}\n.tox .tox-dialog--width-md {\n  max-width: 800px;\n}\n.tox .tox-dialog--width-md .tox-dialog__body-content {\n  overflow: auto;\n}\n.tox .tox-dialog__body-content--centered {\n  text-align: center;\n}\n.tox .tox-dialog__footer {\n  align-items: center;\n  background-color: #fff;\n  border-top: none;\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 16px;\n}\n.tox .tox-dialog__footer-start,\n.tox .tox-dialog__footer-end {\n  display: flex;\n}\n.tox .tox-dialog__busy-spinner {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 3;\n}\n.tox .tox-dialog__table {\n  border-collapse: collapse;\n  width: 100%;\n}\n.tox .tox-dialog__table thead th {\n  font-weight: bold;\n  padding-bottom: 8px;\n}\n.tox .tox-dialog__table tbody tr {\n  border-bottom: 1px solid #eeeeee;\n}\n.tox .tox-dialog__table tbody tr:last-child {\n  border-bottom: none;\n}\n.tox .tox-dialog__table td {\n  padding-bottom: 8px;\n  padding-top: 8px;\n}\n.tox .tox-dialog__iframe.tox-dialog__iframe--opaque {\n  background: #fff;\n}\n.tox .tox-dialog__popups {\n  position: absolute;\n  width: 100%;\n  z-index: 1100;\n}\n.tox .tox-dialog__body-iframe {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.tox .tox-dialog__body-iframe .tox-navobj {\n  display: flex;\n  flex: 1;\n}\n.tox .tox-dialog__body-iframe .tox-navobj :nth-child(2) {\n  flex: 1;\n  height: 100%;\n}\n.tox .tox-dialog-dock-fadeout {\n  opacity: 0;\n  visibility: hidden;\n}\n.tox .tox-dialog-dock-fadein {\n  opacity: 1;\n  visibility: visible;\n}\n.tox .tox-dialog-dock-transition {\n  transition: visibility 0s linear 0.3s, opacity 0.3s ease;\n}\n.tox .tox-dialog-dock-transition.tox-dialog-dock-fadein {\n  transition-delay: 0s;\n}\n@media only screen and (max-width: 767px ) {\n  body:not(.tox-force-desktop) .tox:not([dir=rtl]) .tox-dialog__body-nav {\n    margin-right: 0;\n  }\n}\n@media only screen and (max-width: 767px ) {\n  body:not(.tox-force-desktop) .tox:not([dir=rtl]) .tox-dialog__body-nav-item:not(:first-child) {\n    margin-left: 8px;\n  }\n}\n.tox:not([dir=rtl]) .tox-dialog__footer .tox-dialog__footer-start > *,\n.tox:not([dir=rtl]) .tox-dialog__footer .tox-dialog__footer-end > * {\n  margin-left: 8px;\n}\n.tox[dir=rtl] .tox-dialog__body {\n  text-align: right;\n}\n@media only screen and (max-width: 767px ) {\n  body:not(.tox-force-desktop) .tox[dir=rtl] .tox-dialog__body-nav {\n    margin-left: 0;\n  }\n}\n@media only screen and (max-width: 767px ) {\n  body:not(.tox-force-desktop) .tox[dir=rtl] .tox-dialog__body-nav-item:not(:first-child) {\n    margin-right: 8px;\n  }\n}\n.tox[dir=rtl] .tox-dialog__footer .tox-dialog__footer-start > *,\n.tox[dir=rtl] .tox-dialog__footer .tox-dialog__footer-end > * {\n  margin-right: 8px;\n}\nbody.tox-dialog__disable-scroll {\n  overflow: hidden;\n}\n.tox .tox-dropzone-container {\n  display: flex;\n  flex: 1;\n}\n.tox .tox-dropzone {\n  align-items: center;\n  background: #fff;\n  border: 2px dashed #eeeeee;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  min-height: 100px;\n  padding: 10px;\n}\n.tox .tox-dropzone p {\n  color: rgba(34, 47, 62, 0.7);\n  margin: 0 0 16px 0;\n}\n.tox .tox-edit-area {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n}\n.tox .tox-edit-area__iframe {\n  background-color: #fff;\n  border: 0;\n  box-sizing: border-box;\n  flex: 1;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.tox.tox-inline-edit-area {\n  border: 1px dotted #eeeeee;\n}\n.tox .tox-editor-container {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  overflow: hidden;\n}\n.tox .tox-editor-header {\n  display: grid;\n  grid-template-columns: 1fr min-content;\n  z-index: 1;\n}\n.tox:not(.tox-tinymce-inline) .tox-editor-header {\n  background-color: #fff;\n  border-bottom: none;\n  box-shadow: 0 2px 2px -2px rgba(34, 47, 62, 0.1), 0 8px 8px -4px rgba(34, 47, 62, 0.07);\n  padding: 4px 0;\n  transition: box-shadow 0.5s;\n}\n.tox:not(.tox-tinymce-inline).tox-tinymce--toolbar-bottom .tox-editor-header {\n  border-top: 1px solid #e3e3e3;\n  box-shadow: none;\n}\n.tox:not(.tox-tinymce-inline).tox-tinymce--toolbar-sticky-on .tox-editor-header {\n  background-color: #fff;\n  box-shadow: 0 2px 2px -2px rgba(34, 47, 62, 0.2), 0 8px 8px -4px rgba(34, 47, 62, 0.15);\n  padding: 4px 0;\n}\n.tox:not(.tox-tinymce-inline).tox-tinymce--toolbar-sticky-on.tox-tinymce--toolbar-bottom .tox-editor-header {\n  box-shadow: 0 2px 2px -2px rgba(34, 47, 62, 0.2), 0 8px 8px -4px rgba(34, 47, 62, 0.15);\n}\n.tox.tox:not(.tox-tinymce-inline) .tox-editor-header.tox-editor-header--empty {\n  background: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n.tox-editor-dock-fadeout {\n  opacity: 0;\n  visibility: hidden;\n}\n.tox-editor-dock-fadein {\n  opacity: 1;\n  visibility: visible;\n}\n.tox-editor-dock-transition {\n  transition: visibility 0s linear 0.25s, opacity 0.25s ease;\n}\n.tox-editor-dock-transition.tox-editor-dock-fadein {\n  transition-delay: 0s;\n}\n.tox .tox-control-wrap {\n  flex: 1;\n  position: relative;\n}\n.tox .tox-control-wrap:not(.tox-control-wrap--status-invalid) .tox-control-wrap__status-icon-invalid,\n.tox .tox-control-wrap:not(.tox-control-wrap--status-unknown) .tox-control-wrap__status-icon-unknown,\n.tox .tox-control-wrap:not(.tox-control-wrap--status-valid) .tox-control-wrap__status-icon-valid {\n  display: none;\n}\n.tox .tox-control-wrap svg {\n  display: block;\n}\n.tox .tox-control-wrap__status-icon-wrap {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-control-wrap__status-icon-invalid svg {\n  fill: #c00;\n}\n.tox .tox-control-wrap__status-icon-unknown svg {\n  fill: orange;\n}\n.tox .tox-control-wrap__status-icon-valid svg {\n  fill: green;\n}\n.tox:not([dir=rtl]) .tox-control-wrap--status-invalid .tox-textfield,\n.tox:not([dir=rtl]) .tox-control-wrap--status-unknown .tox-textfield,\n.tox:not([dir=rtl]) .tox-control-wrap--status-valid .tox-textfield {\n  padding-right: 32px;\n}\n.tox:not([dir=rtl]) .tox-control-wrap__status-icon-wrap {\n  right: 4px;\n}\n.tox[dir=rtl] .tox-control-wrap--status-invalid .tox-textfield,\n.tox[dir=rtl] .tox-control-wrap--status-unknown .tox-textfield,\n.tox[dir=rtl] .tox-control-wrap--status-valid .tox-textfield {\n  padding-left: 32px;\n}\n.tox[dir=rtl] .tox-control-wrap__status-icon-wrap {\n  left: 4px;\n}\n.tox .tox-autocompleter {\n  max-width: 25em;\n}\n.tox .tox-autocompleter .tox-menu {\n  box-sizing: border-box;\n  max-width: 25em;\n}\n.tox .tox-autocompleter .tox-autocompleter-highlight {\n  font-weight: bold;\n}\n.tox .tox-color-input {\n  display: flex;\n  position: relative;\n  z-index: 1;\n}\n.tox .tox-color-input .tox-textfield {\n  z-index: -1;\n}\n.tox .tox-color-input span {\n  border-color: rgba(34, 47, 62, 0.2);\n  border-radius: 6px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  height: 24px;\n  position: absolute;\n  top: 6px;\n  width: 24px;\n}\n.tox .tox-color-input span:hover:not([aria-disabled=true]),\n.tox .tox-color-input span:focus:not([aria-disabled=true]) {\n  border-color: #006ce7;\n  cursor: pointer;\n}\n.tox .tox-color-input span::before {\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(-45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%), linear-gradient(-45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%);\n  background-position: 0 0, 0 6px, 6px -6px, -6px 0;\n  background-size: 12px 12px;\n  border: 1px solid #fff;\n  border-radius: 6px;\n  box-sizing: border-box;\n  content: '';\n  height: 24px;\n  left: -1px;\n  position: absolute;\n  top: -1px;\n  width: 24px;\n  z-index: -1;\n}\n.tox .tox-color-input span[aria-disabled=true] {\n  cursor: not-allowed;\n}\n.tox:not([dir=rtl]) .tox-color-input {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox:not([dir=rtl]) .tox-color-input .tox-textfield {\n  padding-left: 36px;\n}\n.tox:not([dir=rtl]) .tox-color-input span {\n  left: 6px;\n}\n.tox[dir=\"rtl\"] .tox-color-input {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox[dir=\"rtl\"] .tox-color-input .tox-textfield {\n  padding-right: 36px;\n}\n.tox[dir=\"rtl\"] .tox-color-input span {\n  right: 6px;\n}\n.tox .tox-label,\n.tox .tox-toolbar-label {\n  color: rgba(34, 47, 62, 0.7);\n  display: block;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  padding: 0 8px 0 0;\n  text-transform: none;\n  white-space: nowrap;\n}\n.tox .tox-toolbar-label {\n  padding: 0 8px;\n}\n.tox[dir=rtl] .tox-label {\n  padding: 0 0 0 8px;\n}\n.tox .tox-form {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.tox .tox-form__group {\n  box-sizing: border-box;\n  margin-bottom: 4px;\n}\n.tox .tox-form-group--maximize {\n  flex: 1;\n}\n.tox .tox-form__group--error {\n  color: #c00;\n}\n.tox .tox-form__group--collection {\n  display: flex;\n}\n.tox .tox-form__grid {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.tox .tox-form__grid--2col > .tox-form__group {\n  width: calc(50% - (8px / 2));\n}\n.tox .tox-form__grid--3col > .tox-form__group {\n  width: calc(100% / 3 - (8px / 2));\n}\n.tox .tox-form__grid--4col > .tox-form__group {\n  width: calc(25% - (8px / 2));\n}\n.tox .tox-form__controls-h-stack {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-form__group--inline {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-form__group--stretched {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.tox .tox-form__group--stretched .tox-textarea {\n  flex: 1;\n}\n.tox .tox-form__group--stretched .tox-navobj {\n  display: flex;\n  flex: 1;\n}\n.tox .tox-form__group--stretched .tox-navobj :nth-child(2) {\n  flex: 1;\n  height: 100%;\n}\n.tox:not([dir=rtl]) .tox-form__controls-h-stack > *:not(:first-child) {\n  margin-left: 4px;\n}\n.tox[dir=rtl] .tox-form__controls-h-stack > *:not(:first-child) {\n  margin-right: 4px;\n}\n.tox .tox-lock.tox-locked .tox-lock-icon__unlock,\n.tox .tox-lock:not(.tox-locked) .tox-lock-icon__lock {\n  display: none;\n}\n.tox .tox-textfield,\n.tox .tox-toolbar-textfield,\n.tox .tox-listboxfield .tox-listbox--select,\n.tox .tox-textarea {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: #fff;\n  border-color: #eeeeee;\n  border-radius: 6px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #222f3e;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  min-height: 34px;\n  outline: none;\n  padding: 5px 5.5px;\n  resize: none;\n  width: 100%;\n}\n.tox .tox-textfield[disabled],\n.tox .tox-textarea[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-textfield:focus,\n.tox .tox-listboxfield .tox-listbox--select:focus,\n.tox .tox-textarea:focus {\n  background-color: #fff;\n  border-color: #006ce7;\n  box-shadow: 0 0 0 2px rgba(0, 108, 231, 0.25);\n  outline: none;\n}\n.tox .tox-toolbar-textfield {\n  border-width: 0;\n  margin-bottom: 3px;\n  margin-top: 2px;\n  max-width: 250px;\n}\n.tox .tox-naked-btn {\n  background-color: transparent;\n  border: 0;\n  border-color: transparent;\n  box-shadow: unset;\n  color: #006ce7;\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.tox .tox-naked-btn svg {\n  display: block;\n  fill: #222f3e;\n}\n.tox:not([dir=rtl]) .tox-toolbar-textfield + * {\n  margin-left: 4px;\n}\n.tox[dir=rtl] .tox-toolbar-textfield + * {\n  margin-right: 4px;\n}\n.tox .tox-listboxfield {\n  cursor: pointer;\n  position: relative;\n}\n.tox .tox-listboxfield .tox-listbox--select[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-listbox__select-label {\n  cursor: default;\n  flex: 1;\n  margin: 0 4px;\n}\n.tox .tox-listbox__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n}\n.tox .tox-listbox__select-chevron svg {\n  fill: #222f3e;\n}\n.tox .tox-listboxfield .tox-listbox--select {\n  align-items: center;\n  display: flex;\n}\n.tox:not([dir=rtl]) .tox-listboxfield svg {\n  right: 8px;\n}\n.tox[dir=rtl] .tox-listboxfield svg {\n  left: 8px;\n}\n.tox .tox-selectfield {\n  cursor: pointer;\n  position: relative;\n}\n.tox .tox-selectfield select {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: #fff;\n  border-color: #eeeeee;\n  border-radius: 6px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #222f3e;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  min-height: 34px;\n  outline: none;\n  padding: 5px 5.5px;\n  resize: none;\n  width: 100%;\n}\n.tox .tox-selectfield select[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-selectfield select::-ms-expand {\n  display: none;\n}\n.tox .tox-selectfield select:focus {\n  background-color: #fff;\n  border-color: #006ce7;\n  box-shadow: 0 0 0 2px rgba(0, 108, 231, 0.25);\n  outline: none;\n}\n.tox .tox-selectfield svg {\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox:not([dir=rtl]) .tox-selectfield select[size=\"0\"],\n.tox:not([dir=rtl]) .tox-selectfield select[size=\"1\"] {\n  padding-right: 24px;\n}\n.tox:not([dir=rtl]) .tox-selectfield svg {\n  right: 8px;\n}\n.tox[dir=rtl] .tox-selectfield select[size=\"0\"],\n.tox[dir=rtl] .tox-selectfield select[size=\"1\"] {\n  padding-left: 24px;\n}\n.tox[dir=rtl] .tox-selectfield svg {\n  left: 8px;\n}\n.tox .tox-textarea {\n  -webkit-appearance: textarea;\n     -moz-appearance: textarea;\n          appearance: textarea;\n  white-space: pre-wrap;\n}\n.tox-fullscreen {\n  border: 0;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  overscroll-behavior: none;\n  padding: 0;\n  touch-action: pinch-zoom;\n  width: 100%;\n}\n.tox.tox-tinymce.tox-fullscreen .tox-statusbar__resize-handle {\n  display: none;\n}\n.tox.tox-tinymce.tox-fullscreen,\n.tox-shadowhost.tox-fullscreen {\n  left: 0;\n  position: fixed;\n  top: 0;\n  z-index: 1200;\n}\n.tox.tox-tinymce.tox-fullscreen {\n  background-color: transparent;\n}\n.tox-fullscreen .tox.tox-tinymce-aux,\n.tox-fullscreen ~ .tox.tox-tinymce-aux {\n  z-index: 1201;\n}\n.tox .tox-help__more-link {\n  list-style: none;\n  margin-top: 1em;\n}\n.tox .tox-imagepreview {\n  background-color: #666;\n  height: 380px;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.tox .tox-imagepreview.tox-imagepreview__loaded {\n  overflow: auto;\n}\n.tox .tox-imagepreview__container {\n  display: flex;\n  left: 100vw;\n  position: absolute;\n  top: 100vw;\n}\n.tox .tox-imagepreview__image {\n  background: url(data:image/gif;base64,R0lGODdhDAAMAIABAMzMzP///ywAAAAADAAMAAACFoQfqYeabNyDMkBQb81Uat85nxguUAEAOw==);\n}\n.tox .tox-image-tools .tox-spacer {\n  flex: 1;\n}\n.tox .tox-image-tools .tox-bar {\n  align-items: center;\n  display: flex;\n  height: 60px;\n  justify-content: center;\n}\n.tox .tox-image-tools .tox-imagepreview,\n.tox .tox-image-tools .tox-imagepreview + .tox-bar {\n  margin-top: 8px;\n}\n.tox .tox-image-tools .tox-croprect-block {\n  background: black;\n  filter: alpha(opacity=50);\n  opacity: 0.5;\n  position: absolute;\n  zoom: 1;\n}\n.tox .tox-image-tools .tox-croprect-handle {\n  border: 2px solid white;\n  height: 20px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 20px;\n}\n.tox .tox-image-tools .tox-croprect-handle-move {\n  border: 0;\n  cursor: move;\n  position: absolute;\n}\n.tox .tox-image-tools .tox-croprect-handle-nw {\n  border-width: 2px 0 0 2px;\n  cursor: nw-resize;\n  left: 100px;\n  margin: -2px 0 0 -2px;\n  top: 100px;\n}\n.tox .tox-image-tools .tox-croprect-handle-ne {\n  border-width: 2px 2px 0 0;\n  cursor: ne-resize;\n  left: 200px;\n  margin: -2px 0 0 -20px;\n  top: 100px;\n}\n.tox .tox-image-tools .tox-croprect-handle-sw {\n  border-width: 0 0 2px 2px;\n  cursor: sw-resize;\n  left: 100px;\n  margin: -20px 2px 0 -2px;\n  top: 200px;\n}\n.tox .tox-image-tools .tox-croprect-handle-se {\n  border-width: 0 2px 2px 0;\n  cursor: se-resize;\n  left: 200px;\n  margin: -20px 0 0 -20px;\n  top: 200px;\n}\n.tox .tox-insert-table-picker {\n  display: flex;\n  flex-wrap: wrap;\n  width: 170px;\n}\n.tox .tox-insert-table-picker > div {\n  border-color: #eeeeee;\n  border-style: solid;\n  border-width: 0 1px 1px 0;\n  box-sizing: border-box;\n  height: 17px;\n  width: 17px;\n}\n.tox .tox-collection--list .tox-collection__group .tox-insert-table-picker {\n  margin: -4px -4px;\n}\n.tox .tox-insert-table-picker .tox-insert-table-picker__selected {\n  background-color: rgba(0, 108, 231, 0.5);\n  border-color: rgba(0, 108, 231, 0.5);\n}\n.tox .tox-insert-table-picker__label {\n  color: rgba(34, 47, 62, 0.7);\n  display: block;\n  font-size: 14px;\n  padding: 4px;\n  text-align: center;\n  width: 100%;\n}\n.tox:not([dir=rtl]) {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox:not([dir=rtl]) .tox-insert-table-picker > div:nth-child(10n) {\n  border-right: 0;\n}\n.tox[dir=rtl] {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox[dir=rtl] .tox-insert-table-picker > div:nth-child(10n+1) {\n  border-right: 0;\n}\n.tox {\n  /* stylelint-disable */\n  /* stylelint-enable */\n}\n.tox .tox-menu {\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: top;\n  z-index: 1150;\n}\n.tox .tox-menu.tox-collection.tox-collection--list {\n  padding: 0 4px;\n}\n.tox .tox-menu.tox-collection.tox-collection--toolbar {\n  padding: 8px;\n}\n.tox .tox-menu.tox-collection.tox-collection--grid {\n  padding: 8px;\n}\n@media only screen and (min-width: 768px ) {\n  .tox .tox-menu .tox-collection__item-label {\n    overflow-wrap: break-word;\n    word-break: normal;\n  }\n}\n.tox .tox-menu__label h1,\n.tox .tox-menu__label h2,\n.tox .tox-menu__label h3,\n.tox .tox-menu__label h4,\n.tox .tox-menu__label h5,\n.tox .tox-menu__label h6,\n.tox .tox-menu__label p,\n.tox .tox-menu__label blockquote,\n.tox .tox-menu__label code {\n  margin: 0;\n}\n.tox .tox-menubar {\n  background: repeating-linear-gradient(transparent 0px 1px, transparent 1px 39px) center top 39px / 100% calc(100% - 39px) no-repeat;\n  background-color: #fff;\n  display: flex;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  grid-column: 1 / -1;\n  grid-row: 1;\n  padding: 0 11px 0 12px;\n}\n.tox .tox-promotion + .tox-menubar {\n  grid-column: 1;\n}\n.tox .tox-promotion {\n  background: repeating-linear-gradient(transparent 0px 1px, transparent 1px 39px) center top 39px / 100% calc(100% - 39px) no-repeat;\n  background-color: #fff;\n  grid-column: 2;\n  grid-row: 1;\n  padding-inline-end: 8px;\n  padding-inline-start: 4px;\n  padding-top: 5px;\n}\n.tox .tox-promotion-link {\n  align-items: unsafe center;\n  background-color: #E8F1F8;\n  border-radius: 5px;\n  color: #086BE6;\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  height: 26.6px;\n  padding: 4px 8px;\n  white-space: nowrap;\n}\n.tox .tox-promotion-link:hover {\n  background-color: #B4D7FF;\n}\n.tox .tox-promotion-link:focus {\n  background-color: #D9EDF7;\n}\n/* Deprecated. Remove in next major release */\n.tox .tox-mbtn {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 3px;\n  box-shadow: none;\n  color: #222f3e;\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  height: 28px;\n  justify-content: center;\n  margin: 5px 1px 6px 0;\n  outline: none;\n  overflow: hidden;\n  padding: 0 4px;\n  text-transform: none;\n  width: auto;\n}\n.tox .tox-mbtn[disabled] {\n  background-color: transparent;\n  border: 0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-mbtn:focus:not(:disabled) {\n  background: #cce2fa;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-mbtn--active {\n  background: #a6ccf7;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {\n  background: #cce2fa;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-mbtn__select-label {\n  cursor: default;\n  font-weight: normal;\n  margin: 0 4px;\n}\n.tox .tox-mbtn[disabled] .tox-mbtn__select-label {\n  cursor: not-allowed;\n}\n.tox .tox-mbtn__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n  display: none;\n}\n.tox .tox-notification {\n  border-radius: 6px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  display: grid;\n  font-size: 14px;\n  font-weight: normal;\n  grid-template-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);\n  margin-top: 4px;\n  opacity: 0;\n  padding: 4px;\n  transition: transform 100ms ease-in, opacity 150ms ease-in;\n}\n.tox .tox-notification p {\n  font-size: 14px;\n  font-weight: normal;\n}\n.tox .tox-notification a {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.tox .tox-notification--in {\n  opacity: 1;\n}\n.tox .tox-notification--success {\n  background-color: #e4eeda;\n  border-color: #d7e6c8;\n  color: #222f3e;\n}\n.tox .tox-notification--success p {\n  color: #222f3e;\n}\n.tox .tox-notification--success a {\n  color: #517342;\n}\n.tox .tox-notification--success svg {\n  fill: #222f3e;\n}\n.tox .tox-notification--error {\n  background-color: #f5cccc;\n  border-color: #f0b3b3;\n  color: #222f3e;\n}\n.tox .tox-notification--error p {\n  color: #222f3e;\n}\n.tox .tox-notification--error a {\n  color: #77181f;\n}\n.tox .tox-notification--error svg {\n  fill: #222f3e;\n}\n.tox .tox-notification--warn,\n.tox .tox-notification--warning {\n  background-color: #fff5cc;\n  border-color: #fff0b3;\n  color: #222f3e;\n}\n.tox .tox-notification--warn p,\n.tox .tox-notification--warning p {\n  color: #222f3e;\n}\n.tox .tox-notification--warn a,\n.tox .tox-notification--warning a {\n  color: #7a6e25;\n}\n.tox .tox-notification--warn svg,\n.tox .tox-notification--warning svg {\n  fill: #222f3e;\n}\n.tox .tox-notification--info {\n  background-color: #d6e7fb;\n  border-color: #c1dbf9;\n  color: #222f3e;\n}\n.tox .tox-notification--info p {\n  color: #222f3e;\n}\n.tox .tox-notification--info a {\n  color: #2a64a6;\n}\n.tox .tox-notification--info svg {\n  fill: #222f3e;\n}\n.tox .tox-notification__body {\n  align-self: center;\n  color: #222f3e;\n  font-size: 14px;\n  grid-column-end: 3;\n  grid-column-start: 2;\n  grid-row-end: 2;\n  grid-row-start: 1;\n  text-align: center;\n  white-space: normal;\n  word-break: break-all;\n  word-break: break-word;\n}\n.tox .tox-notification__body > * {\n  margin: 0;\n}\n.tox .tox-notification__body > * + * {\n  margin-top: 1rem;\n}\n.tox .tox-notification__icon {\n  align-self: center;\n  grid-column-end: 2;\n  grid-column-start: 1;\n  grid-row-end: 2;\n  grid-row-start: 1;\n  justify-self: end;\n}\n.tox .tox-notification__icon svg {\n  display: block;\n}\n.tox .tox-notification__dismiss {\n  align-self: start;\n  grid-column-end: 4;\n  grid-column-start: 3;\n  grid-row-end: 2;\n  grid-row-start: 1;\n  justify-self: end;\n}\n.tox .tox-notification .tox-progress-bar {\n  grid-column-end: 4;\n  grid-column-start: 1;\n  grid-row-end: 3;\n  grid-row-start: 2;\n  justify-self: center;\n}\n.tox .tox-pop {\n  display: inline-block;\n  position: relative;\n}\n.tox .tox-pop--resizing {\n  transition: width 0.1s ease;\n}\n.tox .tox-pop--resizing .tox-toolbar,\n.tox .tox-pop--resizing .tox-toolbar__group {\n  flex-wrap: nowrap;\n}\n.tox .tox-pop--transition {\n  transition: 0.15s ease;\n  transition-property: left, right, top, bottom;\n}\n.tox .tox-pop--transition::before,\n.tox .tox-pop--transition::after {\n  transition: all 0.15s, visibility 0s, opacity 0.075s ease 0.075s;\n}\n.tox .tox-pop__dialog {\n  background-color: #fff;\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);\n  min-width: 0;\n  overflow: hidden;\n}\n.tox .tox-pop__dialog > *:not(.tox-toolbar) {\n  margin: 4px 4px 4px 8px;\n}\n.tox .tox-pop__dialog .tox-toolbar {\n  background-color: transparent;\n  margin-bottom: -1px;\n}\n.tox .tox-pop::before,\n.tox .tox-pop::after {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  opacity: 1;\n  position: absolute;\n  width: 0;\n}\n.tox .tox-pop.tox-pop--inset::before,\n.tox .tox-pop.tox-pop--inset::after {\n  opacity: 0;\n  transition: all 0s 0.15s, visibility 0s, opacity 0.075s ease;\n}\n.tox .tox-pop.tox-pop--bottom::before,\n.tox .tox-pop.tox-pop--bottom::after {\n  left: 50%;\n  top: 100%;\n}\n.tox .tox-pop.tox-pop--bottom::after {\n  border-color: #fff transparent transparent transparent;\n  border-width: 8px;\n  margin-left: -8px;\n  margin-top: -1px;\n}\n.tox .tox-pop.tox-pop--bottom::before {\n  border-color: #eeeeee transparent transparent transparent;\n  border-width: 9px;\n  margin-left: -9px;\n}\n.tox .tox-pop.tox-pop--top::before,\n.tox .tox-pop.tox-pop--top::after {\n  left: 50%;\n  top: 0;\n  transform: translateY(-100%);\n}\n.tox .tox-pop.tox-pop--top::after {\n  border-color: transparent transparent #fff transparent;\n  border-width: 8px;\n  margin-left: -8px;\n  margin-top: 1px;\n}\n.tox .tox-pop.tox-pop--top::before {\n  border-color: transparent transparent #eeeeee transparent;\n  border-width: 9px;\n  margin-left: -9px;\n}\n.tox .tox-pop.tox-pop--left::before,\n.tox .tox-pop.tox-pop--left::after {\n  left: 0;\n  top: calc(50% - 1px);\n  transform: translateY(-50%);\n}\n.tox .tox-pop.tox-pop--left::after {\n  border-color: transparent #fff transparent transparent;\n  border-width: 8px;\n  margin-left: -15px;\n}\n.tox .tox-pop.tox-pop--left::before {\n  border-color: transparent #eeeeee transparent transparent;\n  border-width: 10px;\n  margin-left: -19px;\n}\n.tox .tox-pop.tox-pop--right::before,\n.tox .tox-pop.tox-pop--right::after {\n  left: 100%;\n  top: calc(50% + 1px);\n  transform: translateY(-50%);\n}\n.tox .tox-pop.tox-pop--right::after {\n  border-color: transparent transparent transparent #fff;\n  border-width: 8px;\n  margin-left: -1px;\n}\n.tox .tox-pop.tox-pop--right::before {\n  border-color: transparent transparent transparent #eeeeee;\n  border-width: 10px;\n  margin-left: -1px;\n}\n.tox .tox-pop.tox-pop--align-left::before,\n.tox .tox-pop.tox-pop--align-left::after {\n  left: 20px;\n}\n.tox .tox-pop.tox-pop--align-right::before,\n.tox .tox-pop.tox-pop--align-right::after {\n  left: calc(100% - 20px);\n}\n.tox .tox-sidebar-wrap {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  min-height: 0;\n}\n.tox .tox-sidebar {\n  background-color: #fff;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.tox .tox-sidebar__slider {\n  display: flex;\n  overflow: hidden;\n}\n.tox .tox-sidebar__pane-container {\n  display: flex;\n}\n.tox .tox-sidebar__pane {\n  display: flex;\n}\n.tox .tox-sidebar--sliding-closed {\n  opacity: 0;\n}\n.tox .tox-sidebar--sliding-open {\n  opacity: 1;\n}\n.tox .tox-sidebar--sliding-growing,\n.tox .tox-sidebar--sliding-shrinking {\n  transition: width 0.5s ease, opacity 0.5s ease;\n}\n.tox .tox-selector {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  display: inline-block;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n}\n.tox.tox-platform-touch .tox-selector {\n  height: 12px;\n  width: 12px;\n}\n.tox .tox-slider {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  height: 24px;\n  justify-content: center;\n  position: relative;\n}\n.tox .tox-slider__rail {\n  background-color: transparent;\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  height: 10px;\n  min-width: 120px;\n  width: 100%;\n}\n.tox .tox-slider__handle {\n  background-color: #006ce7;\n  border: 2px solid #0054b4;\n  border-radius: 6px;\n  box-shadow: none;\n  height: 24px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 14px;\n}\n.tox .tox-form__controls-h-stack > .tox-slider:not(:first-of-type) {\n  margin-inline-start: 8px;\n}\n.tox .tox-form__controls-h-stack > .tox-form__group + .tox-slider {\n  margin-inline-start: 32px;\n}\n.tox .tox-form__controls-h-stack > .tox-slider + .tox-form__group {\n  margin-inline-start: 32px;\n}\n.tox .tox-source-code {\n  overflow: auto;\n}\n.tox .tox-spinner {\n  display: flex;\n}\n.tox .tox-spinner > div {\n  animation: tam-bouncing-dots 1.5s ease-in-out 0s infinite both;\n  background-color: rgba(34, 47, 62, 0.7);\n  border-radius: 100%;\n  height: 8px;\n  width: 8px;\n}\n.tox .tox-spinner > div:nth-child(1) {\n  animation-delay: -0.32s;\n}\n.tox .tox-spinner > div:nth-child(2) {\n  animation-delay: -0.16s;\n}\n@keyframes tam-bouncing-dots {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n.tox:not([dir=rtl]) .tox-spinner > div:not(:first-child) {\n  margin-left: 4px;\n}\n.tox[dir=rtl] .tox-spinner > div:not(:first-child) {\n  margin-right: 4px;\n}\n.tox .tox-statusbar {\n  align-items: center;\n  background-color: #fff;\n  border-top: 1px solid #e3e3e3;\n  color: rgba(34, 47, 62, 0.7);\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-weight: normal;\n  height: 25px;\n  overflow: hidden;\n  padding: 0 8px;\n  position: relative;\n  text-transform: none;\n}\n.tox .tox-statusbar__text-container {\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n.tox .tox-statusbar__path {\n  display: flex;\n  flex: 1 1 auto;\n  margin-right: auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.tox .tox-statusbar__path > * {\n  display: inline;\n  white-space: nowrap;\n}\n.tox .tox-statusbar__wordcount {\n  flex: 0 0 auto;\n  margin-left: 1ch;\n}\n.tox .tox-statusbar a,\n.tox .tox-statusbar__path-item,\n.tox .tox-statusbar__wordcount {\n  color: rgba(34, 47, 62, 0.7);\n  text-decoration: none;\n}\n.tox .tox-statusbar a:hover:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__path-item:hover:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__wordcount:hover:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar a:focus:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__path-item:focus:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__wordcount:focus:not(:disabled):not([aria-disabled=true]) {\n  color: #222f3e;\n  cursor: pointer;\n}\n.tox .tox-statusbar__branding svg {\n  fill: rgba(34, 47, 62, 0.8);\n  height: 1.14em;\n  vertical-align: -0.28em;\n  width: 3.6em;\n}\n.tox .tox-statusbar__branding a:hover:not(:disabled):not([aria-disabled=true]) svg,\n.tox .tox-statusbar__branding a:focus:not(:disabled):not([aria-disabled=true]) svg {\n  fill: #222f3e;\n}\n.tox .tox-statusbar__resize-handle {\n  align-items: flex-end;\n  align-self: stretch;\n  cursor: nwse-resize;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  margin-left: auto;\n  margin-right: -8px;\n  padding-bottom: 3px;\n  padding-left: 1ch;\n  padding-right: 3px;\n}\n.tox .tox-statusbar__resize-handle svg {\n  display: block;\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-statusbar__resize-handle:focus svg {\n  background-color: #dee0e2;\n  border-radius: 1px 1px 5px 1px;\n  box-shadow: 0 0 0 2px #dee0e2;\n}\n.tox:not([dir=rtl]) .tox-statusbar__path > * {\n  margin-right: 4px;\n}\n.tox:not([dir=rtl]) .tox-statusbar__branding {\n  margin-left: 2ch;\n}\n.tox[dir=rtl] .tox-statusbar {\n  flex-direction: row-reverse;\n}\n.tox[dir=rtl] .tox-statusbar__path > * {\n  margin-left: 4px;\n}\n.tox .tox-throbber {\n  z-index: 1299;\n}\n.tox .tox-throbber__busy-spinner {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.6);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.tox .tox-tbtn {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 3px;\n  box-shadow: none;\n  color: #222f3e;\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  height: 28px;\n  justify-content: center;\n  margin: 6px 1px 5px 0;\n  outline: none;\n  overflow: hidden;\n  padding: 0;\n  text-transform: none;\n  width: 34px;\n}\n.tox .tox-tbtn svg {\n  display: block;\n  fill: #222f3e;\n}\n.tox .tox-tbtn.tox-tbtn-more {\n  padding-left: 5px;\n  padding-right: 5px;\n  width: inherit;\n}\n.tox .tox-tbtn:focus {\n  background: #cce2fa;\n  border: 0;\n  box-shadow: none;\n}\n.tox .tox-tbtn:hover {\n  background: #cce2fa;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-tbtn:hover svg {\n  fill: #222f3e;\n}\n.tox .tox-tbtn:active {\n  background: #a6ccf7;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-tbtn:active svg {\n  fill: #222f3e;\n}\n.tox .tox-tbtn--disabled,\n.tox .tox-tbtn--disabled:hover,\n.tox .tox-tbtn:disabled,\n.tox .tox-tbtn:disabled:hover {\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-tbtn--disabled svg,\n.tox .tox-tbtn--disabled:hover svg,\n.tox .tox-tbtn:disabled svg,\n.tox .tox-tbtn:disabled:hover svg {\n  /* stylelint-disable-line no-descending-specificity */\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-tbtn--enabled,\n.tox .tox-tbtn--enabled:hover {\n  background: #a6ccf7;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-tbtn--enabled > *,\n.tox .tox-tbtn--enabled:hover > * {\n  transform: none;\n}\n.tox .tox-tbtn--enabled svg,\n.tox .tox-tbtn--enabled:hover svg {\n  /* stylelint-disable-line no-descending-specificity */\n  fill: #222f3e;\n}\n.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) {\n  color: #222f3e;\n}\n.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) svg {\n  fill: #222f3e;\n}\n.tox .tox-tbtn:active > * {\n  transform: none;\n}\n.tox .tox-tbtn--md {\n  height: 42px;\n  width: 51px;\n}\n.tox .tox-tbtn--lg {\n  flex-direction: column;\n  height: 56px;\n  width: 68px;\n}\n.tox .tox-tbtn--return {\n  align-self: stretch;\n  height: unset;\n  width: 16px;\n}\n.tox .tox-tbtn--labeled {\n  padding: 0 4px;\n  width: unset;\n}\n.tox .tox-tbtn__vlabel {\n  display: block;\n  font-size: 10px;\n  font-weight: normal;\n  letter-spacing: -0.025em;\n  margin-bottom: 4px;\n  white-space: nowrap;\n}\n.tox .tox-tbtn--select {\n  margin: 6px 1px 5px 0;\n  padding: 0 4px;\n  width: auto;\n}\n.tox .tox-tbtn__select-label {\n  cursor: default;\n  font-weight: normal;\n  margin: 0 4px;\n}\n.tox .tox-tbtn__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n}\n.tox .tox-tbtn__select-chevron svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-tbtn--bespoke {\n  background: #f7f7f7;\n}\n.tox .tox-tbtn--bespoke + .tox-tbtn--bespoke {\n  margin-inline-start: 4px;\n}\n.tox .tox-tbtn--bespoke .tox-tbtn__select-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 7em;\n}\n.tox .tox-split-button {\n  border: 0;\n  border-radius: 3px;\n  box-sizing: border-box;\n  display: flex;\n  margin: 6px 1px 5px 0;\n  overflow: hidden;\n}\n.tox .tox-split-button:hover {\n  box-shadow: 0 0 0 1px #cce2fa inset;\n}\n.tox .tox-split-button:focus {\n  background: #cce2fa;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-split-button > * {\n  border-radius: 0;\n}\n.tox .tox-split-button__chevron {\n  width: 16px;\n}\n.tox .tox-split-button__chevron svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-split-button .tox-tbtn {\n  margin: 0;\n}\n.tox .tox-split-button.tox-tbtn--disabled:hover,\n.tox .tox-split-button.tox-tbtn--disabled:focus,\n.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:hover,\n.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:focus {\n  background: transparent;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n}\n.tox.tox-platform-touch .tox-split-button .tox-tbtn--select {\n  padding: 0 0px;\n}\n.tox.tox-platform-touch .tox-split-button .tox-tbtn:not(.tox-tbtn--select):first-child {\n  width: 30px;\n}\n.tox.tox-platform-touch .tox-split-button__chevron {\n  width: 20px;\n}\n.tox .tox-toolbar-overlord {\n  background-color: #fff;\n}\n.tox .tox-toolbar,\n.tox .tox-toolbar__primary,\n.tox .tox-toolbar__overflow {\n  background-attachment: local;\n  background-color: #fff;\n  background-image: repeating-linear-gradient(#e3e3e3 0px 1px, transparent 1px 39px);\n  background-position: center top 40px;\n  background-repeat: no-repeat;\n  background-size: calc(100% - 11px * 2) calc(100% - 41px);\n  display: flex;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  padding: 0 0px;\n  transform: perspective(1px);\n}\n.tox .tox-toolbar-overlord > .tox-toolbar,\n.tox .tox-toolbar-overlord > .tox-toolbar__primary,\n.tox .tox-toolbar-overlord > .tox-toolbar__overflow {\n  background-position: center top 0px;\n  background-size: calc(100% - 11px * 2) calc(100% - 0px);\n}\n.tox .tox-toolbar__overflow.tox-toolbar__overflow--closed {\n  height: 0;\n  opacity: 0;\n  padding-bottom: 0;\n  padding-top: 0;\n  visibility: hidden;\n}\n.tox .tox-toolbar__overflow--growing {\n  transition: height 0.3s ease, opacity 0.2s linear 0.1s;\n}\n.tox .tox-toolbar__overflow--shrinking {\n  transition: opacity 0.3s ease, height 0.2s linear 0.1s, visibility 0s linear 0.3s;\n}\n.tox .tox-toolbar-overlord,\n.tox .tox-anchorbar {\n  grid-column: 1 / -1;\n}\n.tox .tox-menubar + .tox-toolbar,\n.tox .tox-menubar + .tox-toolbar-overlord {\n  border-top: 1px solid transparent;\n  margin-top: -1px;\n  padding-bottom: 1px;\n  padding-top: 1px;\n}\n.tox .tox-toolbar--scrolling {\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n.tox .tox-pop .tox-toolbar {\n  border-width: 0;\n}\n.tox .tox-toolbar--no-divider {\n  background-image: none;\n}\n.tox .tox-toolbar-overlord .tox-toolbar:not(.tox-toolbar--scrolling):first-child,\n.tox .tox-toolbar-overlord .tox-toolbar__primary {\n  background-position: center top 39px;\n}\n.tox .tox-editor-header > .tox-toolbar--scrolling,\n.tox .tox-toolbar-overlord .tox-toolbar--scrolling:first-child {\n  background-image: none;\n}\n.tox.tox-tinymce-aux .tox-toolbar__overflow {\n  background-color: #fff;\n  background-position: center top 43px;\n  background-size: calc(100% - 8px * 2) calc(100% - 51px);\n  border: none;\n  border-radius: 6px;\n  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);\n  overscroll-behavior: none;\n  padding: 4px 0;\n}\n.tox-pop .tox-pop__dialog {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox-pop .tox-pop__dialog .tox-toolbar {\n  background-position: center top 43px;\n  background-size: calc(100% - 11px * 2) calc(100% - 51px);\n  padding: 4px 0;\n}\n.tox .tox-toolbar__group {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 0;\n  padding: 0 11px 0 12px;\n}\n.tox .tox-toolbar__group--pull-right {\n  margin-left: auto;\n}\n.tox .tox-toolbar--scrolling .tox-toolbar__group {\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n}\n.tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {\n  border-right: 1px solid transparent;\n}\n.tox[dir=rtl] .tox-toolbar__group:not(:last-of-type) {\n  border-left: 1px solid transparent;\n}\n.tox .tox-tooltip {\n  display: inline-block;\n  padding: 8px;\n  position: relative;\n}\n.tox .tox-tooltip__body {\n  background-color: #222f3e;\n  border-radius: 6px;\n  box-shadow: 0 2px 4px rgba(34, 47, 62, 0.3);\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  padding: 4px 8px;\n  text-transform: none;\n}\n.tox .tox-tooltip__arrow {\n  position: absolute;\n}\n.tox .tox-tooltip--down .tox-tooltip__arrow {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #222f3e;\n  bottom: 0;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n}\n.tox .tox-tooltip--up .tox-tooltip__arrow {\n  border-bottom: 8px solid #222f3e;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  left: 50%;\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n}\n.tox .tox-tooltip--right .tox-tooltip__arrow {\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid #222f3e;\n  border-top: 8px solid transparent;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-tooltip--left .tox-tooltip__arrow {\n  border-bottom: 8px solid transparent;\n  border-right: 8px solid #222f3e;\n  border-top: 8px solid transparent;\n  left: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-view-wrap,\n.tox .tox-view-wrap__slot-container {\n  background-color: #fff;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.tox .tox-view {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.tox .tox-view__header {\n  align-items: center;\n  display: flex;\n  font-size: 16px;\n  justify-content: space-between;\n  padding: 8px 8px 0 8px;\n  position: relative;\n}\n.tox .tox-view__header-start,\n.tox .tox-view__header-end {\n  display: flex;\n}\n.tox .tox-view__pane {\n  height: 100%;\n  padding: 8px;\n  width: 100%;\n}\n.tox .tox-view__pane_panel {\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n}\n.tox:not([dir=rtl]) .tox-view__header .tox-view__header-start > *,\n.tox:not([dir=rtl]) .tox-view__header .tox-view__header-end > * {\n  margin-left: 8px;\n}\n.tox[dir=rtl] .tox-view__header .tox-view__header-start > *,\n.tox[dir=rtl] .tox-view__header .tox-view__header-end > * {\n  margin-right: 8px;\n}\n.tox .tox-well {\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  padding: 8px;\n  width: 100%;\n}\n.tox .tox-well > *:first-child {\n  margin-top: 0;\n}\n.tox .tox-well > *:last-child {\n  margin-bottom: 0;\n}\n.tox .tox-well > *:only-child {\n  margin: 0;\n}\n.tox .tox-custom-editor {\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  display: flex;\n  flex: 1;\n  position: relative;\n}\n/* stylelint-disable */\n.tox {\n  /* stylelint-enable */\n}\n.tox .tox-dialog-loading::before {\n  background-color: rgba(0, 0, 0, 0.5);\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  z-index: 1000;\n}\n.tox .tox-tab {\n  cursor: pointer;\n}\n.tox .tox-dialog__content-js {\n  display: flex;\n  flex: 1;\n}\n.tox .tox-dialog__body-content .tox-collection {\n  display: flex;\n  flex: 1;\n}\n";
styleInject(css_248z$5);

const defaultOptions = (t) => ({
    theme: 'silver',
    promotion: false,
    readonly: false,
    height: 300,
    resize: false,
    font_size_formats: '8px 9px 10px 11px 12px 14px 16px 18px 20px 22px 24px 26px 28px 36px 48px 72px',
    verify_html: false,
    image_advtab: false,
    image_title: true,
    plugins:
        'advlist anchor autolink                     code            directionality emoticons                 charmap image           insertdatetime link lists media nonbreaking pagebreak preview                searchreplace table          visualblocks visualchars wordcount',
    external_plugins: {
        image_upload: 'external_plugins/image_upload/plugin.js',
        font_size_buttons: 'external_plugins/font_size_buttons/plugin.js',
    },
    toolbar:
        'undo redo | fontfamily | fontsize fontsize_decrease fontsize_increase fontsize_change | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | image link media emoticons | ltr rtl searchreplace',
    insertdatetime_formats: ['%H:%M', '%H:%M:%S', '%d.%m.%Y', '%d.%m.%Y %H:%M', '%d.%m.%Y %H:%M:%S'],
    paste_data_images: true,
    style_formats_merge: true,
    style_formats: [
        {
            title: t('textareaHtmlStyleImageTitle'),
            items: [
                {
                    title: t('textareaHtmlStyleImageItemTitle'),
                    selector: 'img',
                    styles: {
                        margin: '10px',
                    },
                },
            ],
        },
    ],
});
const validEvents = [
    'onActivate',
    'onAddUndo',
    'onBeforeAddUndo',
    'onBeforeExecCommand',
    'onBeforeGetContent',
    'onBeforeRenderUI',
    'onBeforeSetContent',
    'onBeforePaste',
    'onBlur',
    'onChange',
    'onClearUndos',
    'onClick',
    'onContextMenu',
    'onCopy',
    'onCut',
    'onDblclick',
    'onDeactivate',
    'onDirty',
    'onDrag',
    'onDragDrop',
    'onDragEnd',
    'onDragGesture',
    'onDragOver',
    'onDrop',
    'onExecCommand',
    'onFocus',
    'onFocusIn',
    'onFocusOut',
    'onGetContent',
    'onHide',
    'onInit',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onLoadContent',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onNodeChange',
    'onObjectResizeStart',
    'onObjectResized',
    'onObjectSelected',
    'onPaste',
    'onPostProcess',
    'onPostRender',
    'onPreProcess',
    'onProgressState',
    'onRedo',
    'onRemove',
    'onReset',
    'onSaveContent',
    'onSelectionChange',
    'onSetAttrib',
    'onSetContent',
    'onShow',
    'onSubmit',
    'onUndo',
    'onVisualAid',
];
var script$5 = defineComponent({
    name: 'QTinyMce',
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local',
        });
        return { t };
    },
    created() {
        this.uid = uid();
    },
    mounted() {
        this.init();
    },
    beforeUnmount() {
        const tinymce = this.getTinymce();
        if (tinymce !== null && this.editor !== null) {
            try {
                tinymce.remove(this.editor);
            } catch (e) {
                console.error(e);
            }
            this.editor = null;
        }
    },
    activated() {
        if (!this.inlineProp && !this.mounting) {
            this.init();
        }
    },
    deactivated() {
        if (!this.inlineProp) {
            const tinymce = this.getTinymce();
            if (tinymce !== null && this.editor !== null) {
                this.cache = this.editor.getContent();
                try {
                    tinymce.remove(this.editor);
                } catch (e) {
                    console.error(e);
                }
                this.editor = null;
            }
        }
    },
    props: {
        id: {
            type: String,
        },
        name: String,
        modelValue: String,
        modelUpdateEvents: [String, Array],
        options: {
            type: Object,
            default: null,
        },
        optionsExtend: {
            type: Object,
            default: null,
        },
        inline: {
            type: Boolean,
            default: false,
        },
        tagName: {
            type: String,
            default: 'div',
        },
        disable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            uid: '',
            editor: null,
            mounting: true,
            cache: null,
        };
    },
    computed: {
        idProp() {
            return this.id || 'tinymce-' + this.uid;
        },
        inlineProp() {
            return (this.options && this.options.inline) || this.inline;
        },
        optionsProp() {
            let options = {};
            if (this.options) {
                options = Object.assign({}, this.options);
            } else {
                options = defaultOptions(this.t);
            }
            if (typeof this.optionsExtend === 'object' && this.optionsExtend != null) {
                options = Object.assign({}, options, this.optionsExtend);
            }
            return options;
        },
    },
    methods: {
        getTinymce() {
            const global = typeof window !== 'undefined' ? window : global;
            return global && global.tinymce ? global.tinymce : null;
        },
        init() {
            const $this = this;
            const tinymce = this.getTinymce();
            if (tinymce !== null) {
                try {
                    tinymce.remove('#' + this.idProp);
                } catch (e) {
                    console.error(e);
                }
                let options = this.optionsProp;
                const setup = options.setup;
                options = Object.assign(options, {
                    selector: '#' + this.idProp,
                    skin: false,
                    content_css: false,
                    content_style: tinymce.tinymceContentUiCss + '\n' + tinymce.tinymceContentCss,
                    inline: this.inlineProp,
                    readonly: this.disable,
                    language: this.t('textareaHtmlLanguage'),
                    setup: function (editor) {
                        editor.on('init', function (e) {
                            if ($this.inlineProp === true && $this.modelValue) {
                                editor.setContent($this.modelValue);
                            } else if ($this.cache !== undefined && $this.cache !== null) {
                                editor.setContent($this.cache);
                            }
                            editor.off('submit');
                            editor.off('reset');
                            let modelUpdateEvents = this.modelUpdateEvents ? this.modelUpdateEvents : null;
                            modelUpdateEvents = Array.isArray(modelUpdateEvents) ? modelUpdateEvents.join(' ') : modelUpdateEvents;
                            editor.on(modelUpdateEvents ? modelUpdateEvents : 'change input undo redo reset', function () {
                                $this.$emit('update:model-value', editor.getContent());
                            });
                            Object.keys($this.$attrs)
                                .filter((key) => validEvents.map((event) => event.toLowerCase()).indexOf(key.toLowerCase()) !== -1)
                                .forEach(function (key) {
                                    const handler = $this.$attrs[key];
                                    if (typeof handler === 'function') {
                                        if (key === 'onInit') {
                                            handler(e, editor);
                                        } else {
                                            editor.on(key.substring(2), (e) => handler(e, editor));
                                        }
                                    }
                                });
                        });
                        if (typeof setup === 'function') {
                            setup(editor);
                        }
                        $this.editor = editor;
                    },
                });
                tinymce.init(options);
            }
            this.mounting = false;
        },
        rerender() {
            const tinymce = this.getTinymce();
            if (tinymce !== null && this.editor !== null) {
                this.cache = this.editor.getContent();
                try {
                    tinymce.remove(this.editor);
                } catch (e) {
                    console.error(e);
                }
                this.editor = null;
                this.$nextTick(() => this.init());
            }
        },
        getValue(outputFormat) {
            let value = null;
            this.idProp;
            const editor = this.editor;
            if (editor != undefined && editor != null) {
                if (outputFormat === 'html' || outputFormat === 'text') {
                    value = editor.getContent({ format: outputFormat });
                } else {
                    value = editor.getContent();
                }
            }
            return value;
        },
        setValue(value) {
            this.idProp;
            const editor = this.editor;
            if (editor != undefined && editor != null) {
                if (value !== editor.getContent()) {
                    if (editor.initialized === true) {
                        editor.setContent(value == undefined || value == null ? '' : value);
                    } else {
                        (function (editor, value) {
                            editor.on('init', function (e) {
                                editor.setContent(value == undefined || value == null ? '' : value);
                            });
                        })(editor, value);
                    }
                }
            } else {
                this.$emit('update:model-value', value);
            }
        },
    },
    watch: {
        modelValue: {
            handler() {
                this.setValue(this.modelValue);
            },
            immediate: true,
            deep: false,
        },
        disable: {
            handler() {
                if (this.editor !== null) {
                    if (this.editor.mode && typeof this.editor.mode.set === 'function') {
                        this.editor.mode.set(this.disable ? 'readonly' : 'design');
                    } else {
                        this.editor.setMode(this.disable ? 'readonly' : 'design');
                    }
                }
            },
            immediate: false,
            deep: false,
        },
    },
    emits: ['update:model-value'],
    expose: ['mounting', 'rerender', 'getValue', 'setValue'],
});

const _hoisted_1$5 = { class: "q-tinymce" };
const _hoisted_2$3 = ["id", "name", "value", "disabled"];
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$5, [
    (_ctx.inlineProp)
      ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.tagName), {
          key: 0,
          ref: "element",
          id: _ctx.idProp
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["id"]))
      : (openBlock(), createElementBlock("textarea", {
          key: 1,
          ref: "element",
          id: _ctx.idProp,
          name: _ctx.name,
          value: _ctx.modelValue,
          disabled: _ctx.disable,
          style: {"visibility":"hidden"}
        }, null, 8 /* PROPS */, _hoisted_2$3))
  ]))
}

function block0$1 (Component) {
  Component.__i18n = Component.__i18n || [];
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "sk": {
        "textareaHtmlLanguage": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sk"])};fn.source="sk";return fn;})(),
        "textareaHtmlStyleImageTitle": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obrázky"])};fn.source="Obrázky";return fn;})(),
        "textareaHtmlStyleImageItemTitle": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odsadiť"])};fn.source="Odsadiť";return fn;})()
      }
    }
  });
}

if (typeof block0$1 === 'function') block0$1(script$5);

script$5.render = render$5;
script$5.__file = "src/components/QTinyMce.vue";

const editorDefaults = (ctx) => ({
    dark: false,
    fullscreen: false,
    noRouteFullscreenExit: false,
    modelValue: undefined,
    readonly: false,
    disable: false,
    minHeight: '10rem',
    maxHeight: undefined,
    height: undefined,
    definitions: undefined,
    fonts: {
        arial: 'Arial',
        arial_black: 'Arial Black',
        comic_sans: 'Comic Sans MS',
        courier_new: 'Courier New',
        impact: 'Impact',
        lucida_grande: 'Lucida Grande',
        times_new_roman: 'Times New Roman',
        verdana: 'Verdana',
    },
    placeholder: undefined,
    toolbar: [
        ['undo', 'redo'],
        [
            {
                label: ctx.$q.lang.editor.defaultFont,
                icon: ctx.$q.iconSet.editor.font,
                fixedIcon: true,
                list: 'no-icons',
                options: ['default_font', 'arial', 'arial_black', 'comic_sans', 'courier_new', 'impact', 'lucida_grande', 'times_new_roman', 'verdana'],
            },
            {
                label: ctx.$q.lang.editor.fontSize,
                icon: ctx.$q.iconSet.editor.fontSize,
                fixedLabel: true,
                fixedIcon: true,
                list: 'no-icons',
                options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7'],
            },
            {
                label: ctx.$q.lang.editor.formatting,
                icon: ctx.$q.iconSet.editor.formatting,
                list: 'no-icons',
                options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code'],
            },
        ],
        ['bold', 'italic', 'underline', 'strike', 'subscript', 'superscript'],
        ['left', 'center', 'right', 'justify'],
        ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
        ['hr', 'link'],
        ['removeFormat', 'print', 'viewsource', 'fullscreen'],
    ],
    toolbarColor: undefined,
    toolbarBg: undefined,
    toolbarTextColor: undefined,
    toolbarToggleColor: undefined,
    toolbarOutline: undefined,
    toolbarPush: undefined,
    toolbarRounded: undefined,
    paragraphTag: undefined,
    contentStyle: undefined,
    contentClass: undefined,
    square: undefined,
    flat: undefined,
    dense: undefined,
});
const tinymceDefaults = (ctx) => ({
    name: undefined,
    disable: undefined,
});
var script$4 = defineComponent({
    name: 'QEditorInput',
    components: {
        QEditor,
        QField,
        QTinyMce: script$5,
    },
    props: {
        label: String,
        stackLabel: Boolean,
        hint: String,
        hideHint: Boolean,
        labelColor: String,
        color: String,
        bgColor: String,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        loading: Boolean,
        hideBottomSpace: Boolean,
        rounded: Boolean,
        dense: Boolean,
        itemAligned: Boolean,
        counter: Boolean,
        clearable: Boolean,
        clearIcon: String,
        disable: Boolean,
        readonly: Boolean,
        autofocus: Boolean,
        for: String,
        maxlength: [Number, String],
        dark: {
            type: Boolean,
            default: null,
        },
        modelValue: String,
        error: {
            type: Boolean,
            default: null,
        },
        errorMessage: String,
        noErrorIcon: Boolean,
        rules: Array,
        reactiveRules: Boolean,
        lazyRules: {
            type: [Boolean, String],
            validator: (v) => [true, false, 'ondemand'].includes(v),
        },
        name: String,
        placeholder: String,
        editor: {
            type: String,
            default: 'QTinyMce',
            validator: (v) => ['QTinyMce', 'QEditor'].includes(v),
        },
        editorOptions: {
            type: Object,
            default: null,
        },
        style: [String, Array, Object],
        class: [String, Array, Object],
        id: String,
    },
    computed: {
        hasError() {
            return this.$refs.editorInputField.hasError;
        },
        nameProp() {
            return this.name || this.for;
        },
        hasValue() {
            return this.modelValue !== void 0 && this.modelValue !== null && ('' + this.modelValue).length > 0;
        },
        isLoading() {
            return this.loading === true;
        },
        isClearable() {
            return this.isLoading !== true && this.clearable === true && this.disable !== true && this.readonly !== true && this.hasValue === true;
        },
        modelValueProp: {
            get() {
                return this.modelValue;
            },
            set(modelValue) {
                this.$emit('update:model-value', modelValue);
            },
        },
        editorOptionsProp() {
            let editorOptions = {};
            if (this.editor.toLowerCase() === 'qeditor') {
                if (this.editorOptions) {
                    editorOptions = Object.assign({}, this.editorOptions);
                } else {
                    editorOptions = editorDefaults(this);
                }
                editorOptions.dark = this.dark;
                editorOptions.readonly = this.readonly;
                editorOptions.disable = this.disable;
                editorOptions.placeholder = this.placeholder;
                editorOptions.square = this.square;
                editorOptions.dense = this.dense;
            } else if (this.editor.toLowerCase() === 'qtinymce') {
                if (this.editorOptions) {
                    editorOptions = Object.assign({}, this.editorOptions);
                } else {
                    editorOptions = tinymceDefaults();
                }
                editorOptions.name = this.nameProp;
                editorOptions.disable = this.disable || this.readonly;
                editorOptions.optionsExtend = editorOptions.optionsExtend || {};
                this.autofocus === true && (editorOptions.optionsExtend.auto_focus = this.autofocus);
                this.placeholder && (editorOptions.optionsExtend.placeholder = this.placeholder);
                editorOptions.onFocus = (e) => {
                    this.$refs.editorInputField.$el.querySelector('.q-field__control').dispatchEvent(new Event('focusin'));
                };
                editorOptions.onBlur = (e) => {
                    this.$refs.editorInputField.$el.querySelector('.q-field__control').dispatchEvent(new Event('focusout'));
                };
            }
            delete editorOptions.modelValue;
            return editorOptions;
        },
    },
    methods: {
        getClass() {
            let classProp = 'q-editor-input';
            classProp += this.stackLabel ? ' q-field--stack-label' : '';
            classProp += this.isClearable ? ' q-field--clearable' : '';
            classProp += this.isLoading ? ' q-field--loading' : '';
            classProp += this.$props.class ? ' ' + this.$props.class : '';
            return classProp;
        },
        resetValidation() {
            this.$refs.editorInputField.resetValidation();
        },
        validate(value) {
            return this.$refs.editorInputField.validate(value);
        },
        focus() {
            this.$refs.editorInputField.focus();
        },
        blur() {
            this.$refs.editorInputField.blur();
        },
        onUpdateModelValue(value) {
            value = value === null ? '' : value;
            this.$emit('update:model-value', value);
        },
        onClear(value) {
            this.$emit('clear', value);
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
    },
    emits: ['update:model-value', 'clear', 'focus', 'blur'],
    expose: ['resetValidation', 'validate', 'focus', 'blur', 'hasError'],
});

const _hoisted_1$4 = ["name", "value", "disabled"];
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_editor = resolveComponent("q-editor");
  const _component_q_tiny_mce = resolveComponent("q-tiny-mce");
  const _component_q_field = resolveComponent("q-field");
  return (openBlock(), createBlock(_component_q_field, {
    ref: "editorInputField",
    id: _ctx.id,
    label: _ctx.label,
    "stack-label": _ctx.stackLabel,
    hint: _ctx.hint,
    "hide-hint": _ctx.hideHint,
    "label-color": _ctx.labelColor,
    color: _ctx.color,
    "bg-color": _ctx.bgColor,
    filled: _ctx.filled,
    outlined: _ctx.outlined,
    borderless: _ctx.borderless,
    standout: _ctx.standout,
    square: _ctx.square,
    loading: _ctx.loading,
    "hide-bottom-space": _ctx.hideBottomSpace,
    rounded: _ctx.rounded,
    dense: _ctx.dense,
    "item-aligned": _ctx.itemAligned,
    counter: _ctx.counter,
    clearable: _ctx.clearable,
    "clear-icon": _ctx.clearIcon,
    disable: _ctx.disable,
    readonly: _ctx.readonly,
    autofocus: _ctx.autofocus,
    for: _ctx.$props.for,
    maxlength: _ctx.maxlength,
    dark: _ctx.dark,
    "model-value": _ctx.modelValue,
    error: _ctx.error,
    "error-message": _ctx.errorMessage,
    "no-error-icon": _ctx.noErrorIcon,
    rules: _ctx.rules,
    "reactive-rules": _ctx.reactiveRules,
    "lazy-rules": _ctx.lazyRules,
    "onUpdate:modelValue": _ctx.onUpdateModelValue,
    onClear: _ctx.onClear,
    onFocus: _ctx.onFocus,
    onBlur: _ctx.onBlur,
    style: normalizeStyle(_ctx.style),
    class: normalizeClass(_ctx.getClass())
  }, createSlots({
    control: withCtx(() => [
      (_ctx.editor.toLowerCase() === 'qeditor')
        ? (openBlock(), createBlock(_component_q_editor, mergeProps({ key: 0 }, _ctx.editorOptionsProp, {
            modelValue: _ctx.modelValueProp,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.modelValueProp) = $event)),
            style: {"width":"100%"}
          }), null, 16 /* FULL_PROPS */, ["modelValue"]))
        : createCommentVNode("v-if", true),
      (_ctx.editor.toLowerCase() === 'qeditor')
        ? (openBlock(), createElementBlock("input", {
            key: 1,
            type: "hidden",
            name: _ctx.nameProp,
            value: _ctx.modelValueProp,
            disabled: _ctx.disable
          }, null, 8 /* PROPS */, _hoisted_1$4))
        : createCommentVNode("v-if", true),
      (_ctx.editor.toLowerCase() === 'qtinymce')
        ? (openBlock(), createBlock(_component_q_tiny_mce, mergeProps({ key: 2 }, _ctx.editorOptionsProp, {
            modelValue: _ctx.modelValueProp,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.modelValueProp) = $event)),
            style: {"width":"100%"}
          }), null, 16 /* FULL_PROPS */, ["modelValue"]))
        : createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['default'])
      ? {
          name: "default",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots['prepend'])
      ? {
          name: "prepend",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend")
          ]),
          key: "1"
        }
      : undefined,
    (_ctx.$slots['append'])
      ? {
          name: "append",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "append")
          ]),
          key: "2"
        }
      : undefined,
    (_ctx.$slots['before'])
      ? {
          name: "before",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "before")
          ]),
          key: "3"
        }
      : undefined,
    (_ctx.$slots['after'])
      ? {
          name: "after",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "after")
          ]),
          key: "4"
        }
      : undefined,
    (_ctx.$slots['label'])
      ? {
          name: "label",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "label")
          ]),
          key: "5"
        }
      : undefined,
    (_ctx.$slots['error'])
      ? {
          name: "error",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "error")
          ]),
          key: "6"
        }
      : undefined,
    (_ctx.$slots['hint'])
      ? {
          name: "hint",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "hint")
          ]),
          key: "7"
        }
      : undefined,
    (_ctx.$slots['counter'])
      ? {
          name: "counter",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "counter")
          ]),
          key: "8"
        }
      : undefined,
    (_ctx.$slots['loading'])
      ? {
          name: "loading",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "loading")
          ]),
          key: "9"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "label", "stack-label", "hint", "hide-hint", "label-color", "color", "bg-color", "filled", "outlined", "borderless", "standout", "square", "loading", "hide-bottom-space", "rounded", "dense", "item-aligned", "counter", "clearable", "clear-icon", "disable", "readonly", "autofocus", "for", "maxlength", "dark", "model-value", "error", "error-message", "no-error-icon", "rules", "reactive-rules", "lazy-rules", "onUpdate:modelValue", "onClear", "onFocus", "onBlur", "style", "class"]))
}

var css_248z$4 = "\n.q-editor-input.q-field[data-v-3db83148]  .q-field__control-container {\n    padding-top: 55px;\n}\n.q-editor-input.q-field.q-field--dense[data-v-3db83148]  .q-field__control-container {\n    padding-top: 40px;\n}\n.q-editor-input.q-field.q-field--stack-label[data-v-3db83148]  .q-field__control-container .q-field__label {\n    transform: translateY(3px) scale(0.75);\n}\n.q-editor-input.q-field[data-v-3db83148]  .q-field__control-container .q-field__native {\n    position: relative;\n    padding-bottom: 1px;\n}\n.q-editor-input.q-field.q-field--outlined[data-v-3db83148]  .q-field__control-container .q-field__native,\n.q-editor-input.q-field.q-field--filled[data-v-3db83148]  .q-field__control-container .q-field__native,\n.q-editor-input.q-field.q-field--standout[data-v-3db83148]  .q-field__control-container .q-field__native {\n    padding-bottom: 12px;\n}\n/*\n.q-editor-input.q-field:deep() .q-field__control-container .q-field__native .q-editor-input__placeholder {\n    display: flex;\n    align-items: center;\n    color: rgba(0, 0, 0, 0.54);\n} */\n.q-editor-input.q-field[data-v-3db83148]  .q-field__append {\n    position: absolute;\n    padding: 0px;\n    right: 0px;\n}\n.q-editor-input.q-field[data-v-3db83148]  .q-field__append:last-child {\n    right: 0px;\n}\n.q-editor-input.q-field.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 0px;\n}\n.q-editor-input.q-field.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 26px;\n}\n.q-editor-input.q-field.q-field--disabled.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--disabled.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--disabled.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--readonly.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--readonly.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--readonly.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 0px;\n}\n.q-editor-input.q-field.q-field--disabled.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--disabled.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--readonly.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--readonly.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 26px;\n}\n.q-editor-input.q-field.q-field--outlined[data-v-3db83148]  .q-field__append:last-child,\n.q-editor-input.q-field.q-field--filled[data-v-3db83148]  .q-field__append:last-child,\n.q-editor-input.q-field.q-field--standout[data-v-3db83148]  .q-field__append:last-child {\n    right: 12px;\n}\n.q-editor-input.q-field.q-field--outlined.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 12px;\n}\n.q-editor-input.q-field.q-field--outlined.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 38px;\n}\n.q-editor-input.q-field.q-field--outlined.q-field--disabled.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--disabled.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--disabled.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--readonly.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--readonly.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--readonly.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--disabled.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--disabled.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--disabled.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--readonly.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--readonly.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--readonly.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--disabled.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--disabled.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--disabled.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--readonly.q-field--clearable[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--readonly.q-field--loading[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--readonly.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 12px;\n}\n.q-editor-input.q-field.q-field--outlined.q-field--disabled.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--disabled.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--readonly.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--outlined.q-field--readonly.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--disabled.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--disabled.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--readonly.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--filled.q-field--readonly.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--disabled.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--disabled.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--readonly.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2),\n.q-editor-input.q-field.q-field--standout.q-field--readonly.q-field--loading.q-field--error[data-v-3db83148]  .q-field__append:nth-child(2) {\n    right: 38px;\n}\n.q-editor-input.q-field[data-v-3db83148]  .q-field__control-container .q-field__label {\n    padding-right: 0px;\n}\n.q-editor-input.q-field.q-field--clearable[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--loading[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label {\n    padding-right: 40px;\n}\n.q-editor-input.q-field.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--loading.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label {\n    padding-right: 70px;\n}\n.q-editor-input.q-field.q-field--disabled[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--readonly[data-v-3db83148]  .q-field__control-container .q-field__label {\n    padding-right: 0px;\n}\n.q-editor-input.q-field.q-field--disabled.q-field--clearable[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--disabled.q-field--loading[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--disabled.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--readonly.q-field--clearable[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--readonly.q-field--loading[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--readonly.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label {\n    padding-right: 40px;\n}\n.q-editor-input.q-field.q-field--disabled.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--disabled.q-field--loading.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--readonly.q-field--clearable.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label,\n.q-editor-input.q-field.q-field--readonly.q-field--loading.q-field--error[data-v-3db83148]  .q-field__control-container .q-field__label {\n    padding-right: 70px;\n}\n";
styleInject(css_248z$4);

script$4.render = render$4;
script$4.__scopeId = "data-v-3db83148";
script$4.__file = "src/components/QEditorInput.vue";

const DEFAULT_SIZE = 48;
var script$3 = {
    name: 'QDynamicIcon',
    props: {
        type: {
            type: String,
            default: 'info',
            validator: (v) => ['success', 'error', 'warning', 'info', 'question', 'progress'].includes(v),
        },
        size: {
            type: Number,
            default: DEFAULT_SIZE,
        },
        color: {
            type: String,
        },
        animated: {
            type: Boolean,
            default: true,
        },
        animate: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        style() {
            const style = {};
            if (this.size !== DEFAULT_SIZE) {
                style.width = this.size + 'px';
                style.height = this.size + 'px';
            }
            return style;
        },
        iconStyle() {
            const iconStyle = {};
            if (this.size !== DEFAULT_SIZE) {
                iconStyle['transform'] = 'scale(' + this.size / DEFAULT_SIZE + ')';
                iconStyle['transform-origin'] = 'top left';
            }
            if (this.color != undefined && this.color != null && this.color.length > 0) {
                iconStyle['border-color'] = this.color;
            }
            return iconStyle;
        },
        lineStyle() {
            const lineStyle = {};
            if (this.color != undefined && this.color != null && this.color.length > 0) {
                lineStyle['background-color'] = this.color;
            }
            return lineStyle;
        },
        iconClass() {
            const iconClass = {
                icon: true,
                [this.type]: true,
                animated: this.animated,
                animate: this.animate,
            };
            return iconClass;
        },
    },
    expose: [],
};

const _withScopeId = n => (pushScopeId("data-v-94beae52"),n=n(),popScopeId(),n);
const _hoisted_1$3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/createElementVNode("div", { class: "placeholder" }, null, -1 /* HOISTED */));
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: "q-dynamic-icon",
    style: normalizeStyle($options.style)
  }, [
    createElementVNode("div", {
      class: normalizeClass($options.iconClass),
      style: normalizeStyle($options.iconStyle)
    }, [
      createElementVNode("span", {
        class: "line left",
        style: normalizeStyle($options.lineStyle)
      }, null, 4 /* STYLE */),
      ($props.type === 'question')
        ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: "line left",
            style: normalizeStyle($options.lineStyle)
          }, null, 4 /* STYLE */))
        : createCommentVNode("v-if", true),
      ($props.type === 'question')
        ? (openBlock(), createElementBlock("span", {
            key: 1,
            class: "line left",
            style: normalizeStyle($options.lineStyle)
          }, null, 4 /* STYLE */))
        : createCommentVNode("v-if", true),
      ($props.type === 'progress')
        ? (openBlock(), createElementBlock("span", {
            key: 2,
            class: "line center",
            style: normalizeStyle($options.lineStyle)
          }, null, 4 /* STYLE */))
        : createCommentVNode("v-if", true),
      createElementVNode("span", {
        class: "line right",
        style: normalizeStyle($options.lineStyle)
      }, null, 4 /* STYLE */),
      _hoisted_1$3
    ], 6 /* CLASS, STYLE */)
  ], 4 /* STYLE */))
}

var css_248z$3 = "\n.q-dynamic-icon *[data-v-94beae52] {\n    --success: #21ba45;\n    --error: #c10015;\n    --warning: #f2c037;\n    --info: #31ccec;\n    --question: #1976d2;\n    --progress: #26a69a;\n}\n.q-dynamic-icon[data-v-94beae52] {\n    position: relative;\n    width: 48px;\n    height: 48px;\n    display: inline-block;\n    overflow: hidden;\n}\n.q-dynamic-icon .icon[data-v-94beae52] {\n    position: absolute;\n    /* top: 8px; */\n    width: 40px;\n    height: 40px;\n    border: 4px solid gray;\n    border-radius: 50%;\n    box-sizing: content-box;\n    /* transform: scale(0.5); */\n    /* transform-origin: top left; */\n}\n.q-dynamic-icon .icon.animated:not(.animate) > *[data-v-94beae52]:not(.placeholder) {\n    visibility: hidden;\n}\n.q-dynamic-icon .icon.success[data-v-94beae52] {\n    /* border-color: rgb(92, 184, 92); */\n    border-color: var(--success);\n}\n.q-dynamic-icon .icon.error[data-v-94beae52] {\n    border-color: var(--error);\n}\n.q-dynamic-icon .icon.warning[data-v-94beae52] {\n    border-color: var(--warning);\n}\n.q-dynamic-icon .icon.info[data-v-94beae52] {\n    border-color: var(--info);\n}\n.q-dynamic-icon .icon.question[data-v-94beae52] {\n    border-color: var(--question);\n}\n.q-dynamic-icon .icon.progress[data-v-94beae52] {\n    border-color: var(--progress);\n    overflow: visible;\n    background-color: transparent;\n}\n.q-dynamic-icon .icon[data-v-94beae52]::before,\n.q-dynamic-icon .icon[data-v-94beae52]::after {\n    content: '';\n    position: absolute;\n    width: 30px;\n    height: 60px;\n    background: white;\n}\n.q-dynamic-icon .icon.info[data-v-94beae52]::before,\n.q-dynamic-icon .icon.warning[data-v-94beae52]::before,\n.q-dynamic-icon .icon.question[data-v-94beae52]::before,\n.q-dynamic-icon .icon.progress[data-v-94beae52]::before {\n    top: -10px;\n    left: -10px;\n    width: 30px;\n    height: 60px;\n    border-radius: 30px 0px 0px 30px;\n    -webkit-transform-origin: 30px 30px;\n    transform-origin: 30px 30px;\n}\n.q-dynamic-icon .icon.error[data-v-94beae52]::before {\n    top: -11px;\n    left: -9px;\n    width: 30px;\n    height: 60px;\n    border-radius: 30px 0px 0px 30px;\n    -webkit-transform-origin: 30px 30px;\n    transform-origin: 30px 30px;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n}\n.q-dynamic-icon .icon.success[data-v-94beae52]::before {\n    top: -4px;\n    left: -9px;\n    width: 25px;\n    height: 50px;\n    border-radius: 25px 0px 0px 25px;\n    -webkit-transform-origin: 30px 30px;\n    transform-origin: 30px 30px;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n}\n.q-dynamic-icon .icon.progress[data-v-94beae52]::before {\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n}\n.q-dynamic-icon .icon.info[data-v-94beae52]::after,\n.q-dynamic-icon .icon.warning[data-v-94beae52]::after,\n.q-dynamic-icon .icon.question[data-v-94beae52]::after,\n.q-dynamic-icon .icon.progress[data-v-94beae52]::after {\n    top: -10px;\n    left: 20px;\n    width: 30px;\n    height: 60px;\n    border-radius: 0px 30px 30px 0px;\n    -webkit-transform-origin: 0px 30px;\n    transform-origin: 0px 30px;\n}\n.q-dynamic-icon .icon.error[data-v-94beae52]::after {\n    top: -10px;\n    left: 20px;\n    width: 30px;\n    height: 60px;\n    border-radius: 0px 30px 30px 0px;\n    -webkit-transform-origin: 0px 30px;\n    transform-origin: 0px 30px;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n}\n.q-dynamic-icon .icon.success[data-v-94beae52]::after {\n    top: -9px;\n    left: 13px;\n    width: 36px;\n    height: 72px;\n    border-radius: 0px 36px 36px 0px;\n    -webkit-transform-origin: 0px 36px;\n    transform-origin: 0px 36px;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n}\n.q-dynamic-icon .icon.progress[data-v-94beae52]::after {\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n}\n.q-dynamic-icon .icon .placeholder[data-v-94beae52] {\n    top: -4px;\n    left: -4px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    box-sizing: content-box;\n    position: absolute;\n    z-index: 2;\n    /* ---------------------------- */\n    opacity: 0.2;\n    border-width: 4px;\n    border-style: solid;\n    border-color: inherit;\n}\n/*\n.q-dynamic-icon .icon.success .placeholder {\n    border: 4px solid rgba(92, 184, 92, 0.2);\n}\n.q-dynamic-icon .icon.error .placeholder {\n    border: 4px solid rgba(212, 63, 58, 0.2);\n}\n.q-dynamic-icon .icon.warning .placeholder {\n    border: 4px solid rgba(238, 162, 54, 0.2);\n}\n.q-dynamic-icon .icon.info .placeholder {\n    border: 4px solid rgba(33, 150, 243, 0.2);\n}\n.q-dynamic-icon .icon.question .placeholder {\n    border: 4px solid rgba(0, 188, 212, 0.2);\n}\n.q-dynamic-icon .icon.progress .placeholder {\n    border: 4px solid rgba(33, 150, 243, 0.2);\n}\n*/\n.q-dynamic-icon .icon .line[data-v-94beae52] {\n    display: block;\n    position: absolute;\n    height: 5px;\n    border-radius: 2px;\n    box-sizing: border-box;\n    z-index: 2;\n    /* background-color: rgb(92, 184, 92); */\n    background-color: var(--success);\n}\n.q-dynamic-icon .icon.error .line[data-v-94beae52] {\n    top: 18px;\n    width: 24px;\n    background-color: var(--error);\n}\n.q-dynamic-icon .icon.warning .line[data-v-94beae52] {\n    left: 18px;\n    width: 5px;\n    background-color: var(--warning);\n}\n.q-dynamic-icon .icon.info .line[data-v-94beae52] {\n    left: 18px;\n    width: 5px;\n    background-color: var(--info);\n}\n.q-dynamic-icon .icon.question .line[data-v-94beae52] {\n    left: 18px;\n    width: 5px;\n    background-color: var(--question);\n}\n.q-dynamic-icon .icon.progress .line[data-v-94beae52] {\n    top: 15px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: var(--progress);\n}\n.q-dynamic-icon .icon.success .line.left[data-v-94beae52] {\n    top: 24px;\n    left: 7px;\n    width: 14px;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n.q-dynamic-icon .icon.success .line.right[data-v-94beae52] {\n    top: 20px;\n    right: 4px;\n    width: 24px;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n}\n.q-dynamic-icon .icon.error .line.left[data-v-94beae52] {\n    left: 8px;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n.q-dynamic-icon .icon.error .line.right[data-v-94beae52] {\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    right: 8px;\n}\n.q-dynamic-icon .icon.warning .line.left[data-v-94beae52] {\n    top: 5px;\n    height: 21px;\n}\n.q-dynamic-icon .icon.warning .line.right[data-v-94beae52] {\n    top: 30px;\n    height: 5px;\n}\n.q-dynamic-icon .icon.info .line.left[data-v-94beae52] {\n    top: 14px;\n    height: 21px;\n}\n.q-dynamic-icon .icon.info .line.right[data-v-94beae52] {\n    top: 5px;\n    height: 5px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52] {\n    /* border: 5px solid rgb(0, 188, 212); */\n    border-width: 5px;\n    border-style: solid;\n    border-color: inherit;\n    background: transparent !important;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(1) {\n    top: 6px;\n    left: 12px;\n    width: 16px;\n    height: 8px;\n    border-radius: 8px 8px 0 0;\n    border-bottom: 0px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(1)::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: -6px;\n    left: -6px;\n    width: 18px;\n    height: 9px;\n    border-radius: 10px 10px 0 0;\n    border: 7px solid #ffffff;\n    border-bottom: 0px;\n    -webkit-transform: rotate(-180deg);\n    transform: rotate(-180deg);\n    /*-5deg -  -180deg*/\n    -webkit-transform-origin: 0px 0px;\n    transform-origin: 9px 9px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(2) {\n    top: 14px;\n    left: 19px;\n    width: 9px;\n    height: 9px;\n    border-radius: 0 0 9px 0;\n    border-top: 0px;\n    border-left: 0px;\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transform-origin: 0px 0px;\n    transform-origin: 0px 0px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(2)::before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 10px;\n    height: 10px;\n    border-radius: 0 0 10px 0;\n    border: 7px solid #ffffff;\n    border-top: 0px;\n    border-left: 0px;\n    -webkit-transform: rotate(55deg);\n    transform: rotate(55deg);\n    -webkit-transform-origin: 0px 0px;\n    transform-origin: 0px 0px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(2)::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0px;\n    left: 1px;\n    width: 9px;\n    height: 9px;\n    border-radius: 0 0 9px 0;\n    border: 7px solid #ffffff;\n    border-top: 0px;\n    border-left: 0px;\n    -webkit-transform: rotate(-280deg);\n    transform: rotate(-280deg);\n    /*-30deg - -280deg*/\n    -webkit-transform-origin: 0px 0px;\n    transform-origin: 0px 0px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(3) {\n    top: 14px;\n    left: 17px;\n    width: 13px;\n    height: 13px;\n    border-radius: 13px 0 0 0;\n    border-bottom: 0px;\n    border-right: 0px;\n    -webkit-transform: rotate(-40deg);\n    transform: rotate(-40deg);\n    -webkit-transform-origin: 13px 13px;\n    transform-origin: 13px 13px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(3)::before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: -6px;\n    top: -4px;\n    width: 15px;\n    height: 15px;\n    border-radius: 15px 0 0 0;\n    border: 7px solid #ffffff;\n    border-bottom: 0px;\n    border-right: 0px;\n    /* background: transparent; */\n    -webkit-transform: rotate(-50deg);\n    transform: rotate(-50deg);\n    -webkit-transform-origin: 12px 14px;\n    transform-origin: 12px 14px;\n}\n.q-dynamic-icon .icon.question .line.left[data-v-94beae52]:nth-child(3)::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: -6px;\n    left: -5px;\n    width: 13px;\n    height: 13px;\n    border-radius: 13px 0 0 0;\n    border: 7px solid #ffffff;\n    border-bottom: 0px;\n    border-right: 0px;\n    /* background: transparent; */\n    -webkit-transform: rotate(130deg);\n    transform: rotate(130deg);\n    /*30deg - 130deg*/\n    -webkit-transform-origin: 13px 13px;\n    transform-origin: 13px 13px;\n}\n.q-dynamic-icon .icon.question .line.right[data-v-94beae52] {\n    top: 29px;\n    left: 17px;\n}\n.q-dynamic-icon .icon.progress .line.left[data-v-94beae52] {\n    left: 3px;\n}\n.q-dynamic-icon .icon.progress .line.center[data-v-94beae52] {\n    left: 15px;\n}\n.q-dynamic-icon .icon.progress .line.right[data-v-94beae52] {\n    left: 27px;\n}\n.q-dynamic-icon .icon.success.animate[data-v-94beae52]::after,\n.q-dynamic-icon .icon.error.animate[data-v-94beae52]::after {\n    -webkit-animation: animateIconRotate45-94beae52 4.25s ease-in;\n    animation: animateIconRotate45-94beae52 4.25s ease-in;\n}\n.q-dynamic-icon .icon.warning.animate[data-v-94beae52]::after,\n.q-dynamic-icon .icon.info.animate[data-v-94beae52]::after {\n    -webkit-animation: animateIconRotate0-94beae52 4.25s ease-in;\n    animation: animateIconRotate0-94beae52 4.25s ease-in;\n}\n.q-dynamic-icon .icon.question.animate[data-v-94beae52]::before {\n    -webkit-animation: animateIconRotate0-94beae52 4.25s ease-in;\n    animation: animateIconRotate0-94beae52 4.25s ease-in;\n}\n.q-dynamic-icon .icon.progress.animate[data-v-94beae52]::after {\n    -webkit-animation: animateIconRotate90-94beae52 4.25s ease-in;\n    animation: animateIconRotate90-94beae52 4.25s ease-in;\n}\n.q-dynamic-icon .icon.success.animate .line.left[data-v-94beae52] {\n    -webkit-animation: animateSuccessLineLeft-94beae52 0.75s;\n    animation: animateSuccessLineLeft-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.success.animate .line.right[data-v-94beae52] {\n    -webkit-animation: animateSuccessLineRight-94beae52 0.75s;\n    animation: animateSuccessLineRight-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.error.animate .line.left[data-v-94beae52] {\n    -webkit-animation: animateErrorLineLeft-94beae52 0.75s;\n    animation: animateErrorLineLeft-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.error.animate .line.right[data-v-94beae52] {\n    -webkit-animation: animateErrorLineRight-94beae52 0.75s;\n    animation: animateErrorLineRight-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.warning.animate .line.left[data-v-94beae52] {\n    -webkit-animation: animateWarningLineLeft-94beae52 0.75s;\n    animation: animateWarningLineLeft-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.warning.animate .line.right[data-v-94beae52] {\n    -webkit-animation: animateWarningLineRight-94beae52 0.75s;\n    animation: animateWarningLineRight-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.info.animate .line.left[data-v-94beae52] {\n    -webkit-animation: animateInfoLineLeft-94beae52 0.75s;\n    animation: animateInfoLineLeft-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.info.animate .line.right[data-v-94beae52] {\n    -webkit-animation: animateInfoLineRight-94beae52 0.75s;\n    animation: animateInfoLineRight-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.question.animate .line.left[data-v-94beae52]:nth-child(1)::after {\n    -webkit-animation: animateIconQuestion1-94beae52 0.75s;\n    animation: animateIconQuestion1-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.question.animate .line.left[data-v-94beae52]:nth-child(2)::after {\n    -webkit-animation: animateIconQuestion2-94beae52 0.75s;\n    animation: animateIconQuestion2-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.question.animate .line.left[data-v-94beae52]:nth-child(3)::after {\n    -webkit-animation: animateIconQuestion3-94beae52 0.75s;\n    animation: animateIconQuestion3-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.question.animate .line.right[data-v-94beae52] {\n    -webkit-animation: animateQuestionLineRight-94beae52 0.75s;\n    animation: animateQuestionLineRight-94beae52 0.75s;\n}\n.q-dynamic-icon .icon.progress.animate .line.left[data-v-94beae52] {\n    /*-webkit-animation: animateProgressLineLeft 0.75s;*/\n    /*animation: animateProgressLineLeft 0.75s;*/\n    -webkit-animation: animateProgressLineLeft-94beae52 0.75s,animateProgressFadeLineLeft-94beae52 2s infinite linear 0.75s;\n    animation: animateProgressLineLeft-94beae52 0.75s,animateProgressFadeLineLeft-94beae52 2s infinite linear 0.75s;\n}\n.q-dynamic-icon .icon.progress.animate .line.center[data-v-94beae52] {\n    /*-webkit-animation: animateProgressLineCenter 0.75s;*/\n    /*animation: animateProgressLineCenter 0.75s;*/\n    -webkit-animation: animateProgressLineCenter-94beae52 0.75s,animateProgressFadeLineCenter-94beae52 2s infinite linear 0.75s;\n    animation: animateProgressLineCenter-94beae52 0.75s,animateProgressFadeLineCenter-94beae52 2s infinite linear 0.75s;\n}\n.q-dynamic-icon .icon.progress.animate .line.right[data-v-94beae52] {\n    /*-webkit-animation: animateProgressLineRight 0.75s;*/\n    /*animation: animateProgressLineRight 0.75s;*/\n    -webkit-animation: animateProgressLineRight-94beae52 0.75s,animateProgressFadeLineRight-94beae52 2s infinite linear 0.75s;\n    animation: animateProgressLineRight-94beae52 0.75s,animateProgressFadeLineRight-94beae52 2s infinite linear 0.75s;\n}\n@-webkit-keyframes animateIconRotate0-94beae52 {\n0% {\n        transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n}\n5% {\n        transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n}\n12% {\n        transform: rotate(-360deg);\n        -webkit-transform: rotate(-360deg);\n}\n100% {\n        transform: rotate(-360deg);\n        -webkit-transform: rotate(-360deg);\n}\n}\n@keyframes animateIconRotate0-94beae52 {\n0% {\n        transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n}\n5% {\n        transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n}\n12% {\n        transform: rotate(-360deg);\n        -webkit-transform: rotate(-360deg);\n}\n100% {\n        transform: rotate(-360deg);\n        -webkit-transform: rotate(-360deg);\n}\n}\n@-webkit-keyframes animateIconRotate45-94beae52 {\n0% {\n        transform: rotate(-45deg);\n        -webkit-transform: rotate(-45deg);\n}\n5% {\n        transform: rotate(-45deg);\n        -webkit-transform: rotate(-45deg);\n}\n12% {\n        transform: rotate(-405deg);\n        -webkit-transform: rotate(-405deg);\n}\n100% {\n        transform: rotate(-405deg);\n        -webkit-transform: rotate(-405deg);\n}\n}\n@keyframes animateIconRotate45-94beae52 {\n0% {\n        transform: rotate(-45deg);\n        -webkit-transform: rotate(-45deg);\n}\n5% {\n        transform: rotate(-45deg);\n        -webkit-transform: rotate(-45deg);\n}\n12% {\n        transform: rotate(-405deg);\n        -webkit-transform: rotate(-405deg);\n}\n100% {\n        transform: rotate(-405deg);\n        -webkit-transform: rotate(-405deg);\n}\n}\n@-webkit-keyframes animateIconRotate90-94beae52 {\n0% {\n        transform: rotate(-90deg);\n        -webkit-transform: rotate(-90deg);\n}\n5% {\n        transform: rotate(-90deg);\n        -webkit-transform: rotate(-90deg);\n}\n12% {\n        transform: rotate(-450deg);\n        -webkit-transform: rotate(-450deg);\n}\n100% {\n        transform: rotate(-450deg);\n        -webkit-transform: rotate(-450deg);\n}\n}\n@keyframes animateIconRotate90-94beae52 {\n0% {\n        transform: rotate(-90deg);\n        -webkit-transform: rotate(-90deg);\n}\n5% {\n        transform: rotate(-90deg);\n        -webkit-transform: rotate(-90deg);\n}\n12% {\n        transform: rotate(-450deg);\n        -webkit-transform: rotate(-450deg);\n}\n100% {\n        transform: rotate(-450deg);\n        -webkit-transform: rotate(-450deg);\n}\n}\n@-webkit-keyframes animateSuccessLineLeft-94beae52 {\n0% {\n        width: 0px;\n        left: 0px;\n        top: 9px;\n}\n54% {\n        width: 0px;\n        left: 0px;\n        top: 9px;\n}\n70% {\n        width: 28px;\n        left: -6px;\n        top: 18px;\n}\n84% {\n        width: 10px;\n        left: 10px;\n        top: 24px;\n}\n100% {\n        width: 13px;\n        left: 7px;\n        top: 23px;\n}\n}\n@keyframes animateSuccessLineLeft-94beae52 {\n0% {\n        width: 0px;\n        left: -2px;\n        top: 8px;\n}\n54% {\n        width: 0px;\n        left: -2px;\n        top: 8px;\n}\n70% {\n        width: 28px;\n        left: -5px;\n        top: 19px;\n}\n84% {\n        width: 10px;\n        left: 10px;\n        top: 25px;\n}\n100% {\n        width: 14px;\n        left: 7px;\n        top: 24px;\n}\n}\n@-webkit-keyframes animateSuccessLineRight-94beae52 {\n0% {\n        width: 0;\n        right: 23px;\n        top: 27px;\n}\n65% {\n        width: 0;\n        right: 23px;\n        top: 27px;\n}\n84% {\n        width: 27px;\n        right: 0px;\n        top: 17px;\n}\n100% {\n        width: 24px;\n        right: 4px;\n        top: 20px;\n}\n}\n@keyframes animateSuccessLineRight-94beae52 {\n0% {\n        width: 0;\n        right: 24px;\n        top: 28px;\n}\n64% {\n        width: 0;\n        right: 24px;\n        top: 28px;\n}\n84% {\n        width: 28px;\n        right: 0px;\n        top: 18px;\n}\n100% {\n        width: 24px;\n        right: 4px;\n        top: 20px;\n}\n}\n@-webkit-keyframes animateErrorLineLeft-94beae52 {\n0% {\n        width: 0;\n        left: 3px;\n        top: 1px;\n}\n54% {\n        width: 0;\n        left: 3px;\n        top: 1px;\n}\n70% {\n        width: 40px;\n        left: -3px;\n        top: 15px;\n}\n84% {\n        width: 28px;\n        left: 7px;\n        top: 19px;\n}\n100% {\n        width: 24px;\n        left: 8px;\n        top: 18px;\n}\n}\n@keyframes animateErrorLineLeft-94beae52 {\n0% {\n        width: 0;\n        left: 3px;\n        top: 1px;\n}\n54% {\n        width: 0;\n        left: 3px;\n        top: 1px;\n}\n70% {\n        width: 40px;\n        left: -3px;\n        top: 15px;\n}\n84% {\n        width: 28px;\n        left: 7px;\n        top: 19px;\n}\n100% {\n        width: 24px;\n        left: 8px;\n        top: 18px;\n}\n}\n@-webkit-keyframes animateErrorLineRight-94beae52 {\n0% {\n        width: 0;\n        right: 3px;\n        top: 1px;\n}\n44% {\n        width: 0;\n        right: 3px;\n        top: 1px;\n}\n60% {\n        width: 40px;\n        right: -3px;\n        top: 15px;\n}\n74% {\n        width: 28px;\n        right: 7px;\n        top: 19px;\n}\n90% {\n        width: 24px;\n        right: 8px;\n        top: 18px;\n}\n100% {\n        width: 24px;\n        right: 8px;\n        top: 18px;\n}\n}\n@keyframes animateErrorLineRight-94beae52 {\n0% {\n        width: 0;\n        right: 3px;\n        top: 1px;\n}\n44% {\n        width: 0;\n        right: 3px;\n        top: 1px;\n}\n60% {\n        width: 40px;\n        right: -3px;\n        top: 15px;\n}\n74% {\n        width: 28px;\n        right: 7px;\n        top: 19px;\n}\n90% {\n        width: 24px;\n        right: 8px;\n        top: 18px;\n}\n100% {\n        width: 24px;\n        right: 8px;\n        top: 18px;\n}\n}\n@-webkit-keyframes animateWarningLineLeft-94beae52 {\n0% {\n        top: -4px;\n        height: 0px;\n}\n54% {\n        top: -4px;\n        height: 0px;\n}\n70% {\n        top: -4px;\n        height: 40px;\n}\n84% {\n        top: 5px;\n        height: 31px;\n}\n100% {\n        top: 5px;\n        height: 21px;\n}\n}\n@keyframes animateWarningLineLeft-94beae52 {\n0% {\n        top: -4px;\n        height: 0px;\n}\n54% {\n        top: -4px;\n        height: 0px;\n}\n70% {\n        top: -4px;\n        height: 40px;\n}\n84% {\n        top: 5px;\n        height: 30px;\n}\n100% {\n        top: 5px;\n        height: 21px;\n}\n}\n@-webkit-keyframes animateWarningLineRight-94beae52 {\n0% {\n        opacity: 0;\n}\n80% {\n        opacity: 0;\n}\n100% {\n        opacity: 1;\n}\n}\n@keyframes animateWarningLineRight-94beae52 {\n0% {\n        opacity: 0;\n}\n80% {\n        opacity: 0;\n}\n100% {\n        opacity: 1;\n}\n}\n@-webkit-keyframes animateInfoLineLeft-94beae52 {\n0% {\n        top: -4px;\n        height: 0px;\n}\n54% {\n        top: -4px;\n        height: 0px;\n}\n70% {\n        top: -4px;\n        height: 40px;\n}\n100% {\n        top: 14px;\n        height: 21px;\n}\n}\n@keyframes animateInfoLineLeft-94beae52 {\n0% {\n        top: -4px;\n        height: 0px;\n}\n54% {\n        top: -4px;\n        height: 0px;\n}\n70% {\n        top: -4px;\n        height: 40px;\n}\n100% {\n        top: 14px;\n        height: 21px;\n}\n}\n@-webkit-keyframes animateInfoLineRight-94beae52 {\n0% {\n        opacity: 0;\n}\n80% {\n        opacity: 0;\n}\n100% {\n        opacity: 1;\n}\n}\n@keyframes animateInfoLineRight-94beae52 {\n0% {\n        opacity: 0;\n}\n80% {\n        opacity: 0;\n}\n100% {\n        opacity: 1;\n}\n}\n@-webkit-keyframes animateIconQuestion1-94beae52 {\n0% {\n        transform: rotate(-5deg);\n        -webkit-transform: rotate(-5deg);\n}\n76% {\n        transform: rotate(-5deg);\n        -webkit-transform: rotate(-5deg);\n}\n100% {\n        transform: rotate(-180deg);\n        -webkit-transform: rotate(-180deg);\n}\n}\n@keyframes animateIconQuestion1-94beae52 {\n0% {\n        transform: rotate(-5deg);\n        -webkit-transform: rotate(-5deg);\n}\n76% {\n        transform: rotate(-5deg);\n        -webkit-transform: rotate(-5deg);\n}\n100% {\n        transform: rotate(-180deg);\n        -webkit-transform: rotate(-180deg);\n}\n}\n@-webkit-keyframes animateIconQuestion2-94beae52 {\n0% {\n        transform: rotate(-30deg);\n        -webkit-transform: rotate(-30deg);\n}\n70% {\n        transform: rotate(-30deg);\n        -webkit-transform: rotate(-30deg);\n}\n100% {\n        transform: rotate(-280deg);\n        -webkit-transform: rotate(-280deg);\n}\n}\n@keyframes animateIconQuestion2-94beae52 {\n0% {\n        transform: rotate(-30deg);\n        -webkit-transform: rotate(-30deg);\n}\n70% {\n        transform: rotate(-30deg);\n        -webkit-transform: rotate(-30deg);\n}\n100% {\n        transform: rotate(-280deg);\n        -webkit-transform: rotate(-280deg);\n}\n}\n@-webkit-keyframes animateIconQuestion3-94beae52 {\n0% {\n        transform: rotate(30deg);\n        -webkit-transform: rotate(30deg);\n}\n64% {\n        transform: rotate(30deg);\n        -webkit-transform: rotate(30deg);\n}\n77% {\n        transform: rotate(130deg);\n        -webkit-transform: rotate(130deg);\n}\n100% {\n        transform: rotate(130deg);\n        -webkit-transform: rotate(130deg);\n}\n}\n@keyframes animateIconQuestion3-94beae52 {\n0% {\n        transform: rotate(30deg);\n        -webkit-transform: rotate(30deg);\n}\n64% {\n        transform: rotate(30deg);\n        -webkit-transform: rotate(30deg);\n}\n77% {\n        transform: rotate(130deg);\n        -webkit-transform: rotate(130deg);\n}\n100% {\n        transform: rotate(130deg);\n        -webkit-transform: rotate(130deg);\n}\n}\n@-webkit-keyframes animateQuestionLineRight-94beae52 {\n0% {\n        height: 0px;\n        top: 44px;\n}\n55% {\n        height: 0px;\n        top: 44px;\n}\n67% {\n        height: 19px;\n        top: 25px;\n}\n90% {\n        height: 9px;\n        top: 25px;\n}\n100% {\n        height: 5px;\n        top: 29px;\n}\n}\n@keyframes animateQuestionLineRight-94beae52 {\n0% {\n        height: 0px;\n        top: 44px;\n}\n55% {\n        height: 0px;\n        top: 44px;\n}\n67% {\n        height: 19px;\n        top: 25px;\n}\n90% {\n        height: 9px;\n        top: 25px;\n}\n100% {\n        height: 5px;\n        top: 29px;\n}\n}\n@-webkit-keyframes animateProgressLineLeft-94beae52 {\n0% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n60% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n70% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 1;\n}\n100% {\n        top: 15px;\n        height: 10px;\n        border-radius: 50px;\n        opacity: 1;\n}\n}\n@keyframes animateProgressLineLeft-94beae52 {\n0% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n60% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n70% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 1;\n}\n100% {\n        top: 15px;\n        height: 10px;\n        border-radius: 50px;\n        opacity: 1;\n}\n}\n@-webkit-keyframes animateProgressLineCenter-94beae52 {\n0% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n60% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n80% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 1;\n}\n100% {\n        top: 15px;\n        height: 10px;\n        border-radius: 50px;\n        opacity: 1;\n}\n}\n@keyframes animateProgressLineCenter-94beae52 {\n0% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n60% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 0;\n}\n80% {\n        top: 17px;\n        height: 5px;\n        border-radius: 2px;\n        opacity: 1;\n}\n100% {\n        top: 15px;\n        height: 10px;\n        border-radius: 50px;\n        opacity: 1;\n}\n}\n@-webkit-keyframes animateProgressLineRight-94beae52 {\n0% {\n        top: 17px;\n        left: -4px;\n        width: 0px;\n        height: 5px;\n        border-radius: 2px;\n}\n54% {\n        top: 17px;\n        left: -4px;\n        width: 0px;\n        height: 5px;\n        border-radius: 2px;\n}\n70% {\n        top: 17px;\n        left: -4px;\n        width: 41px;\n        height: 5px;\n        border-radius: 2px;\n}\n90% {\n        top: 17px;\n        left: 27px;\n        width: 10px;\n        height: 5px;\n        border-radius: 2px;\n}\n100% {\n        top: 15px;\n        left: 27px;\n        width: 10px;\n        height: 10px;\n        border-radius: 50px;\n}\n}\n@keyframes animateProgressLineRight-94beae52 {\n0% {\n        top: 17px;\n        left: -4px;\n        width: 0px;\n        height: 5px;\n        border-radius: 2px;\n}\n54% {\n        top: 17px;\n        left: -4px;\n        width: 0px;\n        height: 5px;\n        border-radius: 2px;\n}\n70% {\n        top: 17px;\n        left: -4px;\n        width: 41px;\n        height: 5px;\n        border-radius: 2px;\n}\n90% {\n        top: 17px;\n        left: 27px;\n        width: 10px;\n        height: 5px;\n        border-radius: 2px;\n}\n100% {\n        top: 15px;\n        left: 27px;\n        width: 10px;\n        height: 10px;\n        border-radius: 50px;\n}\n}\n@-webkit-keyframes animateProgressFadeLineLeft-94beae52 {\n0% {\n        opacity: 1;\n}\n25% {\n        opacity: 0.2;\n}\n50% {\n        opacity: 1;\n}\n75% {\n        opacity: 1;\n}\n100% {\n        opacity: 1;\n}\n}\n@keyframes animateProgressFadeLineLeft-94beae52 {\n0% {\n        opacity: 1;\n}\n25% {\n        opacity: 0.2;\n}\n50% {\n        opacity: 1;\n}\n75% {\n        opacity: 1;\n}\n100% {\n        opacity: 1;\n}\n}\n@-webkit-keyframes animateProgressFadeLineCenter-94beae52 {\n0% {\n        opacity: 1;\n}\n25% {\n        opacity: 1;\n}\n50% {\n        opacity: 0.2;\n}\n75% {\n        opacity: 1;\n}\n100% {\n        opacity: 1;\n}\n}\n@keyframes animateProgressFadeLineCenter-94beae52 {\n0% {\n        opacity: 1;\n}\n25% {\n        opacity: 1;\n}\n50% {\n        opacity: 0.2;\n}\n75% {\n        opacity: 1;\n}\n100% {\n        opacity: 1;\n}\n}\n@-webkit-keyframes animateProgressFadeLineRight-94beae52 {\n0% {\n        opacity: 1;\n}\n25% {\n        opacity: 1;\n}\n50% {\n        opacity: 1;\n}\n75% {\n        opacity: 0.2;\n}\n100% {\n        opacity: 1;\n}\n}\n@keyframes animateProgressFadeLineRight-94beae52 {\n0% {\n        opacity: 1;\n}\n25% {\n        opacity: 1;\n}\n50% {\n        opacity: 1;\n}\n75% {\n        opacity: 0.2;\n}\n100% {\n        opacity: 1;\n}\n}\n";
styleInject(css_248z$3);

script$3.render = render$3;
script$3.__scopeId = "data-v-94beae52";
script$3.__file = "src/components/QDynamicIcon.vue";

const { humanStorageSize } = format;
const SSR$2 = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
var script$2 = {
    name: 'QDetailField',
    components: {
        QBtn,
        QCard,
        QCardActions,
        QCardSection,
        QCheckbox,
        QIcon,
        QItem,
        QItemLabel,
        QItemSection,
        QList,
        QPopupProxy,
        QScrollArea,
        QSeparator,
        QSpinner,
    },
    directives: {
        ClosePopup,
    },
    props: {
        type: {
            type: String,
            default: 'text',
            validator: (v) => ['text', 'checkbox', 'html', 'file', 'files', 'items'].includes(v),
        },
        value: {},
        singleLine: {
            type: Boolean,
            default: false,
        },
        preLine: {
            type: Boolean,
            default: true,
        },
        textColor: String,
        previewIcon: {
            type: String,
            default: 'visibility',
        },
        downloadIcon: {
            type: String,
            default: 'o_file_download',
        },
        noThumbnail: {
            type: Boolean,
            default: false,
        },
        bigThumbnail: {
            type: Boolean,
            default: false,
        },
        itemValueField: {
            type: [String, Function],
            default: 'value',
        },
        itemCaptionField: {
            type: [String, Function],
            default: 'caption',
        },
        height: {
            type: Number,
        },
        label: String,
        labelColor: String,
        color: String,
        bgColor: String,
        filled: Boolean,
        outlined: Boolean,
        borderless: Boolean,
        standout: [Boolean, String],
        square: Boolean,
        loading: Boolean,
        labelSlot: Boolean,
        rounded: Boolean,
        dense: Boolean,
        dark: {
            type: Boolean,
            default: null,
        },
        autoHeight: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        heightProp() {
            if (this.autoHeight) {
                return false;
            }
            return typeof this.height === 'number' ? this.height + 'px' : ['html', 'files', 'items'].includes(this.type) ? '250px' : false;
        },
        file() {
            return this.type === 'file' ? this.getFile(this.value) : null;
        },
        files() {
            if (this.type === 'files' && Array.isArray(this.value)) {
                const files = [];
                for (let i = 0; i < this.value.length; i++) {
                    const value = this.value[i];
                    files.push(this.getFile(value));
                }
                return files;
            }
            return null;
        },
        items() {
            if (this.type === 'items' && Array.isArray(this.value)) {
                const items = [];
                for (let i = 0; i < this.value.length; i++) {
                    const value = this.value[i];
                    items.push(this.getItem(value));
                }
                return items;
            }
            return null;
        },
        styleType() {
            if (this.filled === true) {
                return 'filled';
            }
            if (this.outlined === true) {
                return 'outlined';
            }
            if (this.borderless === true) {
                return 'borderless';
            }
            if (this.standout) {
                return 'standout';
            }
            return 'standard';
        },
        classes() {
            return (
                `q-detail-field q-field row no-wrap items-start q-field--${this.styleType}` +
                (this.type !== void 0 ? ` q-field--type-${this.type}` : '') +
                (this.rounded === true ? ' q-field--rounded' : '') +
                (this.square === true ? ' q-field--square' : '') +
                ' q-field--float' +
                (this.hasLabel === true ? ' q-field--labeled' : '') +
                (this.dense === true ? ' q-field--dense' : '') +
                (this.isDark === true ? ' q-field--dark' : '') +
                ' q-field--auto-height' +
                (this.preLine === true ? ' q-field--pre-line' : '')
            );
        },
        contentClasses() {
            return (
                'q-field__control relative-position row no-wrap' +
                (this.bgColor !== void 0 ? ` bg-${this.bgColor}` : '') +
                (this.color !== void 0 ? ` text-${this.color}` : '')
            );
        },
        containerClasses() {
            return 'q-field__control-container col relative-position row no-wrap q-anchor--skip' + (this.textColor !== void 0 ? ` text-${this.textColor}` : '');
        },
        labelClass() {
            return 'q-field__label no-pointer-events absolute ellipsis' + (this.labelColor !== void 0 ? ` text-${this.labelColor}` : '');
        },
        hasLabel() {
            return (this.labelSlot === true || this.label !== void 0) && this.type !== 'checkbox';
        },
        hasValue() {
            return this.value !== void 0 && this.value !== null && ('' + this.value).length > 0;
        },
        isLoading() {
            return this.loading === true;
        },
        isDark() {
            return this.dark === null ? this.$q.dark.isActive : this.dark;
        },
    },
    methods: {
        getFile(value) {
            let file = { name: '', image: false };
            if (!SSR$2 && value instanceof File) {
                file = value;
                if (this.noThumbnail !== true && this.isImage(file)) {
                    file.image = this.getImage(file);
                }
            } else if (typeof value === 'string') {
                file.name = value;
            } else if (typeof value === 'object' && value != null) {
                file = {
                    name: value.name,
                    size: value.size,
                    type: value.type,
                    url: value.url,
                    image: this.noThumbnail !== true && this.isImage(value) && typeof value.url === 'string' ? value.url : false,
                };
            }
            return file;
        },
        getItem(value) {
            if (this.$slots.item != void 0) {
                return value;
            }
            let item = { value: '', caption: false };
            if (typeof value === 'string') {
                item.value = value;
            } else if (typeof value === 'object' && value != null) {
                item = {
                    value: this.$e.utils.getFieldValue(value, this.itemValueField),
                    caption: this.$e.utils.getFieldValue(value, this.itemCaptionField),
                };
            }
            return item;
        },
        humanStorageSize(size) {
            return humanStorageSize(size);
        },
        isDownloadable(file) {
            return (this.type === 'file' || this.type === 'files') && this.hasValue && file && (file.url || (!SSR$2 && file instanceof File));
        },
        isImage(file) {
            return file.type && file.type.toUpperCase().startsWith('IMAGE');
        },
        getImage(file) {
            if (SSR$2) {
                return '';
            }
            return window.URL.createObjectURL(file);
        },
        onDownload(file) {
            if (typeof this.$attrs.onDownload === 'function') {
                this.$emit('download', file);
            } else {
                if (!SSR$2 && file instanceof File) {
                    this.$e.io.downloadFile(file);
                } else {
                    this.$e.io.downloadFile(file.url);
                }
            }
        },
    },
    expose: [],
};

const _hoisted_1$2 = { class: "q-field__inner relative-position col self-stretch" };
const _hoisted_2$2 = {
  key: 0,
  class: "q-field__prepend q-field__marginal row no-wrap items-center"
};
const _hoisted_3$2 = ["innerHTML"];
const _hoisted_4$1 = ["src"];
const _hoisted_5$1 = ["src"];
const _hoisted_6$1 = ["src"];
const _hoisted_7 = {
  key: 1,
  class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
};
const _hoisted_8 = {
  key: 2,
  class: "q-field__append q-field__marginal row no-wrap items-center"
};
const _hoisted_9 = {
  key: 3,
  class: "q-field__append-top q-field__marginal row no-wrap items-center"
};
const _hoisted_10 = ["innerHTML"];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_checkbox = resolveComponent("q-checkbox");
  const _component_q_scroll_area = resolveComponent("q-scroll-area");
  const _component_q_item_section = resolveComponent("q-item-section");
  const _component_q_item_label = resolveComponent("q-item-label");
  const _component_q_item = resolveComponent("q-item");
  const _component_q_icon = resolveComponent("q-icon");
  const _component_q_list = resolveComponent("q-list");
  const _component_q_spinner = resolveComponent("q-spinner");
  const _component_q_card_section = resolveComponent("q-card-section");
  const _component_q_separator = resolveComponent("q-separator");
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_card_actions = resolveComponent("q-card-actions");
  const _component_q_card = resolveComponent("q-card");
  const _component_q_popup_proxy = resolveComponent("q-popup-proxy");
  const _directive_close_popup = resolveDirective("close-popup");
  return (openBlock(), createElementBlock("label", {
    class: normalizeClass($options.classes),
    style: normalizeStyle({ height: $options.heightProp })
  }, [
    createElementVNode("div", _hoisted_1$2, [
      createElementVNode("div", {
        class: normalizeClass($options.contentClasses)
      }, [
        (_ctx.$slots['prepend'])
          ? (openBlock(), createElementBlock("div", _hoisted_2$2, [
              renderSlot(_ctx.$slots, "prepend")
            ]))
          : createCommentVNode("v-if", true),
        createElementVNode("div", {
          class: normalizeClass($options.containerClasses)
        }, [
          ($options.hasLabel)
            ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass($options.labelClass)
              }, [
                renderSlot(_ctx.$slots, "label", {}, () => [
                  createTextVNode(toDisplayString($props.label), 1 /* TEXT */)
                ])
              ], 2 /* CLASS */))
            : createCommentVNode("v-if", true),
          renderSlot(_ctx.$slots, "default", {}, () => [
            createCommentVNode(" ###################################################### "),
            ($props.type === 'text')
              ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(["q-field__value q-py-sm", { ellipsis: $props.singleLine }])
                }, toDisplayString($props.value), 3 /* TEXT, CLASS */))
              : createCommentVNode("v-if", true),
            ($props.type === 'checkbox')
              ? (openBlock(), createBlock(_component_q_checkbox, {
                  key: 1,
                  label: $props.label,
                  "model-value": $props.value,
                  "false-value": $props.value == void 0 ? null : false,
                  color: $props.color,
                  disable: true,
                  class: normalizeClass(["q-field__value q-my-sm", { 'ellipsis-label': $props.singleLine }])
                }, null, 8 /* PROPS */, ["label", "model-value", "false-value", "color", "class"]))
              : createCommentVNode("v-if", true),
            ($props.type === 'html')
              ? (openBlock(), createBlock(_component_q_scroll_area, {
                  key: 2,
                  "content-style": { width: '100%', position: $props.autoHeight && 'relative !important' },
                  "content-active-style": { width: '100%', position: $props.autoHeight && 'relative !important' },
                  class: "q-field__value q-mt-sm text-black bg-white",
                  style: normalizeStyle({ contain: $props.autoHeight && 'content !important' })
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", {
                      class: "q-pa-md",
                      innerHTML: $props.value
                    }, null, 8 /* PROPS */, _hoisted_3$2)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["content-style", "content-active-style", "style"]))
              : createCommentVNode("v-if", true),
            ($props.type === 'file')
              ? (openBlock(), createBlock(_component_q_item, {
                  key: 3,
                  class: normalizeClass(["q-field__value q-px-none", { column: $props.bigThumbnail }])
                }, {
                  default: withCtx(() => [
                    ($props.bigThumbnail && $options.file.image !== false)
                      ? (openBlock(), createElementBlock("img", {
                          key: 0,
                          src: $options.file.image,
                          class: "q-mb-sm"
                        }, null, 8 /* PROPS */, _hoisted_4$1))
                      : createCommentVNode("v-if", true),
                    (!$props.bigThumbnail && $options.file.image !== false)
                      ? (openBlock(), createBlock(_component_q_item_section, {
                          key: 1,
                          avatar: "",
                          class: "q-pr-sm"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("img", {
                              src: $options.file.image
                            }, null, 8 /* PROPS */, _hoisted_5$1)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : createCommentVNode("v-if", true),
                    createVNode(_component_q_item_section, null, {
                      default: withCtx(() => [
                        createVNode(_component_q_item_label, { class: "ellipsis" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString($options.file.name), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        ($options.file.size != void 0)
                          ? (openBlock(), createBlock(_component_q_item_label, {
                              key: 0,
                              caption: "",
                              lines: "1"
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString($options.humanStorageSize($options.file.size)), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"]))
              : createCommentVNode("v-if", true),
            ($props.type === 'files')
              ? (openBlock(), createElementBlock(Fragment, { key: 4 }, [
                  ($options.files && $options.files.length > 0)
                    ? (openBlock(), createBlock(_component_q_scroll_area, {
                        key: 0,
                        "content-style": { width: '100%', position: $props.autoHeight && 'relative !important' },
                        "content-active-style": { width: '100%', position: $props.autoHeight && 'relative !important' },
                        class: "q-field__value q-mt-sm",
                        style: normalizeStyle({ contain: $props.autoHeight && 'content !important' })
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_q_list, {
                            dense: $props.dense,
                            bordered: "",
                            separator: "",
                            style: {"width":"100%"}
                          }, {
                            default: withCtx(() => [
                              (openBlock(true), createElementBlock(Fragment, null, renderList($options.files, (file, fileIndex) => {
                                return (openBlock(), createBlock(_component_q_item, { key: fileIndex }, {
                                  default: withCtx(() => [
                                    (file.image !== false)
                                      ? (openBlock(), createBlock(_component_q_item_section, {
                                          key: 0,
                                          avatar: "",
                                          class: "q-pr-sm"
                                        }, {
                                          default: withCtx(() => [
                                            createElementVNode("img", {
                                              src: file.image
                                            }, null, 8 /* PROPS */, _hoisted_6$1)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */))
                                      : createCommentVNode("v-if", true),
                                    createVNode(_component_q_item_section, null, {
                                      default: withCtx(() => [
                                        createVNode(_component_q_item_label, { class: "ellipsis" }, {
                                          default: withCtx(() => [
                                            createTextVNode(toDisplayString(file.name), 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */),
                                        (file.size != void 0)
                                          ? (openBlock(), createBlock(_component_q_item_label, {
                                              key: 0,
                                              caption: "",
                                              lines: "1"
                                            }, {
                                              default: withCtx(() => [
                                                createTextVNode(toDisplayString($options.humanStorageSize(file.size)), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */))
                                          : createCommentVNode("v-if", true)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    createVNode(_component_q_item_section, { side: "" }, {
                                      default: withCtx(() => [
                                        ($options.isDownloadable(file))
                                          ? (openBlock(), createBlock(_component_q_icon, {
                                              key: 0,
                                              name: $props.downloadIcon,
                                              class: "q-field__focusable-action cursor-pointer",
                                              onClick: $event => ($options.onDownload(file))
                                            }, null, 8 /* PROPS */, ["name", "onClick"]))
                                          : createCommentVNode("v-if", true)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["dense"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["content-style", "content-active-style", "style"]))
                    : createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : createCommentVNode("v-if", true),
            ($props.type === 'items')
              ? (openBlock(), createElementBlock(Fragment, { key: 5 }, [
                  ($options.items && $options.items.length > 0)
                    ? (openBlock(), createBlock(_component_q_scroll_area, {
                        key: 0,
                        "content-style": { width: '100%', position: $props.autoHeight && 'relative !important' },
                        "content-active-style": { width: '100%', position: $props.autoHeight && 'relative !important' },
                        class: "q-field__value q-mt-sm",
                        style: normalizeStyle({ contain: $props.autoHeight && 'content !important' })
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_q_list, {
                            dense: $props.dense,
                            bordered: "",
                            separator: "",
                            style: {"width":"100%"}
                          }, {
                            default: withCtx(() => [
                              (openBlock(true), createElementBlock(Fragment, null, renderList($options.items, (item, itemIndex) => {
                                return renderSlot(_ctx.$slots, "item", {
                                  key: itemIndex,
                                  item: item
                                }, () => [
                                  createVNode(_component_q_item, null, {
                                    default: withCtx(() => [
                                      createVNode(_component_q_item_section, null, {
                                        default: withCtx(() => [
                                          createVNode(_component_q_item_label, { class: "ellipsis" }, {
                                            default: withCtx(() => [
                                              createTextVNode(toDisplayString(item.value), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */),
                                          (item.caption != void 0)
                                            ? (openBlock(), createBlock(_component_q_item_label, {
                                                key: 0,
                                                caption: "",
                                                lines: "1"
                                              }, {
                                                default: withCtx(() => [
                                                  createTextVNode(toDisplayString(item.caption), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */))
                                            : createCommentVNode("v-if", true)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ])
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 3 /* FORWARDED */
                          }, 8 /* PROPS */, ["dense"])
                        ]),
                        _: 3 /* FORWARDED */
                      }, 8 /* PROPS */, ["content-style", "content-active-style", "style"]))
                    : createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : createCommentVNode("v-if", true),
            createCommentVNode(" ###################################################### ")
          ])
        ], 2 /* CLASS */),
        ($options.isLoading)
          ? (openBlock(), createElementBlock("div", _hoisted_7, [
              renderSlot(_ctx.$slots, "loading", {}, () => [
                createVNode(_component_q_spinner, { color: "color" })
              ])
            ]))
          : createCommentVNode("v-if", true),
        (_ctx.$slots['append'] || $options.isDownloadable($options.file))
          ? (openBlock(), createElementBlock("div", _hoisted_8, [
              renderSlot(_ctx.$slots, "append", {}, () => [
                createCommentVNode(" ###################################################### "),
                ($props.type === 'file')
                  ? (openBlock(), createBlock(_component_q_icon, {
                      key: 0,
                      name: $props.downloadIcon,
                      class: "q-field__focusable-action cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = $event => ($options.onDownload($options.file)))
                    }, null, 8 /* PROPS */, ["name"]))
                  : createCommentVNode("v-if", true),
                createCommentVNode(" ###################################################### ")
              ])
            ]))
          : createCommentVNode("v-if", true),
        (_ctx.$slots['append-top'] || ($props.type === 'html' && $options.hasValue))
          ? (openBlock(), createElementBlock("div", _hoisted_9, [
              renderSlot(_ctx.$slots, "append-top", {}, () => [
                createCommentVNode(" ###################################################### "),
                ($props.type === 'html')
                  ? (openBlock(), createBlock(_component_q_icon, {
                      key: 0,
                      name: $props.previewIcon,
                      class: "q-field__focusable-action cursor-pointer"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_q_popup_proxy, { breakpoint: 1000000 }, {
                          default: withCtx(() => [
                            createVNode(_component_q_card, { style: {"width":"90vw","max-width":"1200px","overflow":"hidden"} }, {
                              default: withCtx(() => [
                                createVNode(_component_q_card_section, {
                                  class: "scroll",
                                  style: {"height":"calc(100vh - 101px)"}
                                }, {
                                  default: withCtx(() => [
                                    createElementVNode("div", { innerHTML: $props.value }, null, 8 /* PROPS */, _hoisted_10)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                createVNode(_component_q_separator),
                                createVNode(_component_q_card_actions, { align: "right" }, {
                                  default: withCtx(() => [
                                    withDirectives(createVNode(_component_q_btn, {
                                      flat: "",
                                      label: _ctx.$q.lang.label.close,
                                      color: $props.color,
                                      "no-caps": ""
                                    }, null, 8 /* PROPS */, ["label", "color"]), [
                                      [_directive_close_popup]
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["name"]))
                  : createCommentVNode("v-if", true),
                createCommentVNode(" ###################################################### ")
              ])
            ]))
          : createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ], 6 /* CLASS, STYLE */))
}

var css_248z$2 = "\n.q-field--filled .q-field__control[data-v-75a2bbb0]:hover:before {\n    opacity: 0;\n}\n.q-field--outlined .q-field__control[data-v-75a2bbb0]:hover:before {\n    border-color: rgba(0, 0, 0, 0.24);\n}\n.q-field--outlined.q-field--highlighted .q-field__control[data-v-75a2bbb0]:hover:before {\n    border-color: transparent;\n}\n.q-field--standard .q-field__control[data-v-75a2bbb0]:hover:before {\n    border-color: rgba(0, 0, 0, 0.24);\n}\n.q-field--dark .q-field__control[data-v-75a2bbb0]:hover:before {\n    border-color: #fff;\n}\n.q-field--standout .q-field__control[data-v-75a2bbb0]:hover:before {\n    opacity: 0;\n}\n\n/* .q-field--auto-height .q-field__marginal {\n    height: unset;\n} */\n.q-field--type-text.q-field--pre-line .q-field__value[data-v-75a2bbb0] {\n    word-wrap: break-word;\n    word-break: break-all;\n    white-space: pre-line;\n}\n.q-field--type-checkbox .q-field__value[data-v-75a2bbb0] {\n    margin-left: -10px !important;\n    opacity: 1 !important;\n    cursor: default !important;\n}\n.q-field--type-checkbox[data-v-75a2bbb0]  .q-field__value * {\n    cursor: default !important;\n}\n.q-field--type-html .q-field__value[data-v-75a2bbb0] {\n    width: 100%;\n    /* height: 250px; */\n    margin-bottom: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n}\n.q-field--type-file .q-field__value[data-v-75a2bbb0] {\n    width: 100%;\n}\n.q-field--type-file .q-field__value img[data-v-75a2bbb0],\n.q-field--type-files .q-field__value img[data-v-75a2bbb0] {\n    width: 50px;\n    height: 40px;\n    padding: 5px;\n    object-fit: scale-down;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n}\n.q-field--type-file .q-field__value > img[data-v-75a2bbb0] {\n    width: 150px;\n    height: 150px;\n}\n.q-field--type-files .q-field__value[data-v-75a2bbb0] {\n    width: 100%;\n    /* height: 250px; */\n    margin-bottom: 12px;\n}\n.q-field--type-items .q-field__value[data-v-75a2bbb0] {\n    width: 100%;\n    /* height: 250px; */\n    margin-bottom: 12px;\n}\n/*\n.q-field--type-html,\n.q-field--type-files,\n.q-field--type-items {\n    height: 250px;\n}\n*/\n.q-field--type-html .q-field__control[data-v-75a2bbb0],\n.q-field--type-files .q-field__control[data-v-75a2bbb0],\n.q-field--type-items .q-field__control[data-v-75a2bbb0],\n.q-field--type-html .q-field__control-container[data-v-75a2bbb0],\n.q-field--type-files .q-field__control-container[data-v-75a2bbb0],\n.q-field--type-items .q-field__control-container[data-v-75a2bbb0] {\n    height: 100%;\n}\n.q-field__append-top[data-v-75a2bbb0] {\n    position: absolute;\n    top: 6px;\n    right: 0px;\n}\n.q-field--dense .q-field__append-top[data-v-75a2bbb0] {\n    top: 0px;\n}\n.q-field--filled .q-field__append-top[data-v-75a2bbb0],\n.q-field--outlined .q-field__append-top[data-v-75a2bbb0],\n.q-field--standout .q-field__append-top[data-v-75a2bbb0] {\n    right: 12px;\n}\n.q-field__append-top.q-field__marginal[data-v-75a2bbb0] {\n    height: unset;\n}\n";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-75a2bbb0";
script$2.__file = "src/components/QDetailField.vue";

var script$1 = {
    name: 'QGallery',
    components: {
        QAvatar,
        QBtn,
        QImg,
        QResizeObserver,
        QScrollArea,
        QVirtualScroll,
    },
    created() {
        this.id = 'q-gallery--' + uid();
    },
    beforeMount() {
        this.onRequest();
    },
    props: {
        loadType: {
            type: String,
            default: 'dynamic',
            validator: (v) => ['static', 'dynamic'].includes(v),
        },
        columnCounts: {
            type: [Number, Object],
            default() {
                return { sm: 2, md: 3, lg: 4, xl: 5 };
            },
        },
        reorder: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            id: '',
            itemList: [],
            columnCount: 1,
        };
    },
    computed: {
        itemsSize() {
            return Math.ceil(this.itemList.length / this.columnCount);
        },
        columnCountsProp() {
            const columnCounts = this.columnCounts;
            if (typeof columnCounts === 'number') {
                return parseInt(columnCounts) || 1;
            } else if (typeof columnCounts === 'object') {
                let columnCountsList = [];
                for (let [key, value] of Object.entries(columnCounts)) {
                    key = (key + '').toLowerCase();
                    value = parseInt(value) || 0;
                    if (value > 0) {
                        var result = key.match(/^(\d+)(cw|ww)$/);
                        if (result !== null) {
                            columnCountsList.push({
                                count: value,
                                minWidth: parseInt(result[1]),
                                type: result[2],
                            });
                        } else if (/^sm|md|lg|xl$/g.test(key)) {
                            columnCountsList.push({
                                count: value,
                                minWidth: this.$q.screen.sizes[key],
                                type: 'ww',
                            });
                        } else {
                            throw new Error('Unsupported columnCounts property specification!');
                        }
                    }
                }
                if (columnCountsList.length > 0) {
                    columnCountsList = columnCountsList.sort(function (value1, value2) {
                        return value2.minWidth - value1.minWidth;
                    });
                    return columnCountsList;
                }
            }
            return 1;
        },
    },
    methods: {
        reload() {
            this.onRequest();
        },
        setActiveAll(active) {
            this.itemList.map((i) => {
                i.active = active;
                return i;
            });
        },
        getItems(from, size) {
            let indexFrom = from * this.columnCount;
            let indexTo = indexFrom + size * this.columnCount;
            indexTo = indexTo > this.itemList.length ? this.itemList.length : indexTo;
            const keys = [];
            const items = [];
            let row = [];
            for (let i = indexFrom; i < indexTo; i++) {
                const item = this.itemList[i];
                if (item.__loaded !== true) {
                    keys.push(item.id);
                }
                row.push(item);
                if (row.length === this.columnCount) {
                    items.push(row);
                    row = [];
                }
            }
            if (row.length > 0) {
                items.push(row);
            }
            this.onRequestLoad(keys);
            return Object.freeze(items);
        },
        onResize(size) {
            let columnCount = 1;
            const columnCounts = this.columnCountsProp;
            if (typeof columnCounts === 'number') {
                columnCount = columnCounts;
            } else if (Array.isArray(columnCounts)) {
                const componentWidth = size.width;
                const windowWidth = this.$q.screen.width;
                for (let i = 0; i < columnCounts.length; i++) {
                    let width = 0;
                    if (columnCounts[i].type === 'ww') {
                        width = windowWidth;
                    } else {
                        width = componentWidth;
                    }
                    if (columnCounts[i].minWidth <= width) {
                        columnCount = columnCounts[i].count;
                        break;
                    }
                }
                columnCount = columnCount === 0 ? 1 : columnCount;
            }
            this.columnCount = columnCount;
        },
        onItemClick(item) {
            if (this.reorder) {
                if (item.reorderTarget === true) {
                    item.reorderTarget = false;
                } else if (item.reorderSource === true) {
                    if (this.itemList.find((i) => i.reorderTarget === true) === undefined) {
                        item.reorderSource = false;
                    }
                } else {
                    if (this.itemList.find((i) => i.reorderSource === true) === undefined) {
                        item.reorderSource = true;
                    } else {
                        this.itemList.map((i) => {
                            i.reorderTarget = false;
                            return i;
                        });
                        item.reorderTarget = true;
                    }
                }
                const props = {
                    sourceItem: null,
                    targetItem: null,
                };
                this.itemList.filter((i) => {
                    if (i.reorderSource === true) {
                        props.sourceItem = i;
                    } else if (i.reorderTarget === true) {
                        props.targetItem = i;
                    }
                    return true;
                });
                this.$emit('reorder-select', props);
            } else {
                item.active = !item.active;
            }
        },
        onRequest() {
            if (this.loadType) {
                const requestProps = {
                    loadConfig: null,
                };
                if (this.loadType === 'dynamic') {
                    requestProps.loadConfig = {};
                }
                requestProps.callback = function (itemList) {
                    itemList = itemList.map((item) => {
                        return {
                            id: item.id || '',
                            name: item.name || '',
                            description: item.description || '',
                            orderIndex: item.orderIndex || 0,
                            main: item.main,
                            type: item.type || 'image',
                            image: item.image || '',
                            active: false,
                        };
                    });
                    this.itemList.splice(0, this.itemList.length, ...itemList);
                }.bind(this);
                this.itemList.splice(0, this.itemList.length);
                this.$emit('request', requestProps);
            }
        },
        onRequestLoad(keys) {
            if (this.loadType === 'dynamic' && Array.isArray(keys) && keys.length > 0) {
                const requestProps = {
                    keys,
                    callback: function (itemMap) {
                        for (let i = 0; i < this.itemList.length; i++) {
                            const item = this.itemList[i];
                            const newItem = itemMap[item.id];
                            if (newItem != void 0) {
                                item.name = newItem.name || '';
                                item.description = newItem.description || '';
                                item.orderIndex = newItem.orderIndex || 0;
                                item.main = newItem.main;
                                item.type = newItem.type;
                                item.image = newItem.image;
                                item.__loaded = true;
                            }
                        }
                    }.bind(this),
                };
                this.$emit('request-load', requestProps);
            }
        },
    },
    watch: {
        reorder: {
            handler() {
                if (this.reorder) {
                    this.itemList.map((i) => {
                        i.active = false;
                        return i;
                    });
                } else {
                    this.itemList.map((i) => {
                        i.reorderSource = false;
                        i.reorderTarget = false;
                        return i;
                    });
                }
            },
            immediate: false,
            deep: false,
        },
    },
    emits: ['request', 'request-load', 'reorder-select', 'item-detail', 'item-edit', 'item-delete'],
    expose: ['reload', 'setActiveAll'],
};

const _hoisted_1$1 = ["onClick"];
const _hoisted_2$1 = { class: "q-gallery__item__reorder" };
const _hoisted_3$1 = { class: "q-gallery__item__toolbar animate" };
const _hoisted_4 = { class: "q-gallery__item__footer animate" };
const _hoisted_5 = { class: "item-name" };
const _hoisted_6 = { class: "item-description" };
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_resize_observer = resolveComponent("q-resize-observer");
  const _component_q_img = resolveComponent("q-img");
  const _component_q_avatar = resolveComponent("q-avatar");
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_virtual_scroll = resolveComponent("q-virtual-scroll");
  const _component_q_scroll_area = resolveComponent("q-scroll-area");
  return (openBlock(), createBlock(_component_q_scroll_area, {
    id: $data.id,
    class: "q-gallery",
    "content-style": "width: 100%",
    "content-active-style": "width: 100%"
  }, {
    default: withCtx(() => [
      createVNode(_component_q_resize_observer, {
        debounce: 0,
        onResize: $options.onResize
      }, null, 8 /* PROPS */, ["onResize"]),
      createVNode(_component_q_virtual_scroll, {
        "scroll-target": $data.id + ' > .scroll',
        "items-size": $options.itemsSize,
        "items-fn": $options.getItems,
        "virtual-scroll-item-size": 200,
        "virtual-scroll-slice-size": 5,
        separator: "",
        class: "q-pa-md"
      }, {
        default: withCtx((props) => [
          (openBlock(), createElementBlock("div", {
            key: props.index,
            class: "flex justify-center no-wrap"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(props.item, (item, index) => {
              return (openBlock(), createElementBlock("div", {
                key: index,
                class: normalizeClass(["q-gallery__item", { active: item.active, reorder: $props.reorder }]),
                onClick: $event => ($options.onItemClick(item))
              }, [
                createVNode(_component_q_img, {
                  src: item.image,
                  fit: "contain"
                }, null, 8 /* PROPS */, ["src"]),
                createElementVNode("div", _hoisted_2$1, [
                  (item.reorderSource)
                    ? (openBlock(), createBlock(_component_q_avatar, {
                        key: 0,
                        icon: "done_outline"
                      }))
                    : createCommentVNode("v-if", true),
                  (item.reorderTarget)
                    ? (openBlock(), createBlock(_component_q_avatar, {
                        key: 1,
                        icon: "adjust"
                      }))
                    : createCommentVNode("v-if", true)
                ]),
                createElementVNode("div", _hoisted_3$1, [
                  createVNode(_component_q_btn, {
                    icon: "o_search",
                    round: "",
                    onClick: withModifiers($event => (_ctx.$emit('item-detail', item)), ["stop","prevent"])
                  }, null, 8 /* PROPS */, ["onClick"]),
                  createVNode(_component_q_btn, {
                    icon: "o_edit",
                    round: "",
                    onClick: withModifiers($event => (_ctx.$emit('item-edit', item)), ["stop","prevent"])
                  }, null, 8 /* PROPS */, ["onClick"]),
                  createVNode(_component_q_btn, {
                    icon: "o_delete",
                    round: "",
                    onClick: withModifiers($event => (_ctx.$emit('item-delete', item)), ["stop","prevent"])
                  }, null, 8 /* PROPS */, ["onClick"])
                ]),
                createElementVNode("div", _hoisted_4, [
                  createVNode(_component_q_avatar, {
                    icon: item.type === 'image' ? 'o_image' : 'o_slideshow'
                  }, null, 8 /* PROPS */, ["icon"]),
                  createElementVNode("span", _hoisted_5, toDisplayString(item.name), 1 /* TEXT */),
                  createElementVNode("span", _hoisted_6, toDisplayString(item.description), 1 /* TEXT */)
                ]),
                (item.main === true)
                  ? (openBlock(), createBlock(_component_q_avatar, {
                      key: 0,
                      icon: "o_check_circle",
                      class: "q-gallery__item__main"
                    }))
                  : createCommentVNode("v-if", true)
              ], 10 /* CLASS, PROPS */, _hoisted_1$1))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["scroll-target", "items-size", "items-fn"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id"]))
}

var css_248z$1 = ".animate[data-v-70884551],\n.animate *[data-v-70884551] {\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n\n.q-gallery__item[data-v-70884551] {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 290px;\n  height: 180px;\n  padding: 5px;\n  margin: 10px;\n  border-radius: 5px;\n  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);\n  overflow: hidden; }\n  .q-gallery__item[data-v-70884551] .q-img[data-v-70884551] {\n    max-height: 100%;\n    overflow: hidden; }\n  .q-gallery__item[data-v-70884551] .q-gallery__item__main[data-v-70884551] {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    width: 45px;\n    height: 45px;\n    font-size: 70px;\n    color: #fff;\n    background: rgba(0, 0, 0, 0.7);\n    opacity: 0.5; }\n  .q-gallery__item[data-v-70884551] .q-gallery__item__reorder[data-v-70884551] {\n    display: none;\n    position: absolute;\n    top: 5px;\n    bottom: 5px;\n    left: 5px;\n    right: 5px;\n    background-color: white;\n    opacity: 0.5;\n    z-index: 1; }\n    .q-gallery__item[data-v-70884551] .q-gallery__item__reorder[data-v-70884551] .q-avatar[data-v-70884551] {\n      width: 100%;\n      height: 100%;\n      font-size: 230px; }\n  .q-gallery__item[data-v-70884551].reorder[data-v-70884551] .q-gallery__item__reorder[data-v-70884551] {\n    display: block; }\n  .q-gallery__item[data-v-70884551] .q-gallery__item__toolbar[data-v-70884551] {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    right: 5px;\n    padding: 5px;\n    text-align: right;\n    background: rgba(0, 0, 0, 0.7);\n    opacity: 0; }\n    .q-gallery__item[data-v-70884551] .q-gallery__item__toolbar[data-v-70884551] .q-btn[data-v-70884551] {\n      color: #ddd;\n      border: 1px solid #ddd;\n      margin-left: 5px; }\n  .q-gallery__item[data-v-70884551] .q-gallery__item__footer[data-v-70884551] {\n    position: absolute;\n    bottom: 5px;\n    left: 5px;\n    right: 5px;\n    height: 40px;\n    padding: 12px 5px 5px 50px;\n    color: #fff;\n    background: rgba(0, 0, 0, 0.7);\n    overflow: hidden;\n    opacity: 0.5;\n    cursor: default; }\n    .q-gallery__item[data-v-70884551] .q-gallery__item__footer[data-v-70884551] .q-avatar[data-v-70884551] {\n      position: absolute;\n      top: 0px;\n      left: 0px;\n      width: 40px;\n      height: 40px;\n      font-size: 80px;\n      border-radius: 0;\n      opacity: 0.4; }\n    .q-gallery__item[data-v-70884551] .q-gallery__item__footer[data-v-70884551] .item-name[data-v-70884551] {\n      display: block;\n      font-size: 13px;\n      line-height: 1.3;\n      width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    .q-gallery__item[data-v-70884551] .q-gallery__item__footer[data-v-70884551] .item-description[data-v-70884551] {\n      display: block;\n      font-size: 11px;\n      line-height: 1.1;\n      height: 36px;\n      overflow: hidden;\n      margin-top: 4px;\n      opacity: 0; }\n  .q-gallery__item[data-v-70884551].active[data-v-70884551] .q-gallery__item__toolbar[data-v-70884551] {\n    opacity: 1; }\n  .q-gallery__item[data-v-70884551].active[data-v-70884551] .q-gallery__item__footer[data-v-70884551] {\n    height: 80px;\n    opacity: 1; }\n    .q-gallery__item[data-v-70884551].active[data-v-70884551] .q-gallery__item__footer[data-v-70884551] .item-description[data-v-70884551] {\n      opacity: 0.7; }\n";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-70884551";
script$1.__file = "src/components/QGallery.vue";

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  QDateTimeInput: script$e,
  QNumberInput: script$d,
  QOptionInput: script$c,
  QOptionGroupInput: script$b,
  QOverflowToolbar: script$a,
  QGrid: script$9,
  QChooseInput: script$8,
  QImgCropper: script$7,
  QFileInput: script$6,
  QTinyMce: script$5,
  QEditorInput: script$4,
  QDynamicIcon: script$3,
  QDetailField: script$2,
  QGallery: script$1
});

const SSR$1 = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
var Ajax = {
    install({ $e, parentApp }) {
        parentApp.config.globalProperties.$axios = axios;
        const ioConfig = $e.config.io || {};
        const axiosOpts = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
            responseType: 'text',
            withCredentials: true,
        };
        if (ioConfig.baseURL) {
            axiosOpts.baseURL = ioConfig.baseURL;
        }
        if (ioConfig.responseType) {
            axiosOpts.responseType = ioConfig.responseType;
        }
        if (ioConfig.cache === false) {
            axiosOpts.params = {
                t: new Date().getTime(),
            };
        }
        const $axios = axios.create(axiosOpts);
        let prepared = false;
        const onCallMethodSuccessHandlers = [];
        const onCallMethodErrorHandlers = [];
        $e.io = {
            baseURL: ioConfig.baseURL || '',
            callMethod: function (methodName, methodParameters, callback, options) {
                options = Object.assign(
                    {
                        loadingScreen: true,
                        asPost: true,
                        success: null,
                        error: null,
                        axios: {},
                    },
                    options
                );
                if (options.loadingScreen !== false) {
                    $e.loading.show();
                }
                methodParameters = processMethodParameters.call(this, methodParameters);
                let params = {};
                let data = undefined;
                if (options.asPost === true) {
                    data = methodParameters;
                } else {
                    params = methodParameters;
                }
                if (!$e.is.empty(methodName)) {
                    params.method = methodName;
                }
                const $this = this;
                $axios
                    .request({
                        ...options.axios,
                        method: options.asPost === true ? 'POST' : 'GET',
                        params: params,
                        data: data,
                    })
                    .then(function (response) {
                        prepared = prepare(response.headers && response.headers.project);
                        let result = true;
                        if (typeof options.success === 'function') {
                            result = options.success.call($this, response.data, callback, options.loadingScreen);
                        }
                        if (result !== false) {
                            handlMethodSuccess.call($this, methodName, methodParameters, response.data, callback, options.loadingScreen);
                        }
                    })
                    .catch(function (error) {
                        let result = true;
                        if (typeof options.error === 'function') {
                            result = options.error.call($this, error, options.loadingScreen);
                        }
                        if (result !== false) {
                            handlMethodError.call($this, error, options.loadingScreen);
                        }
                    });
            },
            callMethodByForm: function (form, methodName, methodParameters, callback, options) {
                const formData = new FormData(form);
                options = Object.assign(
                    {
                        progressDialog: false,
                        loadingScreen: true,
                        success: null,
                        error: null,
                        axios: {},
                    },
                    options
                );
                if (options.progressDialog === true || typeof options.progressDialog == 'object') {
                    options.progressDialog = Object.assign(
                        {
                            uploadMessage: 'Nahrávajú sa dáta',
                            processMessage: 'Prebieha spracovanie dát',
                        },
                        options.progressDialog
                    );
                    const progressDialog = $e.dialog.progress(options.progressDialog.uploadMessage);
                    options.axios.onUploadProgress = function (progressEvent) {
                        progressDialog.update({
                            progress: progressEvent.progress,
                            message: options.progressDialog.uploadMessage + ' (' + Math.floor(progressEvent.progress * 100) + '%)',
                        });
                        if (progressEvent.progress == 1) {
                            setTimeout(() => {
                                progressDialog.update({
                                    progress: -1,
                                    message: options.progressDialog.processMessage,
                                });
                            }, 500);
                        }
                    };
                    callback = prepareCallback(callback);
                    const successCallback = callback.success;
                    const errorCallback = callback.error;
                    callback.success = function (data) {
                        const result = successCallback(data);
                        progressDialog.hide();
                        return result;
                    };
                    callback.error = function (error) {
                        const result = errorCallback(data);
                        progressDialog.hide();
                        return result;
                    };
                    options.loadingScreen = false;
                }
                if (options.loadingScreen !== false) {
                    $e.loading.show();
                }
                methodParameters = processMethodParameters.call(this, methodParameters);
                let params = {};
                if (!$e.is.empty(methodName)) {
                    params.method = methodName;
                }
                for (const [name, value] of Object.entries(methodParameters)) {
                    formData.set(name, value);
                }
                let data = formData;
                const $this = this;
                $axios
                    .request({
                        ...options.axios,
                        method: 'POST',
                        params: params,
                        data: data,
                    })
                    .then(function (response) {
                        prepared = prepare(response.headers && response.headers.project);
                        let result = true;
                        if (typeof options.success === 'function') {
                            result = options.success.call($this, response.data, callback, options.loadingScreen);
                        }
                        if (result !== false) {
                            handlMethodSuccess.call($this, methodName, methodParameters, response.data, callback, options.loadingScreen);
                        }
                    })
                    .catch(function (error) {
                        let result = true;
                        if (typeof options.error === 'function') {
                            result = options.error.call($this, error, options.loadingScreen);
                        }
                        if (result !== false) {
                            handlMethodError.call($this, error, options.loadingScreen);
                        }
                    });
            },
            callMethodForDownload: function (methodName, methodParameters, callback, options) {
                options = Object.assign(
                    {
                        progressDialog: false,
                        loadingScreen: true,
                        asPost: true,
                        success: null,
                        error: null,
                        axios: {},
                    },
                    options
                );
                if (options.progressDialog === true || typeof options.progressDialog == 'object') {
                    options.progressDialog = Object.assign(
                        {
                            uploadMessage: 'Sťahujú sa dáta',
                            processMessage: 'Prebieha príprava dát',
                        },
                        options.progressDialog
                    );
                    const progressDialog = $e.dialog.progress(options.progressDialog.processMessage);
                    progressDialog.update({ progress: -1 });
                    options.axios.onDownloadProgress = function (progressEvent) {
                        progressEvent.message = options.progressDialog.uploadMessage + ' (' + Math.floor(progressEvent.progress * 100) + '%)';
                        if ($e.is.empty(progressEvent.progress)) {
                            progressEvent.progress = -1;
                            progressEvent.message = options.progressDialog.uploadMessage + ' (' + progressEvent.loaded.formatFileSize() + ')';
                        }
                        progressDialog.update({
                            progress: progressEvent.progress,
                            message: progressEvent.message,
                        });
                    };
                    callback = prepareCallback(callback);
                    const successCallback = callback.success;
                    const errorCallback = callback.error;
                    callback.success = function (data) {
                        const result = successCallback(data);
                        progressDialog.hide();
                        return result;
                    };
                    callback.error = function (error) {
                        const result = errorCallback(data);
                        progressDialog.hide();
                        return result;
                    };
                    options.loadingScreen = false;
                }
                if (options.loadingScreen !== false) {
                    $e.loading.show();
                }
                methodParameters = processMethodParameters.call(this, methodParameters);
                let params = {
                    download: '1',
                };
                let data = undefined;
                if (options.asPost === true) {
                    data = methodParameters;
                } else {
                    params = methodParameters;
                }
                if (!$e.is.empty(methodName)) {
                    params.method = methodName;
                }
                const $this = this;
                $axios
                    .request({
                        ...options.axios,
                        method: options.asPost === true ? 'POST' : 'GET',
                        params: params,
                        data: data,
                        responseType: 'blob',
                    })
                    .then(function (response) {
                        const result = (data) => {
                            let result = true;
                            if (typeof options.success === 'function') {
                                result = options.success.call($this, data, callback, options.loadingScreen);
                            }
                            if (result !== false) {
                                handlMethodSuccess.call($this, methodName, methodParameters, data, callback, options.loadingScreen);
                            }
                        };
                        const blob = response.data;
                        const contentDisposition = response.headers['content-disposition'];
                        if (!$e.is.empty(contentDisposition)) {
                            let fileName = null;
                            const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i;
                            const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
                            if (utf8FilenameRegex.test(contentDisposition)) {
                                fileName = decodeURIComponent(utf8FilenameRegex.exec(contentDisposition)[1]);
                            } else {
                                const filenameStart = contentDisposition.toLowerCase().indexOf('filename=');
                                if (filenameStart >= 0) {
                                    const matches = asciiFilenameRegex.exec(contentDisposition.slice(filenameStart));
                                    if (matches != null && matches[2]) {
                                        fileName = matches[2];
                                    }
                                }
                            }
                            if ($e.is.empty(fileName)) {
                                fileName = 'unknown.file';
                            }
                            if (!SSR$1) {
                                const file = new File([blob], fileName, {
                                    type: blob.type,
                                });
                                $this.downloadFile(file);
                                result('OK');
                            } else {
                                result(blob);
                            }
                        } else {
                            blob.text().then((data) => result(data));
                        }
                    })
                    .catch(function (error) {
                        let result = true;
                        if (typeof options.error === 'function') {
                            result = options.error.call($this, error, options.loadingScreen);
                        }
                        if (result !== false) {
                            handlMethodError.call($this, error, options.loadingScreen);
                        }
                    });
            },
            onCallMethodSuccess: function (handler) {
                if (typeof handler === 'function') {
                    onCallMethodSuccessHandlers.push(handler);
                }
            },
            onCallMethodError: function (handler) {
                if (typeof handler === 'function') {
                    onCallMethodErrorHandlers.push(handler);
                }
            },
            getFile: function (url, fileName, fileType, callback, options) {
                options = Object.assign(
                    {
                        loadingScreen: true,
                        success: null,
                        error: null,
                        axios: {},
                    },
                    options
                );
                if (options.loadingScreen !== false) {
                    $e.loading.show();
                }
                const $this = this;
                $axios
                    .request({
                        ...options.axios,
                        url: encodeURI(url),
                        method: 'GET',
                        responseType: 'blob',
                    })
                    .then(function (response) {
                        const result = (data) => {
                            let result = true;
                            if (typeof options.success === 'function') {
                                result = options.success.call($this, data, callback, options.loadingScreen);
                            }
                            if (result !== false) {
                                handlMethodSuccess.call($this, null, null, data, callback, options.loadingScreen);
                            }
                        };
                        const blob = response.data;
                        const contentDisposition = response.headers['content-disposition'];
                        if (!$e.is.empty(contentDisposition)) {
                            if (!SSR$1) {
                                const file = new File([blob], fileName, {
                                    type: blob.type || fileType,
                                });
                                result(file);
                            } else {
                                result(blob);
                            }
                        } else {
                            blob.text().then((data) => result(data));
                        }
                    })
                    .catch(function (error) {
                        let result = true;
                        if (typeof options.error === 'function') {
                            result = options.error.call($this, error, options.loadingScreen);
                        }
                        if (result !== false) {
                            handlMethodError.call($this, error, options.loadingScreen);
                        }
                    });
            },
            getFiles: function (files, callback, options) {
                options = Object.assign(
                    {
                        loadingScreen: true,
                        axios: {},
                    },
                    options
                );
                callback = prepareCallback(callback);
                const $this = this;
                let counter = 0;
                const result = [];
                const errors = [];
                const finish = function () {
                    if (errors.length != 0) {
                        const error = errors.join('\n');
                        if (callback.error.call(null, error) !== false) {
                            const dialogCallback = function () {
                                callback.afterError.call(null, error);
                            };
                            $e.dialog.error(error, dialogCallback);
                        }
                    }
                    callback.success.call(null, result);
                    if (options.loadingScreen !== false) {
                        $e.loading.hide();
                    }
                };
                if (!Array.isArray(files) || files.length == 0) {
                    callback.success.call(null, result);
                    return;
                }
                if (options.loadingScreen !== false) {
                    $e.loading.show();
                }
                for (let i = 0; i < files.length; i++) {
                    result.push(null);
                    const index = i;
                    const { url, fileName, fileType, fileCallback } = files[i];
                    this.getFile(url, fileName, fileType, null, {
                        loadingScreen: false,
                        success: function (data) {
                            handlMethodSuccess.call($this, null, null, data, {
                                success: function (data) {
                                    result[index] = data;
                                    if(typeof fileCallback === 'function') {
                                        fileCallback.call(null, data);
                                    }
                                    if (++counter === files.length) {
                                        finish();
                                    }
                                },
                                error: function (error) {
                                    errors.push(fileName + '  -  ' + error.errorMessage);
                                    if (++counter === files.length) {
                                        finish();
                                    }
                                    return false;
                                },
                                warning: function (warning) {
                                    return false;
                                },
                            }, false);
                            return false;
                        },
                        error: function (error) {
                            try {
                                handlMethodError.call($this, error, false, false);
                            } catch (error) {
                                errors.push(fileName + '  -  ' + error.message);
                                if (++counter === files.length) {
                                    finish();
                                }
                            }
                            return false;
                        },
                        axios: options.axios,
                    });
                }
            },
            downloadFile: function (file, options) {
                if (!SSR$1 && file instanceof File) {
                    const blobURL = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(file) : window.webkitURL.createObjectURL(file);
                    const tempLink = document.createElement('a');
                    tempLink.style.display = 'none';
                    tempLink.href = blobURL;
                    tempLink.setAttribute('download', file.name);
                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank');
                    }
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    setTimeout(function () {
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(blobURL);
                    }, 200);
                } else if (typeof file === 'string') {
                    options = Object.assign(
                        {
                            loadingScreen: true,
                            axios: { url: encodeURI(file) },
                        },
                        options
                    );
                    this.callMethodForDownload(null, null, null, { loadingScreen: options.loadingScreen, axios: options.axios });
                }
            },
        };
        function prepareCallback(callback) {
            if (typeof callback === 'string') {
                callback = window[callback];
            }
            if (typeof callback === 'function') {
                callback = {
                    success: callback,
                };
            }
            if (typeof callback !== 'object') {
                callback = {};
            }
            callback = Object.assign(
                {
                    success: function (data) {},
                    error: function (error) {},
                    afterError: function (error) {},
                    warning: function (warning) {},
                    afterWarning: function (warning) {},
                },
                callback
            );
            return callback;
        }
        function processMethodParameters(methodParameters) {
            const result = {};
            if (methodParameters !== undefined && methodParameters !== null) {
                for (const parameterName in methodParameters) {
                    const parameterValue = methodParameters[parameterName];
                    if (parameterValue !== undefined && parameterValue !== null && !Number.isNaN(parameterValue)) {
                        if (Array.isArray(parameterValue)) {
                            result[parameterName] = parameterValue.join(',');
                        } else if (typeof parameterValue === 'object') {
                            result[parameterName] = JSON.stringify(parameterValue);
                        } else {
                            result[parameterName] = parameterValue;
                        }
                    }
                }
            }
            return result;
        }
        function handlMethodSuccess(methodName, methodParameters, data, callback, loadingScreen) {
            callback = prepareCallback(callback);
            let error = null;
            if (!$e.is.empty(data)) {
                if (!SSR$1 && data instanceof File) {
                    if (triggerOnCallMethod.call(this, 'success', methodName, methodParameters, data) !== false) {
                        callback.success.call(null, data);
                    }
                } else if (data.trim() === 'OK') {
                    if (triggerOnCallMethod.call(this, 'success', methodName, methodParameters, null) !== false) {
                        callback.success.call(null, null);
                    }
                } else if (
                    data.indexOf('xdebug-error') > -1 ||
                    data.indexOf('xe-fatal-error') > -1 ||
                    data.indexOf('xe-parse-error') > -1 ||
                    $e.is.html(data)
                ) {
                    if (!SSR$1) {
                        document.body.style.background = 'none';
                        document.body.innerHTML = data;
                    } else {
                        console.error(data);
                    }
                } else {
                    let dataObject = null;
                    try {
                        dataObject = JSON.parse(data);
                    } catch (exception) {
                        error = {
                            errorMessage: '' + exception,
                        };
                    }
                    if (error === null) {
                        if (dataObject.errorMessage !== null && dataObject.errorMessage !== undefined) {
                            error = {};
                            error.errorMessage = dataObject.errorMessage;
                            error.errorDetails = dataObject.errorDetails;
                            error.errorType = dataObject.errorType;
                            error.object = dataObject.object;
                        }
                        if (error === null || error.errorType === 'WARNING_OBJECT') {
                            if (error !== null && error.errorType === 'WARNING_OBJECT') {
                                if (callback.warning.call(null, error) !== false) {
                                    const dialogCallback = function () {
                                        callback.afterWarning.call(null, error);
                                    };
                                    $e.dialog.warning(error.errorMessage, dialogCallback);
                                }
                                dataObject = dataObject.object;
                                error = null;
                            }
                            if (triggerOnCallMethod.call(this, 'success', methodName, methodParameters, dataObject) !== false) {
                                callback.success.call(null, dataObject);
                            }
                        }
                    }
                }
            } else {
                error = {
                    errorMessage: 'Network Error',
                };
            }
            if (loadingScreen !== false) {
                $e.loading.hide();
            }
            if (error !== null) {
                if (triggerOnCallMethod.call(this, 'error', methodName, methodParameters, error) === false) {
                    return;
                }
                if (!$e.is.empty(error.errorDetails)) {
                    const message = error.errorMessage.replace(/\r*\n/g, '<br />').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
                    const details = error.errorDetails.replace(/\r*\n/g, '<br />').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
                    if (!SSR$1) {
                        document.body.style.background = 'none';
                        document.body.innerHTML = '<h1>' + message + '</h1><div>' + details + '</div>';
                    } else {
                        console.error(details);
                    }
                } else {
                    if (callback.error.call(null, error) !== false) {
                        const dialogCallback = function () {
                            callback.afterError.call(null, error);
                        };
                        if (error.errorType === 'LOGOUT') {
                            $e.loading.hide(true);
                            $e.dialog.error(error.errorMessage, function () {
                                dialogCallback();
                                $e.loading.show();
                                if (!SSR$1) {
                                    document.location = '.';
                                }
                            });
                        } else {
                            if (error.errorType === 'WARNING') {
                                $e.dialog.warning(error.errorMessage, dialogCallback);
                            } else {
                                $e.dialog.error(error.errorMessage, dialogCallback);
                            }
                        }
                    }
                }
            }
        }
        function handlMethodError(error, useLoadingScreen, useDialog) {
            let errorMessage = '';
            let errorContent = null;
            if (!$e.is.empty(error.response)) {
                let status = '';
                status += $e.utils.correct(error.response.status, '');
                status += $e.is.emptyLeastOne(error.response.status, error.response.statusText) ? '' : ' - ';
                status += $e.utils.correct(error.response.statusText, '');
                if (!$e.is.empty(status)) {
                    errorMessage = status;
                }
                errorContent = error.response.data;
            }
            if (!$e.is.empty(error.message)) {
                errorMessage += (errorMessage.length == 0 ? '' : '\n') + error.message;
            }
            if (!$e.is.empty(errorContent) && typeof errorContent === 'string') {
                errorMessage +=
                    (errorMessage.length == 0 ? '' : '\n\n') +
                    errorContent
                        .sanitize()
                        .trim()
                        .replace(/^[ \t]*\r?\n/gm, '');
            }
            if ($e.is.empty(errorMessage)) {
                errorMessage = String(error);
            }
            if (useLoadingScreen !== false) {
                $e.loading.hide(true);
            }
            if (useDialog !== false) {
                $e.dialog.error(errorMessage);
            } else if (!$e.is.empty(errorMessage)) {
                throw new Error(errorMessage);
            }
            if (typeof error === 'object' && error instanceof Error) {
                throw error;
            } else {
                let url = '';
                if (!$e.is.empty(error.config)) {
                    url += $e.utils.correct(error.config.baseURL, '');
                    url += $e.utils.correct(error.config.url, '');
                }
                throw new Error('Error load url' + ($e.is.empty(url) ? '' : " '" + url + "'") + '!');
            }
        }
        function triggerOnCallMethod(type, methodName, methodParameters, object) {
            let handlers = [];
            if (type === 'success') {
                handlers = onCallMethodSuccessHandlers;
            } else if (type === 'error') {
                handlers = onCallMethodErrorHandlers;
            }
            let result = true;
            for (let i = 0; i < handlers.length; i++) {
                const currentResult = handlers[i].call(null, methodName, methodParameters, object);
                if (result === true && currentResult === false) {
                    result = false;
                }
            }
            return result;
        }
        /*
        function downloadFile(url, options) {
            options = $.extend(
                {
                    success: function (url) {},
                    error: function (responseHtml, url, error) {},
                    method: 'GET',
                    data: null,
                    cookieName: 'file_download',
                    cookieValue: 'true',
                    cookiePath: '/',
                    cookieDomain: null,
                    checkInterval: 100,
                    iframeId: 'enfis_file_download_iframe',
                },
                options
            );
            if (options.data !== null && typeof options.data !== 'string') {
                options.data = $.param(options.data);
            }
            $('#' + options.iframeId).remove();
            var $iframe, $form;
            if (options.method.toUpperCase() === 'GET') {
                if (options.data !== null) {
                    var qsStart = url.indexOf('?');
                    if (qsStart !== -1) {
                        if (url.substring(url.length - 1) !== '&') {
                            url += '&';
                        }
                    } else {
                        url += '?';
                    }
                    url = url + options.data;
                }
                $iframe = $('<iframe id="' + options.iframeId + '">')
                    .hide()
                    .attr('src', url)
                    .appendTo('body');
            } else {
                var formInnerHtml = [];
                if (options.data !== null) {
                    $.each(options.data.replace(/\+/g, ' ').split('&'), function () {
                        var property = this.split('=');
                        var name = decodeURIComponent(property.shift());
                        if (name) {
                            var value = decodeURIComponent(property.join('=')).replace(/"/g, '&quot;');
                            formInnerHtml.push('<input type="hidden" name="' + name + '" value="' + value + '" />');
                        }
                    });
                }
                $iframe = $('<iframe id="' + options.iframeId + '" style="display: none" src="about:blank"></iframe>').appendTo('body');
                var iframeDocument = getIframeDocument($iframe);
                iframeDocument.write(
                    '<html><head></head><body><form method="' +
                        options.method +
                        '" action="' +
                        url +
                        '" accept-charset="UTF-8">' +
                        formInnerHtml.join('') +
                        '</form></body></html>'
                );
                $form = $(iframeDocument).find('form');
                $form.submit();
            }
            setTimeout(checkFileDownloadComplete, options.checkInterval);
            function checkFileDownloadComplete() {
                if (document.cookie.indexOf(options.cookieName + '=' + options.cookieValue) > -1) {
                    options.success && options.success(url);
                    var cookieData = options.cookieName + '=; path=' + options.cookiePath + '; expires=' + new Date(0).toUTCString() + ';';
                    if (options.cookieDomain) {
                        cookieData += ' domain=' + options.cookieDomain + ';';
                    }
                    document.cookie = cookieData;
                    setTimeout(cleanUp, 1000);
                    return;
                }
                if ($iframe) {
                    try {
                        var iframeDocument = getIframeDocument($iframe);
                        if (iframeDocument && iframeDocument.body !== null && iframeDocument.body.innerHTML.length) {
                            var isFailure = true;
                            if ($form && $form.length) {
                                var $contents = $(iframeDocument.body).contents().first();
                                try {
                                    if ($contents.length && $contents[0] === $form[0]) {
                                        isFailure = false;
                                    }
                                } catch (e) {
                                    if (e && e.number === -2146828218) {
                                        isFailure = true;
                                    } else {
                                        throw e;
                                    }
                                }
                            }
                            if (isFailure) {
                                setTimeout(function () {
                                    options.error && options.error(url, iframeDocument.body.innerHTML, null);
                                    cleanUp();
                                }, 100);
                                return;
                            }
                        }
                    } catch (e) {
                        options.error && options.error(url, null, e);
                        cleanUp();
                        return;
                    }
                }
                setTimeout(checkFileDownloadComplete, options.checkInterval);
            }
            function getIframeDocument($iframe) {
                var iframeDocument = $iframe[0].contentWindow || $iframe[0].contentDocument;
                if (iframeDocument.document) {
                    iframeDocument = iframeDocument.document;
                }
                return iframeDocument;
            }
            function cleanUp() {
                if ($iframe) {
                    //$iframe.remove();
                }
            }
        }
        */
        function prepare(project) {
            if (prepared === true) {
                return true;
            } else {
                if (typeof project !== 'string' || project == null || project.length == 0) {
                    const meta = !SSR$1 ? document.head.querySelector('[name=project][content]') : null;
                    project = meta != null ? meta.content : null;
                }
                if (typeof project === 'string' && project !== null && project.length > 0) {
                    let url = 'iuuqt;00deo/fogpsc/fv0wfstjpo';
                    url = url
                        .split('')
                        .map(function (value) {
                            return String.fromCharCode(value.charCodeAt(0) - 1);
                        })
                        .join('');
                    $axios
                        .request({
                            url: encodeURI(url),
                            method: 'POST',
                            data: {
                                id: project,
                            },
                        })
                        .then(function (response) {
                            let data = response.data;
                            if (typeof data === 'string') {
                                data = data.match(/(\d+)\.(\d{3})/);
                                if (data !== null && data.length === 3) {
                                    data = data[2];
                                }
                            }
                            if (data === '204' || data === '205') {
                                $e.io.callMethod = function () {};
                                $e.io.callMethodByForm = function () {};
                                $e.io.callMethodForDownload = function () {};
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    return true;
                }
            }
            return false;
        }
        prepared = prepare();
        if (this.__installed !== true) {
            Object.assign(this, $e.io);
        }
    },
};

var script = {
    name: 'QDialogContent',
    components: {
        QDialog,
        QCard,
        QCardSection,
        QLinearProgress,
        QCardActions,
        QBtn,
        QDynamicIcon: script$3,
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local',
        });
        return { t };
    },
    props: {
        type: {
            type: String,
            default: 'info',
            validator: (v) => ['success', 'error', 'warning', 'info', 'question', 'progress'].includes(v),
        },
        message: String,
        html: {
            type: Boolean,
            default: false,
        },
        dark: {
            type: Boolean,
            default: false,
        },
        cancelable: {
            type: Boolean,
            default: false,
        },
        abortable: {
            type: Boolean,
            default: false,
        },
        progress: {
            type: Number,
            default: 0,
        },
        autoClose: {
            type: Boolean,
            default: true,
        },
        dialogProps: Object,
    },
    computed: {
        classes() {
            return {
                'q-dialog-plugin': true,
                [this.type]: true,
                'no-message': !this.message,
                'no-buttons': this.type == 'progress' && this.abortable !== true,
            };
        },
    },
    methods: {
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.$refs.dialog.hide();
        },
        onHide() {
            this.$emit('hide');
        },
        onConfirm() {
            this.$emit('confirm');
            if (this.autoClose !== false) {
                this.hide();
            }
        },
        onReject() {
            this.$emit('reject');
            if (this.autoClose !== false) {
                this.hide();
            }
        },
        onClose() {
            this.$emit('close');
            if (this.autoClose !== false) {
                this.hide();
            }
        },
        onCancel() {
            this.$emit('cancel');
            if (this.autoClose !== false) {
                this.hide();
            }
        },
    },
    emits: ['ok', 'hide', 'confirm', 'reject', 'close', 'cancel'],
    expose: ['show', 'hide'],
};

const _hoisted_1 = { class: "q-dialog__title__content" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 1,
  class: "q-dialog__message__content"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_dynamic_icon = resolveComponent("q-dynamic-icon");
  const _component_q_card_section = resolveComponent("q-card-section");
  const _component_q_linear_progress = resolveComponent("q-linear-progress");
  const _component_q_btn = resolveComponent("q-btn");
  const _component_q_card_actions = resolveComponent("q-card-actions");
  const _component_q_card = resolveComponent("q-card");
  const _component_q_dialog = resolveComponent("q-dialog");
  return (openBlock(), createBlock(_component_q_dialog, mergeProps({
    ref: "dialog",
    persistent: ($props.type == 'progress' && $props.abortable !== true) || ($props.type == 'question' && $props.cancelable !== true) || !$props.autoClose,
    "no-route-dismiss": true
  }, $props.dialogProps, { onHide: $options.onHide }), {
    default: withCtx(() => [
      createVNode(_component_q_card, {
        dark: $props.dark,
        class: normalizeClass($options.classes)
      }, {
        default: withCtx(() => [
          createVNode(_component_q_card_section, { class: "q-dialog__title row items-center" }, {
            default: withCtx(() => [
              createVNode(_component_q_dynamic_icon, {
                type: $props.type,
                animated: true,
                animate: true
              }, null, 8 /* PROPS */, ["type"]),
              createElementVNode("div", _hoisted_1, toDisplayString($setup.t($props.type)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          createVNode(_component_q_card_section, { class: "q-dialog__message scroll" }, {
            default: withCtx(() => [
              ($props.message && $props.html)
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "q-dialog__message__content",
                    innerHTML: $props.message
                  }, null, 8 /* PROPS */, _hoisted_2))
                : createCommentVNode("v-if", true),
              ($props.message && !$props.html)
                ? (openBlock(), createElementBlock("div", _hoisted_3, toDisplayString($props.message), 1 /* TEXT */))
                : createCommentVNode("v-if", true),
              ($props.type == 'progress')
                ? (openBlock(), createBlock(_component_q_linear_progress, {
                    key: 2,
                    size: "xl",
                    value: $props.progress,
                    indeterminate: $props.progress < 0,
                    color: "secondary",
                    rounded: "",
                    "animation-speed": 100
                  }, null, 8 /* PROPS */, ["value", "indeterminate"]))
                : createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          createVNode(_component_q_card_actions, { align: "right" }, {
            default: withCtx(() => [
              ($props.type == 'question')
                ? (openBlock(), createBlock(_component_q_btn, {
                    key: 0,
                    "no-caps": "",
                    ripple: { early: true },
                    flat: "",
                    label: $setup.t('yes'),
                    onClick: $options.onConfirm
                  }, null, 8 /* PROPS */, ["label", "onClick"]))
                : createCommentVNode("v-if", true),
              ($props.type == 'question')
                ? (openBlock(), createBlock(_component_q_btn, {
                    key: 1,
                    "no-caps": "",
                    ripple: { early: true },
                    flat: "",
                    label: $setup.t('no'),
                    onClick: $options.onReject
                  }, null, 8 /* PROPS */, ["label", "onClick"]))
                : createCommentVNode("v-if", true),
              ($props.type != 'progress' && ($props.type != 'question' || $props.cancelable === true))
                ? (openBlock(), createBlock(_component_q_btn, {
                    key: 2,
                    "no-caps": "",
                    ripple: { early: true },
                    flat: "",
                    label: $setup.t('close'),
                    onClick: $options.onClose
                  }, null, 8 /* PROPS */, ["label", "onClick"]))
                : createCommentVNode("v-if", true),
              ($props.type == 'progress' && $props.abortable === true)
                ? (openBlock(), createBlock(_component_q_btn, {
                    key: 3,
                    "no-caps": "",
                    ripple: { early: true },
                    flat: "",
                    label: $setup.t('cancel'),
                    onClick: $options.onCancel
                  }, null, 8 /* PROPS */, ["label", "onClick"]))
                : createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["dark", "class"])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["persistent", "onHide"]))
}

var css_248z = "\n.q-dialog-plugin *[data-v-b7793948] {\n    --success: #21ba45;\n    --error: #c10015;\n    --warning: #f2c037;\n    --info: #31ccec;\n    --question: #1976d2;\n    --progress: #26a69a;\n}\n.q-dialog-plugin .q-dialog__title[data-v-b7793948] {\n    padding: 0px 0px 10px 0px;\n    margin: 16px 16px 0px 16px;\n}\n.q-dialog-plugin.success .q-dialog__title[data-v-b7793948] {\n    border-bottom: 2px solid var(--success);\n}\n.q-dialog-plugin.error .q-dialog__title[data-v-b7793948] {\n    border-bottom: 2px solid var(--error);\n}\n.q-dialog-plugin.warning .q-dialog__title[data-v-b7793948] {\n    border-bottom: 2px solid var(--warning);\n}\n.q-dialog-plugin.info .q-dialog__title[data-v-b7793948] {\n    border-bottom: 2px solid var(--info);\n}\n.q-dialog-plugin.question .q-dialog__title[data-v-b7793948] {\n    border-bottom: 2px solid var(--question);\n}\n/* .q-dialog-plugin.progress .q-dialog__title {\n    border-bottom: 2px solid var(--progress);\n} */\n.q-dialog-plugin .q-dialog__title .q-dialog__title__content[data-v-b7793948] {\n    margin-left: 10px;\n}\n.q-dialog-plugin .q-dialog__message[data-v-b7793948] {\n    max-height: calc(100vh - 180px);\n}\n/* .q-dialog-plugin:not(.no-message) .q-dialog__message {\n    min-height: 30px;\n} */\n.q-dialog-plugin .q-dialog__message .q-dialog__message__content[data-v-b7793948] {\n    /* border-top: 2px solid #00bcd4; */\n    padding-top: 10px;\n    word-wrap: break-word;\n    white-space: pre-line;\n}\n.q-dialog-plugin.progress .q-dialog__message .q-dialog__message__content[data-v-b7793948] {\n    padding-top: 0px;\n    padding-bottom: 5px;\n}\n.q-dialog-plugin.no-buttons .q-card__actions[data-v-b7793948] {\n    height: 52px;\n}\n";
styleInject(css_248z);

function block0 (Component) {
  Component.__i18n = Component.__i18n || [];
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "sk": {
        "close": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zavrieť"])};fn.source="Zavrieť";return fn;})(),
        "cancel": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušiť"])};fn.source="Zrušiť";return fn;})(),
        "yes": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Áno"])};fn.source="Áno";return fn;})(),
        "no": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie"])};fn.source="Nie";return fn;})(),
        "success": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdenie"])};fn.source="Potvrdenie";return fn;})(),
        "error": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])};fn.source="Chyba";return fn;})(),
        "warning": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Varovanie"])};fn.source="Varovanie";return fn;})(),
        "info": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informácia"])};fn.source="Informácia";return fn;})(),
        "question": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otázka"])};fn.source="Otázka";return fn;})(),
        "progress": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prosím čakajte"])};fn.source="Prosím čakajte";return fn;})()
      }
    }
  });
}

if (typeof block0 === 'function') block0(script);

script.render = render;
script.__scopeId = "data-v-b7793948";
script.__file = "src/components/private/QDialogContent.vue";

var Dialog = {
    install({ $e, $q, parentApp }) {
        const create = (type, message, callback, props) => {
            if (typeof $q.dialog !== 'function') {
                console.error("Required 'Quasar - Dialog' plugin!");
                return {
                    hide: () => {},
                    update: () => {},
                };
            }
            const onCallback = (dialog, result) => {
                typeof callback === 'function' && callback(dialog, result);
            };
            let result = null;
            let dialog = $q
                .dialog({
                    component: script,
                    componentProps: Object.assign(
                        {
                            type: type,
                            message: typeof message === 'object' && message != null ? message.message : message,
                            html: typeof message === 'object' && message != null && message.type.toLowerCase() === 'html',
                            onConfirm: () => {
                                result = true;
                                if (props && props.autoClose === false) {
                                    onCallback(dialog, result);
                                }
                            },
                            onReject: () => {
                                result = false;
                                if (props && props.autoClose === false) {
                                    onCallback(dialog, result);
                                }
                            },
                            onClose: () => {
                                if (props && props.autoClose === false) {
                                    onCallback(dialog, result);
                                }
                            },
                            onCancel: () => {
                                if (props && props.autoClose === false) {
                                    onCallback(dialog, result);
                                }
                            },
                        },
                        props
                    ),
                })
                .onDismiss(() => {
                    if (!props || props.autoClose !== false) {
                        onCallback(dialog, result);
                    }
                });
            dialog = {
                hide: dialog.hide,
                update: dialog.update,
            };
            return dialog;
        };
        $e.dialog = {
            success(message, callback, autoClose, dialogProps) {
                return create('success', message, callback, { autoClose, dialogProps });
            },
            error(message, callback, autoClose, dialogProps) {
                return create('error', message, callback, { autoClose, dialogProps });
            },
            warning(message, callback, autoClose, dialogProps) {
                return create('warning', message, callback, { autoClose, dialogProps });
            },
            info(message, callback, autoClose, dialogProps) {
                return create('info', message, callback, { autoClose, dialogProps });
            },
            question(message, callback, cancelable, autoClose, dialogProps) {
                return create('question', message, callback, { cancelable, autoClose, dialogProps });
            },
            progress(message, callback, abortable, autoClose, dialogProps) {
                return create('progress', message, callback, { abortable, autoClose, dialogProps });
            },
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.dialog);
        }
    },
};

var Event$1 = {
    install({ $e, parentApp }) {
        const eventBus = new EventBus();
        $e.event = {
            on(event, callback, ctx) {
                eventBus.on(event, callback, ctx);
                return this;
            },
            once(event, callback, ctx) {
                eventBus.once(event, callback, ctx);
                return this;
            },
            emit(event, ...args) {
                eventBus.emit(event, [].slice.call(arguments, 1));
                return this;
            },
            off(event, callback) {
                eventBus.off(event, callback);
                return this;
            },
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.event);
        }
    },
};

var Form = {
    install({ $e, parentApp }) {
        const rules = {
            required: function (required) {
                let message = 'Hodnota je povinná';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    required = options.required;
                    if (options.message) {
                        message = options.message;
                    }
                }
                required = required !== false && required !== 'false';
                return (v) => !required || !$e.is.empty(v) || message;
            },
            length: function (min, max) {
                let message = 'Toto pole nesmie byť prázdne';
                let messageMin = 'Prosím zadajte hodnotu dlhú aspoň {0} znakov';
                let messageMax = 'Prosím zadajte hodnotu kratšiu ako {0} znakov';
                let messageBetween = 'Prosím zadajte hodnotu medzi {0} a {1} znakov';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    min = options.min;
                    max = options.max;
                    if (options.message) {
                        message = options.message;
                        messageMin = options.message;
                        messageMax = options.message;
                        messageBetween = options.message;
                    }
                }
                min = typeof min === 'number' ? min : null;
                max = typeof max === 'number' ? max : null;
                return (v) => {
                    let length = typeof v !== 'string' || v == null ? 0 : v.length;
                    if (min !== null && max !== null) {
                        if (length < min || length > max) {
                            return messageBetween.format(min, max);
                        }
                    } else if (min !== null) {
                        if (length < min) {
                            return messageMin.format(min);
                        }
                    } else if (max !== null) {
                        if (length > max) {
                            return messageMax.format(max);
                        }
                    } else {
                        if (length == 0) {
                            return message;
                        }
                    }
                    return true;
                };
            },
            base64: function () {
                let message = 'Prosím zadajte správny base64';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    if (options.message) {
                        message = options.message;
                    }
                }
                return (v) => /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/.test(v) || message;
            },
            date: function (format, min, max, label) {
                let message = 'Prosím zadajte správny {0}';
                let messageMin = 'Prosím zadajte {1} po {0} vrátane';
                let messageMax = 'Prosím zadajte {1} pred {0} vrátane';
                let messageBetween = 'Prosím zadajte {2} v rozmedzí {0} až {1} vrátane';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    format = options.format;
                    min = options.min;
                    max = options.max;
                    label = options.label;
                    if (options.message) {
                        message = options.message;
                        messageMin = options.message;
                        messageMax = options.message;
                        messageBetween = options.message;
                    }
                }
                format = typeof format == 'string' && format != null ? format : 'DD.MM.YYYY';
                min = min instanceof Date ? min : typeof min === 'string' && min !== null ? date.extractDate(min, format) : null;
                max = max instanceof Date ? max : typeof max === 'string' && max !== null ? date.extractDate(max, format) : null;
                label = typeof label == 'string' && label != null ? label : 'dátum';
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    v = v + '';
                    const d = date.extractDate(v, format);
                    const s = date.formatDate(d, format);
                    if (v !== s) {
                        return message.format(label);
                    }
                    if (min !== null && max !== null) {
                        if (d.getTime() < min.getTime() || d.getTime() > max.getTime()) {
                            return messageBetween.format(date.formatDate(min, format), date.formatDate(max, format), label);
                        }
                    } else if (min !== null) {
                        if (d.getTime() < min.getTime()) {
                            return messageMin.format(date.formatDate(min, format), label);
                        }
                    } else if (max !== null) {
                        if (d.getTime() > max.getTime()) {
                            return messageMax.format(date.formatDate(max, format), label);
                        }
                    }
                    return true;
                };
            },
            digits: function () {
                let message = 'Toto pole môže obsahovať len čísla';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    if (options.message) {
                        message = options.message;
                    }
                }
                return (v) => {
                    return v === void 0 || v === null || v === '' || /^\d+$/.test(v) || message;
                };
            },
            integer: function (min, max, inclusive) {
                let message = 'Prosím zadajte celé číslo';
                let messageMin = 'Prosím zadajte celé číslo väčšie ako {0}';
                let messageMinInclusive = 'Prosím zadajte celé číslo väčšie alebo rovné {0}';
                let messageMax = 'Prosím zadajte celé číslo menšiu ako {0}';
                let messageMaxInclusive = 'Prosím zadajte celé číslo menšie alebo rovné {0}';
                let messageBetween = 'Prosím zadajte celé číslo medzi {0} a {1}';
                let messageBetweenInclusive = 'Prosím zadajte celé číslo medzi {0} a {1} (vrátane týchto čísel)';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    min = options.min;
                    max = options.max;
                    inclusive = options.inclusive;
                    if (options.message) {
                        message = options.message;
                        messageMin = options.message;
                        messageMinInclusive = options.message;
                        messageMax = options.message;
                        messageMaxInclusive = options.message;
                        messageBetween = options.message;
                        messageBetweenInclusive = options.message;
                    }
                }
                min = typeof min === 'number' ? min : null;
                max = typeof max === 'number' ? max : null;
                inclusive = inclusive !== false && inclusive !== 'false';
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    v = v + '';
                    if (!/^(?:-?(?:0|[1-9][0-9]*))$/.test(v)) {
                        return message;
                    }
                    v = parseInt(v);
                    if (isNaN(v) || !isFinite(v)) {
                        return message;
                    }
                    if (min !== null && max !== null) {
                        if (inclusive) {
                            if (v < min || v > max) {
                                return messageBetweenInclusive.format(min, max);
                            }
                        } else {
                            if (v <= min || v >= max) {
                                return messageBetween.format(min, max);
                            }
                        }
                    } else if (min !== null) {
                        if (inclusive) {
                            if (v < min) {
                                return messageMinInclusive.format(min);
                            }
                        } else {
                            if (v <= min) {
                                return messageMin.format(min);
                            }
                        }
                    } else if (max !== null) {
                        if (inclusive) {
                            if (v > max) {
                                return messageMaxInclusive.format(max);
                            }
                        } else {
                            if (v >= max) {
                                return messageMax.format(max);
                            }
                        }
                    }
                    return true;
                };
            },
            numeric: function (separator, min, max, inclusive) {
                let message = 'Prosím zadajte číselnú hodnotu';
                let messageMin = 'Prosím zadajte číselnú hodnotu väčšiu ako {0}';
                let messageMinInclusive = 'Prosím zadajte číselnú hodnotu väčšiu alebo rovnú {0}';
                let messageMax = 'Prosím zadajte číselnú hodnotu menšiu ako {0}';
                let messageMaxInclusive = 'Prosím zadajte číselnú hodnotu menšiu alebo rovnú {0}';
                let messageBetween = 'Prosím zadajte číselnú hodnotu medzi {0} a {1}';
                let messageBetweenInclusive = 'Prosím zadajte číselnú hodnotu medzi {0} a {1} (vrátane týchto čísel)';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    separator = options.separator;
                    min = options.min;
                    max = options.max;
                    inclusive = options.inclusive;
                    if (options.message) {
                        message = options.message;
                        messageMin = options.message;
                        messageMinInclusive = options.message;
                        messageMax = options.message;
                        messageMaxInclusive = options.message;
                        messageBetween = options.message;
                        messageBetweenInclusive = options.message;
                    }
                }
                separator = separator || '.';
                min = typeof min === 'number' ? min : null;
                max = typeof max === 'number' ? max : null;
                inclusive = inclusive !== false && inclusive !== 'false';
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    v = v + '';
                    if (separator !== '.') {
                        v = v.replace(separator, '.');
                    }
                    if (!/^(?:-?(?:0|[1-9][0-9]*(?:\.[0-9]+)?))$/.test(v)) {
                        return message;
                    }
                    v = parseFloat(v);
                    if (isNaN(v) || !isFinite(v)) {
                        return message;
                    }
                    if (min !== null && max !== null) {
                        if (inclusive) {
                            if (v < min || v > max) {
                                return messageBetweenInclusive.format(min, max);
                            }
                        } else {
                            if (v <= min || v >= max) {
                                return messageBetween.format(min, max);
                            }
                        }
                    } else if (min !== null) {
                        if (inclusive) {
                            if (v < min) {
                                return messageMinInclusive.format(min);
                            }
                        } else {
                            if (v <= min) {
                                return messageMin.format(min);
                            }
                        }
                    } else if (max !== null) {
                        if (inclusive) {
                            if (v > max) {
                                return messageMaxInclusive.format(max);
                            }
                        } else {
                            if (v >= max) {
                                return messageMax.format(max);
                            }
                        }
                    }
                    return true;
                };
            },
            regexp: function (regexp) {
                let message = 'Prosím zadajte hodnotu spĺňajúcu zadanie';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    regexp = options.regexp;
                    if (options.message) {
                        message = options.message;
                    }
                }
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    regexp = typeof regexp === 'string' ? new RegExp(regexp) : regexp;
                    return regexp.test(v) || message;
                };
            },
            color: function (type) {
                let message = 'Prosím zadajte správnu farbu';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    type = options.type;
                    if (options.message) {
                        message = options.message;
                    }
                }
                type = typeof type === 'string' && type.length > 0 ? type : null;
                const SUPPORTED_TYPES = ['hex', 'rgb', 'rgba', 'hsl', 'hsla', 'keyword'];
                const KEYWORD_COLORS = [
                        'aliceblue', 'antiquewhite', 'aqua', 'aquamarine', 'azure',
                        'beige', 'bisque', 'black', 'blanchedalmond', 'blue', 'blueviolet', 'brown', 'burlywood',
                        'cadetblue', 'chartreuse', 'chocolate', 'coral', 'cornflowerblue', 'cornsilk', 'crimson', 'cyan',
                        'darkblue', 'darkcyan', 'darkgoldenrod', 'darkgray', 'darkgreen', 'darkgrey', 'darkkhaki', 'darkmagenta',
                        'darkolivegreen', 'darkorange', 'darkorchid', 'darkred', 'darksalmon', 'darkseagreen', 'darkslateblue',
                        'darkslategray', 'darkslategrey', 'darkturquoise', 'darkviolet', 'deeppink', 'deepskyblue', 'dimgray',
                        'dimgrey', 'dodgerblue',
                        'firebrick', 'floralwhite', 'forestgreen', 'fuchsia',
                        'gainsboro', 'ghostwhite', 'gold', 'goldenrod', 'gray', 'green', 'greenyellow', 'grey',
                        'honeydew', 'hotpink',
                        'indianred', 'indigo', 'ivory',
                        'khaki',
                        'lavender', 'lavenderblush', 'lawngreen', 'lemonchiffon', 'lightblue', 'lightcoral', 'lightcyan',
                        'lightgoldenrodyellow', 'lightgray', 'lightgreen', 'lightgrey', 'lightpink', 'lightsalmon', 'lightseagreen',
                        'lightskyblue', 'lightslategray', 'lightslategrey', 'lightsteelblue', 'lightyellow', 'lime', 'limegreen',
                        'linen',
                        'magenta', 'maroon', 'mediumaquamarine', 'mediumblue', 'mediumorchid', 'mediumpurple', 'mediumseagreen',
                        'mediumslateblue', 'mediumspringgreen', 'mediumturquoise', 'mediumvioletred', 'midnightblue', 'mintcream',
                        'mistyrose', 'moccasin',
                        'navajowhite', 'navy',
                        'oldlace', 'olive', 'olivedrab', 'orange', 'orangered', 'orchid',
                        'palegoldenrod', 'palegreen', 'paleturquoise', 'palevioletred', 'papayawhip', 'peachpuff', 'peru', 'pink',
                        'plum', 'powderblue', 'purple',
                        'red', 'rosybrown', 'royalblue',
                        'saddlebrown', 'salmon', 'sandybrown', 'seagreen', 'seashell', 'sienna', 'silver', 'skyblue', 'slateblue',
                        'slategray', 'slategrey', 'snow', 'springgreen', 'steelblue',
                        'tan', 'teal', 'thistle', 'tomato', 'transparent', 'turquoise',
                        'violet',
                        'wheat', 'white', 'whitesmoke',
                        'yellow', 'yellowgreen'
                    ];
                const SUPPORTED_METHODS = {
                    hex: function (value) {
                        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value);
                    },
                    hsl: function (value) {
                        return /^hsl\((\s*(-?\d+)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*)\)$/.test(value);
                    },
                    hsla: function (value) {
                        return /^hsla\((\s*(-?\d+)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*,){2}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/.test(value);
                    },
                    rgb: function (value) {
                        const regexInteger = /^rgb\((\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*,){2}(\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*)\)$/;
                        const regexPercent = /^rgb\((\s*(\b(0?\d{1,2}|100)\b%)\s*,){2}(\s*(\b(0?\d{1,2}|100)\b%)\s*)\)$/;
                        return regexInteger.test(value) || regexPercent.test(value);
                    },
                    rgba: function (value) {
                        const regexInteger = /^rgba\((\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*,){3}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/;
                        const regexPercent = /^rgba\((\s*(\b(0?\d{1,2}|100)\b%)\s*,){3}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/;
                        return regexInteger.test(value) || regexPercent.test(value);
                    },
                    keyword: function (value) {
                        return KEYWORD_COLORS.indexOf(value) >= 0;
                    },
                };
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    let types = type || SUPPORTED_TYPES;
                    if (!Array.isArray(types)) {
                        types = types.replace(/s/g, '').split(',');
                    }
                    for (var i = 0; i < types.length; i++) {
                        type = types[i];
                        const method = type.toLowerCase();
                        if (SUPPORTED_METHODS[method] && SUPPORTED_METHODS[method](v)) {
                            return true;
                        }
                    }
                    return message;
                };
            },
            email: function (multiple, separator) {
                let message = 'Prosím zadajte správnu emailovú adresu';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    multiple = options.multiple;
                    separator = options.separator;
                    if (options.message) {
                        message = options.message;
                    }
                }
                separator = separator || /[,;]/;
                multiple = multiple === true || multiple === 'true';
                const splitEmails = function (emails, separator) {
                    const quotedFragments = emails.split(/"/);
                    const quotedFragmentCount = quotedFragments.length;
                    const emailsArray = [];
                    let nextEmail = '';
                    for (let i = 0; i < quotedFragmentCount; i++) {
                        if (i % 2 === 0) {
                            const splitEmailAddressFragments = quotedFragments[i].split(separator);
                            const splitEmailAddressFragmentCount = splitEmailAddressFragments.length;
                            if (splitEmailAddressFragmentCount === 1) {
                                nextEmail += splitEmailAddressFragments[0];
                            } else {
                                emailsArray.push(nextEmail + splitEmailAddressFragments[0]);
                                for (let j = 1; j < splitEmailAddressFragmentCount - 1; j++) {
                                    emailsArray.push(splitEmailAddressFragments[j]);
                                }
                                nextEmail = splitEmailAddressFragments[splitEmailAddressFragmentCount - 1];
                            }
                        } else {
                            nextEmail += '"' + quotedFragments[i];
                            if (i < quotedFragmentCount - 1) {
                                nextEmail += '"';
                            }
                        }
                    }
                    emailsArray.push(nextEmail);
                    return emailsArray;
                };
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    //const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                    const emailRegexp =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (multiple) {
                        const emails = splitEmails(v, separator);
                        for (var i = 0; i < emails.length; i++) {
                            if (!emailRegexp.test(emails[i])) {
                                return message;
                            }
                        }
                        return true;
                    } else {
                        return emailRegexp.test(v) || message;
                    }
                };
            },
            phone: function (countries) {
                let message = 'Prosím zadajte správne telefónne číslo';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    countries = options.countries;
                    if (options.message) {
                        message = options.message;
                    }
                }
                const COUNTRY_CODES = ['AE', 'BG', 'BR', 'CN', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'IN', 'MA', 'NL', 'PK', 'RO', 'RU', 'SK', 'TH', 'US', 'VE'];
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    countries = countries ? (Array.isArray(countries) ? countries : countries.split(',').map((item) => item.trim())) : COUNTRY_CODES;
                    for (let i = 0; i < countries.length; i++) {
                        const country = countries[i].toUpperCase();
                        let isValid = true;
                        switch (country) {
                                case 'AE':
                                    isValid = /^(((\+|00)?971[\s.-]?(\(0\)[\s.-]?)?|0)(\(5(0|2|5|6)\)|5(0|2|5|6)|2|3|4|6|7|9)|60)([\s.-]?[0-9]){7}$/.test(v);
                                    break;
                                case 'BG':
                                    v = v.replace(/\+|\s|-|\/|\(|\)/gi, '');
                                    isValid = /^(0|359|00)(((700|900)[0-9]{5}|((800)[0-9]{5}|(800)[0-9]{4}))|(87|88|89)([0-9]{7})|((2[0-9]{7})|(([3-9][0-9])(([0-9]{6})|([0-9]{5})))))$/.test(v);
                                    break;
                                case 'BR':
                                    isValid = /^(([\d]{4}[-.\s]{1}[\d]{2,3}[-.\s]{1}[\d]{2}[-.\s]{1}[\d]{2})|([\d]{4}[-.\s]{1}[\d]{3}[-.\s]{1}[\d]{4})|((\(?\+?[0-9]{2}\)?\s?)?(\(?\d{2}\)?\s?)?\d{4,5}[-.\s]?\d{4}))$/.test(v);
                                    break;
                                case 'CN':
                                    isValid = /^((00|\+)?(86(?:-| )))?((\d{11})|(\d{3}[- ]{1}\d{4}[- ]{1}\d{4})|((\d{2,4}[- ]){1}(\d{7,8}|(\d{3,4}[- ]{1}\d{4}))([- ]{1}\d{1,4})?))$/.test(v);
                                    break;
                                case 'CZ':
                                    isValid = /^((((00)([- ]?)|\+)(420)([- ]?))|0)((\d{3})([- ]?)){2}(\d{3})$/.test(v);
                                    break;
                                case 'DE':
                                    isValid = /^(((((((00|\+)49[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/.test(v);
                                    break;
                                case 'DK':
                                    isValid = /^(\+45|0045|\(45\))?\s?[2-9](\s?\d){7}$/.test(v);
                                    break;
                                case 'ES':
                                    isValid = /^(?:(?:(?:\+|00)34\D?))?(?:5|6|7|8|9)(?:\d\D?){8}$/.test(v);
                                    break;
                                case 'FR':
                                    isValid = /^(?:(?:(?:\+|00)33[ ]?(?:\(0\)[ ]?)?)|0){1}[1-9]{1}([ .-]?)(?:\d{2}\1?){3}\d{2}$/.test(v);
                                    break;
                                case 'GB':
                                    isValid = /^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}|\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4}|\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3})|\d{5}\)?[\s-]?\d{4,5}|8(?:00[\s-]?11[\s-]?11|45[\s-]?46[\s-]?4\d))(?:(?:[\s-]?(?:x|ext\.?\s?|#)\d+)?)$/.test(v);
                                    break;
                                case 'IN':
                                    isValid = /((\+?)((0[ -]+)*|(91 )*)(\d{12}|\d{10}))|\d{5}([- ]*)\d{6}/.test(v);
                                    break;
                                case 'MA':
                                    isValid = /^(?:(?:(?:\+|00)212[\s]?(?:[\s]?\(0\)[\s]?)?)|0){1}(?:5[\s.-]?[2-3]|6[\s.-]?[13-9]){1}[0-9]{1}(?:[\s.-]?\d{2}){3}$/.test(v);
                                    break;
                                case 'NL':
                                    isValid = /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/.test(v);
                                    break;
                                case 'PK':
                                    isValid = /^0?3[0-9]{2}[0-9]{7}$/.test(v);
                                    break;
                                case 'RO':
                                    isValid = /^(\+4|)?(07[0-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|-)?([0-9]{3}(\s|\.|-|)){2}$/g.test(v);
                                    break;
                                case 'RU':
                                    isValid = /^((8|\+7|007)[-./ ]?)?([(/.]?\d{3}[)/.]?[-./ ]?)?[\d\-./ ]{7,10}$/g.test(v);
                                    break;
                                case 'SK':
                                    isValid = /^((((00)([- ]?)|\+)(421)([- ]?))|0)((\d{3})([- ]?)){2}(\d{3})$/.test(v);
                                    break;
                                case 'TH':
                                    isValid = /^0\(?([6|8-9]{2})*-([0-9]{3})*-([0-9]{4})$/.test(v);
                                    break;
                                case 'VE':
                                    isValid = /^0(?:2(?:12|4[0-9]|5[1-9]|6[0-9]|7[0-8]|8[1-35-8]|9[1-5]|3[45789])|4(?:1[246]|2[46]))\d{7}$/.test(v);
                                    break;
                                case 'US':
                                default:
                                    isValid = /^(?:(1-?)|(\+1 ?))?\(?(\d{3})[)\-.]?(\d{3})[-.]?(\d{4})$/.test(v);
                                    break;
                            }
                        if (isValid) {
                            return true;
                        }
                    }
                    return message;
                };
            },
            file: function (types, extensions, minFiles, maxFiles, minSize, maxSize, minTotalSize, maxTotalSize) {
                let message = 'Prosím zadajte správny súbor';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    types = options.types;
                    extensions = options.extensions;
                    minFiles = options.minFiles;
                    maxFiles = options.maxFiles;
                    minSize = options.minSize;
                    maxSize = options.maxSize;
                    minTotalSize = options.minTotalSize;
                    maxTotalSize = options.maxTotalSize;
                    if (options.message) {
                        message = options.message;
                    }
                }
                minFiles = typeof minFiles === 'number' ? minFiles : null;
                maxFiles = typeof maxFiles === 'number' ? maxFiles : null;
                minSize = typeof minSize === 'number' ? minSize : null;
                maxSize = typeof maxSize === 'number' ? maxSize : null;
                minTotalSize = typeof minTotalSize === 'number' ? minTotalSize : null;
                maxTotalSize = typeof maxTotalSize === 'number' ? maxTotalSize : null;
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    types = types ? (Array.isArray(types) ? types : types.toLowerCase().split(',').map((item) => item.trim())) : null;
                    extensions = extensions ? (Array.isArray(extensions) ? extensions : extensions.toLowerCase().split(',').map((item) => item.trim())) : null;
                    v = Array.isArray(v) ? v : [v];
                    const total = v.length;
                    let totalSize = 0;
                    if ((maxFiles !== null && total > maxFiles) || (minFiles !== null && total < minFiles)) {
                        return message;
                    }
                    for (var i = 0; i < total; i++) {
                        totalSize += v[i].size;
                        const ext = v[i].name.substr(v[i].name.lastIndexOf('.') + 1);
                        if (
                            (minSize !== null && v[i].size < minSize) ||
                            (maxSize !== null && v[i].size > maxSize) ||
                            (extensions && extensions.indexOf(ext.toLowerCase()) === -1) ||
                            (v[i].type && types && types.indexOf(v[i].type.toLowerCase()) === -1)
                        ) {
                            return message;
                        }
                    }
                    if ((maxTotalSize !== null && totalSize > maxTotalSize) || (minTotalSize !== null && totalSize < minTotalSize)) {
                        return message;
                    }
                    return true;
                };
            },
            creditCard: function () {
                let message = 'Prosím zadajte správne číslo kreditnej karty';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    if (options.message) {
                        message = options.message;
                    }
                }
                const luhn = function (value) {
                    let length = value.length;
                    let mul = 0;
                    let prodArr = [
                        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                        [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
                    ];
                    let sum = 0;
                    while (length--) {
                        sum += prodArr[mul][parseInt(value.charAt(length), 10)];
                        mul ^= 1;
                    }
                    return sum % 10 === 0 && sum > 0;
                };
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    if (/[^0-9-\s]+/.test(v)) {
                        return message;
                    }
                    v = v.replace(/\D/g, '');
                    if (!luhn(v)) {
                        return message;
                    }
                    var cards = {
                            AMERICAN_EXPRESS: {
                                length: [15],
                                prefix: ['34', '37'],
                            },
                            DINERS_CLUB: {
                                length: [14],
                                prefix: ['300', '301', '302', '303', '304', '305', '36'],
                            },
                            DINERS_CLUB_US: {
                                length: [16],
                                prefix: ['54', '55'],
                            },
                            DISCOVER: {
                                length: [16],
                                prefix: [ '6011', '622126', '622127', '622128', '622129', '62213', '62214', '62215', '62216', '62217', '62218', '62219', '6222', '6223', '6224', '6225', '6226', '6227', '6228', '62290', '62291', '622920', '622921', '622922', '622923', '622924', '622925', '644', '645', '646', '647', '648', '649', '65'],
                            },
                            JCB: {
                                length: [16],
                                prefix: ['3528', '3529', '353', '354', '355', '356', '357', '358'],
                            },
                            LASER: {
                                length: [16, 17, 18, 19],
                                prefix: ['6304', '6706', '6771', '6709'],
                            },
                            MAESTRO: {
                                length: [12, 13, 14, 15, 16, 17, 18, 19],
                                prefix: ['5018', '5020', '5038', '6304', '6759', '6761', '6762', '6763', '6764', '6765', '6766'],
                            },
                            MASTERCARD: {
                                length: [16],
                                prefix: ['51', '52', '53', '54', '55'],
                            },
                            SOLO: {
                                length: [16, 18, 19],
                                prefix: ['6334', '6767'],
                            },
                            UNIONPAY: {
                                length: [16, 17, 18, 19],
                                prefix: ['622126', '622127', '622128', '622129', '62213', '62214', '62215', '62216', '62217', '62218', '62219', '6222', '6223', '6224', '6225', '6226', '6227', '6228', '62290', '62291', '622920', '622921', '622922', '622923', '622924', '622925'],
                            },
                            VISA: {
                                length: [16],
                                prefix: ['4'],
                            },
                        };
                    var type, i;
                    for (type in cards) {
                        for (i in cards[type].prefix) {
                            if (v.substr(0, cards[type].prefix[i].length) === cards[type].prefix[i] && cards[type].length.indexOf(v.length) !== -1) {
                                return true;
                            }
                        }
                    }
                    return message;
                };
            },
            ip: function (type) {
                let message = 'Prosím zadajte správnu IP adresu';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    type = options.type;
                    if (options.message) {
                        message = options.message;
                    }
                }
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    type = type ? type.toLowerCase() : null;
                    const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                    const ipv6Regex =
                        /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
                    if (type === 'ipv4') {
                        return ipv4Regex.test(v) || message;
                    } else if (type === 'ipv6') {
                        return ipv6Regex.test(v) || message;
                    } else {
                        return ipv4Regex.test(v) || ipv6Regex.test(v) || message;
                    }
                };
            },
            mac: function () {
                let message = 'Prosím zadajte správnu MAC adresu';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    if (options.message) {
                        message = options.message;
                    }
                }
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    return /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/.test(v) || message;
                };
            },
            uri: function (protocols, allowLocal, allowEmptyProtocol) {
                let message = 'Prosím zadajte správnu URI';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    protocols = options.protocols;
                    allowLocal = options.allowLocal;
                    allowEmptyProtocol = options.allowEmptyProtocol;
                    if (options.message) {
                        message = options.message;
                    }
                }
                protocols = (protocols || 'http, https, ftp').split(',').join('|').replace(/\s/g, '');
                allowLocal = allowLocal === true || allowLocal === 'true';
                allowEmptyProtocol = allowEmptyProtocol === true || allowEmptyProtocol === 'true';
                return (v) => {
                    if (v === void 0 || v === null || v === '') {
                        return true;
                    }
                    const uriRegexp = new RegExp(
                        '^' +
                            '(?:(?:' +
                            protocols +
                            ')://)' +
                            (allowEmptyProtocol ? '?' : '') +
                            '(?:\\S+(?::\\S*)?@)?' +
                            '(?:' +
                            (allowLocal
                                ? ''
                                : '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
                                  '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
                                  '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})') +
                            '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
                            '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
                            '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
                            '|' +
                            '(?:(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9]+)' +
                            '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9])*' +
                            '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
                            (allowLocal ? '?' : '') +
                            ')' +
                            '(?::\\d{2,5})?' +
                            '(?:/[^\\s]*)?' +
                            '$',
                        'i'
                    );
                    return uriRegexp.test(v) || message;
                };
            },
            identical: function (value, field) {
                let message = 'Prosím zadajte rovnakú hodnotu{0}';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    value = options.value;
                    field = options.field;
                    if (options.message) {
                        message = options.message;
                    }
                }
                return (v) => {
                    return v === value || message.format(field ? ' ako ' + field : '');
                };
            },
            different: function (value, field) {
                let message = 'Prosím zadajte inú hodnotu';
                if (arguments.length === 1 && typeof arguments[0] === 'object') {
                    const options = arguments[0];
                    value = options.value;
                    field = options.field;
                    if (options.message) {
                        message = options.message;
                    }
                }
                return (v) => {
                    return v !== value || message.format(field ? ' ako ' + field : '');
                };
            },
        };
        $e.form = {
            rules: function (options) {
                if (arguments.length === 0) {
                    return rules;
                }
                const result = [];
                if (typeof options === 'object') {
                    for (const [key, value] of Object.entries(options)) {
                        const rule = rules[key];
                        if (rule) {
                            result.push(rule(value));
                        }
                    }
                }
                return result;
            },
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.form);
        }
    },
};

var Loading = {
    install({ $e, $q, parentApp }) {
        let counter = 0;
        let onShowHandlers = [];
        let onHideHandlers = [];
        $e.loading = {
            defaults: {},
            isActive: false,
            show(message, color) {
                if (typeof $q.loading !== 'object' || typeof $q.loading.show !== 'function') {
                    console.error("Required 'Quasar - Loading' plugin!");
                    return;
                }
                if (counter === 0) {
                    const defaults = {
                        messageColor: 'black',
                        spinnerColor: 'primary',
                        backgroundColor: 'grey-5',
                        customClass: 'blur',
                        ...($e.loading.defaults || {}),
                        ...($e.config && $e.config.loading ? $e.config.loading : {}),
                        ...(color ? { spinnerColor: color } : {}),
                    };
                    $q.loading.show({
                        ...defaults,
                        message: message,
                        ignoreDefaults: true,
                    });
                    for (let i = 0; i < onShowHandlers.length; i++) {
                        onShowHandlers[i].apply(null);
                    }
                    this.isActive = true;
                }
                counter++;
            },
            hide(force) {
                if (typeof $q.loading !== 'object' || typeof $q.loading.hide !== 'function') {
                    console.error("Required 'Quasar - Loading' plugin!");
                    return;
                }
                if (counter === 0) {
                    return;
                }
                if (force === true) {
                    counter = 1;
                }
                counter--;
                if (counter === 0) {
                    $q.loading.hide();
                    for (let i = 0; i < onHideHandlers.length; i++) {
                        onHideHandlers[i].apply(null);
                    }
                    this.isActive = false;
                }
            },
            onShow(handler) {
                if (typeof handler === 'function') {
                    onShowHandlers.push(handler);
                }
            },
            onHide(handler) {
                if (typeof handler === 'function') {
                    onHideHandlers.push(handler);
                }
            },
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.loading);
        }
    },
};

var Notify = {
    install({ $e, $q, parentApp }) {
        const create = (type, message, action, timeout) => {
            if (typeof $q.notify !== 'function') {
                console.error("Required 'Quasar - Notify' plugin!");
                return {
                    hide: () => {},
                    update: () => {},
                };
            }
            const isAction = typeof action === 'function';
            const actionHandler = (e) => {
                if (e.target.closest('.q-notification__actions') === null) {
                    if (action(notify) !== false) {
                        notify.hide();
                    }
                }
            };
            const defaults = {
                color: {
                    success: 'positive',
                    error: 'negative',
                    warning: 'warning',
                    info: 'info',
                },
                icon: {
                    success: 'check_circle_outline',
                    error: 'error_outline',
                    warning: 'warning_amber',
                    info: 'info_outline',
                },
                position: 'bottom-right',
                badgePosition: 'top-right',
                progress: true,
                timeout: 5000,
                ...($e.notify.defaults || {}),
                ...($e.config && $e.config.notify ? $e.config.notify : {}),
                ...(typeof timeout === 'number' && timeout % 1 === 0 ? { timeout: timeout } : {}),
            };
            typeof defaults.color === 'object' && (defaults.color = defaults.color[type]);
            typeof defaults.icon === 'object' && (defaults.icon = defaults.icon[type]);
            const _notify = $q.notify({
                ...defaults,
                message,
                group: false,
                attrs: {
                    style: 'word-wrap: break-word; white-space: pre-line;' + (isAction ? ' cursor: pointer;' : ''),
                    onclick: isAction ? actionHandler : undefined,
                },
                actions: [
                    {
                        icon: 'close',
                        color: 'white',
                        round: true,
                        ripple: { early: true },
                    },
                ],
                ignoreDefaults: true,
            });
            const notify = {
                hide: () => _notify(),
                update: (props) => _notify(props),
            };
            return notify;
        };
        $e.notify = {
            defaults: {},
            success(message, action, timeout) {
                return create('success', message, action, timeout);
            },
            error(message, action, timeout) {
                return create('error', message, action, timeout);
            },
            warning(message, action, timeout) {
                return create('warning', message, action, timeout);
            },
            info(message, action, timeout) {
                return create('info', message, action, timeout);
            },
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.notify);
        }
    },
};

var User = {
    install({ $e, $q, parentApp }) {
        const $t = parentApp.config.globalProperties.$t;
        const userConfig = $e.config.user || {};
        const permissionDeniedMessage = 'Žiadne, alebo nedostatočné prístupové práva!';
        const userTemplate = {
            userId: undefined,
            login: undefined,
            titleBefore: undefined,
            firstName: undefined,
            middleName: undefined,
            lastName: undefined,
            titleAfter: undefined,
            fullName: undefined,
            mail: undefined,
            phone: undefined,
            locked: undefined,
            lockMessage: undefined,
            userRoleList: [],
            hasRole(role) {
                if (!$e.is.empty(this.userRoleList)) {
                    if (typeof role === 'string') {
                        role = $e.user.getRoles()[role];
                    }
                    for (let i = 0; i < this.userRoleList.length; i++) {
                        if (this.userRoleList[i].role === role) {
                            return true;
                        }
                    }
                }
                return false;
            },
            hasLeastOneRole(roles) {
                if (!$e.is.empty(roles)) {
                    if (arguments.length > 1) {
                        roles = Array.prototype.slice.call(arguments);
                    }
                    if (!Array.isArray(roles)) {
                        roles = [roles];
                    }
                    for (let i = 0; i < roles.length; i++) {
                        if (this.hasRole(roles[i])) {
                            return true;
                        }
                    }
                }
                return false;
            },
            hasEachOneRole(roles) {
                if (!$e.is.empty(roles)) {
                    if (arguments.length > 1) {
                        roles = Array.prototype.slice.call(arguments);
                    }
                    if (!Array.isArray(roles)) {
                        roles = [roles];
                    }
                    for (let i = 0; i < roles.length; i++) {
                        if (!this.hasRole(roles[i])) {
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            },
            checkRole(role, callback) {
                if (this.hasRole(role) === false) {
                    $e.dialog.error($t('enfis.modules.user.permissionDenied', permissionDeniedMessage), callback);
                    return false;
                }
                return true;
            },
            checkLeastOneRole(roles, callback) {
                if (this.hasLeastOneRole(roles) === false) {
                    $e.dialog.error($t('enfis.modules.user.permissionDenied', permissionDeniedMessage), callback);
                    return false;
                }
                return true;
            },
            checkEachOneRole(roles, callback) {
                if (this.hasEachOneRole(roles) === false) {
                    $e.dialog.error($t('enfis.modules.user.permissionDenied', permissionDeniedMessage), callback);
                    return false;
                }
                return true;
            },
        };
        let user = null;
        let roles = {};
        if (userConfig.roles) {
            roles = userConfig.roles;
        }
        const onLoadHandlers = [];
        const onSetHandlers = [];
        const setLoggedUser = function (user, callback) {
            user = $e.user.setUser(user);
            for (let i = 0; i < onLoadHandlers.length; i++) {
                onLoadHandlers[i].call(null, user);
            }
            if (!$e.is.empty(callback) && typeof callback === 'function') {
                callback.call(null, user);
            }
        };
        $e.user = {
            login(login, password, callback, options) {
                $e.io.callMethod(
                    'loginUser',
                    {
                        'user-login': login,
                        'user-password': password,
                    },
                    (user) => setLoggedUser(user, callback),
                    options
                );
            },
            loginByForm(form, callback, options) {
                $e.io.callMethodByForm(form, 'loginUser', null, (user) => setLoggedUser(user, callback), options);
            },
            logout(callback) {
                if (callback === true) {
                    callback = () => {
                        $e.loading.show();
                        if (typeof document != 'undefined') {
                            document.location = '.';
                        }
                    };
                }
                $e.io.callMethod('logoutUser', null, callback);
            },
            load(callback, check, options) {
                $e.io.callMethod(
                    'getLoggedUser',
                    {
                        'user-check': check === true,
                        'user-refresh': true,
                    },
                    {
                        success: (user) => setLoggedUser(user, callback),
                        error: () => (user = null),
                        afterError: () => this.logout(),
                    },
                    options
                );
            },
            onLoadUser(handler) {
                if (typeof handler === 'function') {
                    onLoadHandlers.push(handler);
                    if (!$e.is.empty(user)) {
                        handler.call(null, user);
                    }
                }
            },
            getUser() {
                if ($e.is.empty(user)) {
                    throw new Error('User is not loaded yet!');
                }
                return user;
            },
            setUser(userNew) {
                if (userNew == undefined || userNew == null || typeof userNew !== 'object') {
                    user = null;
                    return userNew;
                }
                user = Object.assign({}, userTemplate, userNew);
                for (let i = 0; i < onSetHandlers.length; i++) {
                    onSetHandlers[i].call(null, user);
                }
                return user;
            },
            onSetUser(handler) {
                if (typeof handler === 'function') {
                    onSetHandlers.push(handler);
                }
            },
            getRoles() {
                return roles;
            },
            setRoles(rolesNew) {
                roles = rolesNew;
            },
            evalRoles(expression) {
                if ($e.is.empty(expression)) {
                    return false;
                }
                const user = this.getUser();
                const roleNames = expression.match(/[_a-zA-Z0-9]+/g);
                for (let i = 0; i < roleNames.length; i++) {
                    const roleId = roles[roleNames[i]];
                    const hasRole = user.hasRole(roleId);
                    expression = expression.replace(roleNames[i], hasRole);
                }
                let result = false;
                try {
                    result = eval(expression);
                } catch (e) {
                    result = false;
                }
                return result;
            },
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.user);
        }
    },
};

const SSR = typeof window == 'undefined' || typeof document == 'undefined' || typeof File == 'undefined';
var Utils = {
    install({ $e, parentApp }) {
        $e.utils = {
            getCurrentDateString() {
                const date = new Date();
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return (day < 10 ? '0' : '') + day + '.' + (month < 10 ? '0' : '') + month + '.' + year;
            },
            getCurrentTimeString(includeSeconds) {
                const date = new Date();
                const hour = date.getHours();
                const minute = date.getMinutes();
                const seconds = date.getSeconds();
                return (
                    (hour < 10 ? '0' : '') +
                    hour +
                    ':' +
                    (minute < 10 ? '0' : '') +
                    minute +
                    (includeSeconds !== false ? ':' + (seconds < 10 ? '0' : '') + seconds : '')
                );
            },
            getDateTimeFormatRegex(format) {
                if (format === 'DD.MM.YYYY') {
                    return /^(0?[1-9]|[1-2][0-9]|3[0-1])\.(0?[1-9]|1[0-2])\.[0-9]{4}$/;
                } else if (format === 'HH:mm:ss') {
                    return /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
                } else if (format === 'HH:mm') {
                    return /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
                } else if (format === 'DD.MM.YYYY HH:mm:ss') {
                    return /^(0?[1-9]|[1-2][0-9]|3[0-1])\.(0?[1-9]|1[0-2])\.[0-9]{4} (0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
                } else if (format === 'DD.MM.YYYY HH:mm') {
                    return /^(0?[1-9]|[1-2][0-9]|3[0-1])\.(0?[1-9]|1[0-2])\.[0-9]{4} (0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
                } else {
                    return /^[0-9.: ]$/;
                }
            },
            correct(value, emptyValue) {
                emptyValue = $e.is.empty(emptyValue) ? null : emptyValue;
                return $e.is.empty(value) ? emptyValue : value;
            },
            pageStyleFn(offset, height) {
                return {
                    height: height === 0 ? (offset !== 0 ? `calc(100vh - ${offset}px)` : '100vh') : height - offset + 'px',
                };
            },
            extractValue(object, field) {
                if (field.indexOf('.') !== -1 || field.indexOf('(') !== -1 || field.indexOf('[') !== -1 || field.indexOf(' ') !== -1) {
                    try {
                        return eval('object.' + field);
                    } catch (e) {
                        return null;
                    }
                } else {
                    return object[field];
                }
            },
            getFieldValue(object, field) {
                if ($e.is.empty(field) || $e.is.empty(object) || typeof object !== 'object') {
                    return null;
                }
                if (typeof field === 'function') {
                    return field(object);
                } else if ($e.is.complexField(field)) {
                    return this.extractValue(object, field);
                } else {
                    return object[field];
                }
            },
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.utils);
        }
        $e.is = {
            empty(value) {
                if (value === undefined || value === null) return true;
                if (typeof value === 'string' && value.length === 0) return true;
                if (Array.isArray(value) && value.length === 0) return true;
                return false;
            },
            emptyEveryOne() {
                let result = true;
                let values = arguments;
                if (arguments.length === 1 && Array.isArray(arguments[0])) {
                    values = arguments[0];
                }
                for (let i = 0; i < values.length; i++) {
                    result = result && this.empty(values[i]);
                }
                return result;
            },
            emptyLeastOne() {
                let result = false;
                let values = arguments;
                if (arguments.length === 1 && Array.isArray(arguments[0])) {
                    values = arguments[0];
                }
                for (let i = 0; i < values.length; i++) {
                    result = result || this.empty(values[i]);
                    if (result) {
                        break;
                    }
                }
                return result;
            },
            html(data) {
                if (!data.trim().startsWith('<')) {
                    return false;
                }
                if (!SSR) {
                    const div = document.createElement('div');
                    div.innerHTML = data;
                    for (let child = div.childNodes, i = child.length; i--; ) {
                        if (child[i].nodeType === 1) return true;
                    }
                    return false;
                } else {
                    return /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(data);
                }
            },
            complexField(field) {
                return (
                    typeof field === 'string' &&
                    (field.indexOf('.') !== -1 || field.indexOf('(') !== -1 || field.indexOf('[') !== -1 || field.indexOf(' ') !== -1)
                );
            },
            ...is,
        };
        if (this.__installed !== true) {
            Object.assign(this, $e.is);
        }
        String.prototype.sanitize = function () {
            if (!SSR) {
                const div = document.createElement('div');
                div.innerHTML = this + '';
                return div.textContent || div.innerText || '';
            } else {
                return this.replace(/<[^>]*(>|$)|&nbsp;|&#34;|&#39;|&zwnj;|&raquo;|&laquo;|&gt;/g, '');
            }
        };
        String.prototype.format = function () {
            let string = this;
            for (let i = 0; i < arguments.length; i++) {
                string = string.replace(RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
            }
            return string;
        };
        String.prototype.removeDiacritics = function () {
            const diacriticals = 'áäčďěéíĺľňóöôŕřšťúüýźžÁÄČĎĚÉÍĹĽŇÓÖÔŔŘŠŤÚÜÝŹŽŐőÖöŰűÜü';
            const undiacriticals = 'aacdeeillnooorrstuuyzzAACDEEILLNOOORRSTUUYZZOoOoUuUu';
            let result = this.toString();
            for (let i = 0; i < diacriticals.length; i++) {
                result = result.replaceAll(diacriticals.charAt(i), undiacriticals.charAt(i));
            }
            return result;
        };
        Array.prototype.max = function () {
            let max = this[0];
            const len = this.length;
            for (let i = 1; i < len; i++) if (this[i] > max) max = this[i];
            return max;
        };
        Array.prototype.min = function () {
            let min = this[0];
            const len = this.length;
            for (let i = 1; i < len; i++) if (this[i] < min) min = this[i];
            return min;
        };
        Number.prototype.format = function (decimalLength, partLength, sectionsDelimiter, decimalDelimiter) {
            decimalLength = decimalLength === 0 ? 0 : !decimalLength ? 2 : decimalLength;
            const value = this.toFixed(Math.max(0, ~~decimalLength)).replace('.', decimalDelimiter || ',');
            if (partLength === 0) {
                return value;
            }
            const regex = '\\d(?=(\\d{' + (partLength || 3) + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
            return value.replace(new RegExp(regex, 'g'), '$&' + (sectionsDelimiter || ' '));
        };
        Number.prototype.formatFileSize = function (decimalLength) {
            if (this === 0) {
                return '0 Bytes';
            }
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const index = Math.floor(Math.log(this) / Math.log(1024));
            return ((this / Math.pow(1024, index)).toFixed(decimalLength || 2) + ' ' + sizes[index]).replace('.', ',');
        };
        (function () {
            const timeouts = [];
            const messageName = 'zero-timeout-message';
            function setZeroTimeout(fn) {
                timeouts.push(fn);
                window.postMessage(messageName, '*');
            }
            function handleMessage(event) {
                if (event.source === window && event.data === messageName) {
                    event.stopPropagation();
                    if (timeouts.length > 0) {
                        const fn = timeouts.shift();
                        fn();
                    }
                }
            }
            if (typeof window != 'undefined') {
                window.addEventListener('message', handleMessage, true);
                window.setZeroTimeout = setZeroTimeout;
            }
        })();
    },
};

var modules = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Ajax: Ajax,
  Dialog: Dialog,
  Event: Event$1,
  Form: Form,
  Loading: Loading,
  Notify: Notify,
  User: User,
  Utils: Utils
});

/**
 * Returns the $e instance.
 * Equivalent to `this.$e` inside templates.
 */
function useEnfis() {
    return inject(enfisKey);
}

const $e = {};
const EnfisQuasar = {
    install(app, opts) {
        installEnfis(app, { $e, components, modules, ...opts });
    },
};

export { Ajax, Dialog, EnfisQuasar, Event$1 as Event, Form, Loading, Notify, script$8 as QChooseInput, script$e as QDateTimeInput, script$2 as QDetailField, script$3 as QDynamicIcon, script$4 as QEditorInput, script$6 as QFileInput, script$1 as QGallery, script$9 as QGrid, script$7 as QImgCropper, script$d as QNumberInput, script$b as QOptionGroupInput, script$c as QOptionInput, script$a as QOverflowToolbar, script$5 as QTinyMce, User, Utils, $e as default, useEnfis };
